//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IExitApi {
    getExitRequests(exitType: string | null, sortParameters: SortParameters): Observable<OperationResultOfCandidateGridInfo>;
    deleteExitRequest(id: number): Observable<OperationResultOfInteger>;
    saveProfile(submitProfile: boolean | undefined, exitCandidate: ExitCandidate): Observable<OperationResultOfExitRequest>;
    getEligibleDocuments(exitType: string | null, teamType: number, request: ExitRequest): Observable<DocumentType[]>;
    documentsUpload(): Observable<OperationResultOfExitDocument>;
    getDocumentDetails(id: number, type: number): Observable<ExitDocument[]>;
    getAllDocumentDetails(id: number): Observable<ExitDocument[]>;
    downLoadFile(document: ExitDocument): Observable<void>;
    downloadAll(id: number, typeId: number | undefined): Observable<void>;
    exitRequest(requestId: number): Observable<ExitRequest>;
    deleteFile(exitDocument: ExitDocument): Observable<boolean>;
    eligibleExitTypes(lookupTypeId: number): Observable<LookupField[]>;
    saveRequestProcess(submitProfile: boolean | undefined, exitCandidate: ExitCandidate): Observable<OperationResultOfExitRequest>;
    acceptProfile(candidate: ExitCandidate): Observable<OperationResultOfExitRequest>;
    declineProfile(candidate: ExitCandidate): Observable<OperationResultOfExitRequest>;
    getComments(id: number): Observable<ExitComment[]>;
    saveComment(comment: ExitComment): Observable<OperationResultOfInteger>;
    exitRequestActivities(exitRequestId: number): Observable<RequestActivities>;
    resetRequestActivities(exitRequestId: number, activities: ExitRequestActivity[]): Observable<RequestActivities>;
    updateExitActivity(requestID: number, activityID: number, status: ActivityStatus): Observable<ExitRequestActivity>;
    attachmentsUpload(): Observable<OperationResultOfExitEmailAttachments>;
    getAttachmentsDetails(profileId: number, activityId: number, activityTemplateId: number): Observable<ExitEmailAttachments[]>;
    deleteAttachment(emailAttachments: ExitEmailAttachments): Observable<boolean>;
    saveExtendedProfile(newExitDate: Date, exitType: string | null, id: number): Observable<OperationResultOfExitRequest>;
    saveAcceptedProfile(candidate: ExitCandidate): Observable<OperationResultOfExitRequest>;
    markProfileAsComplete(requestId: number): Observable<OperationResultOfInteger>;
    canUserViewThisRequest(requestId: number): Observable<boolean>;
    exportExitReportToCSV(exitType: string | null, filterParameters: FilterParams): Observable<void>;
    attachCandidateDocsToMail(emailAttachments: ExitEmailAttachments[]): Observable<ExitEmailAttachments[]>;
    isExitReqExists(exitID: number): Observable<boolean>;
    getNotifications(userid: number, type: string | null, sortParams: SortParameters): Observable<NotificationGrdiInfo>;
    getNotificationCount(userid: number, type: string | null): Observable<number>;
    markNotificationRead(notificationId: number, userId: number): Observable<boolean>;
    acceptProfileBulk(exitTypeID: number, exitProfileIds: number[]): Observable<OperationResultOfInteger>;
    downLoadTemplate(document: string | null): Observable<void>;
    templateUpload(): Observable<OperationResultOfString>;
    validateIETemplate(): Observable<OperationResultOfListOfInternExitBulkUpload>;
    exitActivityCompleteCheck(id: number, exitActivityId: number): Observable<boolean>;
    exportExitReportBasedOnLocation(filter: ExitKPIReportFilter): Observable<void>;
    getDashboardLink(dashboardId: number): Observable<string>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ExitApi implements IExitApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
      this.jsonParseReviver = (key: string, value: any) => {
        let keys = ["dateTerminationCommunicated", "lastDateOfEmployment", "lastWorkingDate",
          "gardenLeaveStartDate", "gardenLeaveEndDate", "seniorityDate", "dateOfExit", "exitDate", "miCancellationDate"]

        if (key && key != "" && keys.includes(key)) {
          return value?.replace('Z', '');
        }
        return value; // TODO: Transform value if necessary
      };
    }

    getExitRequests(exitType: string | null, sortParameters: SortParameters): Observable<OperationResultOfCandidateGridInfo> {
        let url_ = this.baseUrl + "/api/Exit/getExitRequests/{exitType}";
        if (exitType === undefined || exitType === null)
            throw new Error("The parameter 'exitType' must be defined.");
        url_ = url_.replace("{exitType}", encodeURIComponent("" + exitType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfCandidateGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfCandidateGridInfo>;
        }));
    }

    protected processGetExitRequests(response: HttpResponseBase): Observable<OperationResultOfCandidateGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfCandidateGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteExitRequest(id: number): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Exit/DeleteExitRequest?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExitRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExitRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processDeleteExitRequest(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveProfile(submitProfile: boolean | undefined, exitCandidate: ExitCandidate): Observable<OperationResultOfExitRequest> {
        let url_ = this.baseUrl + "/api/Exit/SaveProfile?";
        if (submitProfile === null)
            throw new Error("The parameter 'submitProfile' cannot be null.");
        else if (submitProfile !== undefined)
            url_ += "submitProfile=" + encodeURIComponent("" + submitProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exitCandidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfExitRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfExitRequest>;
        }));
    }

    protected processSaveProfile(response: HttpResponseBase): Observable<OperationResultOfExitRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfExitRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEligibleDocuments(exitType: string | null, teamType: number, request: ExitRequest): Observable<DocumentType[]> {
        let url_ = this.baseUrl + "/api/Exit/GetEligibleDocuments/{exitType}?";
        if (exitType === undefined || exitType === null)
            throw new Error("The parameter 'exitType' must be defined.");
        url_ = url_.replace("{exitType}", encodeURIComponent("" + exitType));
        if (teamType === undefined || teamType === null)
            throw new Error("The parameter 'teamType' must be defined and cannot be null.");
        else
            url_ += "teamType=" + encodeURIComponent("" + teamType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibleDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibleDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentType[]>;
        }));
    }

    protected processGetEligibleDocuments(response: HttpResponseBase): Observable<DocumentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentsUpload(): Observable<OperationResultOfExitDocument> {
        let url_ = this.baseUrl + "/api/Exit/DocumentsUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfExitDocument>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfExitDocument>;
        }));
    }

    protected processDocumentsUpload(response: HttpResponseBase): Observable<OperationResultOfExitDocument> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfExitDocument.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentDetails(id: number, type: number): Observable<ExitDocument[]> {
        let url_ = this.baseUrl + "/api/Exit/GetDocumentDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitDocument[]>;
        }));
    }

    protected processGetDocumentDetails(response: HttpResponseBase): Observable<ExitDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExitDocument.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDocumentDetails(id: number): Observable<ExitDocument[]> {
        let url_ = this.baseUrl + "/api/Exit/GetAllDocumentDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDocumentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitDocument[]>;
        }));
    }

    protected processGetAllDocumentDetails(response: HttpResponseBase): Observable<ExitDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExitDocument.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downLoadFile(document: ExitDocument): Observable<void> {
        let url_ = this.baseUrl + "/api/Exit/DocumentDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(document);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownLoadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAll(id: number, typeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Exit/DownloadAll?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exitRequest(requestId: number): Observable<ExitRequest> {
        let url_ = this.baseUrl + "/api/Exit/ExitRequest/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExitRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExitRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitRequest>;
        }));
    }

    protected processExitRequest(response: HttpResponseBase): Observable<ExitRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExitRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(exitDocument: ExitDocument): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Exit/DocumentDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exitDocument);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    eligibleExitTypes(lookupTypeId: number): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Exit/EligibleExitTypes/{lookupTypeId}";
        if (lookupTypeId === undefined || lookupTypeId === null)
            throw new Error("The parameter 'lookupTypeId' must be defined.");
        url_ = url_.replace("{lookupTypeId}", encodeURIComponent("" + lookupTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEligibleExitTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEligibleExitTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processEligibleExitTypes(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveRequestProcess(submitProfile: boolean | undefined, exitCandidate: ExitCandidate): Observable<OperationResultOfExitRequest> {
        let url_ = this.baseUrl + "/api/Exit/SaveRequestProcess?";
        if (submitProfile === null)
            throw new Error("The parameter 'submitProfile' cannot be null.");
        else if (submitProfile !== undefined)
            url_ += "submitProfile=" + encodeURIComponent("" + submitProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exitCandidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRequestProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRequestProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfExitRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfExitRequest>;
        }));
    }

    protected processSaveRequestProcess(response: HttpResponseBase): Observable<OperationResultOfExitRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfExitRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acceptProfile(candidate: ExitCandidate): Observable<OperationResultOfExitRequest> {
        let url_ = this.baseUrl + "/api/Exit/AcceptProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfExitRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfExitRequest>;
        }));
    }

    protected processAcceptProfile(response: HttpResponseBase): Observable<OperationResultOfExitRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfExitRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    declineProfile(candidate: ExitCandidate): Observable<OperationResultOfExitRequest> {
        let url_ = this.baseUrl + "/api/Exit/DeclineProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfExitRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfExitRequest>;
        }));
    }

    protected processDeclineProfile(response: HttpResponseBase): Observable<OperationResultOfExitRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfExitRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComments(id: number): Observable<ExitComment[]> {
        let url_ = this.baseUrl + "/api/Exit/GetComments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitComment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitComment[]>;
        }));
    }

    protected processGetComments(response: HttpResponseBase): Observable<ExitComment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExitComment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveComment(comment: ExitComment): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Exit/SaveComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSaveComment(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exitRequestActivities(exitRequestId: number): Observable<RequestActivities> {
        let url_ = this.baseUrl + "/api/Exit/{ExitRequestId}/activities";
        if (exitRequestId === undefined || exitRequestId === null)
            throw new Error("The parameter 'exitRequestId' must be defined.");
        url_ = url_.replace("{ExitRequestId}", encodeURIComponent("" + exitRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExitRequestActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExitRequestActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestActivities>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestActivities>;
        }));
    }

    protected processExitRequestActivities(response: HttpResponseBase): Observable<RequestActivities> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestActivities.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetRequestActivities(exitRequestId: number, activities: ExitRequestActivity[]): Observable<RequestActivities> {
        let url_ = this.baseUrl + "/api/Exit/resetRequestActivities?";
        if (exitRequestId === undefined || exitRequestId === null)
            throw new Error("The parameter 'exitRequestId' must be defined and cannot be null.");
        else
            url_ += "ExitRequestId=" + encodeURIComponent("" + exitRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activities);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetRequestActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetRequestActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestActivities>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestActivities>;
        }));
    }

    protected processResetRequestActivities(response: HttpResponseBase): Observable<RequestActivities> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestActivities.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExitActivity(requestID: number, activityID: number, status: ActivityStatus): Observable<ExitRequestActivity> {
        let url_ = this.baseUrl + "/api/Exit/UpdateExitActivity?";
        if (requestID === undefined || requestID === null)
            throw new Error("The parameter 'requestID' must be defined and cannot be null.");
        else
            url_ += "requestID=" + encodeURIComponent("" + requestID) + "&";
        if (activityID === undefined || activityID === null)
            throw new Error("The parameter 'activityID' must be defined and cannot be null.");
        else
            url_ += "activityID=" + encodeURIComponent("" + activityID) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExitActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExitActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitRequestActivity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitRequestActivity>;
        }));
    }

    protected processUpdateExitActivity(response: HttpResponseBase): Observable<ExitRequestActivity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExitRequestActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachmentsUpload(): Observable<OperationResultOfExitEmailAttachments> {
        let url_ = this.baseUrl + "/api/Exit/AttachmentsUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfExitEmailAttachments>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfExitEmailAttachments>;
        }));
    }

    protected processAttachmentsUpload(response: HttpResponseBase): Observable<OperationResultOfExitEmailAttachments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfExitEmailAttachments.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttachmentsDetails(profileId: number, activityId: number, activityTemplateId: number): Observable<ExitEmailAttachments[]> {
        let url_ = this.baseUrl + "/api/Exit/GetAttachmentsDetails?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (activityTemplateId === undefined || activityTemplateId === null)
            throw new Error("The parameter 'activityTemplateId' must be defined and cannot be null.");
        else
            url_ += "activityTemplateId=" + encodeURIComponent("" + activityTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitEmailAttachments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitEmailAttachments[]>;
        }));
    }

    protected processGetAttachmentsDetails(response: HttpResponseBase): Observable<ExitEmailAttachments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExitEmailAttachments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAttachment(emailAttachments: ExitEmailAttachments): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Exit/DeleteAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveExtendedProfile(newExitDate: Date, exitType: string | null, id: number): Observable<OperationResultOfExitRequest> {
        let url_ = this.baseUrl + "/api/Exit/SaveExtendedProfile?";
        if (newExitDate === undefined || newExitDate === null)
            throw new Error("The parameter 'newExitDate' must be defined and cannot be null.");
        else
            url_ += "newExitDate=" + encodeURIComponent(newExitDate ? "" + newExitDate.toISOString() : "") + "&";
        if (exitType === undefined)
            throw new Error("The parameter 'exitType' must be defined.");
        else if(exitType !== null)
            url_ += "exitType=" + encodeURIComponent("" + exitType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveExtendedProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveExtendedProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfExitRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfExitRequest>;
        }));
    }

    protected processSaveExtendedProfile(response: HttpResponseBase): Observable<OperationResultOfExitRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfExitRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveAcceptedProfile(candidate: ExitCandidate): Observable<OperationResultOfExitRequest> {
        let url_ = this.baseUrl + "/api/Exit/SaveAcceptedProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAcceptedProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAcceptedProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfExitRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfExitRequest>;
        }));
    }

    protected processSaveAcceptedProfile(response: HttpResponseBase): Observable<OperationResultOfExitRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfExitRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markProfileAsComplete(requestId: number): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Exit/MarkProfileAsComplete?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkProfileAsComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkProfileAsComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processMarkProfileAsComplete(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    canUserViewThisRequest(requestId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Exit/CanUserViewThisRequest?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanUserViewThisRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanUserViewThisRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanUserViewThisRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportExitReportToCSV(exitType: string | null, filterParameters: FilterParams): Observable<void> {
        let url_ = this.baseUrl + "/api/Exit/ExportExitReportToCSV?";
        if (exitType === undefined)
            throw new Error("The parameter 'exitType' must be defined.");
        else if(exitType !== null)
            url_ += "exitType=" + encodeURIComponent("" + exitType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExitReportToCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExitReportToCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportExitReportToCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachCandidateDocsToMail(emailAttachments: ExitEmailAttachments[]): Observable<ExitEmailAttachments[]> {
        let url_ = this.baseUrl + "/api/Exit/AttachCandidateDocsToMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachCandidateDocsToMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachCandidateDocsToMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitEmailAttachments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitEmailAttachments[]>;
        }));
    }

    protected processAttachCandidateDocsToMail(response: HttpResponseBase): Observable<ExitEmailAttachments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExitEmailAttachments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isExitReqExists(exitID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Exit/IsExitReqExists?";
        if (exitID === undefined || exitID === null)
            throw new Error("The parameter 'exitID' must be defined and cannot be null.");
        else
            url_ += "exitID=" + encodeURIComponent("" + exitID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsExitReqExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsExitReqExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsExitReqExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNotifications(userid: number, type: string | null, sortParams: SortParameters): Observable<NotificationGrdiInfo> {
        let url_ = this.baseUrl + "/api/Exit/GetPendingNotifications?";
        if (userid === undefined || userid === null)
            throw new Error("The parameter 'userid' must be defined and cannot be null.");
        else
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationGrdiInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationGrdiInfo>;
        }));
    }

    protected processGetNotifications(response: HttpResponseBase): Observable<NotificationGrdiInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationGrdiInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNotificationCount(userid: number, type: string | null): Observable<number> {
        let url_ = this.baseUrl + "/api/Exit/GetPendingNotificationCount?";
        if (userid === undefined || userid === null)
            throw new Error("The parameter 'userid' must be defined and cannot be null.");
        else
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        if (type === undefined)
            throw new Error("The parameter 'type' must be defined.");
        else if(type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNotificationCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markNotificationRead(notificationId: number, userId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Exit/MarkNotificationAsRead?";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined and cannot be null.");
        else
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNotificationRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotificationRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkNotificationRead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acceptProfileBulk(exitTypeID: number, exitProfileIds: number[]): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Exit/AcceptProfileBulk?";
        if (exitTypeID === undefined || exitTypeID === null)
            throw new Error("The parameter 'exitTypeID' must be defined and cannot be null.");
        else
            url_ += "exitTypeID=" + encodeURIComponent("" + exitTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exitProfileIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptProfileBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptProfileBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processAcceptProfileBulk(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downLoadTemplate(document: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Exit/TemplateDownload?";
        if (document === undefined)
            throw new Error("The parameter 'document' must be defined.");
        else if(document !== null)
            url_ += "document=" + encodeURIComponent("" + document) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownLoadTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    templateUpload(): Observable<OperationResultOfString> {
        let url_ = this.baseUrl + "/api/Exit/TemplateUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTemplateUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemplateUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfString>;
        }));
    }

    protected processTemplateUpload(response: HttpResponseBase): Observable<OperationResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateIETemplate(): Observable<OperationResultOfListOfInternExitBulkUpload> {
        let url_ = this.baseUrl + "/api/Exit/ValidateIETemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateIETemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateIETemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfListOfInternExitBulkUpload>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfListOfInternExitBulkUpload>;
        }));
    }

    protected processValidateIETemplate(response: HttpResponseBase): Observable<OperationResultOfListOfInternExitBulkUpload> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfListOfInternExitBulkUpload.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exitActivityCompleteCheck(id: number, exitActivityId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Exit/ExitActivityCompleteCheck?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (exitActivityId === undefined || exitActivityId === null)
            throw new Error("The parameter 'exitActivityId' must be defined and cannot be null.");
        else
            url_ += "exitActivityId=" + encodeURIComponent("" + exitActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExitActivityCompleteCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExitActivityCompleteCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExitActivityCompleteCheck(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportExitReportBasedOnLocation(filter: ExitKPIReportFilter): Observable<void> {
        let url_ = this.baseUrl + "/api/Exit/ExportExitReportBasedOnLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExitReportBasedOnLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExitReportBasedOnLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportExitReportBasedOnLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardLink(dashboardId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/Exit/GetDashboardLink/{dashboardId}";
        if (dashboardId === undefined || dashboardId === null)
            throw new Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDashboardLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Exit?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IImmigrationAutoRequestApi {
    generateRequest(masterActivityId: number, candidateProfileId: number, activityType: ActivityTypes): Observable<ImmigrationAutoRequest>;
    generateRequestWithoutTask(candidateProfileId: number, visaTypeId: number): Observable<ImmigrationAutoRequest>;
    checkImmigrationRequestSubmitted(candidateProfileId: number, visaTypeId: number): Observable<boolean>;
    generateRequestExit(activityId: number, exitRequestActId: number, exitRequest: ExitRequest): Observable<ImmigrationExitVisa>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ImmigrationAutoRequestApi implements IImmigrationAutoRequestApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    generateRequest(masterActivityId: number, candidateProfileId: number, activityType: ActivityTypes): Observable<ImmigrationAutoRequest> {
        let url_ = this.baseUrl + "/api/ImmigrationAutoRequest/GenerateRequest?";
        if (masterActivityId === undefined || masterActivityId === null)
            throw new Error("The parameter 'masterActivityId' must be defined and cannot be null.");
        else
            url_ += "masterActivityId=" + encodeURIComponent("" + masterActivityId) + "&";
        if (candidateProfileId === undefined || candidateProfileId === null)
            throw new Error("The parameter 'candidateProfileId' must be defined and cannot be null.");
        else
            url_ += "candidateProfileId=" + encodeURIComponent("" + candidateProfileId) + "&";
        if (activityType === undefined || activityType === null)
            throw new Error("The parameter 'activityType' must be defined and cannot be null.");
        else
            url_ += "activityType=" + encodeURIComponent("" + activityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationAutoRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationAutoRequest>;
        }));
    }

    protected processGenerateRequest(response: HttpResponseBase): Observable<ImmigrationAutoRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationAutoRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateRequestWithoutTask(candidateProfileId: number, visaTypeId: number): Observable<ImmigrationAutoRequest> {
        let url_ = this.baseUrl + "/api/ImmigrationAutoRequest/GenerateRequestWithoutTask?";
        if (candidateProfileId === undefined || candidateProfileId === null)
            throw new Error("The parameter 'candidateProfileId' must be defined and cannot be null.");
        else
            url_ += "candidateProfileId=" + encodeURIComponent("" + candidateProfileId) + "&";
        if (visaTypeId === undefined || visaTypeId === null)
            throw new Error("The parameter 'visaTypeId' must be defined and cannot be null.");
        else
            url_ += "visaTypeId=" + encodeURIComponent("" + visaTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateRequestWithoutTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateRequestWithoutTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationAutoRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationAutoRequest>;
        }));
    }

    protected processGenerateRequestWithoutTask(response: HttpResponseBase): Observable<ImmigrationAutoRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationAutoRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkImmigrationRequestSubmitted(candidateProfileId: number, visaTypeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ImmigrationAutoRequest/CheckImmigrationRequestSubmitted?";
        if (candidateProfileId === undefined || candidateProfileId === null)
            throw new Error("The parameter 'candidateProfileId' must be defined and cannot be null.");
        else
            url_ += "candidateProfileId=" + encodeURIComponent("" + candidateProfileId) + "&";
        if (visaTypeId === undefined || visaTypeId === null)
            throw new Error("The parameter 'visaTypeId' must be defined and cannot be null.");
        else
            url_ += "visaTypeId=" + encodeURIComponent("" + visaTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckImmigrationRequestSubmitted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckImmigrationRequestSubmitted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckImmigrationRequestSubmitted(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateRequestExit(activityId: number, exitRequestActId: number, exitRequest: ExitRequest): Observable<ImmigrationExitVisa> {
        let url_ = this.baseUrl + "/api/ImmigrationAutoRequest/GenerateRequestExit?";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (exitRequestActId === undefined || exitRequestActId === null)
            throw new Error("The parameter 'exitRequestActId' must be defined and cannot be null.");
        else
            url_ += "exitRequestActId=" + encodeURIComponent("" + exitRequestActId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exitRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateRequestExit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateRequestExit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationExitVisa>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationExitVisa>;
        }));
    }

    protected processGenerateRequestExit(response: HttpResponseBase): Observable<ImmigrationExitVisa> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationExitVisa.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/ImmigrationAutoRequest?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IImmigrationApi {
    eligibleVisaTypes(lookupTypeId: number, parentId: number | null | undefined, filterKey: number | null | undefined): Observable<LookupField[]>;
    getDashboardLink(countryId: number): Observable<string>;
    immigrationProfile(profileId: number): Observable<ImmigrationProfile>;
    renewProfile(profileId: number): Observable<ImmigrationProfile>;
    getAllRequests(country: string | null, sortParameters: SortParameters): Observable<CandidateGridInfo>;
    resetActivities(candidate: ImmigrationProfile): Observable<OperationResultOfInteger>;
    acceptProfile(candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile>;
    declineProfile(candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile>;
    withdraw(candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile>;
    approveProfile(isApprove: boolean | undefined, candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile>;
    rejectProfile(candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile>;
    getProfiles(visaType: string | null, country: string | null, sortParameters: SortParameters): Observable<CandidateGridInfo>;
    checkVisaApproverAccess(country: string | null): Observable<boolean>;
    saveRequest(immigrationProfile: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile>;
    saveRequestTeam(team: string | null, submitProfile: boolean | undefined, immigrationProfile: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile>;
    saveProfile(submitProfile: boolean | undefined, immigrationProfile: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile>;
    documentsUpload(): Observable<OperationResultOfImmigrationDocument>;
    getAttachmentsDetails(profileId: number, activityId: number, activityTemplateId: number): Observable<ImmigrationEmailAttachments[]>;
    deleteAttachment(emailAttachments: ImmigrationEmailAttachments): Observable<boolean>;
    deleteProfile(id: number): Observable<OperationResultOfInteger>;
    getEligibleDocuments(visaType: string | null, countryType: string | null, isApprover: boolean, request: ImmigrationProfile): Observable<ImmigrationDocumentType[]>;
    getEligibleAdditionalDocuments(profileId: number): Observable<ImmigrationDocCombined[]>;
    getImmigrationDocuments(visaType: string | null, countryType: string | null, isApprover: boolean, request: ImmigrationProfile): Observable<ImmigrationDocCombined[]>;
    getDocumentDetails(id: number, type: number): Observable<ImmigrationDocument[]>;
    getAllDocumentDetails(id: number): Observable<ImmigrationDocument[]>;
    deleteFile(immigrationDocument: ImmigrationDocument): Observable<boolean>;
    downloadAll(id: number, typeId: number | undefined): Observable<void>;
    downLoadDocumentFile(fileName: string | null): Observable<void>;
    downLoadFile(document: ImmigrationDocument): Observable<void>;
    immigrationProfileActivities(immigrationProfileId: number): Observable<ProfileActivities>;
    updateImmigrationActivity(immID: number, profileActivityID: number, status: ActivityStatus): Observable<ImmigrationProfileActivity>;
    downloadAttachment(emailAttachments: ImmigrationEmailAttachments): Observable<void>;
    attachmentsUpload(): Observable<OperationResultOfImmigrationEmailAttachments>;
    markProfileAsComplete(immigrationProfileId: number): Observable<OperationResultOfInteger>;
    exportReportToCSV(visaType: string | null, filterParameters: FilterParams): Observable<void>;
    canUserViewThisRequest(requestId: number, countryValue: string | null, visaType: string | null, activeRoleId: number): Observable<boolean>;
    isImmigrationExists(immigrationID: number): Observable<boolean>;
    exportProcessorReport(processorId: number): Observable<void>;
    exportPJCReport(pjcId: number): Observable<void>;
    cloneProfile(immigrationProfile: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile>;
    exportImmigrationActivity(immigrationProfileId: number): Observable<void>;
    attachCandidateDocsToMail(emailAttachments: ImmigrationEmailAttachments[]): Observable<ImmigrationEmailAttachments[]>;
    getDocumentInstructions(visaType: string | null, profileId: number, isApprover: boolean, nationalId: number): Observable<DocumentInstructions[]>;
    getRequestMileStones(immProfileId: number, countryCode: string | null): Observable<ImmigrationProfileMiletones[]>;
    getImmigrationInfoMin(immProfileId: number): Observable<ImmigrationInfoMin>;
    getRequestedImmDocuments(immigrationProfileId: number): Observable<ImmAdditionalDocRequests[]>;
    requestImmAdditionalDocuments(profileId: number, processorId: number, reqList: ImmAdditionalDocRequests[]): Observable<OperationResultOfBoolean>;
    uploadAdditionalDocs(profileId: number): Observable<OperationResultOfBoolean>;
    additionalDocUploadPageStatus(immigrationProfileId: number): Observable<boolean>;
    milestoneAccess(immigrationProfileId: number): Observable<boolean>;
    getEmailOfRequestor(profile: ImmigrationProfile): Observable<string>;
    sentSurveyMail(immigrationProfileId: number): Observable<OperationResultOfInteger>;
    cancellationVisa(request: ExitVisaRequest): Observable<OperationResultOfExitRequest>;
    checkCandidatePTC(profileId: number): Observable<boolean>;
    getVisasWithGpnGuiWarning(visaTypeId: number): Observable<boolean>;
    getImmActivityById(activityId: number): Observable<ImmigrationActivity>;
    documentsUploadedCheck(immProfieId: number, activityId: number): Observable<ImmigrationDocumentCheck[]>;
    updateImmigrationActivityFromProfile(immigrationProfileId: number, profileActivityID: number, status: ActivityStatus): Observable<OperationResultOfImmigrationProfileActivity>;
    getLatestImmigrationId(visaTypeId: number): Observable<number>;
    getLocationFieldAccessibility(module: string | null): Observable<LocationFieldAccessibility[]>;
    createImmVisaPreApprovalRequest(profileId: number, isCancelled: boolean | undefined): Observable<ImmigrationProfile>;
    getRenewalVisas(): Observable<number[]>;
    editCompletedImmProfile(immProfileId: number, isProfileCompleted: boolean, isEditable: boolean, candidate: ImmigrationCandidate): Observable<string>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ImmigrationApi implements IImmigrationApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
      this.jsonParseReviver = (key: string, value: any) => {
        let keys = ["bioMetricCompletedDate", "civilIdExpiryDate", "cprExpiryDate", "cprIssuanceDate", "currentKSABusinessVisaExpiryDate",
          "dateCourierTrackingNumberSent", "dateDocumentAttestationCompleted", "dateHardCopyVisaDocumentsReceivedByVendorOrNJ",
          "dateHardcopyVisaDocumentsSent", "dateKSABusinessVisaExpiry", "dateOfBirth", "dateOfExit", "dateOfGatePassIssuance",
          "dateOfInvitationLetterIssuance", "dateOfPayment", "dateOfTravel", "dateSoftcopyVisaDocumentsSent", "departureDate",
          "dependentFinalExitDeadline", "dependentRPExpiryDate", "dependentRPIssuanceDate", "dependentsRPCancellationDate",
          "dependentVisaCancellationDate", "entryDate", "extensionIssuanceDate", "gosiTerminationDate", "gracePeriodExpiryDate",
          "iqamaExpiryDate", "ksaFinalExitDate", "laborCardCancellationDate", "laborCardExpiryDate", "lastVaccineDate",
          "lastWorkingDate", "lastWorkingDay", "loiIssueDate", "medicalExamCompletionDate", "missionExpiryCancellation",
          "missionExpiryDate", "molContractCancellationDate", "newResidencyExpirydate", "pasiContractCancellationRequestDate",
          "passportExpiryDate", "pensionCancellationDate", "pensionRegistrationDate", "pifssCancellationDate",
          "rpCancellationDate", "rpExpiryDate", "rpIssuanceDate", "rpRenewalDate", "rpTransferDate",
          "securityPermitCancellationDate", "securityPermitExpiryDate", "securityPermitIssuanceDate",
          "siCancellationDate", "siRegistrationDate", "startDate", "statusDate", "tentativeStartDate", "tentativeTravelDate",
          "transferApprovalDate", "travelDate", "visaCancellationDate", "visaCancellationExtensionDate", "visaExpiryDate",
          "visaExtensionDate", "visaIssuanceDate", "visaRenewal", "visaValidityDate", "workPermitApprovalDate",
          "workPermitCancellationDate", "workPermitExpiryDate", "workPermitIssuanceDate", "workPermitPreApprovalDate",
          "courierDispatchDate", "gcCresidentExpiryDate", "visaTransferDate"
        ]
        if (key && key != "" && keys.includes(key)) {
          return value?.replace('Z', '');
        }
        return value; // TODO: Transform value if necessary
      };

    }  

    eligibleVisaTypes(lookupTypeId: number, parentId: number | null | undefined, filterKey: number | null | undefined): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Immigration/EligibleVisaTypes/{lookupTypeId}?";
        if (lookupTypeId === undefined || lookupTypeId === null)
            throw new Error("The parameter 'lookupTypeId' must be defined.");
        url_ = url_.replace("{lookupTypeId}", encodeURIComponent("" + lookupTypeId));
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEligibleVisaTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEligibleVisaTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processEligibleVisaTypes(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardLink(countryId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/Immigration/GetDashboardLink/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDashboardLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    immigrationProfile(profileId: number): Observable<ImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/ImmigrationProfile/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImmigrationProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImmigrationProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationProfile>;
        }));
    }

    protected processImmigrationProfile(response: HttpResponseBase): Observable<ImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    renewProfile(profileId: number): Observable<ImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/RenewProfile/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationProfile>;
        }));
    }

    protected processRenewProfile(response: HttpResponseBase): Observable<ImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllRequests(country: string | null, sortParameters: SortParameters): Observable<CandidateGridInfo> {
        let url_ = this.baseUrl + "/api/Immigration/ImmigrationProfile/{country}";
        if (country === undefined || country === null)
            throw new Error("The parameter 'country' must be defined.");
        url_ = url_.replace("{country}", encodeURIComponent("" + country));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateGridInfo>;
        }));
    }

    protected processGetAllRequests(response: HttpResponseBase): Observable<CandidateGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetActivities(candidate: ImmigrationProfile): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Immigration/ResetActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processResetActivities(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acceptProfile(candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/AcceptProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfile>;
        }));
    }

    protected processAcceptProfile(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    declineProfile(candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/DeclineProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfile>;
        }));
    }

    protected processDeclineProfile(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    withdraw(candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/Withdraw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdraw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdraw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfile>;
        }));
    }

    protected processWithdraw(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveProfile(isApprove: boolean | undefined, candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/ApproveProfile?";
        if (isApprove === null)
            throw new Error("The parameter 'isApprove' cannot be null.");
        else if (isApprove !== undefined)
            url_ += "isApprove=" + encodeURIComponent("" + isApprove) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfile>;
        }));
    }

    protected processApproveProfile(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectProfile(candidate: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/RejectProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfile>;
        }));
    }

    protected processRejectProfile(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfiles(visaType: string | null, country: string | null, sortParameters: SortParameters): Observable<CandidateGridInfo> {
        let url_ = this.baseUrl + "/api/Immigration/GetProfiles/{visaType}/{country}";
        if (visaType === undefined || visaType === null)
            throw new Error("The parameter 'visaType' must be defined.");
        url_ = url_.replace("{visaType}", encodeURIComponent("" + visaType));
        if (country === undefined || country === null)
            throw new Error("The parameter 'country' must be defined.");
        url_ = url_.replace("{country}", encodeURIComponent("" + country));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateGridInfo>;
        }));
    }

    protected processGetProfiles(response: HttpResponseBase): Observable<CandidateGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkVisaApproverAccess(country: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Immigration/CheckVisaApproverAccess/{country}";
        if (country === undefined || country === null)
            throw new Error("The parameter 'country' must be defined.");
        url_ = url_.replace("{country}", encodeURIComponent("" + country));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckVisaApproverAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckVisaApproverAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckVisaApproverAccess(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveRequest(immigrationProfile: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/SaveRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(immigrationProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfile>;
        }));
    }

    protected processSaveRequest(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveRequestTeam(team: string | null, submitProfile: boolean | undefined, immigrationProfile: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/SaveRequestTeam?";
        if (team === undefined)
            throw new Error("The parameter 'team' must be defined.");
        else if(team !== null)
            url_ += "team=" + encodeURIComponent("" + team) + "&";
        if (submitProfile === null)
            throw new Error("The parameter 'submitProfile' cannot be null.");
        else if (submitProfile !== undefined)
            url_ += "submitProfile=" + encodeURIComponent("" + submitProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(immigrationProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRequestTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRequestTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfile>;
        }));
    }

    protected processSaveRequestTeam(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveProfile(submitProfile: boolean | undefined, immigrationProfile: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/SaveProfile?";
        if (submitProfile === null)
            throw new Error("The parameter 'submitProfile' cannot be null.");
        else if (submitProfile !== undefined)
            url_ += "submitProfile=" + encodeURIComponent("" + submitProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(immigrationProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfile>;
        }));
    }

    protected processSaveProfile(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentsUpload(): Observable<OperationResultOfImmigrationDocument> {
        let url_ = this.baseUrl + "/api/Immigration/DocumentsUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationDocument>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationDocument>;
        }));
    }

    protected processDocumentsUpload(response: HttpResponseBase): Observable<OperationResultOfImmigrationDocument> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationDocument.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttachmentsDetails(profileId: number, activityId: number, activityTemplateId: number): Observable<ImmigrationEmailAttachments[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetAttachmentsDetails?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (activityTemplateId === undefined || activityTemplateId === null)
            throw new Error("The parameter 'activityTemplateId' must be defined and cannot be null.");
        else
            url_ += "activityTemplateId=" + encodeURIComponent("" + activityTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationEmailAttachments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationEmailAttachments[]>;
        }));
    }

    protected processGetAttachmentsDetails(response: HttpResponseBase): Observable<ImmigrationEmailAttachments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationEmailAttachments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAttachment(emailAttachments: ImmigrationEmailAttachments): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Immigration/DeleteAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProfile(id: number): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Immigration/DeleteImmigrationProfile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processDeleteProfile(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEligibleDocuments(visaType: string | null, countryType: string | null, isApprover: boolean, request: ImmigrationProfile): Observable<ImmigrationDocumentType[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetEligibleDocuments/{visaType}/{countryType}?";
        if (visaType === undefined || visaType === null)
            throw new Error("The parameter 'visaType' must be defined.");
        url_ = url_.replace("{visaType}", encodeURIComponent("" + visaType));
        if (countryType === undefined || countryType === null)
            throw new Error("The parameter 'countryType' must be defined.");
        url_ = url_.replace("{countryType}", encodeURIComponent("" + countryType));
        if (isApprover === undefined || isApprover === null)
            throw new Error("The parameter 'isApprover' must be defined and cannot be null.");
        else
            url_ += "isApprover=" + encodeURIComponent("" + isApprover) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibleDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibleDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationDocumentType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationDocumentType[]>;
        }));
    }

    protected processGetEligibleDocuments(response: HttpResponseBase): Observable<ImmigrationDocumentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationDocumentType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEligibleAdditionalDocuments(profileId: number): Observable<ImmigrationDocCombined[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetEligibleAdditionalDocuments/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibleAdditionalDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibleAdditionalDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationDocCombined[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationDocCombined[]>;
        }));
    }

    protected processGetEligibleAdditionalDocuments(response: HttpResponseBase): Observable<ImmigrationDocCombined[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationDocCombined.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImmigrationDocuments(visaType: string | null, countryType: string | null, isApprover: boolean, request: ImmigrationProfile): Observable<ImmigrationDocCombined[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetImmigrationDocuments/{visaType}/{countryType}?";
        if (visaType === undefined || visaType === null)
            throw new Error("The parameter 'visaType' must be defined.");
        url_ = url_.replace("{visaType}", encodeURIComponent("" + visaType));
        if (countryType === undefined || countryType === null)
            throw new Error("The parameter 'countryType' must be defined.");
        url_ = url_.replace("{countryType}", encodeURIComponent("" + countryType));
        if (isApprover === undefined || isApprover === null)
            throw new Error("The parameter 'isApprover' must be defined and cannot be null.");
        else
            url_ += "isApprover=" + encodeURIComponent("" + isApprover) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImmigrationDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImmigrationDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationDocCombined[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationDocCombined[]>;
        }));
    }

    protected processGetImmigrationDocuments(response: HttpResponseBase): Observable<ImmigrationDocCombined[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationDocCombined.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentDetails(id: number, type: number): Observable<ImmigrationDocument[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetDocumentDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationDocument[]>;
        }));
    }

    protected processGetDocumentDetails(response: HttpResponseBase): Observable<ImmigrationDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationDocument.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDocumentDetails(id: number): Observable<ImmigrationDocument[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetAllDocumentDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDocumentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationDocument[]>;
        }));
    }

    protected processGetAllDocumentDetails(response: HttpResponseBase): Observable<ImmigrationDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationDocument.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(immigrationDocument: ImmigrationDocument): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Immigration/DocumentDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(immigrationDocument);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAll(id: number, typeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Immigration/DownloadAll?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downLoadDocumentFile(fileName: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Immigration/DownLoadDocumentFile?";
        if (fileName === undefined)
            throw new Error("The parameter 'fileName' must be defined.");
        else if(fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownLoadDocumentFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downLoadFile(document: ImmigrationDocument): Observable<void> {
        let url_ = this.baseUrl + "/api/Immigration/DocumentDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(document);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownLoadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    immigrationProfileActivities(immigrationProfileId: number): Observable<ProfileActivities> {
        let url_ = this.baseUrl + "/api/Immigration/{ImmigrationProfileId}/activities";
        if (immigrationProfileId === undefined || immigrationProfileId === null)
            throw new Error("The parameter 'immigrationProfileId' must be defined.");
        url_ = url_.replace("{ImmigrationProfileId}", encodeURIComponent("" + immigrationProfileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImmigrationProfileActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImmigrationProfileActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileActivities>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileActivities>;
        }));
    }

    protected processImmigrationProfileActivities(response: HttpResponseBase): Observable<ProfileActivities> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileActivities.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateImmigrationActivity(immID: number, profileActivityID: number, status: ActivityStatus): Observable<ImmigrationProfileActivity> {
        let url_ = this.baseUrl + "/api/Immigration/UpdateImmigrationActivity?";
        if (immID === undefined || immID === null)
            throw new Error("The parameter 'immID' must be defined and cannot be null.");
        else
            url_ += "immID=" + encodeURIComponent("" + immID) + "&";
        if (profileActivityID === undefined || profileActivityID === null)
            throw new Error("The parameter 'profileActivityID' must be defined and cannot be null.");
        else
            url_ += "profileActivityID=" + encodeURIComponent("" + profileActivityID) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateImmigrationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateImmigrationActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationProfileActivity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationProfileActivity>;
        }));
    }

    protected processUpdateImmigrationActivity(response: HttpResponseBase): Observable<ImmigrationProfileActivity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationProfileActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAttachment(emailAttachments: ImmigrationEmailAttachments): Observable<void> {
        let url_ = this.baseUrl + "/api/Immigration/DownloadAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachmentsUpload(): Observable<OperationResultOfImmigrationEmailAttachments> {
        let url_ = this.baseUrl + "/api/Immigration/AttachmentsUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationEmailAttachments>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationEmailAttachments>;
        }));
    }

    protected processAttachmentsUpload(response: HttpResponseBase): Observable<OperationResultOfImmigrationEmailAttachments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationEmailAttachments.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markProfileAsComplete(immigrationProfileId: number): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Immigration/MarkProfileAsComplete?";
        if (immigrationProfileId === undefined || immigrationProfileId === null)
            throw new Error("The parameter 'immigrationProfileId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileId=" + encodeURIComponent("" + immigrationProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkProfileAsComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkProfileAsComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processMarkProfileAsComplete(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportReportToCSV(visaType: string | null, filterParameters: FilterParams): Observable<void> {
        let url_ = this.baseUrl + "/api/Immigration/ExportImmigrationReport?";
        if (visaType === undefined)
            throw new Error("The parameter 'visaType' must be defined.");
        else if(visaType !== null)
            url_ += "visaType=" + encodeURIComponent("" + visaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportToCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportToCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportReportToCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    canUserViewThisRequest(requestId: number, countryValue: string | null, visaType: string | null, activeRoleId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Immigration/CanUserViewThisRequest?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (countryValue === undefined)
            throw new Error("The parameter 'countryValue' must be defined.");
        else if(countryValue !== null)
            url_ += "countryValue=" + encodeURIComponent("" + countryValue) + "&";
        if (visaType === undefined)
            throw new Error("The parameter 'visaType' must be defined.");
        else if(visaType !== null)
            url_ += "visaType=" + encodeURIComponent("" + visaType) + "&";
        if (activeRoleId === undefined || activeRoleId === null)
            throw new Error("The parameter 'activeRoleId' must be defined and cannot be null.");
        else
            url_ += "ActiveRoleId=" + encodeURIComponent("" + activeRoleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanUserViewThisRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanUserViewThisRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanUserViewThisRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isImmigrationExists(immigrationID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Immigration/IsImmigrationExists?";
        if (immigrationID === undefined || immigrationID === null)
            throw new Error("The parameter 'immigrationID' must be defined and cannot be null.");
        else
            url_ += "immigrationID=" + encodeURIComponent("" + immigrationID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsImmigrationExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsImmigrationExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsImmigrationExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportProcessorReport(processorId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Immigration/ExportProcessorRequests?";
        if (processorId === undefined || processorId === null)
            throw new Error("The parameter 'processorId' must be defined and cannot be null.");
        else
            url_ += "processorId=" + encodeURIComponent("" + processorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProcessorReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProcessorReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportProcessorReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPJCReport(pjcId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Immigration/ExportPJCRequests?";
        if (pjcId === undefined || pjcId === null)
            throw new Error("The parameter 'pjcId' must be defined and cannot be null.");
        else
            url_ += "pjcId=" + encodeURIComponent("" + pjcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPJCReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPJCReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportPJCReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cloneProfile(immigrationProfile: ImmigrationCandidate): Observable<OperationResultOfImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/CloneProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(immigrationProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfile>;
        }));
    }

    protected processCloneProfile(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportImmigrationActivity(immigrationProfileId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Immigration/ExportImmigrationActivity?";
        if (immigrationProfileId === undefined || immigrationProfileId === null)
            throw new Error("The parameter 'immigrationProfileId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileId=" + encodeURIComponent("" + immigrationProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportImmigrationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportImmigrationActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportImmigrationActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachCandidateDocsToMail(emailAttachments: ImmigrationEmailAttachments[]): Observable<ImmigrationEmailAttachments[]> {
        let url_ = this.baseUrl + "/api/Immigration/AttachCandidateDocsToMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachCandidateDocsToMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachCandidateDocsToMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationEmailAttachments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationEmailAttachments[]>;
        }));
    }

    protected processAttachCandidateDocsToMail(response: HttpResponseBase): Observable<ImmigrationEmailAttachments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationEmailAttachments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentInstructions(visaType: string | null, profileId: number, isApprover: boolean, nationalId: number): Observable<DocumentInstructions[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetDocumentInstructions/{visaType}/{profileId}?";
        if (visaType === undefined || visaType === null)
            throw new Error("The parameter 'visaType' must be defined.");
        url_ = url_.replace("{visaType}", encodeURIComponent("" + visaType));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (isApprover === undefined || isApprover === null)
            throw new Error("The parameter 'isApprover' must be defined and cannot be null.");
        else
            url_ += "isApprover=" + encodeURIComponent("" + isApprover) + "&";
        if (nationalId === undefined || nationalId === null)
            throw new Error("The parameter 'nationalId' must be defined and cannot be null.");
        else
            url_ += "nationalId=" + encodeURIComponent("" + nationalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentInstructions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentInstructions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentInstructions[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentInstructions[]>;
        }));
    }

    protected processGetDocumentInstructions(response: HttpResponseBase): Observable<DocumentInstructions[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentInstructions.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequestMileStones(immProfileId: number, countryCode: string | null): Observable<ImmigrationProfileMiletones[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetRequestMileStones?";
        if (immProfileId === undefined || immProfileId === null)
            throw new Error("The parameter 'immProfileId' must be defined and cannot be null.");
        else
            url_ += "ImmProfileId=" + encodeURIComponent("" + immProfileId) + "&";
        if (countryCode === undefined)
            throw new Error("The parameter 'countryCode' must be defined.");
        else if(countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestMileStones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestMileStones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationProfileMiletones[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationProfileMiletones[]>;
        }));
    }

    protected processGetRequestMileStones(response: HttpResponseBase): Observable<ImmigrationProfileMiletones[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationProfileMiletones.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImmigrationInfoMin(immProfileId: number): Observable<ImmigrationInfoMin> {
        let url_ = this.baseUrl + "/api/Immigration/GetImmigrationInfoMin?";
        if (immProfileId === undefined || immProfileId === null)
            throw new Error("The parameter 'immProfileId' must be defined and cannot be null.");
        else
            url_ += "ImmProfileId=" + encodeURIComponent("" + immProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImmigrationInfoMin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImmigrationInfoMin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationInfoMin>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationInfoMin>;
        }));
    }

    protected processGetImmigrationInfoMin(response: HttpResponseBase): Observable<ImmigrationInfoMin> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationInfoMin.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequestedImmDocuments(immigrationProfileId: number): Observable<ImmAdditionalDocRequests[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetRequestedImmDocuments?";
        if (immigrationProfileId === undefined || immigrationProfileId === null)
            throw new Error("The parameter 'immigrationProfileId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileId=" + encodeURIComponent("" + immigrationProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestedImmDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestedImmDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmAdditionalDocRequests[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmAdditionalDocRequests[]>;
        }));
    }

    protected processGetRequestedImmDocuments(response: HttpResponseBase): Observable<ImmAdditionalDocRequests[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmAdditionalDocRequests.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestImmAdditionalDocuments(profileId: number, processorId: number, reqList: ImmAdditionalDocRequests[]): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Immigration/RequestImmAdditionalDocuments?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (processorId === undefined || processorId === null)
            throw new Error("The parameter 'processorId' must be defined and cannot be null.");
        else
            url_ += "processorId=" + encodeURIComponent("" + processorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reqList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestImmAdditionalDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestImmAdditionalDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processRequestImmAdditionalDocuments(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadAdditionalDocs(profileId: number): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Immigration/uploadAdditionalDocs?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAdditionalDocs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAdditionalDocs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processUploadAdditionalDocs(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    additionalDocUploadPageStatus(immigrationProfileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Immigration/AdditionalDocUploadPageStatus?";
        if (immigrationProfileId === undefined || immigrationProfileId === null)
            throw new Error("The parameter 'immigrationProfileId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileId=" + encodeURIComponent("" + immigrationProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdditionalDocUploadPageStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdditionalDocUploadPageStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAdditionalDocUploadPageStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    milestoneAccess(immigrationProfileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Immigration/milestoneAccess?";
        if (immigrationProfileId === undefined || immigrationProfileId === null)
            throw new Error("The parameter 'immigrationProfileId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileId=" + encodeURIComponent("" + immigrationProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMilestoneAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMilestoneAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMilestoneAccess(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailOfRequestor(profile: ImmigrationProfile): Observable<string> {
        let url_ = this.baseUrl + "/api/Immigration/GetEmailOfRequestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailOfRequestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailOfRequestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEmailOfRequestor(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sentSurveyMail(immigrationProfileId: number): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Immigration/SentSurveyMail?";
        if (immigrationProfileId === undefined || immigrationProfileId === null)
            throw new Error("The parameter 'immigrationProfileId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileId=" + encodeURIComponent("" + immigrationProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSentSurveyMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSentSurveyMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSentSurveyMail(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancellationVisa(request: ExitVisaRequest): Observable<OperationResultOfExitRequest> {
        let url_ = this.baseUrl + "/api/Immigration/CancellationVisa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancellationVisa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancellationVisa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfExitRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfExitRequest>;
        }));
    }

    protected processCancellationVisa(response: HttpResponseBase): Observable<OperationResultOfExitRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfExitRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkCandidatePTC(profileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Immigration/CheckCandidatePTC?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCandidatePTC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCandidatePTC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCandidatePTC(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVisasWithGpnGuiWarning(visaTypeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Immigration/GetVisasWithGpnGuiWarning?";
        if (visaTypeId === undefined || visaTypeId === null)
            throw new Error("The parameter 'visaTypeId' must be defined and cannot be null.");
        else
            url_ += "visaTypeId=" + encodeURIComponent("" + visaTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisasWithGpnGuiWarning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisasWithGpnGuiWarning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetVisasWithGpnGuiWarning(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImmActivityById(activityId: number): Observable<ImmigrationActivity> {
        let url_ = this.baseUrl + "/api/Immigration/GetImmActivityById?";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImmActivityById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImmActivityById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationActivity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationActivity>;
        }));
    }

    protected processGetImmActivityById(response: HttpResponseBase): Observable<ImmigrationActivity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentsUploadedCheck(immProfieId: number, activityId: number): Observable<ImmigrationDocumentCheck[]> {
        let url_ = this.baseUrl + "/api/Immigration/DocumentsUploadedCheck?";
        if (immProfieId === undefined || immProfieId === null)
            throw new Error("The parameter 'immProfieId' must be defined and cannot be null.");
        else
            url_ += "immProfieId=" + encodeURIComponent("" + immProfieId) + "&";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsUploadedCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsUploadedCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationDocumentCheck[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationDocumentCheck[]>;
        }));
    }

    protected processDocumentsUploadedCheck(response: HttpResponseBase): Observable<ImmigrationDocumentCheck[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationDocumentCheck.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateImmigrationActivityFromProfile(immigrationProfileId: number, profileActivityID: number, status: ActivityStatus): Observable<OperationResultOfImmigrationProfileActivity> {
        let url_ = this.baseUrl + "/api/Immigration/UpdateImmigrationActivityFromProfile?";
        if (immigrationProfileId === undefined || immigrationProfileId === null)
            throw new Error("The parameter 'immigrationProfileId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileId=" + encodeURIComponent("" + immigrationProfileId) + "&";
        if (profileActivityID === undefined || profileActivityID === null)
            throw new Error("The parameter 'profileActivityID' must be defined and cannot be null.");
        else
            url_ += "profileActivityID=" + encodeURIComponent("" + profileActivityID) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateImmigrationActivityFromProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateImmigrationActivityFromProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfImmigrationProfileActivity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfImmigrationProfileActivity>;
        }));
    }

    protected processUpdateImmigrationActivityFromProfile(response: HttpResponseBase): Observable<OperationResultOfImmigrationProfileActivity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfImmigrationProfileActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLatestImmigrationId(visaTypeId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Immigration/GetLatestImmigrationId?";
        if (visaTypeId === undefined || visaTypeId === null)
            throw new Error("The parameter 'visaTypeId' must be defined and cannot be null.");
        else
            url_ += "visaTypeId=" + encodeURIComponent("" + visaTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestImmigrationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestImmigrationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLatestImmigrationId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocationFieldAccessibility(module: string | null): Observable<LocationFieldAccessibility[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetLocationFieldAccessibility?";
        if (module === undefined)
            throw new Error("The parameter 'module' must be defined.");
        else if(module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationFieldAccessibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationFieldAccessibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationFieldAccessibility[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationFieldAccessibility[]>;
        }));
    }

    protected processGetLocationFieldAccessibility(response: HttpResponseBase): Observable<LocationFieldAccessibility[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationFieldAccessibility.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createImmVisaPreApprovalRequest(profileId: number, isCancelled: boolean | undefined): Observable<ImmigrationProfile> {
        let url_ = this.baseUrl + "/api/Immigration/CreateImmVisaPreApprovalRequest/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (isCancelled === null)
            throw new Error("The parameter 'isCancelled' cannot be null.");
        else if (isCancelled !== undefined)
            url_ += "isCancelled=" + encodeURIComponent("" + isCancelled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateImmVisaPreApprovalRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateImmVisaPreApprovalRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationProfile>;
        }));
    }

    protected processCreateImmVisaPreApprovalRequest(response: HttpResponseBase): Observable<ImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRenewalVisas(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Immigration/GetRenewalVisas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenewalVisas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenewalVisas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetRenewalVisas(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editCompletedImmProfile(immProfileId: number, isProfileCompleted: boolean, isEditable: boolean, candidate: ImmigrationCandidate): Observable<string> {
        let url_ = this.baseUrl + "/api/Immigration/EditCompletedImmProfile?";
        if (immProfileId === undefined || immProfileId === null)
            throw new Error("The parameter 'immProfileId' must be defined and cannot be null.");
        else
            url_ += "immProfileId=" + encodeURIComponent("" + immProfileId) + "&";
        if (isProfileCompleted === undefined || isProfileCompleted === null)
            throw new Error("The parameter 'isProfileCompleted' must be defined and cannot be null.");
        else
            url_ += "isProfileCompleted=" + encodeURIComponent("" + isProfileCompleted) + "&";
        if (isEditable === undefined || isEditable === null)
            throw new Error("The parameter 'isEditable' must be defined and cannot be null.");
        else
            url_ += "isEditable=" + encodeURIComponent("" + isEditable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCompletedImmProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCompletedImmProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEditCompletedImmProfile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Immigration?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IImmigrationDatapullApi {
    pullDocumentsFromProfile(visaType: string | null, countryType: string | null, isApprover: boolean, visaRequestModel: ImmigrationProfile): Observable<number>;
    unlinkSyncedImmigrationFile(immigrationDocuments: ImmigrationDocument): Observable<boolean>;
    profileDataFromGpnGui(gPN: string | null | undefined, gUI: string | null | undefined, visaType: string | null | undefined, email: string | null | undefined): Observable<ImmigrationProfile>;
    profileDataFromGpnGuiWithMerrRankGrade(gPN: string | null | undefined, gUI: string | null | undefined, visaType: string | null | undefined, email: string | null | undefined): Observable<ImmigrationProfile>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ImmigrationDatapullApi implements IImmigrationDatapullApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    pullDocumentsFromProfile(visaType: string | null, countryType: string | null, isApprover: boolean, visaRequestModel: ImmigrationProfile): Observable<number> {
        let url_ = this.baseUrl + "/api/ImmigrationDatapull/SyncDocuments?";
        if (visaType === undefined)
            throw new Error("The parameter 'visaType' must be defined.");
        else if(visaType !== null)
            url_ += "visaType=" + encodeURIComponent("" + visaType) + "&";
        if (countryType === undefined)
            throw new Error("The parameter 'countryType' must be defined.");
        else if(countryType !== null)
            url_ += "countryType=" + encodeURIComponent("" + countryType) + "&";
        if (isApprover === undefined || isApprover === null)
            throw new Error("The parameter 'isApprover' must be defined and cannot be null.");
        else
            url_ += "isApprover=" + encodeURIComponent("" + isApprover) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(visaRequestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPullDocumentsFromProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPullDocumentsFromProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPullDocumentsFromProfile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unlinkSyncedImmigrationFile(immigrationDocuments: ImmigrationDocument): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ImmigrationDatapull/UnLinkSynced";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(immigrationDocuments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkSyncedImmigrationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkSyncedImmigrationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUnlinkSyncedImmigrationFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    profileDataFromGpnGui(gPN: string | null | undefined, gUI: string | null | undefined, visaType: string | null | undefined, email: string | null | undefined): Observable<ImmigrationProfile> {
        let url_ = this.baseUrl + "/api/ImmigrationDatapull/ProfileDataFromGpnGui?";
        if (gPN !== undefined && gPN !== null)
            url_ += "GPN=" + encodeURIComponent("" + gPN) + "&";
        if (gUI !== undefined && gUI !== null)
            url_ += "GUI=" + encodeURIComponent("" + gUI) + "&";
        if (visaType !== undefined && visaType !== null)
            url_ += "visaType=" + encodeURIComponent("" + visaType) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileDataFromGpnGui(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileDataFromGpnGui(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationProfile>;
        }));
    }

    protected processProfileDataFromGpnGui(response: HttpResponseBase): Observable<ImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    profileDataFromGpnGuiWithMerrRankGrade(gPN: string | null | undefined, gUI: string | null | undefined, visaType: string | null | undefined, email: string | null | undefined): Observable<ImmigrationProfile> {
        let url_ = this.baseUrl + "/api/ImmigrationDatapull/ProfileDataFromGpnGuiWithMerrRankGrade?";
        if (gPN !== undefined && gPN !== null)
            url_ += "GPN=" + encodeURIComponent("" + gPN) + "&";
        if (gUI !== undefined && gUI !== null)
            url_ += "GUI=" + encodeURIComponent("" + gUI) + "&";
        if (visaType !== undefined && visaType !== null)
            url_ += "visaType=" + encodeURIComponent("" + visaType) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileDataFromGpnGuiWithMerrRankGrade(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileDataFromGpnGuiWithMerrRankGrade(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationProfile>;
        }));
    }

    protected processProfileDataFromGpnGuiWithMerrRankGrade(response: HttpResponseBase): Observable<ImmigrationProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/ImmigrationDatapull?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IValidationApi {
    getChargeCodeDetails(chargeCode: string | null): Observable<ChargeCodes>;
    getCCDetails(chargeCode: string | null): Observable<ChargeCodeDetails>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ValidationApi implements IValidationApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getChargeCodeDetails(chargeCode: string | null): Observable<ChargeCodes> {
        let url_ = this.baseUrl + "/api/Validation/GetChargeCodeDetails/{ChargeCode}";
        if (chargeCode === undefined || chargeCode === null)
            throw new Error("The parameter 'chargeCode' must be defined.");
        url_ = url_.replace("{ChargeCode}", encodeURIComponent("" + chargeCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChargeCodeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChargeCodeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChargeCodes>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChargeCodes>;
        }));
    }

    protected processGetChargeCodeDetails(response: HttpResponseBase): Observable<ChargeCodes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChargeCodes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCCDetails(chargeCode: string | null): Observable<ChargeCodeDetails> {
        let url_ = this.baseUrl + "/api/Validation/GetCCDetails/{ChargeCode}";
        if (chargeCode === undefined || chargeCode === null)
            throw new Error("The parameter 'chargeCode' must be defined.");
        url_ = url_.replace("{ChargeCode}", encodeURIComponent("" + chargeCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCCDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCCDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChargeCodeDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChargeCodeDetails>;
        }));
    }

    protected processGetCCDetails(response: HttpResponseBase): Observable<ChargeCodeDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChargeCodeDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Validation?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAuditHistoryApi {
    candidatePriority(candidateProfileId: number, module: string | null, pageNumber: number, currentAmendedProfileId: number | undefined): Observable<AuditHistoryData>;
    immigrationPriority(requestId: number, pageNumber: number, currentAmendedProfileId: number | undefined): Observable<AuditHistoryData>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class AuditHistoryApi implements IAuditHistoryApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    candidatePriority(candidateProfileId: number, module: string | null, pageNumber: number, currentAmendedProfileId: number | undefined): Observable<AuditHistoryData> {
        let url_ = this.baseUrl + "/api/AuditHistory/CandidatePriority?";
        if (candidateProfileId === undefined || candidateProfileId === null)
            throw new Error("The parameter 'candidateProfileId' must be defined and cannot be null.");
        else
            url_ += "CandidateProfileId=" + encodeURIComponent("" + candidateProfileId) + "&";
        if (module === undefined)
            throw new Error("The parameter 'module' must be defined.");
        else if(module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (currentAmendedProfileId === null)
            throw new Error("The parameter 'currentAmendedProfileId' cannot be null.");
        else if (currentAmendedProfileId !== undefined)
            url_ += "CurrentAmendedProfileId=" + encodeURIComponent("" + currentAmendedProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidatePriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidatePriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditHistoryData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditHistoryData>;
        }));
    }

    protected processCandidatePriority(response: HttpResponseBase): Observable<AuditHistoryData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditHistoryData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    immigrationPriority(requestId: number, pageNumber: number, currentAmendedProfileId: number | undefined): Observable<AuditHistoryData> {
        let url_ = this.baseUrl + "/api/AuditHistory/ImmigrationPriority?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (currentAmendedProfileId === null)
            throw new Error("The parameter 'currentAmendedProfileId' cannot be null.");
        else if (currentAmendedProfileId !== undefined)
            url_ += "CurrentAmendedProfileId=" + encodeURIComponent("" + currentAmendedProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImmigrationPriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImmigrationPriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditHistoryData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditHistoryData>;
        }));
    }

    protected processImmigrationPriority(response: HttpResponseBase): Observable<AuditHistoryData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditHistoryData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/AuditHistory?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBotApi {
    getBotToken(): Observable<OperationResultOfString>;
    getSpeechToken(): Observable<OperationResultOfString>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class BotApi implements IBotApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getBotToken(): Observable<OperationResultOfString> {
        let url_ = this.baseUrl + "/api/Bot/getbottoken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBotToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBotToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfString>;
        }));
    }

    protected processGetBotToken(response: HttpResponseBase): Observable<OperationResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpeechToken(): Observable<OperationResultOfString> {
        let url_ = this.baseUrl + "/api/Bot/getspeechtoken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeechToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeechToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfString>;
        }));
    }

    protected processGetSpeechToken(response: HttpResponseBase): Observable<OperationResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Bot?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICandidateApi {
    getCandidateProfiles(sortParameters: SortParameters): Observable<CandidateGridInfo>;
    getCandidateProfilesForPTC(sortParameters: SortParameters): Observable<CandidateGridInfo>;
    attachCandidateDocsToMail(emailAttachments: EmailAttachments[]): Observable<EmailAttachments[]>;
    saveFilterParams(module: string | null, filterParams: FilterParams): Observable<FilterParams>;
    saveProfile(submitProfile: boolean | undefined, candidateProfile: CandidateProfile): Observable<OperationResultOfCandidateProfile>;
    getCandidateProfile(id: number): Observable<CandidateProfile>;
    deleteProfile(id: number): Observable<OperationResultOfInteger>;
    getCandidateDocsDetails(id: number): Observable<CandidateDocuments[]>;
    documentsUpload(): Observable<OperationResultOfCandidateDocuments>;
    getAttachmentsDetails(profileId: number, activityId: number, activityTemplateId: number): Observable<EmailAttachments[]>;
    downloadAttachment(emailAttachments: EmailAttachments): Observable<void>;
    deleteAttachment(emailAttachments: EmailAttachments): Observable<boolean>;
    attachmentsDownloadAll(id: number, typeId: number | undefined): Observable<void>;
    attachmentsUpload(): Observable<OperationResultOfEmailAttachments>;
    downLoadDocumentFile(fileName: string | null): Observable<void>;
    downloadAttachmentFile(fileName: string | null): Observable<void>;
    downLoadFile(candidateDocuments: CandidateDocuments): Observable<void>;
    deleteFile(candidateDocuments: CandidateDocuments): Observable<boolean>;
    downloadAll(id: number, module: string | null): Observable<void>;
    approveProfile(profile: CombainedProfile): Observable<OperationResultOfCombainedProfile>;
    rejectProfile(candidateId: number, comment: Comments): Observable<OperationResultOfInteger>;
    exportReportToCSV(isRecruitment: boolean, filterParameters: FilterParams): Observable<void>;
    exportTimelineReportToCSV(officelocationCountryId: number, filterParameters: FilterParams): Observable<void>;
    getCombainedProfile(candidateId: number): Observable<CombainedProfile>;
    getProfileForBuddyCounselor(candidateId: number): Observable<CombainedProfile>;
    filePreview(guid: string | null, filename: string | null): Observable<void>;
    getRequiredDocuments(module: string | null, flightBooking: boolean, profile: CandidateProfile): Observable<DocumentType[]>;
    getCandidateDocuments(module: string | null, flightBooking: boolean, profile: CandidateProfile): Observable<CandidateDocCombined[]>;
    getRequestableDocuments(profileId: number, module: string | null): Observable<DocumentType[]>;
    requestCandiateDocuments(profileId: number, reqList: CandidateAdditionDocumentRequest[]): Observable<OperationResultOfBoolean>;
    requestPendingDocuments(profileId: number, reqList: CandidateAdditionDocumentRequest[]): Observable<OperationResultOfBoolean>;
    removePendingDocument(docId: number): Observable<OperationResultOfBoolean>;
    getRequestedDocuments(candidateProfileId: number): Observable<CandidateAdditionDocumentRequest[]>;
    getPendingDocuments(candidateProfileId: number): Observable<CandidatePendingDocumentRequest[]>;
    inviteForRecuriment(isInvited: boolean, candidateProfile: CandidateProfile): Observable<OperationResultOfCandidateProfile>;
    resetPasswordAndsendMail(candidateId: number): Observable<OperationResultOfBoolean>;
    cancelInvite(candidateId: number, comment: Comments): Observable<OperationResultOfBoolean>;
    getPJDocumentInstructions(profile: CandidateProfile): Observable<DocumentInstructions[]>;
    checkAccess(candidateId: number, isComment: boolean): Observable<boolean>;
    getHMDetails(profileId: number): Observable<boolean>;
    getEADetails(profileId: number): Observable<boolean>;
    saveVisaDesignation(cpId: number, combainedProfile: CombainedProfile): Observable<CandidateProfile>;
    getKSAVisaApproverDetails(profileId: number): Observable<boolean>;
    checkEmployeeTravelRole(profileId: number): Observable<boolean>;
    getLookupFieldsByTypePbprofileId(lookupTypeId: number, profileId: number): Observable<LookupField[]>;
    getCandidateImmCaseType(lookupTypeId: number, candidateId: number): Observable<LookupField[]>;
    getCandidateMinDetails(candidateProfileId: number): Observable<CandidateInfoMin>;
    getEAallocators(): Observable<EAAllocator[]>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CandidateApi implements ICandidateApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    this.jsonParseReviver = (key: string, value: any) => {
      let keys = ["startDate", "dateOfBirth", "passportExpiryDate", "currentVisaExpiryDate", "earliestJoiningDate",
        "cnicExpiryDate", "travellingDate", "transferDate", "pbInitiationdatebyPTC", "marriageEffectiveDate", "lastWorkingday", "epRequestedDate",
        "epCreatedDate", "startdate", "confirmedEnddate", "eyApprovedVisaDate", "entryPermitExpiryDate", "attestationCompletedDate",
        "lastEmployerStartDate", "lastEmployerEndDate", "documentExpectedDate", "educationDocumentProcurementforAttestationRequestInitiatedDate",
        "educationDocumentProcurementforAttestationDocumentscollectedDate",
        "educationDocumentProcurementforAttestationAssesmentDate",
        "educationDocumentProcurementforAttestationCompletedDate",
        "documentProcurementforWorkPermitInitiatedDate",
        "documentProcurementforWorkPermitCollectedDate",
        "documentProcurementforWorkPermitAssesmentDate",
        "documentProcurementforWorkPermitCompletedDate",
        "educationDocumentAttestationInitiatedDate",
        "educationDocumentAttestationUnderProcessDate",
        "educationDocumentAttestationCompletedDate",
        "exceptionApprovalWorkPermitInitiatedDate",
        "exceptionApprovalWorkPermitApprovalReceivedDate",
        "corporateDocumentInitiatedDate",
        "corporateDocumentReceivedByVendorDate",
        "corporateDocumentAssesmentDate",
        "corporateDocumentCompletedDate",
        "visaReTaggingInitiatedDate",
        "visaReTaggingCompletedDate",
        "revisedCorporateDocumentInitiatedDate",
        "revisedCorporateDocumentReceivedByVendorDate",
        "revisedCorporateDocumentAssesmentDate",
        "revisedCorporateDocumentCompletedDate",
        "mosadaqaInitiatedDate",
        "mosadaqaUnderProcessDate",
        "mosadaqaCompletedDate",
        "qvpInitiatedDate",
        "qvpUnderProcessDate",
        "qvpCompletedDate",
        "professionalMembershipCertificateInitiatedDate",
        "professionalMembershipCertificateUnderProcessDate",
        "professionalMembershipCertificateCompletedDate",
        "businessVisaCancellationLetterInitiatedDate",
        "businessVisaCancellationLetterCompletedDate",
        "wpApplicationNJMedicalAppointmentDate",
        "wpApplicationNJMedicalProcessCompletedDate",
        "wpApplicationNJPCCAppointmentDate",
        "wpApplicationNJPCCProcessCompletedDate",
        "wpApplicationNJBiometricsAppointmentDate",
        "wpApplicationNJBiometricsProcessCompletedDate",
        "wpApplicationNJHomeCountryVisaStampingProcessDate",
        "wpApplicationNJHomeVisaStampedIssuedDate",
        "wpApplicationEYInitiatedDate",
        "wpApplicationEYQVCAppointmentDate",
        "wpApplicationEYEmbassyAppointmentDate",
        "wpApplicationEYWorkPermitIssuedDate",
        "laborContractReceivedImmigrationDate",
        "laborContractSharedWithEmployeeDate",
        "laborContractReceivedFromEmployeeDate",
        "laborContractSharedWithImmigrationDate",
        "homeCountryExitFormalityInitiatedDate",
        "homeCountryExitFormalityUnderProcessDate",
        "homeCountryExitFormalityCompletedDate",
        "travelBookingInitiatedDate",
        "travelBookingCompletedDate"]

      if (key && key != "" && keys.includes(key)) {
        return value?.replace('Z', '');
      }
      return value; // TODO: Transform value if necessary
    };

  }

    getCandidateProfiles(sortParameters: SortParameters): Observable<CandidateGridInfo> {
        let url_ = this.baseUrl + "/api/Candidate/GetCandidates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateGridInfo>;
        }));
    }

    protected processGetCandidateProfiles(response: HttpResponseBase): Observable<CandidateGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateProfilesForPTC(sortParameters: SortParameters): Observable<CandidateGridInfo> {
        let url_ = this.baseUrl + "/api/Candidate/GetCandidatesForPTC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateProfilesForPTC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateProfilesForPTC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateGridInfo>;
        }));
    }

    protected processGetCandidateProfilesForPTC(response: HttpResponseBase): Observable<CandidateGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachCandidateDocsToMail(emailAttachments: EmailAttachments[]): Observable<EmailAttachments[]> {
        let url_ = this.baseUrl + "/api/Candidate/AttachCandidateDocsToMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachCandidateDocsToMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachCandidateDocsToMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAttachments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAttachments[]>;
        }));
    }

    protected processAttachCandidateDocsToMail(response: HttpResponseBase): Observable<EmailAttachments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailAttachments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveFilterParams(module: string | null, filterParams: FilterParams): Observable<FilterParams> {
        let url_ = this.baseUrl + "/api/Candidate/SaveFilterParams?";
        if (module === undefined)
            throw new Error("The parameter 'module' must be defined.");
        else if(module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFilterParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFilterParams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilterParams>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilterParams>;
        }));
    }

    protected processSaveFilterParams(response: HttpResponseBase): Observable<FilterParams> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilterParams.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveProfile(submitProfile: boolean | undefined, candidateProfile: CandidateProfile): Observable<OperationResultOfCandidateProfile> {
        let url_ = this.baseUrl + "/api/Candidate/SaveCandidateProfile?";
        if (submitProfile === null)
            throw new Error("The parameter 'submitProfile' cannot be null.");
        else if (submitProfile !== undefined)
            url_ += "submitProfile=" + encodeURIComponent("" + submitProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidateProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfCandidateProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfCandidateProfile>;
        }));
    }

    protected processSaveProfile(response: HttpResponseBase): Observable<OperationResultOfCandidateProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfCandidateProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateProfile(id: number): Observable<CandidateProfile> {
        let url_ = this.baseUrl + "/api/Candidate/GetCandidateProfile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateProfile>;
        }));
    }

    protected processGetCandidateProfile(response: HttpResponseBase): Observable<CandidateProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProfile(id: number): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Candidate/DeleteCandidateProfile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processDeleteProfile(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateDocsDetails(id: number): Observable<CandidateDocuments[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetDocumentDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateDocuments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateDocuments[]>;
        }));
    }

    protected processGetCandidateDocsDetails(response: HttpResponseBase): Observable<CandidateDocuments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CandidateDocuments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentsUpload(): Observable<OperationResultOfCandidateDocuments> {
        let url_ = this.baseUrl + "/api/Candidate/DocumentsUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfCandidateDocuments>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfCandidateDocuments>;
        }));
    }

    protected processDocumentsUpload(response: HttpResponseBase): Observable<OperationResultOfCandidateDocuments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfCandidateDocuments.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttachmentsDetails(profileId: number, activityId: number, activityTemplateId: number): Observable<EmailAttachments[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetAttachmentsDetails?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (activityTemplateId === undefined || activityTemplateId === null)
            throw new Error("The parameter 'activityTemplateId' must be defined and cannot be null.");
        else
            url_ += "activityTemplateId=" + encodeURIComponent("" + activityTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAttachments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAttachments[]>;
        }));
    }

    protected processGetAttachmentsDetails(response: HttpResponseBase): Observable<EmailAttachments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailAttachments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAttachment(emailAttachments: EmailAttachments): Observable<void> {
        let url_ = this.baseUrl + "/api/Candidate/DownloadAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAttachment(emailAttachments: EmailAttachments): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Candidate/DeleteAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachmentsDownloadAll(id: number, typeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Candidate/AttachmentsDownloadAll?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsDownloadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsDownloadAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttachmentsDownloadAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachmentsUpload(): Observable<OperationResultOfEmailAttachments> {
        let url_ = this.baseUrl + "/api/Candidate/AttachmentsUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfEmailAttachments>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfEmailAttachments>;
        }));
    }

    protected processAttachmentsUpload(response: HttpResponseBase): Observable<OperationResultOfEmailAttachments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfEmailAttachments.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downLoadDocumentFile(fileName: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Candidate/DownLoadDocumentFile?";
        if (fileName === undefined)
            throw new Error("The parameter 'fileName' must be defined.");
        else if(fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownLoadDocumentFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAttachmentFile(fileName: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Candidate/DownloadAttachmentFile?";
        if (fileName === undefined)
            throw new Error("The parameter 'fileName' must be defined.");
        else if(fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAttachmentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAttachmentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAttachmentFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downLoadFile(candidateDocuments: CandidateDocuments): Observable<void> {
        let url_ = this.baseUrl + "/api/Candidate/DocumentDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidateDocuments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownLoadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(candidateDocuments: CandidateDocuments): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Candidate/DocumentDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidateDocuments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAll(id: number, module: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Candidate/DownloadAll?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (module === undefined)
            throw new Error("The parameter 'module' must be defined.");
        else if(module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveProfile(profile: CombainedProfile): Observable<OperationResultOfCombainedProfile> {
        let url_ = this.baseUrl + "/api/Candidate/ApproveProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfCombainedProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfCombainedProfile>;
        }));
    }

    protected processApproveProfile(response: HttpResponseBase): Observable<OperationResultOfCombainedProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfCombainedProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectProfile(candidateId: number, comment: Comments): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Candidate/RejectProfile?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processRejectProfile(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportReportToCSV(isRecruitment: boolean, filterParameters: FilterParams): Observable<void> {
        let url_ = this.baseUrl + "/api/Candidate/ExportReport?";
        if (isRecruitment === undefined || isRecruitment === null)
            throw new Error("The parameter 'isRecruitment' must be defined and cannot be null.");
        else
            url_ += "isRecruitment=" + encodeURIComponent("" + isRecruitment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportToCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportToCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportReportToCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportTimelineReportToCSV(officelocationCountryId: number, filterParameters: FilterParams): Observable<void> {
        let url_ = this.baseUrl + "/api/Candidate/ExportTimelineReport?";
        if (officelocationCountryId === undefined || officelocationCountryId === null)
            throw new Error("The parameter 'officelocationCountryId' must be defined and cannot be null.");
        else
            url_ += "officelocationCountryId=" + encodeURIComponent("" + officelocationCountryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTimelineReportToCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTimelineReportToCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportTimelineReportToCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCombainedProfile(candidateId: number): Observable<CombainedProfile> {
        let url_ = this.baseUrl + "/api/Candidate/GetCombainedProfile?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCombainedProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCombainedProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CombainedProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CombainedProfile>;
        }));
    }

    protected processGetCombainedProfile(response: HttpResponseBase): Observable<CombainedProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CombainedProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileForBuddyCounselor(candidateId: number): Observable<CombainedProfile> {
        let url_ = this.baseUrl + "/api/Candidate/GetProfileForBuddyCounselor?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileForBuddyCounselor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileForBuddyCounselor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CombainedProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CombainedProfile>;
        }));
    }

    protected processGetProfileForBuddyCounselor(response: HttpResponseBase): Observable<CombainedProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CombainedProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    filePreview(guid: string | null, filename: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Candidate/FilePreview/{guid}/{filename}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFilePreview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequiredDocuments(module: string | null, flightBooking: boolean, profile: CandidateProfile): Observable<DocumentType[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetRequiredDocuments?";
        if (module === undefined)
            throw new Error("The parameter 'module' must be defined.");
        else if(module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        if (flightBooking === undefined || flightBooking === null)
            throw new Error("The parameter 'flightBooking' must be defined and cannot be null.");
        else
            url_ += "flightBooking=" + encodeURIComponent("" + flightBooking) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequiredDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequiredDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentType[]>;
        }));
    }

    protected processGetRequiredDocuments(response: HttpResponseBase): Observable<DocumentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateDocuments(module: string | null, flightBooking: boolean, profile: CandidateProfile): Observable<CandidateDocCombined[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetCandidateDocuments?";
        if (module === undefined)
            throw new Error("The parameter 'module' must be defined.");
        else if(module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        if (flightBooking === undefined || flightBooking === null)
            throw new Error("The parameter 'flightBooking' must be defined and cannot be null.");
        else
            url_ += "flightBooking=" + encodeURIComponent("" + flightBooking) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateDocCombined[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateDocCombined[]>;
        }));
    }

    protected processGetCandidateDocuments(response: HttpResponseBase): Observable<CandidateDocCombined[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CandidateDocCombined.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequestableDocuments(profileId: number, module: string | null): Observable<DocumentType[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetRequestableDocuments?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (module === undefined)
            throw new Error("The parameter 'module' must be defined.");
        else if(module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestableDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestableDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentType[]>;
        }));
    }

    protected processGetRequestableDocuments(response: HttpResponseBase): Observable<DocumentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestCandiateDocuments(profileId: number, reqList: CandidateAdditionDocumentRequest[]): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Candidate/RequestCandiateDocuments?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reqList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestCandiateDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestCandiateDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processRequestCandiateDocuments(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestPendingDocuments(profileId: number, reqList: CandidateAdditionDocumentRequest[]): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Candidate/RequestPendingDocuments?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reqList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPendingDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPendingDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processRequestPendingDocuments(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removePendingDocument(docId: number): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Candidate/RemovePendingDocument?";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined and cannot be null.");
        else
            url_ += "docId=" + encodeURIComponent("" + docId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePendingDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePendingDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processRemovePendingDocument(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequestedDocuments(candidateProfileId: number): Observable<CandidateAdditionDocumentRequest[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetRequestedCandiateDocuments?";
        if (candidateProfileId === undefined || candidateProfileId === null)
            throw new Error("The parameter 'candidateProfileId' must be defined and cannot be null.");
        else
            url_ += "candidateProfileId=" + encodeURIComponent("" + candidateProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestedDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestedDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateAdditionDocumentRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateAdditionDocumentRequest[]>;
        }));
    }

    protected processGetRequestedDocuments(response: HttpResponseBase): Observable<CandidateAdditionDocumentRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CandidateAdditionDocumentRequest.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingDocuments(candidateProfileId: number): Observable<CandidatePendingDocumentRequest[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetPendingCandiateDocuments?";
        if (candidateProfileId === undefined || candidateProfileId === null)
            throw new Error("The parameter 'candidateProfileId' must be defined and cannot be null.");
        else
            url_ += "candidateProfileId=" + encodeURIComponent("" + candidateProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatePendingDocumentRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatePendingDocumentRequest[]>;
        }));
    }

    protected processGetPendingDocuments(response: HttpResponseBase): Observable<CandidatePendingDocumentRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CandidatePendingDocumentRequest.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inviteForRecuriment(isInvited: boolean, candidateProfile: CandidateProfile): Observable<OperationResultOfCandidateProfile> {
        let url_ = this.baseUrl + "/api/Candidate/InviteForRecuriment?";
        if (isInvited === undefined || isInvited === null)
            throw new Error("The parameter 'isInvited' must be defined and cannot be null.");
        else
            url_ += "isInvited=" + encodeURIComponent("" + isInvited) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidateProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteForRecuriment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteForRecuriment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfCandidateProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfCandidateProfile>;
        }));
    }

    protected processInviteForRecuriment(response: HttpResponseBase): Observable<OperationResultOfCandidateProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfCandidateProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordAndsendMail(candidateId: number): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Candidate/ResetPasswordAndsendMail?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordAndsendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordAndsendMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processResetPasswordAndsendMail(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelInvite(candidateId: number, comment: Comments): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Candidate/CancelInvite?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processCancelInvite(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPJDocumentInstructions(profile: CandidateProfile): Observable<DocumentInstructions[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetPJDocumentInstructions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPJDocumentInstructions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPJDocumentInstructions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentInstructions[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentInstructions[]>;
        }));
    }

    protected processGetPJDocumentInstructions(response: HttpResponseBase): Observable<DocumentInstructions[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentInstructions.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkAccess(candidateId: number, isComment: boolean): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Candidate/CheckAccess?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        if (isComment === undefined || isComment === null)
            throw new Error("The parameter 'isComment' must be defined and cannot be null.");
        else
            url_ += "isComment=" + encodeURIComponent("" + isComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckAccess(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHMDetails(profileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Candidate/GetHMDetails?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHMDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHMDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetHMDetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEADetails(profileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Candidate/GetEADetails?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEADetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEADetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetEADetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveVisaDesignation(cpId: number, combainedProfile: CombainedProfile): Observable<CandidateProfile> {
        let url_ = this.baseUrl + "/api/Candidate/SaveVisaDesignation?";
        if (cpId === undefined || cpId === null)
            throw new Error("The parameter 'cpId' must be defined and cannot be null.");
        else
            url_ += "cpId=" + encodeURIComponent("" + cpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(combainedProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveVisaDesignation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveVisaDesignation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateProfile>;
        }));
    }

    protected processSaveVisaDesignation(response: HttpResponseBase): Observable<CandidateProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getKSAVisaApproverDetails(profileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Candidate/GetKSAVisaApproverDetails?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKSAVisaApproverDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKSAVisaApproverDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetKSAVisaApproverDetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkEmployeeTravelRole(profileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Candidate/CheckEmployeeTravelRole?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmployeeTravelRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmployeeTravelRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckEmployeeTravelRole(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLookupFieldsByTypePbprofileId(lookupTypeId: number, profileId: number): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetLookupFieldsByTypePBProfileId/{lookupTypeId}/{profileId}";
        if (lookupTypeId === undefined || lookupTypeId === null)
            throw new Error("The parameter 'lookupTypeId' must be defined.");
        url_ = url_.replace("{lookupTypeId}", encodeURIComponent("" + lookupTypeId));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLookupFieldsByTypePbprofileId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLookupFieldsByTypePbprofileId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetLookupFieldsByTypePbprofileId(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateImmCaseType(lookupTypeId: number, candidateId: number): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetCandidateImmCaseType?";
        if (lookupTypeId === undefined || lookupTypeId === null)
            throw new Error("The parameter 'lookupTypeId' must be defined and cannot be null.");
        else
            url_ += "lookupTypeId=" + encodeURIComponent("" + lookupTypeId) + "&";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateImmCaseType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateImmCaseType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetCandidateImmCaseType(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateMinDetails(candidateProfileId: number): Observable<CandidateInfoMin> {
        let url_ = this.baseUrl + "/api/Candidate/GetCandidateMinDetails?";
        if (candidateProfileId === undefined || candidateProfileId === null)
            throw new Error("The parameter 'candidateProfileId' must be defined and cannot be null.");
        else
            url_ += "candidateProfileId=" + encodeURIComponent("" + candidateProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateMinDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateMinDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateInfoMin>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateInfoMin>;
        }));
    }

    protected processGetCandidateMinDetails(response: HttpResponseBase): Observable<CandidateInfoMin> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateInfoMin.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEAallocators(): Observable<EAAllocator[]> {
        let url_ = this.baseUrl + "/api/Candidate/GetEAallocators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEAallocators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEAallocators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EAAllocator[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EAAllocator[]>;
        }));
    }

    protected processGetEAallocators(response: HttpResponseBase): Observable<EAAllocator[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EAAllocator.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Candidate?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConfigurationApi {
    activitiesForAmend(filter: AmmendActivityFilter): Observable<Activity[]>;
    amendCandidateActivity(act: Activity): Observable<boolean>;
    createCandidateActivity(act: Activity[]): Observable<Activity2[]>;
    getImmActivities(filter: AmmendImmActivityFilter): Observable<ConfigureImmActivities>;
    createImmigrationActivity(act: ImmigrationActivity[]): Observable<OperationResultOfListOfImmigrationActivities>;
    getImmActivitiesById(id: number): Observable<ImmigrationActivity>;
    amendImmigrationActivity(act: ImmigrationActivity): Observable<OperationResultOfString>;
    getExitActivities(filter: AmmendExitActivityFilter): Observable<ExitRequestActivity[]>;
    getExitActivitiesById(id: number): Observable<ExitRequestActivity>;
    saveExitActivities(exitRequest: ExitRequestActivity): Observable<OperationResultOfInteger>;
    getImmDocVisaMappingsById(id: number): Observable<ImmigrationDocumentVisaMappingDTO>;
    getImmDocumentVisaMappings(filter: ImmDocumentVisaMappingFilter): Observable<ImmigrationDocumentVisaMappingDTO[]>;
    saveImmDocumentVisaMappings(immDocMap: ImmigrationDocumentVisaMappingDTO): Observable<OperationResultOfInteger>;
    getAppConfigValue(key: string | null): Observable<string>;
    getAppConfigValues(keys: string | null): Observable<AppConfig[]>;
    setAppConfigValue(appConfigList: AppConfiguration[]): Observable<OperationResultOfString>;
    exportImmigrationActivities(isActive: boolean, filter: AmmendImmActivityFilter): Observable<void>;
    getToolTipTextValuesByVisaType(module: string | null, parentId: number): Observable<FieldToolTips[]>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationApi implements IConfigurationApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    activitiesForAmend(filter: AmmendActivityFilter): Observable<Activity[]> {
        let url_ = this.baseUrl + "/api/Configuration/ActivitiesForAmend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivitiesForAmend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivitiesForAmend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Activity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Activity[]>;
        }));
    }

    protected processActivitiesForAmend(response: HttpResponseBase): Observable<Activity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Activity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    amendCandidateActivity(act: Activity): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Configuration/AmendCandidateActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(act);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAmendCandidateActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAmendCandidateActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAmendCandidateActivity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCandidateActivity(act: Activity[]): Observable<Activity2[]> {
        let url_ = this.baseUrl + "/api/Configuration/CreateCandidateActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(act);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCandidateActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCandidateActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Activity2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Activity2[]>;
        }));
    }

    protected processCreateCandidateActivity(response: HttpResponseBase): Observable<Activity2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Activity2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImmActivities(filter: AmmendImmActivityFilter): Observable<ConfigureImmActivities> {
        let url_ = this.baseUrl + "/api/Configuration/GetImmActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImmActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImmActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigureImmActivities>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigureImmActivities>;
        }));
    }

    protected processGetImmActivities(response: HttpResponseBase): Observable<ConfigureImmActivities> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigureImmActivities.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createImmigrationActivity(act: ImmigrationActivity[]): Observable<OperationResultOfListOfImmigrationActivities> {
        let url_ = this.baseUrl + "/api/Configuration/CreateImmigrationActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(act);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateImmigrationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateImmigrationActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfListOfImmigrationActivities>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfListOfImmigrationActivities>;
        }));
    }

    protected processCreateImmigrationActivity(response: HttpResponseBase): Observable<OperationResultOfListOfImmigrationActivities> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfListOfImmigrationActivities.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImmActivitiesById(id: number): Observable<ImmigrationActivity> {
        let url_ = this.baseUrl + "/api/Configuration/GetImmActivitiesById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImmActivitiesById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImmActivitiesById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationActivity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationActivity>;
        }));
    }

    protected processGetImmActivitiesById(response: HttpResponseBase): Observable<ImmigrationActivity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    amendImmigrationActivity(act: ImmigrationActivity): Observable<OperationResultOfString> {
        let url_ = this.baseUrl + "/api/Configuration/AmendImmigrationActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(act);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAmendImmigrationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAmendImmigrationActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfString>;
        }));
    }

    protected processAmendImmigrationActivity(response: HttpResponseBase): Observable<OperationResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExitActivities(filter: AmmendExitActivityFilter): Observable<ExitRequestActivity[]> {
        let url_ = this.baseUrl + "/api/Configuration/GetExitActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitRequestActivity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitRequestActivity[]>;
        }));
    }

    protected processGetExitActivities(response: HttpResponseBase): Observable<ExitRequestActivity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExitRequestActivity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExitActivitiesById(id: number): Observable<ExitRequestActivity> {
        let url_ = this.baseUrl + "/api/Configuration/GetExitActivitiesById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitActivitiesById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitActivitiesById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitRequestActivity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitRequestActivity>;
        }));
    }

    protected processGetExitActivitiesById(response: HttpResponseBase): Observable<ExitRequestActivity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExitRequestActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveExitActivities(exitRequest: ExitRequestActivity): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Configuration/SaveExitActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exitRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveExitActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveExitActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSaveExitActivities(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImmDocVisaMappingsById(id: number): Observable<ImmigrationDocumentVisaMappingDTO> {
        let url_ = this.baseUrl + "/api/Configuration/GetImmDocVisaMappingsById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImmDocVisaMappingsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImmDocVisaMappingsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationDocumentVisaMappingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationDocumentVisaMappingDTO>;
        }));
    }

    protected processGetImmDocVisaMappingsById(response: HttpResponseBase): Observable<ImmigrationDocumentVisaMappingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationDocumentVisaMappingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImmDocumentVisaMappings(filter: ImmDocumentVisaMappingFilter): Observable<ImmigrationDocumentVisaMappingDTO[]> {
        let url_ = this.baseUrl + "/api/Configuration/GetImmDocumentVisaMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImmDocumentVisaMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImmDocumentVisaMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationDocumentVisaMappingDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationDocumentVisaMappingDTO[]>;
        }));
    }

    protected processGetImmDocumentVisaMappings(response: HttpResponseBase): Observable<ImmigrationDocumentVisaMappingDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationDocumentVisaMappingDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveImmDocumentVisaMappings(immDocMap: ImmigrationDocumentVisaMappingDTO): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Configuration/SaveImmDocumentVisaMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(immDocMap);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveImmDocumentVisaMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveImmDocumentVisaMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSaveImmDocumentVisaMappings(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppConfigValue(key: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Configuration/GetAppConfigValue?";
        if (key === undefined)
            throw new Error("The parameter 'key' must be defined.");
        else if(key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppConfigValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppConfigValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAppConfigValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppConfigValues(keys: string | null): Observable<AppConfig[]> {
        let url_ = this.baseUrl + "/api/Configuration/GetAppConfigValues?";
        if (keys === undefined)
            throw new Error("The parameter 'keys' must be defined.");
        else if(keys !== null)
            url_ += "keys=" + encodeURIComponent("" + keys) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppConfigValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppConfigValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppConfig[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppConfig[]>;
        }));
    }

    protected processGetAppConfigValues(response: HttpResponseBase): Observable<AppConfig[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppConfig.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAppConfigValue(appConfigList: AppConfiguration[]): Observable<OperationResultOfString> {
        let url_ = this.baseUrl + "/api/Configuration/SetAppConfigValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appConfigList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAppConfigValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAppConfigValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfString>;
        }));
    }

    protected processSetAppConfigValue(response: HttpResponseBase): Observable<OperationResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportImmigrationActivities(isActive: boolean, filter: AmmendImmActivityFilter): Observable<void> {
        let url_ = this.baseUrl + "/api/Configuration/ExportImmigrationActivities?";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined and cannot be null.");
        else
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportImmigrationActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportImmigrationActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportImmigrationActivities(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getToolTipTextValuesByVisaType(module: string | null, parentId: number): Observable<FieldToolTips[]> {
        let url_ = this.baseUrl + "/api/Configuration/GetToolTipTextValuesByVisaType?";
        if (module === undefined)
            throw new Error("The parameter 'module' must be defined.");
        else if(module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined and cannot be null.");
        else
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToolTipTextValuesByVisaType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToolTipTextValuesByVisaType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldToolTips[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldToolTips[]>;
        }));
    }

    protected processGetToolTipTextValuesByVisaType(response: HttpResponseBase): Observable<FieldToolTips[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldToolTips.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Configuration?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICWApi {
    saveProfile(submitProfile: boolean | undefined, cwProfile: CWProfile): Observable<OperationResultOfCWProfile>;
    getCandidateProfiles(sortParameters: SortParameters): Observable<CandidateGridInfo>;
    getCWProfile(id: number): Observable<CWProfile>;
    getCWDocuments(request: CWProfile): Observable<CWDocCombined[]>;
    documentsUpload(): Observable<OperationResultOfCWDocument>;
    deleteFile(cwDocument: CWDocument): Observable<boolean>;
    downloadAll(id: number): Observable<void>;
    saveRequestProcess(submitProfile: boolean | undefined, cwCandidate: CWProfile): Observable<OperationResultOfCWProfile>;
    deleteProfile(id: number): Observable<OperationResultOfInteger>;
    exportCWReportToCSV(filterParameters: FilterParams): Observable<void>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CWApi implements ICWApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    this.jsonParseReviver = (key: string, value: any) => {
      let keys = ["startDate", "endDate", "dateOfBirth", "updatedDateOfExit", "previousUpdatedEndDate"
      ]
      if (key && key != "" && keys.includes(key)) {
        return value?.replace('Z', '');
      }
      return value; // TODO: Transform value if necessary
    };


  }

    saveProfile(submitProfile: boolean | undefined, cwProfile: CWProfile): Observable<OperationResultOfCWProfile> {
        let url_ = this.baseUrl + "/api/CW/SaveCWProfile?";
        if (submitProfile === null)
            throw new Error("The parameter 'submitProfile' cannot be null.");
        else if (submitProfile !== undefined)
            url_ += "submitProfile=" + encodeURIComponent("" + submitProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cwProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfCWProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfCWProfile>;
        }));
    }

    protected processSaveProfile(response: HttpResponseBase): Observable<OperationResultOfCWProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfCWProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateProfiles(sortParameters: SortParameters): Observable<CandidateGridInfo> {
        let url_ = this.baseUrl + "/api/CW/GetCandidates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateGridInfo>;
        }));
    }

    protected processGetCandidateProfiles(response: HttpResponseBase): Observable<CandidateGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCWProfile(id: number): Observable<CWProfile> {
        let url_ = this.baseUrl + "/api/CW/GetCWProfile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCWProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCWProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CWProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CWProfile>;
        }));
    }

    protected processGetCWProfile(response: HttpResponseBase): Observable<CWProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CWProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCWDocuments(request: CWProfile): Observable<CWDocCombined[]> {
        let url_ = this.baseUrl + "/api/CW/GetCWDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCWDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCWDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CWDocCombined[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CWDocCombined[]>;
        }));
    }

    protected processGetCWDocuments(response: HttpResponseBase): Observable<CWDocCombined[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CWDocCombined.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentsUpload(): Observable<OperationResultOfCWDocument> {
        let url_ = this.baseUrl + "/api/CW/DocumentsUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfCWDocument>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfCWDocument>;
        }));
    }

    protected processDocumentsUpload(response: HttpResponseBase): Observable<OperationResultOfCWDocument> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfCWDocument.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(cwDocument: CWDocument): Observable<boolean> {
        let url_ = this.baseUrl + "/api/CW/DocumentDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cwDocument);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAll(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/CW/DownloadAll?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveRequestProcess(submitProfile: boolean | undefined, cwCandidate: CWProfile): Observable<OperationResultOfCWProfile> {
        let url_ = this.baseUrl + "/api/CW/SaveRequestProcess?";
        if (submitProfile === null)
            throw new Error("The parameter 'submitProfile' cannot be null.");
        else if (submitProfile !== undefined)
            url_ += "submitProfile=" + encodeURIComponent("" + submitProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cwCandidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRequestProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRequestProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfCWProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfCWProfile>;
        }));
    }

    protected processSaveRequestProcess(response: HttpResponseBase): Observable<OperationResultOfCWProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfCWProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProfile(id: number): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/CW/DeleteCandidateProfile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processDeleteProfile(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCWReportToCSV(filterParameters: FilterParams): Observable<void> {
        let url_ = this.baseUrl + "/api/CW/ExportCWReportToCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCWReportToCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCWReportToCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportCWReportToCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/CW?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmailApi {
    sendMail(candidateId: number, emailMessage: EmailMessage): Observable<OperationResultOfBoolean>;
    getActivityEmailMessage(candidateId: number, activityId: number, activityTemplateId: number | undefined): Observable<EmailMessage>;
    saveAsDraft(emailMessage: EmailMessage): Observable<OperationResultOfInteger>;
    sendImmigrationMail(candidateId: number, emailMessage: ImmigrationEmailMessage): Observable<OperationResultOfBoolean>;
    getImmigrationActivityEmailMessage(candidateId: number, immigrationProfileActivityId: number, activityTemplateId: number | undefined): Observable<ImmigrationEmailMessage>;
    getEmployeeMail(profileId: number): Observable<EmployeeProfileEmailMessage>;
    immigrationSaveAsDraft(emailMessage: ImmigrationEmailMessage): Observable<OperationResultOfInteger>;
    getEmailTemplates(empCategory: number, officeLocation: number, pbType: number, isWso: boolean): Observable<EmailTemplateEditorInfo[]>;
    getPBGeneralTemplates(): Observable<EmailTemplateEditorInfo[]>;
    getWebJobEmailTemplates(): Observable<EmailTemplateEditorInfo[]>;
    getImmEmailTemplates(visatype: number, isAutoTemp: boolean, officeToBeVisitedID: number | null | undefined, officeLEID: number | null | undefined): Observable<ImmigrationMailTemplateInfo[]>;
    getEmailMessageByCode(templateCode: string | null): Observable<EmailMessage>;
    getEmailMessage(templateId: number, isRefreshTemplate: boolean | undefined): Observable<EmailMessage>;
    saveEmailTemplate(template: EmailMessage): Observable<OperationResultOfInteger>;
    attachmentsUpload(): Observable<OperationResultOfTemplateAttachments>;
    getAttachmentsNewDetails(templateId: number): Observable<TemplateAttachments[]>;
    downloadTemplateAttachment(templateAttachments: TemplateAttachments): Observable<void>;
    deleteAttachment(templateAttachments: TemplateAttachments): Observable<TemplateAttachments[]>;
    getEmailTemplatesForEdit(template: SortParameters): Observable<PagedResultOfEmailTemplateEditorInfo>;
    saveEmailTemplateToMany(orginalTempId: number, changedTemp: number[]): Observable<OperationResultOfInteger>;
    sendEmployeeMMail(emailMessage: EmployeeProfileEmailMessage): Observable<boolean>;
    sendEmpProfileUpdateReminder(employeeId: number): Observable<boolean>;
    getRenderedMail(candidateID: number, templateCode: string | null, activitytemplateId: number): Observable<EmailMessage>;
    sendToSelf(candidateID: number, message: EmailMessage): Observable<OperationResultOfBoolean>;
    getIMMRenderedMail(candidateID: number, templateCode: string | null, templateId: number): Observable<ImmigrationEmailMessage>;
    sendImmigrationPreview(candidateId: number, emailMessage: ImmigrationEmailMessage): Observable<OperationResultOfBoolean>;
    getExitActivityEmailMessage(requestId: number, immigrationProfileActivityId: number, isReminder: boolean, activityTemplateId: number | undefined): Observable<ExitEmailMessage>;
    sendExitMail(requestId: number, emailMessage: ExitEmailMessage): Observable<OperationResultOfBoolean>;
    exitEmailSaveAsDraft(emailMessage: ExitEmailMessage): Observable<OperationResultOfInteger>;
    getExitEmailTemplates(exitType: number, isAutoTemp: boolean, exitSubType: number | null | undefined, officeLoc: number | null | undefined, nationality: number | null | undefined): Observable<ExitMailTemplateInfo[]>;
    getExitRenderedMail(exitID: number, templateCode: string | null, templateId: number): Observable<ExitEmailMessage>;
    sendExitPreview(exitId: number, emailMessage: ExitEmailMessage): Observable<OperationResultOfBoolean>;
    sendExitReminderMail(requestId: number, immigrationProfileActivityId: number, isReminder: boolean, activityTemplateId: number | undefined): Observable<OperationResultOfBoolean>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailApi implements IEmailApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    sendMail(candidateId: number, emailMessage: EmailMessage): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Email/SendMail?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processSendMail(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActivityEmailMessage(candidateId: number, activityId: number, activityTemplateId: number | undefined): Observable<EmailMessage> {
        let url_ = this.baseUrl + "/api/Email/GetActivityEmailMessage?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (activityTemplateId === null)
            throw new Error("The parameter 'activityTemplateId' cannot be null.");
        else if (activityTemplateId !== undefined)
            url_ += "activityTemplateId=" + encodeURIComponent("" + activityTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityEmailMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityEmailMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailMessage>;
        }));
    }

    protected processGetActivityEmailMessage(response: HttpResponseBase): Observable<EmailMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveAsDraft(emailMessage: EmailMessage): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Email/SaveAsDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAsDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAsDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSaveAsDraft(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendImmigrationMail(candidateId: number, emailMessage: ImmigrationEmailMessage): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Email/SendImmigrationMail?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendImmigrationMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendImmigrationMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processSendImmigrationMail(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImmigrationActivityEmailMessage(candidateId: number, immigrationProfileActivityId: number, activityTemplateId: number | undefined): Observable<ImmigrationEmailMessage> {
        let url_ = this.baseUrl + "/api/Email/GetImmigrationActivityEmailMessage?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        if (immigrationProfileActivityId === undefined || immigrationProfileActivityId === null)
            throw new Error("The parameter 'immigrationProfileActivityId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileActivityId=" + encodeURIComponent("" + immigrationProfileActivityId) + "&";
        if (activityTemplateId === null)
            throw new Error("The parameter 'activityTemplateId' cannot be null.");
        else if (activityTemplateId !== undefined)
            url_ += "activityTemplateId=" + encodeURIComponent("" + activityTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImmigrationActivityEmailMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImmigrationActivityEmailMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationEmailMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationEmailMessage>;
        }));
    }

    protected processGetImmigrationActivityEmailMessage(response: HttpResponseBase): Observable<ImmigrationEmailMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationEmailMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeMail(profileId: number): Observable<EmployeeProfileEmailMessage> {
        let url_ = this.baseUrl + "/api/Email/getEmployeeMail?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfileEmailMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfileEmailMessage>;
        }));
    }

    protected processGetEmployeeMail(response: HttpResponseBase): Observable<EmployeeProfileEmailMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeProfileEmailMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    immigrationSaveAsDraft(emailMessage: ImmigrationEmailMessage): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Email/ImmSaveAsDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImmigrationSaveAsDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImmigrationSaveAsDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processImmigrationSaveAsDraft(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailTemplates(empCategory: number, officeLocation: number, pbType: number, isWso: boolean): Observable<EmailTemplateEditorInfo[]> {
        let url_ = this.baseUrl + "/api/Email/GetEmailTemplates?";
        if (empCategory === undefined || empCategory === null)
            throw new Error("The parameter 'empCategory' must be defined and cannot be null.");
        else
            url_ += "empCategory=" + encodeURIComponent("" + empCategory) + "&";
        if (officeLocation === undefined || officeLocation === null)
            throw new Error("The parameter 'officeLocation' must be defined and cannot be null.");
        else
            url_ += "officeLocation=" + encodeURIComponent("" + officeLocation) + "&";
        if (pbType === undefined || pbType === null)
            throw new Error("The parameter 'pbType' must be defined and cannot be null.");
        else
            url_ += "pbType=" + encodeURIComponent("" + pbType) + "&";
        if (isWso === undefined || isWso === null)
            throw new Error("The parameter 'isWso' must be defined and cannot be null.");
        else
            url_ += "isWso=" + encodeURIComponent("" + isWso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplateEditorInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplateEditorInfo[]>;
        }));
    }

    protected processGetEmailTemplates(response: HttpResponseBase): Observable<EmailTemplateEditorInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplateEditorInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPBGeneralTemplates(): Observable<EmailTemplateEditorInfo[]> {
        let url_ = this.baseUrl + "/api/Email/GetPBGeneralTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPBGeneralTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPBGeneralTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplateEditorInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplateEditorInfo[]>;
        }));
    }

    protected processGetPBGeneralTemplates(response: HttpResponseBase): Observable<EmailTemplateEditorInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplateEditorInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWebJobEmailTemplates(): Observable<EmailTemplateEditorInfo[]> {
        let url_ = this.baseUrl + "/api/Email/GetWebJobEmailTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebJobEmailTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebJobEmailTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplateEditorInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplateEditorInfo[]>;
        }));
    }

    protected processGetWebJobEmailTemplates(response: HttpResponseBase): Observable<EmailTemplateEditorInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplateEditorInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImmEmailTemplates(visatype: number, isAutoTemp: boolean, officeToBeVisitedID: number | null | undefined, officeLEID: number | null | undefined): Observable<ImmigrationMailTemplateInfo[]> {
        let url_ = this.baseUrl + "/api/Email/GetImmEmailTemplates?";
        if (visatype === undefined || visatype === null)
            throw new Error("The parameter 'visatype' must be defined and cannot be null.");
        else
            url_ += "visatype=" + encodeURIComponent("" + visatype) + "&";
        if (isAutoTemp === undefined || isAutoTemp === null)
            throw new Error("The parameter 'isAutoTemp' must be defined and cannot be null.");
        else
            url_ += "isAutoTemp=" + encodeURIComponent("" + isAutoTemp) + "&";
        if (officeToBeVisitedID !== undefined && officeToBeVisitedID !== null)
            url_ += "officeToBeVisitedID=" + encodeURIComponent("" + officeToBeVisitedID) + "&";
        if (officeLEID !== undefined && officeLEID !== null)
            url_ += "officeLEID=" + encodeURIComponent("" + officeLEID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImmEmailTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImmEmailTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationMailTemplateInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationMailTemplateInfo[]>;
        }));
    }

    protected processGetImmEmailTemplates(response: HttpResponseBase): Observable<ImmigrationMailTemplateInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationMailTemplateInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailMessageByCode(templateCode: string | null): Observable<EmailMessage> {
        let url_ = this.baseUrl + "/api/Email/GetEmailMessageByCode?";
        if (templateCode === undefined)
            throw new Error("The parameter 'templateCode' must be defined.");
        else if(templateCode !== null)
            url_ += "templateCode=" + encodeURIComponent("" + templateCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailMessageByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailMessageByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailMessage>;
        }));
    }

    protected processGetEmailMessageByCode(response: HttpResponseBase): Observable<EmailMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailMessage(templateId: number, isRefreshTemplate: boolean | undefined): Observable<EmailMessage> {
        let url_ = this.baseUrl + "/api/Email/GetEmailMessage?";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (isRefreshTemplate === null)
            throw new Error("The parameter 'isRefreshTemplate' cannot be null.");
        else if (isRefreshTemplate !== undefined)
            url_ += "isRefreshTemplate=" + encodeURIComponent("" + isRefreshTemplate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailMessage>;
        }));
    }

    protected processGetEmailMessage(response: HttpResponseBase): Observable<EmailMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveEmailTemplate(template: EmailMessage): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Email/SaveEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(template);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSaveEmailTemplate(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachmentsUpload(): Observable<OperationResultOfTemplateAttachments> {
        let url_ = this.baseUrl + "/api/Email/TemplateAttachmentsUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfTemplateAttachments>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfTemplateAttachments>;
        }));
    }

    protected processAttachmentsUpload(response: HttpResponseBase): Observable<OperationResultOfTemplateAttachments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfTemplateAttachments.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttachmentsNewDetails(templateId: number): Observable<TemplateAttachments[]> {
        let url_ = this.baseUrl + "/api/Email/GetTemplateAttachmentsDetails?";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentsNewDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentsNewDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateAttachments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateAttachments[]>;
        }));
    }

    protected processGetAttachmentsNewDetails(response: HttpResponseBase): Observable<TemplateAttachments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateAttachments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadTemplateAttachment(templateAttachments: TemplateAttachments): Observable<void> {
        let url_ = this.baseUrl + "/api/Email/DownloadTemplateAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTemplateAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTemplateAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadTemplateAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAttachment(templateAttachments: TemplateAttachments): Observable<TemplateAttachments[]> {
        let url_ = this.baseUrl + "/api/Email/DeleteTemplateAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateAttachments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateAttachments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateAttachments[]>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<TemplateAttachments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateAttachments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailTemplatesForEdit(template: SortParameters): Observable<PagedResultOfEmailTemplateEditorInfo> {
        let url_ = this.baseUrl + "/api/Email/GetEmailTemplatesForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(template);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplatesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplatesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfEmailTemplateEditorInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfEmailTemplateEditorInfo>;
        }));
    }

    protected processGetEmailTemplatesForEdit(response: HttpResponseBase): Observable<PagedResultOfEmailTemplateEditorInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfEmailTemplateEditorInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveEmailTemplateToMany(orginalTempId: number, changedTemp: number[]): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Email/SaveEmailTemplateToMany?";
        if (orginalTempId === undefined || orginalTempId === null)
            throw new Error("The parameter 'orginalTempId' must be defined and cannot be null.");
        else
            url_ += "orginalTempId=" + encodeURIComponent("" + orginalTempId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changedTemp);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmailTemplateToMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmailTemplateToMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSaveEmailTemplateToMany(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendEmployeeMMail(emailMessage: EmployeeProfileEmailMessage): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Email/SendMMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmployeeMMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmployeeMMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendEmployeeMMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendEmpProfileUpdateReminder(employeeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Email/SendProfileUpdateReminder?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmpProfileUpdateReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmpProfileUpdateReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendEmpProfileUpdateReminder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRenderedMail(candidateID: number, templateCode: string | null, activitytemplateId: number): Observable<EmailMessage> {
        let url_ = this.baseUrl + "/api/Email/GetRenderedMail?";
        if (candidateID === undefined || candidateID === null)
            throw new Error("The parameter 'candidateID' must be defined and cannot be null.");
        else
            url_ += "candidateID=" + encodeURIComponent("" + candidateID) + "&";
        if (templateCode === undefined)
            throw new Error("The parameter 'templateCode' must be defined.");
        else if(templateCode !== null)
            url_ += "templateCode=" + encodeURIComponent("" + templateCode) + "&";
        if (activitytemplateId === undefined || activitytemplateId === null)
            throw new Error("The parameter 'activitytemplateId' must be defined and cannot be null.");
        else
            url_ += "activitytemplateId=" + encodeURIComponent("" + activitytemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenderedMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenderedMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailMessage>;
        }));
    }

    protected processGetRenderedMail(response: HttpResponseBase): Observable<EmailMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendToSelf(candidateID: number, message: EmailMessage): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Email/SendPreview?";
        if (candidateID === undefined || candidateID === null)
            throw new Error("The parameter 'candidateID' must be defined and cannot be null.");
        else
            url_ += "candidateID=" + encodeURIComponent("" + candidateID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToSelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToSelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processSendToSelf(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIMMRenderedMail(candidateID: number, templateCode: string | null, templateId: number): Observable<ImmigrationEmailMessage> {
        let url_ = this.baseUrl + "/api/Email/GetIMMRenderedMail?";
        if (candidateID === undefined || candidateID === null)
            throw new Error("The parameter 'candidateID' must be defined and cannot be null.");
        else
            url_ += "candidateID=" + encodeURIComponent("" + candidateID) + "&";
        if (templateCode === undefined)
            throw new Error("The parameter 'templateCode' must be defined.");
        else if(templateCode !== null)
            url_ += "templateCode=" + encodeURIComponent("" + templateCode) + "&";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIMMRenderedMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIMMRenderedMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationEmailMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationEmailMessage>;
        }));
    }

    protected processGetIMMRenderedMail(response: HttpResponseBase): Observable<ImmigrationEmailMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImmigrationEmailMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendImmigrationPreview(candidateId: number, emailMessage: ImmigrationEmailMessage): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Email/SendIMMPreview?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendImmigrationPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendImmigrationPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processSendImmigrationPreview(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExitActivityEmailMessage(requestId: number, immigrationProfileActivityId: number, isReminder: boolean, activityTemplateId: number | undefined): Observable<ExitEmailMessage> {
        let url_ = this.baseUrl + "/api/Email/GetExitActivityEmailMessage?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (immigrationProfileActivityId === undefined || immigrationProfileActivityId === null)
            throw new Error("The parameter 'immigrationProfileActivityId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileActivityId=" + encodeURIComponent("" + immigrationProfileActivityId) + "&";
        if (isReminder === undefined || isReminder === null)
            throw new Error("The parameter 'isReminder' must be defined and cannot be null.");
        else
            url_ += "isReminder=" + encodeURIComponent("" + isReminder) + "&";
        if (activityTemplateId === null)
            throw new Error("The parameter 'activityTemplateId' cannot be null.");
        else if (activityTemplateId !== undefined)
            url_ += "activityTemplateId=" + encodeURIComponent("" + activityTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitActivityEmailMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitActivityEmailMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitEmailMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitEmailMessage>;
        }));
    }

    protected processGetExitActivityEmailMessage(response: HttpResponseBase): Observable<ExitEmailMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExitEmailMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendExitMail(requestId: number, emailMessage: ExitEmailMessage): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Email/SendExitMail?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendExitMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendExitMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processSendExitMail(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exitEmailSaveAsDraft(emailMessage: ExitEmailMessage): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Email/ExitEmailSaveAsDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExitEmailSaveAsDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExitEmailSaveAsDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processExitEmailSaveAsDraft(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExitEmailTemplates(exitType: number, isAutoTemp: boolean, exitSubType: number | null | undefined, officeLoc: number | null | undefined, nationality: number | null | undefined): Observable<ExitMailTemplateInfo[]> {
        let url_ = this.baseUrl + "/api/Email/GetExitEmailTemplates?";
        if (exitType === undefined || exitType === null)
            throw new Error("The parameter 'exitType' must be defined and cannot be null.");
        else
            url_ += "exitType=" + encodeURIComponent("" + exitType) + "&";
        if (isAutoTemp === undefined || isAutoTemp === null)
            throw new Error("The parameter 'isAutoTemp' must be defined and cannot be null.");
        else
            url_ += "isAutoTemp=" + encodeURIComponent("" + isAutoTemp) + "&";
        if (exitSubType !== undefined && exitSubType !== null)
            url_ += "exitSubType=" + encodeURIComponent("" + exitSubType) + "&";
        if (officeLoc !== undefined && officeLoc !== null)
            url_ += "officeLoc=" + encodeURIComponent("" + officeLoc) + "&";
        if (nationality !== undefined && nationality !== null)
            url_ += "nationality=" + encodeURIComponent("" + nationality) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitEmailTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitEmailTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitMailTemplateInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitMailTemplateInfo[]>;
        }));
    }

    protected processGetExitEmailTemplates(response: HttpResponseBase): Observable<ExitMailTemplateInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExitMailTemplateInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExitRenderedMail(exitID: number, templateCode: string | null, templateId: number): Observable<ExitEmailMessage> {
        let url_ = this.baseUrl + "/api/Email/GetExitRenderedMail?";
        if (exitID === undefined || exitID === null)
            throw new Error("The parameter 'exitID' must be defined and cannot be null.");
        else
            url_ += "exitID=" + encodeURIComponent("" + exitID) + "&";
        if (templateCode === undefined)
            throw new Error("The parameter 'templateCode' must be defined.");
        else if(templateCode !== null)
            url_ += "templateCode=" + encodeURIComponent("" + templateCode) + "&";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitRenderedMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitRenderedMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitEmailMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitEmailMessage>;
        }));
    }

    protected processGetExitRenderedMail(response: HttpResponseBase): Observable<ExitEmailMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExitEmailMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendExitPreview(exitId: number, emailMessage: ExitEmailMessage): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Email/SendExtPreview?";
        if (exitId === undefined || exitId === null)
            throw new Error("The parameter 'exitId' must be defined and cannot be null.");
        else
            url_ += "exitId=" + encodeURIComponent("" + exitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendExitPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendExitPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processSendExitPreview(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendExitReminderMail(requestId: number, immigrationProfileActivityId: number, isReminder: boolean, activityTemplateId: number | undefined): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Email/SendExitReminderMail?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (immigrationProfileActivityId === undefined || immigrationProfileActivityId === null)
            throw new Error("The parameter 'immigrationProfileActivityId' must be defined and cannot be null.");
        else
            url_ += "immigrationProfileActivityId=" + encodeURIComponent("" + immigrationProfileActivityId) + "&";
        if (isReminder === undefined || isReminder === null)
            throw new Error("The parameter 'isReminder' must be defined and cannot be null.");
        else
            url_ += "isReminder=" + encodeURIComponent("" + isReminder) + "&";
        if (activityTemplateId === null)
            throw new Error("The parameter 'activityTemplateId' cannot be null.");
        else if (activityTemplateId !== undefined)
            url_ += "activityTemplateId=" + encodeURIComponent("" + activityTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendExitReminderMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendExitReminderMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processSendExitReminderMail(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Email?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFilePreviewApi {
    fileToken(token: string): Observable<string>;
    remote(key: string | null, filename: string | null): Observable<void>;
    preview(key: string | null, filename: string | null): Observable<void>;
    local(filename: string | null): Observable<void>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class FilePreviewApi implements IFilePreviewApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    fileToken(token: string): Observable<string> {
        let url_ = this.baseUrl + "/api/FilePreview/FileToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFileToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remote(key: string | null, filename: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/FilePreview/Remote/{key}/{filename}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    preview(key: string | null, filename: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/FilePreview/preview/{key}/{filename}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPreview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    local(filename: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/FilePreview/Local/{filename}";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLocal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/FilePreview?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMilestonesApi {
    getCandidateMilestones(candidateId: number): Observable<MilestoneDetail[]>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class MilestonesApi implements IMilestonesApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCandidateMilestones(candidateId: number): Observable<MilestoneDetail[]> {
        let url_ = this.baseUrl + "/api/Milestones/GetCandidateMilestones?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateMilestones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateMilestones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MilestoneDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MilestoneDetail[]>;
        }));
    }

    protected processGetCandidateMilestones(response: HttpResponseBase): Observable<MilestoneDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MilestoneDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Milestones?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISystemsApi {
    copyEmailTemplatesToAnotherFolder(): Observable<OperationResultOfBoolean>;
    updateEmailsAndContents(): Observable<void>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SystemsApi implements ISystemsApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    copyEmailTemplatesToAnotherFolder(): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Systems/CopyEmailTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyEmailTemplatesToAnotherFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyEmailTemplatesToAnotherFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processCopyEmailTemplatesToAnotherFolder(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEmailsAndContents(): Observable<void> {
        let url_ = this.baseUrl + "/api/Systems/DownloadEmailTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmailsAndContents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmailsAndContents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmailsAndContents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Systems?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAuthApi {
    getAppUser(displayName: string | null): Observable<AppUser>;
    getAntiforgeryToken(): Observable<string>;
    policyAccepted(encodedEmail: string): Observable<OperationResultOfAppUser>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthApi implements IAuthApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAppUser(displayName: string | null): Observable<AppUser> {
        let url_ = this.baseUrl + "/api/Auth/GetAppUser?";
        if (displayName === undefined)
            throw new Error("The parameter 'displayName' must be defined.");
        else if(displayName !== null)
            url_ += "DisplayName=" + encodeURIComponent("" + displayName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppUser>;
        }));
    }

    protected processGetAppUser(response: HttpResponseBase): Observable<AppUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAntiforgeryToken(): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth/GetAntiforgeryToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAntiforgeryToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAntiforgeryToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAntiforgeryToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    policyAccepted(encodedEmail: string): Observable<OperationResultOfAppUser> {
        let url_ = this.baseUrl + "/api/Auth/PolicyAccepted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(encodedEmail);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyAccepted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyAccepted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfAppUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfAppUser>;
        }));
    }

    protected processPolicyAccepted(response: HttpResponseBase): Observable<OperationResultOfAppUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfAppUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICommentsApi {
    save(isMailConfirm: boolean | undefined, comment: Comments): Observable<OperationResultOfComments>;
    getCommentsById(id: number, type: number): Observable<Comments[]>;
    getCommentsAndNotes(id: number, type: number): Observable<Comments[]>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CommentsApi implements ICommentsApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    save(isMailConfirm: boolean | undefined, comment: Comments): Observable<OperationResultOfComments> {
        let url_ = this.baseUrl + "/api/Comments/SaveComment?";
        if (isMailConfirm === null)
            throw new Error("The parameter 'isMailConfirm' cannot be null.");
        else if (isMailConfirm !== undefined)
            url_ += "isMailConfirm=" + encodeURIComponent("" + isMailConfirm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfComments>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfComments>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<OperationResultOfComments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfComments.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCommentsById(id: number, type: number): Observable<Comments[]> {
        let url_ = this.baseUrl + "/api/Comments/GetComments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Comments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Comments[]>;
        }));
    }

    protected processGetCommentsById(response: HttpResponseBase): Observable<Comments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Comments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCommentsAndNotes(id: number, type: number): Observable<Comments[]> {
        let url_ = this.baseUrl + "/api/Comments/GetCommentsAndNotes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentsAndNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentsAndNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Comments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Comments[]>;
        }));
    }

    protected processGetCommentsAndNotes(response: HttpResponseBase): Observable<Comments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Comments.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Comments?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeeProfileApi {
    save(employeeProfile: EmployeeProfile): Observable<OperationResultOfEmployeeProfile>;
    getProfile(employeeId: number): Observable<EmployeeProfile>;
    getMasterProfileByProfileId(profileId: number): Observable<EmployeeProfile>;
    getPendingProfile(id: number): Observable<EmployeeProfile>;
    getPendingProfileByProfileId(id: number): Observable<EmployeeProfile>;
    getAllEmployeeRequests(gpn: string | null, gui: string | null, sortParameters: SortParameters): Observable<CandidateGridInfo>;
    getAllEmployeeProfileEditRequests(sortParameters: SortParameters): Observable<CandidateGridInfo>;
    approveEmployeeProfile(candidate: EmployeeProfileCandidate): Observable<OperationResultOfEmployeeProfile>;
    rejectEmployeeProfile(candidate: EmployeeProfileCandidate): Observable<OperationResultOfInteger>;
    submit(isSubmit: boolean | undefined, employeeProfileCandidate: EmployeeProfileCandidate): Observable<OperationResultOfEmployeeProfile>;
    documentsUpload(isAdditionalUpload: boolean): Observable<OperationResultOfEmployeeDoc>;
    downLoadFile(document: EmployeeDocCombined): Observable<void>;
    getUploadedFileDetails(id: number, isEdit: boolean): Observable<EmployeeDoc[]>;
    deleteFile(employeeDocDelete: EmployeeDocDelete): Observable<boolean>;
    downloadAll(id: number, isEdit: boolean): Observable<void>;
    getEmployeeProfilesDetails(gpn: string | null, gui: string | null, country: string | null): Observable<EmployeeProfile>;
    checkIfEmployeeProfileExits(gpn: string | null, gui: string | null, country: string | null): Observable<boolean>;
    updateEmployeeProfile(country: string | null, sendMail: boolean, employeeProfile: EmployeeProfile): Observable<OperationResultOfEmployeeProfile>;
    documentsUploadToProfile(): Observable<OperationResultOfEmployeeDoc>;
    saveComment(comment: EmployeeProfileEditComment): Observable<EmployeeProfileEditComment>;
    getComments(id: number): Observable<EmployeeProfileEditComment[]>;
    getRequiredEmployeeDocuments(employeeProfileId: number, isEditRequest: boolean): Observable<EmployeeDocumentType[]>;
    getEmployeeProfileDocuments(employeeProfileId: number, isEditRequest: boolean): Observable<EmployeeDocCombined[]>;
    getProfileRequestbyEmail(ptcEmail: string | null): Observable<EmployeeProfile>;
    getDocumentInstructions(): Observable<DocumentInstructions[]>;
    exportEmployeeReportToCSV(): Observable<void>;
    getRequestedEmpDocuments(profileId: number): Observable<EmpAdditionalDocRequests[]>;
    sendRequestForEmpAdditionalDocs(profileId: number, employeeId: number, reqList: EmpAdditionalDocRequests[]): Observable<OperationResultOfBoolean>;
    getEligibleAdditionalDocuments(profileId: number): Observable<EmployeeDocCombined[]>;
    uploadAdditionalDocs(profileId: number): Observable<OperationResultOfBoolean>;
    additionalDocUploadPageStatus(empProfileId: number): Observable<boolean>;
    getEmployeeProfileDetailsByGUI(gui: string | null): Observable<EmployeeProfile>;
    getEmployeeRPDocuments(): Observable<number[]>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeProfileApi implements IEmployeeProfileApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    this.jsonParseReviver = (key: string, value: any) => {
      let keys = [
        "passportExpiryDate", "dateOfBirth", "labourCardExpiryDate", "employeeVisaExpiryDate",
        "missionVisaExpiryDate", "workPermitExpiryDate", "iqamaExpiryDate", "dateOfExit",
        "cprExpiryDate", "rpExpiryDate", "civilIdExpiryDate", "pensionRegistrationDate", "lastWorkingDay",]

      if (key && key != "" && keys.includes(key)) {
        return value?.replace('Z', '');
      }
      return value; // TODO: Transform value if necessary
    };

  }

    save(employeeProfile: EmployeeProfile): Observable<OperationResultOfEmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfEmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfEmployeeProfile>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<OperationResultOfEmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfEmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfile(employeeId: number): Observable<EmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/profile?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfile>;
        }));
    }

    protected processGetProfile(response: HttpResponseBase): Observable<EmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMasterProfileByProfileId(profileId: number): Observable<EmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/masterProfileByProfileId?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterProfileByProfileId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterProfileByProfileId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfile>;
        }));
    }

    protected processGetMasterProfileByProfileId(response: HttpResponseBase): Observable<EmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingProfile(id: number): Observable<EmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetPendingProfile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfile>;
        }));
    }

    protected processGetPendingProfile(response: HttpResponseBase): Observable<EmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingProfileByProfileId(id: number): Observable<EmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetPendingProfileByProfileId?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingProfileByProfileId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingProfileByProfileId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfile>;
        }));
    }

    protected processGetPendingProfileByProfileId(response: HttpResponseBase): Observable<EmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllEmployeeRequests(gpn: string | null, gui: string | null, sortParameters: SortParameters): Observable<CandidateGridInfo> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetAllEmployeeRequests/{gpn}/{gui}";
        if (gpn === undefined || gpn === null)
            throw new Error("The parameter 'gpn' must be defined.");
        url_ = url_.replace("{gpn}", encodeURIComponent("" + gpn));
        if (gui === undefined || gui === null)
            throw new Error("The parameter 'gui' must be defined.");
        url_ = url_.replace("{gui}", encodeURIComponent("" + gui));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateGridInfo>;
        }));
    }

    protected processGetAllEmployeeRequests(response: HttpResponseBase): Observable<CandidateGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllEmployeeProfileEditRequests(sortParameters: SortParameters): Observable<CandidateGridInfo> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetAllEmployeeProfileRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeProfileEditRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeProfileEditRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateGridInfo>;
        }));
    }

    protected processGetAllEmployeeProfileEditRequests(response: HttpResponseBase): Observable<CandidateGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveEmployeeProfile(candidate: EmployeeProfileCandidate): Observable<OperationResultOfEmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/ApproveEmployeeProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveEmployeeProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveEmployeeProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfEmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfEmployeeProfile>;
        }));
    }

    protected processApproveEmployeeProfile(response: HttpResponseBase): Observable<OperationResultOfEmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfEmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectEmployeeProfile(candidate: EmployeeProfileCandidate): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/RejectEmployeeProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectEmployeeProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectEmployeeProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processRejectEmployeeProfile(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submit(isSubmit: boolean | undefined, employeeProfileCandidate: EmployeeProfileCandidate): Observable<OperationResultOfEmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/Submit?";
        if (isSubmit === null)
            throw new Error("The parameter 'isSubmit' cannot be null.");
        else if (isSubmit !== undefined)
            url_ += "isSubmit=" + encodeURIComponent("" + isSubmit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeProfileCandidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfEmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfEmployeeProfile>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<OperationResultOfEmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfEmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentsUpload(isAdditionalUpload: boolean): Observable<OperationResultOfEmployeeDoc> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/DocumentsUpload/{isAdditionalUpload}";
        if (isAdditionalUpload === undefined || isAdditionalUpload === null)
            throw new Error("The parameter 'isAdditionalUpload' must be defined.");
        url_ = url_.replace("{isAdditionalUpload}", encodeURIComponent("" + isAdditionalUpload));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfEmployeeDoc>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfEmployeeDoc>;
        }));
    }

    protected processDocumentsUpload(response: HttpResponseBase): Observable<OperationResultOfEmployeeDoc> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfEmployeeDoc.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downLoadFile(document: EmployeeDocCombined): Observable<void> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/DocumentDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(document);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownLoadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUploadedFileDetails(id: number, isEdit: boolean): Observable<EmployeeDoc[]> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetUploadedFileDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (isEdit === undefined || isEdit === null)
            throw new Error("The parameter 'isEdit' must be defined and cannot be null.");
        else
            url_ += "IsEdit=" + encodeURIComponent("" + isEdit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadedFileDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadedFileDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDoc[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDoc[]>;
        }));
    }

    protected processGetUploadedFileDetails(response: HttpResponseBase): Observable<EmployeeDoc[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDoc.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(employeeDocDelete: EmployeeDocDelete): Observable<boolean> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/DocumentDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeDocDelete);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAll(id: number, isEdit: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/DownloadAll?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isEdit === undefined || isEdit === null)
            throw new Error("The parameter 'isEdit' must be defined and cannot be null.");
        else
            url_ += "isEdit=" + encodeURIComponent("" + isEdit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeProfilesDetails(gpn: string | null, gui: string | null, country: string | null): Observable<EmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetEmployeeDetails/{country}?";
        if (country === undefined || country === null)
            throw new Error("The parameter 'country' must be defined.");
        url_ = url_.replace("{country}", encodeURIComponent("" + country));
        if (gpn === undefined)
            throw new Error("The parameter 'gpn' must be defined.");
        else if(gpn !== null)
            url_ += "gpn=" + encodeURIComponent("" + gpn) + "&";
        if (gui === undefined)
            throw new Error("The parameter 'gui' must be defined.");
        else if(gui !== null)
            url_ += "gui=" + encodeURIComponent("" + gui) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeProfilesDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeProfilesDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfile>;
        }));
    }

    protected processGetEmployeeProfilesDetails(response: HttpResponseBase): Observable<EmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkIfEmployeeProfileExits(gpn: string | null, gui: string | null, country: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/CheckIfEmployeeProfileExits/{country}?";
        if (country === undefined || country === null)
            throw new Error("The parameter 'country' must be defined.");
        url_ = url_.replace("{country}", encodeURIComponent("" + country));
        if (gpn === undefined)
            throw new Error("The parameter 'gpn' must be defined.");
        else if(gpn !== null)
            url_ += "gpn=" + encodeURIComponent("" + gpn) + "&";
        if (gui === undefined)
            throw new Error("The parameter 'gui' must be defined.");
        else if(gui !== null)
            url_ += "gui=" + encodeURIComponent("" + gui) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfEmployeeProfileExits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfEmployeeProfileExits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfEmployeeProfileExits(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEmployeeProfile(country: string | null, sendMail: boolean, employeeProfile: EmployeeProfile): Observable<OperationResultOfEmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/updateEmployeeProfile/{country}/{sendMail}";
        if (country === undefined || country === null)
            throw new Error("The parameter 'country' must be defined.");
        url_ = url_.replace("{country}", encodeURIComponent("" + country));
        if (sendMail === undefined || sendMail === null)
            throw new Error("The parameter 'sendMail' must be defined.");
        url_ = url_.replace("{sendMail}", encodeURIComponent("" + sendMail));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmployeeProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmployeeProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfEmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfEmployeeProfile>;
        }));
    }

    protected processUpdateEmployeeProfile(response: HttpResponseBase): Observable<OperationResultOfEmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfEmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentsUploadToProfile(): Observable<OperationResultOfEmployeeDoc> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/DocumentsUploadToProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsUploadToProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsUploadToProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfEmployeeDoc>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfEmployeeDoc>;
        }));
    }

    protected processDocumentsUploadToProfile(response: HttpResponseBase): Observable<OperationResultOfEmployeeDoc> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfEmployeeDoc.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveComment(comment: EmployeeProfileEditComment): Observable<EmployeeProfileEditComment> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/saveComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfileEditComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfileEditComment>;
        }));
    }

    protected processSaveComment(response: HttpResponseBase): Observable<EmployeeProfileEditComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeProfileEditComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComments(id: number): Observable<EmployeeProfileEditComment[]> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetComments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfileEditComment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfileEditComment[]>;
        }));
    }

    protected processGetComments(response: HttpResponseBase): Observable<EmployeeProfileEditComment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeProfileEditComment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequiredEmployeeDocuments(employeeProfileId: number, isEditRequest: boolean): Observable<EmployeeDocumentType[]> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetRequiredEmployeeDocuments?";
        if (employeeProfileId === undefined || employeeProfileId === null)
            throw new Error("The parameter 'employeeProfileId' must be defined and cannot be null.");
        else
            url_ += "employeeProfileId=" + encodeURIComponent("" + employeeProfileId) + "&";
        if (isEditRequest === undefined || isEditRequest === null)
            throw new Error("The parameter 'isEditRequest' must be defined and cannot be null.");
        else
            url_ += "isEditRequest=" + encodeURIComponent("" + isEditRequest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequiredEmployeeDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequiredEmployeeDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDocumentType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDocumentType[]>;
        }));
    }

    protected processGetRequiredEmployeeDocuments(response: HttpResponseBase): Observable<EmployeeDocumentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDocumentType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeProfileDocuments(employeeProfileId: number, isEditRequest: boolean): Observable<EmployeeDocCombined[]> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetEmployeeProfileDocuments?";
        if (employeeProfileId === undefined || employeeProfileId === null)
            throw new Error("The parameter 'employeeProfileId' must be defined and cannot be null.");
        else
            url_ += "employeeProfileId=" + encodeURIComponent("" + employeeProfileId) + "&";
        if (isEditRequest === undefined || isEditRequest === null)
            throw new Error("The parameter 'isEditRequest' must be defined and cannot be null.");
        else
            url_ += "isEditRequest=" + encodeURIComponent("" + isEditRequest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeProfileDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeProfileDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDocCombined[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDocCombined[]>;
        }));
    }

    protected processGetEmployeeProfileDocuments(response: HttpResponseBase): Observable<EmployeeDocCombined[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDocCombined.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileRequestbyEmail(ptcEmail: string | null): Observable<EmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetProfileRequestbyEmail?";
        if (ptcEmail === undefined)
            throw new Error("The parameter 'ptcEmail' must be defined.");
        else if(ptcEmail !== null)
            url_ += "ptcEmail=" + encodeURIComponent("" + ptcEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileRequestbyEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileRequestbyEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfile>;
        }));
    }

    protected processGetProfileRequestbyEmail(response: HttpResponseBase): Observable<EmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentInstructions(): Observable<DocumentInstructions[]> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetDocumentInstructions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentInstructions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentInstructions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentInstructions[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentInstructions[]>;
        }));
    }

    protected processGetDocumentInstructions(response: HttpResponseBase): Observable<DocumentInstructions[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentInstructions.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportEmployeeReportToCSV(): Observable<void> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/ExportReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEmployeeReportToCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEmployeeReportToCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportEmployeeReportToCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequestedEmpDocuments(profileId: number): Observable<EmpAdditionalDocRequests[]> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetRequestedEmpDocuments?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestedEmpDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestedEmpDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpAdditionalDocRequests[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpAdditionalDocRequests[]>;
        }));
    }

    protected processGetRequestedEmpDocuments(response: HttpResponseBase): Observable<EmpAdditionalDocRequests[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmpAdditionalDocRequests.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendRequestForEmpAdditionalDocs(profileId: number, employeeId: number, reqList: EmpAdditionalDocRequests[]): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/SendRequestForEmpAdditionalDocs?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reqList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRequestForEmpAdditionalDocs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRequestForEmpAdditionalDocs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processSendRequestForEmpAdditionalDocs(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEligibleAdditionalDocuments(profileId: number): Observable<EmployeeDocCombined[]> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetEligibleAdditionalDocuments/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibleAdditionalDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibleAdditionalDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDocCombined[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDocCombined[]>;
        }));
    }

    protected processGetEligibleAdditionalDocuments(response: HttpResponseBase): Observable<EmployeeDocCombined[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDocCombined.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadAdditionalDocs(profileId: number): Observable<OperationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/uploadAdditionalDocs?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAdditionalDocs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAdditionalDocs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfBoolean>;
        }));
    }

    protected processUploadAdditionalDocs(response: HttpResponseBase): Observable<OperationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    additionalDocUploadPageStatus(empProfileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/AdditionalDocUploadPageStatus?";
        if (empProfileId === undefined || empProfileId === null)
            throw new Error("The parameter 'empProfileId' must be defined and cannot be null.");
        else
            url_ += "empProfileId=" + encodeURIComponent("" + empProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdditionalDocUploadPageStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdditionalDocUploadPageStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAdditionalDocUploadPageStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeProfileDetailsByGUI(gui: string | null): Observable<EmployeeProfile> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetEmployeeProfileDetailsByGUI/{gui}";
        if (gui === undefined || gui === null)
            throw new Error("The parameter 'gui' must be defined.");
        url_ = url_.replace("{gui}", encodeURIComponent("" + gui));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeProfileDetailsByGUI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeProfileDetailsByGUI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfile>;
        }));
    }

    protected processGetEmployeeProfileDetailsByGUI(response: HttpResponseBase): Observable<EmployeeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeRPDocuments(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/EmployeeProfile/GetEmployeeRPDocuments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeRPDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeRPDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetEmployeeRPDocuments(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/EmployeeProfile?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IErrorApi {
    error(): Observable<void>;
    devError(): Observable<void>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ErrorApi implements IErrorApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    error(): Observable<void> {
        let url_ = this.baseUrl + "/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processError(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    devError(): Observable<void> {
        let url_ = this.baseUrl + "/error-dev";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDevError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDevError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDevError(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Error?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IImmigrationCommentApi {
    getComments(id: number): Observable<ImmigrationComment[]>;
    save(comment: ImmigrationComment): Observable<OperationResultOfInteger>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ImmigrationCommentApi implements IImmigrationCommentApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getComments(id: number): Observable<ImmigrationComment[]> {
        let url_ = this.baseUrl + "/api/ImmigrationComment/GetComments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImmigrationComment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImmigrationComment[]>;
        }));
    }

    protected processGetComments(response: HttpResponseBase): Observable<ImmigrationComment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImmigrationComment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(comment: ImmigrationComment): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/ImmigrationComment/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/ImmigrationComment?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILogApi {
    getLogListDetails(id: number): Observable<Log>;
    getLogWithFilters(sortParameters: SortParameters): Observable<LogGridInfo>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class LogApi implements ILogApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLogListDetails(id: number): Observable<Log> {
        let url_ = this.baseUrl + "/api/Log/GetLogListDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogListDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogListDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Log>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Log>;
        }));
    }

    protected processGetLogListDetails(response: HttpResponseBase): Observable<Log> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Log.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLogWithFilters(sortParameters: SortParameters): Observable<LogGridInfo> {
        let url_ = this.baseUrl + "/api/Log/GetLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogWithFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogWithFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogGridInfo>;
        }));
    }

    protected processGetLogWithFilters(response: HttpResponseBase): Observable<LogGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Log?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILookupApi {
    getLookupTypeById(lookupTypeId: number, parentId: number | null | undefined): Observable<LookupType2>;
    getOfficeLocationByEmployee(lookupTypeId: number, parentId: number | null | undefined): Observable<LookupType2>;
    getLookupFieldsByType(lookupTypeId: number, parentId: number | null | undefined, filterKey: number | null | undefined): Observable<LookupField[]>;
    getLookupFieldsWithParentAndFilterKey(lookupTypeId: number, parentId: number | null | undefined, filterKey: number | null | undefined): Observable<LookupField[]>;
    getEmployeesByTeam(teamId: number): Observable<Employee[]>;
    getLookupFieldsByTypes(types: number[]): Observable<LookupField[]>;
    getDeptCodeblocks(lE: number, sMU: number | null, specialityId: number | null): Observable<DeptCodeblock[]>;
    getRank(countryId: number, slId: number): Observable<RankGrade[]>;
    getGrades(rank: string | null, slId: number, countryId: number): Observable<RankGrade[]>;
    getOfficeLocations(country: string | null): Observable<LookupField[]>;
    getAllForeignOffices(countryValue: string | null): Observable<LookupField[]>;
    getAllOfficeLocations(countryValue: string | null): Observable<OfficeLocation[]>;
    getAllTypeAheadOfficeLocations(countryValue: string | null, searchTerm: string | null): Observable<OfficeLocation[]>;
    getRankByCountryCode(countryCode: string | null, slId: number): Observable<RankGrade[]>;
    getGlobalRanks(): Observable<GlobalRank[]>;
    getGlobalGradeForRank(rankCode: string | null): Observable<GlobalGrade[]>;
    getGradeByCountryCode(rank: string | null, slId: number, countryCode: string | null): Observable<RankGrade[]>;
    getOfficeEntities(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<OfficeEntity[]>;
    getServiceLines(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<ServiceLine[]>;
    getWorkPermitJobTitles(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<WorkPermitJobTitle[]>;
    getSubServiceLines(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<SubServiceLine[]>;
    getSMUs(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<SMU[]>;
    getSpecialities(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<Speciality[]>;
    getSectors(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<Sector[]>;
    getOfficeLEByCountryCode(countryCode: string | null): Observable<OfficeEntity[]>;
    getOfficeLEByCountryCodeAndEmployeeId(countryCode: string | null): Observable<OfficeEntity[]>;
    getOfficeLocationByCountryCodeAndEmployee(countryCode: string | null): Observable<LookupField[]>;
    getAuthorisedHubs(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<AuthorisedHub[]>;
    getAllActiveLookupType(): Observable<LookupType2[]>;
    getEditableLookupTypes(): Observable<LookupType2[]>;
    getLookupFieldDataByTypeId(lookyupTypeId: number, sortParameters: SortParameters): Observable<LookupFieldGridInfo>;
    saveLookupFields(isEdit: boolean, lookupField: LookupField): Observable<OperationResultOfInteger>;
    getExitSubTypes(): Observable<LookupField[]>;
    getExitCompanies(): Observable<Companies[]>;
    getJobCategory(): Observable<ExitJobCategory[]>;
    getDeptCodeblocksBySMU(sMU: number, lE: number): Observable<LookupField[]>;
    getExitRank(locationId: number, slId: number): Observable<RankGrade[]>;
    getExitGrades(rank: string | null, slId: number, locationId: number): Observable<RankGrade[]>;
    getOfficeLEByOfficeLocation(officeLocId: number): Observable<OfficeEntity[]>;
    getAirportDetailsBySearch(searchTerm: string | null): Observable<AirportDetails[]>;
    getAllOfficeLocationSearchable(term: string | null): Observable<LookupField[]>;
    getDependentDocuments(module: string | null): Observable<number[]>;
    getCities(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<Cities[]>;
    getCancellationVisa(officeLocation: number): Observable<LookupField[]>;
    getMappedLookUpFieldValues(lookupTypeId: number, typeId: number): Observable<number[]>;
    saveLookUpFieldsAndMapping(isEdit: boolean, selectedIds: string | null, lookupField: LookupField): Observable<OperationResultOfInteger>;
    getOfficeEntitiesByNationality(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<OfficeEntity[]>;
    getLookUpFieldParent(parentId: number, profileId: number): Observable<ValueTupleOfIntegerAndInteger>;
    getVisaOptions(countryId: number): Observable<CountryVisaOptionDto[]>;
    getEmployeeCategoryOptions(employeeId: number, lookuptypeId: number): Observable<LookupField[]>;
    getContractTypeOptions(employeeId: number, lookuptypeId: number): Observable<LookupField[]>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class LookupApi implements ILookupApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLookupTypeById(lookupTypeId: number, parentId: number | null | undefined): Observable<LookupType2> {
        let url_ = this.baseUrl + "/api/Lookup/{lookupTypeId}?";
        if (lookupTypeId === undefined || lookupTypeId === null)
            throw new Error("The parameter 'lookupTypeId' must be defined.");
        url_ = url_.replace("{lookupTypeId}", encodeURIComponent("" + lookupTypeId));
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLookupTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLookupTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupType2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupType2>;
        }));
    }

    protected processGetLookupTypeById(response: HttpResponseBase): Observable<LookupType2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupType2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOfficeLocationByEmployee(lookupTypeId: number, parentId: number | null | undefined): Observable<LookupType2> {
        let url_ = this.baseUrl + "/api/Lookup/GetOfficeLocationByEmployee/{lookupTypeId}?";
        if (lookupTypeId === undefined || lookupTypeId === null)
            throw new Error("The parameter 'lookupTypeId' must be defined.");
        url_ = url_.replace("{lookupTypeId}", encodeURIComponent("" + lookupTypeId));
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeLocationByEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeLocationByEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupType2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupType2>;
        }));
    }

    protected processGetOfficeLocationByEmployee(response: HttpResponseBase): Observable<LookupType2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupType2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLookupFieldsByType(lookupTypeId: number, parentId: number | null | undefined, filterKey: number | null | undefined): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetLookupFieldsByType/{lookupTypeId}?";
        if (lookupTypeId === undefined || lookupTypeId === null)
            throw new Error("The parameter 'lookupTypeId' must be defined.");
        url_ = url_.replace("{lookupTypeId}", encodeURIComponent("" + lookupTypeId));
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLookupFieldsByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLookupFieldsByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetLookupFieldsByType(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLookupFieldsWithParentAndFilterKey(lookupTypeId: number, parentId: number | null | undefined, filterKey: number | null | undefined): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetLookupFieldsWithParentAndFilterKeyAsync/{lookupTypeId}?";
        if (lookupTypeId === undefined || lookupTypeId === null)
            throw new Error("The parameter 'lookupTypeId' must be defined.");
        url_ = url_.replace("{lookupTypeId}", encodeURIComponent("" + lookupTypeId));
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLookupFieldsWithParentAndFilterKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLookupFieldsWithParentAndFilterKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetLookupFieldsWithParentAndFilterKey(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeesByTeam(teamId: number): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetEmployeesByTeam?";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined and cannot be null.");
        else
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesByTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesByTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetEmployeesByTeam(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLookupFieldsByTypes(types: number[]): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetLookupFieldsByTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(types);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLookupFieldsByTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLookupFieldsByTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetLookupFieldsByTypes(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeptCodeblocks(lE: number, sMU: number | null, specialityId: number | null): Observable<DeptCodeblock[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetDeptCodeblocks?";
        if (lE === undefined || lE === null)
            throw new Error("The parameter 'lE' must be defined and cannot be null.");
        else
            url_ += "LE=" + encodeURIComponent("" + lE) + "&";
        if (sMU === undefined)
            throw new Error("The parameter 'sMU' must be defined.");
        else if(sMU !== null)
            url_ += "SMU=" + encodeURIComponent("" + sMU) + "&";
        if (specialityId === undefined)
            throw new Error("The parameter 'specialityId' must be defined.");
        else if(specialityId !== null)
            url_ += "specialityId=" + encodeURIComponent("" + specialityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeptCodeblocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeptCodeblocks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeptCodeblock[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeptCodeblock[]>;
        }));
    }

    protected processGetDeptCodeblocks(response: HttpResponseBase): Observable<DeptCodeblock[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeptCodeblock.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRank(countryId: number, slId: number): Observable<RankGrade[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetRank?";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (slId === undefined || slId === null)
            throw new Error("The parameter 'slId' must be defined and cannot be null.");
        else
            url_ += "SlId=" + encodeURIComponent("" + slId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RankGrade[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RankGrade[]>;
        }));
    }

    protected processGetRank(response: HttpResponseBase): Observable<RankGrade[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RankGrade.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGrades(rank: string | null, slId: number, countryId: number): Observable<RankGrade[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetGrades?";
        if (rank === undefined)
            throw new Error("The parameter 'rank' must be defined.");
        else if(rank !== null)
            url_ += "rank=" + encodeURIComponent("" + rank) + "&";
        if (slId === undefined || slId === null)
            throw new Error("The parameter 'slId' must be defined and cannot be null.");
        else
            url_ += "slId=" + encodeURIComponent("" + slId) + "&";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGrades(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrades(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RankGrade[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RankGrade[]>;
        }));
    }

    protected processGetGrades(response: HttpResponseBase): Observable<RankGrade[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RankGrade.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOfficeLocations(country: string | null): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetOfficeLocations?";
        if (country === undefined)
            throw new Error("The parameter 'country' must be defined.");
        else if(country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetOfficeLocations(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllForeignOffices(countryValue: string | null): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/AllForeignOffices?";
        if (countryValue === undefined)
            throw new Error("The parameter 'countryValue' must be defined.");
        else if(countryValue !== null)
            url_ += "CountryValue=" + encodeURIComponent("" + countryValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForeignOffices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForeignOffices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetAllForeignOffices(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllOfficeLocations(countryValue: string | null): Observable<OfficeLocation[]> {
        let url_ = this.baseUrl + "/api/Lookup/AllOfficeLocations?";
        if (countryValue === undefined)
            throw new Error("The parameter 'countryValue' must be defined.");
        else if(countryValue !== null)
            url_ += "CountryValue=" + encodeURIComponent("" + countryValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOfficeLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOfficeLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeLocation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeLocation[]>;
        }));
    }

    protected processGetAllOfficeLocations(response: HttpResponseBase): Observable<OfficeLocation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeLocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllTypeAheadOfficeLocations(countryValue: string | null, searchTerm: string | null): Observable<OfficeLocation[]> {
        let url_ = this.baseUrl + "/api/Lookup/AllTypeAheadOfficeLocations/{searchTerm}?";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        if (countryValue === undefined)
            throw new Error("The parameter 'countryValue' must be defined.");
        else if(countryValue !== null)
            url_ += "CountryValue=" + encodeURIComponent("" + countryValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypeAheadOfficeLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypeAheadOfficeLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeLocation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeLocation[]>;
        }));
    }

    protected processGetAllTypeAheadOfficeLocations(response: HttpResponseBase): Observable<OfficeLocation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeLocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRankByCountryCode(countryCode: string | null, slId: number): Observable<RankGrade[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetRankByCountryCode?";
        if (countryCode === undefined)
            throw new Error("The parameter 'countryCode' must be defined.");
        else if(countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (slId === undefined || slId === null)
            throw new Error("The parameter 'slId' must be defined and cannot be null.");
        else
            url_ += "slId=" + encodeURIComponent("" + slId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRankByCountryCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankByCountryCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RankGrade[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RankGrade[]>;
        }));
    }

    protected processGetRankByCountryCode(response: HttpResponseBase): Observable<RankGrade[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RankGrade.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGlobalRanks(): Observable<GlobalRank[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetGlobalRanks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlobalRanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalRanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalRank[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalRank[]>;
        }));
    }

    protected processGetGlobalRanks(response: HttpResponseBase): Observable<GlobalRank[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalRank.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGlobalGradeForRank(rankCode: string | null): Observable<GlobalGrade[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetGlobalGradeForRank?";
        if (rankCode === undefined)
            throw new Error("The parameter 'rankCode' must be defined.");
        else if(rankCode !== null)
            url_ += "rankCode=" + encodeURIComponent("" + rankCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlobalGradeForRank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalGradeForRank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalGrade[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalGrade[]>;
        }));
    }

    protected processGetGlobalGradeForRank(response: HttpResponseBase): Observable<GlobalGrade[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalGrade.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGradeByCountryCode(rank: string | null, slId: number, countryCode: string | null): Observable<RankGrade[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetGradeByCountryCode?";
        if (rank === undefined)
            throw new Error("The parameter 'rank' must be defined.");
        else if(rank !== null)
            url_ += "rank=" + encodeURIComponent("" + rank) + "&";
        if (slId === undefined || slId === null)
            throw new Error("The parameter 'slId' must be defined and cannot be null.");
        else
            url_ += "slId=" + encodeURIComponent("" + slId) + "&";
        if (countryCode === undefined)
            throw new Error("The parameter 'countryCode' must be defined.");
        else if(countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGradeByCountryCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGradeByCountryCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RankGrade[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RankGrade[]>;
        }));
    }

    protected processGetGradeByCountryCode(response: HttpResponseBase): Observable<RankGrade[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RankGrade.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOfficeEntities(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<OfficeEntity[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetOfficeEntities?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeEntity[]>;
        }));
    }

    protected processGetOfficeEntities(response: HttpResponseBase): Observable<OfficeEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceLines(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<ServiceLine[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetServiceLines?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceLines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceLines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLine[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLine[]>;
        }));
    }

    protected processGetServiceLines(response: HttpResponseBase): Observable<ServiceLine[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceLine.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkPermitJobTitles(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<WorkPermitJobTitle[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetWorkPermitJobTitles?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkPermitJobTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkPermitJobTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkPermitJobTitle[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkPermitJobTitle[]>;
        }));
    }

    protected processGetWorkPermitJobTitles(response: HttpResponseBase): Observable<WorkPermitJobTitle[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkPermitJobTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubServiceLines(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<SubServiceLine[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetSubServiceLines?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubServiceLines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubServiceLines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubServiceLine[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubServiceLine[]>;
        }));
    }

    protected processGetSubServiceLines(response: HttpResponseBase): Observable<SubServiceLine[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubServiceLine.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSMUs(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<SMU[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetSMUs?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMUs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMUs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMU[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMU[]>;
        }));
    }

    protected processGetSMUs(response: HttpResponseBase): Observable<SMU[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMU.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpecialities(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<Speciality[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetSpecialities?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Speciality[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Speciality[]>;
        }));
    }

    protected processGetSpecialities(response: HttpResponseBase): Observable<Speciality[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Speciality.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSectors(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<Sector[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetSectors?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Sector[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Sector[]>;
        }));
    }

    protected processGetSectors(response: HttpResponseBase): Observable<Sector[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Sector.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOfficeLEByCountryCode(countryCode: string | null): Observable<OfficeEntity[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetOfficeLEByCountryCode?";
        if (countryCode === undefined)
            throw new Error("The parameter 'countryCode' must be defined.");
        else if(countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeLEByCountryCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeLEByCountryCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeEntity[]>;
        }));
    }

    protected processGetOfficeLEByCountryCode(response: HttpResponseBase): Observable<OfficeEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOfficeLEByCountryCodeAndEmployeeId(countryCode: string | null): Observable<OfficeEntity[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetOfficeLEByCountryCodeAndEmployee?";
        if (countryCode === undefined)
            throw new Error("The parameter 'countryCode' must be defined.");
        else if(countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeLEByCountryCodeAndEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeLEByCountryCodeAndEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeEntity[]>;
        }));
    }

    protected processGetOfficeLEByCountryCodeAndEmployeeId(response: HttpResponseBase): Observable<OfficeEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOfficeLocationByCountryCodeAndEmployee(countryCode: string | null): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetOfficeLocationByCountryCodeAndEmployee?";
        if (countryCode === undefined)
            throw new Error("The parameter 'countryCode' must be defined.");
        else if(countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeLocationByCountryCodeAndEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeLocationByCountryCodeAndEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetOfficeLocationByCountryCodeAndEmployee(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAuthorisedHubs(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<AuthorisedHub[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetAuthorisedHubs?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorisedHubs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorisedHubs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorisedHub[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorisedHub[]>;
        }));
    }

    protected processGetAuthorisedHubs(response: HttpResponseBase): Observable<AuthorisedHub[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorisedHub.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllActiveLookupType(): Observable<LookupType2[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetAllActiveLookupTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveLookupType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveLookupType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupType2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupType2[]>;
        }));
    }

    protected processGetAllActiveLookupType(response: HttpResponseBase): Observable<LookupType2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupType2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEditableLookupTypes(): Observable<LookupType2[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetEditableLookupTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditableLookupTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditableLookupTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupType2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupType2[]>;
        }));
    }

    protected processGetEditableLookupTypes(response: HttpResponseBase): Observable<LookupType2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupType2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLookupFieldDataByTypeId(lookyupTypeId: number, sortParameters: SortParameters): Observable<LookupFieldGridInfo> {
        let url_ = this.baseUrl + "/api/Lookup/GetLookupTypeData?";
        if (lookyupTypeId === undefined || lookyupTypeId === null)
            throw new Error("The parameter 'lookyupTypeId' must be defined and cannot be null.");
        else
            url_ += "lookyupTypeId=" + encodeURIComponent("" + lookyupTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sortParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLookupFieldDataByTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLookupFieldDataByTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupFieldGridInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupFieldGridInfo>;
        }));
    }

    protected processGetLookupFieldDataByTypeId(response: HttpResponseBase): Observable<LookupFieldGridInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupFieldGridInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveLookupFields(isEdit: boolean, lookupField: LookupField): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Lookup/SaveLookupFields?";
        if (isEdit === undefined || isEdit === null)
            throw new Error("The parameter 'isEdit' must be defined and cannot be null.");
        else
            url_ += "isEdit=" + encodeURIComponent("" + isEdit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lookupField);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLookupFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLookupFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSaveLookupFields(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExitSubTypes(): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetExitSubTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitSubTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitSubTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetExitSubTypes(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExitCompanies(): Observable<Companies[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Companies[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Companies[]>;
        }));
    }

    protected processGetExitCompanies(response: HttpResponseBase): Observable<Companies[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Companies.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobCategory(): Observable<ExitJobCategory[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetJobCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitJobCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitJobCategory[]>;
        }));
    }

    protected processGetJobCategory(response: HttpResponseBase): Observable<ExitJobCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExitJobCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeptCodeblocksBySMU(sMU: number, lE: number): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetDeptCodeblocksBySMU?";
        if (sMU === undefined || sMU === null)
            throw new Error("The parameter 'sMU' must be defined and cannot be null.");
        else
            url_ += "SMU=" + encodeURIComponent("" + sMU) + "&";
        if (lE === undefined || lE === null)
            throw new Error("The parameter 'lE' must be defined and cannot be null.");
        else
            url_ += "LE=" + encodeURIComponent("" + lE) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeptCodeblocksBySMU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeptCodeblocksBySMU(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetDeptCodeblocksBySMU(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExitRank(locationId: number, slId: number): Observable<RankGrade[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetExitRank?";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined and cannot be null.");
        else
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (slId === undefined || slId === null)
            throw new Error("The parameter 'slId' must be defined and cannot be null.");
        else
            url_ += "SlId=" + encodeURIComponent("" + slId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitRank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitRank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RankGrade[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RankGrade[]>;
        }));
    }

    protected processGetExitRank(response: HttpResponseBase): Observable<RankGrade[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RankGrade.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExitGrades(rank: string | null, slId: number, locationId: number): Observable<RankGrade[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetExitGrades?";
        if (rank === undefined)
            throw new Error("The parameter 'rank' must be defined.");
        else if(rank !== null)
            url_ += "rank=" + encodeURIComponent("" + rank) + "&";
        if (slId === undefined || slId === null)
            throw new Error("The parameter 'slId' must be defined and cannot be null.");
        else
            url_ += "slId=" + encodeURIComponent("" + slId) + "&";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined and cannot be null.");
        else
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitGrades(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitGrades(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RankGrade[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RankGrade[]>;
        }));
    }

    protected processGetExitGrades(response: HttpResponseBase): Observable<RankGrade[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RankGrade.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOfficeLEByOfficeLocation(officeLocId: number): Observable<OfficeEntity[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetOfficeLEByofficeLocation?";
        if (officeLocId === undefined || officeLocId === null)
            throw new Error("The parameter 'officeLocId' must be defined and cannot be null.");
        else
            url_ += "officeLocId=" + encodeURIComponent("" + officeLocId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeLEByOfficeLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeLEByOfficeLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeEntity[]>;
        }));
    }

    protected processGetOfficeLEByOfficeLocation(response: HttpResponseBase): Observable<OfficeEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAirportDetailsBySearch(searchTerm: string | null): Observable<AirportDetails[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetAirportDetailsBySearch?";
        if (searchTerm === undefined)
            throw new Error("The parameter 'searchTerm' must be defined.");
        else if(searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirportDetailsBySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirportDetailsBySearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AirportDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AirportDetails[]>;
        }));
    }

    protected processGetAirportDetailsBySearch(response: HttpResponseBase): Observable<AirportDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirportDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllOfficeLocationSearchable(term: string | null): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetAllOfficeLocationSearchable?";
        if (term === undefined)
            throw new Error("The parameter 'term' must be defined.");
        else if(term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOfficeLocationSearchable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOfficeLocationSearchable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetAllOfficeLocationSearchable(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDependentDocuments(module: string | null): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetDependentDocumentList?";
        if (module === undefined)
            throw new Error("The parameter 'module' must be defined.");
        else if(module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDependentDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDependentDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetDependentDocuments(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCities(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<Cities[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetCities?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Cities[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Cities[]>;
        }));
    }

    protected processGetCities(response: HttpResponseBase): Observable<Cities[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Cities.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCancellationVisa(officeLocation: number): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetCancellationVisa?";
        if (officeLocation === undefined || officeLocation === null)
            throw new Error("The parameter 'officeLocation' must be defined and cannot be null.");
        else
            url_ += "officeLocation=" + encodeURIComponent("" + officeLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancellationVisa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancellationVisa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetCancellationVisa(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMappedLookUpFieldValues(lookupTypeId: number, typeId: number): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetMappedLookUpFieldValues?";
        if (lookupTypeId === undefined || lookupTypeId === null)
            throw new Error("The parameter 'lookupTypeId' must be defined and cannot be null.");
        else
            url_ += "lookupTypeId=" + encodeURIComponent("" + lookupTypeId) + "&";
        if (typeId === undefined || typeId === null)
            throw new Error("The parameter 'typeId' must be defined and cannot be null.");
        else
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMappedLookUpFieldValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMappedLookUpFieldValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetMappedLookUpFieldValues(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveLookUpFieldsAndMapping(isEdit: boolean, selectedIds: string | null, lookupField: LookupField): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/Lookup/SaveLookUpFieldsAndMapping?";
        if (isEdit === undefined || isEdit === null)
            throw new Error("The parameter 'isEdit' must be defined and cannot be null.");
        else
            url_ += "isEdit=" + encodeURIComponent("" + isEdit) + "&";
        if (selectedIds === undefined)
            throw new Error("The parameter 'selectedIds' must be defined.");
        else if(selectedIds !== null)
            url_ += "selectedIds=" + encodeURIComponent("" + selectedIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lookupField);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLookUpFieldsAndMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLookUpFieldsAndMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processSaveLookUpFieldsAndMapping(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOfficeEntitiesByNationality(parentId: number | null | undefined, filterKey: number | null | undefined): Observable<OfficeEntity[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetOfficeEntitiesByNationality?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterKey !== undefined && filterKey !== null)
            url_ += "filterKey=" + encodeURIComponent("" + filterKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeEntitiesByNationality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeEntitiesByNationality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeEntity[]>;
        }));
    }

    protected processGetOfficeEntitiesByNationality(response: HttpResponseBase): Observable<OfficeEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLookUpFieldParent(parentId: number, profileId: number): Observable<ValueTupleOfIntegerAndInteger> {
        let url_ = this.baseUrl + "/api/Lookup/GetLookUpFieldParent?";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined and cannot be null.");
        else
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLookUpFieldParent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLookUpFieldParent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfIntegerAndInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfIntegerAndInteger>;
        }));
    }

    protected processGetLookUpFieldParent(response: HttpResponseBase): Observable<ValueTupleOfIntegerAndInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfIntegerAndInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVisaOptions(countryId: number): Observable<CountryVisaOptionDto[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetVisaOptions?";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisaOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisaOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryVisaOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryVisaOptionDto[]>;
        }));
    }

    protected processGetVisaOptions(response: HttpResponseBase): Observable<CountryVisaOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryVisaOptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeCategoryOptions(employeeId: number, lookuptypeId: number): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetEmployeeCategoryOptions?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (lookuptypeId === undefined || lookuptypeId === null)
            throw new Error("The parameter 'lookuptypeId' must be defined and cannot be null.");
        else
            url_ += "lookuptypeId=" + encodeURIComponent("" + lookuptypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeCategoryOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeCategoryOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetEmployeeCategoryOptions(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContractTypeOptions(employeeId: number, lookuptypeId: number): Observable<LookupField[]> {
        let url_ = this.baseUrl + "/api/Lookup/GetContractTypeOptions?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (lookuptypeId === undefined || lookuptypeId === null)
            throw new Error("The parameter 'lookuptypeId' must be defined and cannot be null.");
        else
            url_ += "lookuptypeId=" + encodeURIComponent("" + lookuptypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractTypeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractTypeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupField[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupField[]>;
        }));
    }

    protected processGetContractTypeOptions(response: HttpResponseBase): Observable<LookupField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Lookup?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPBApi {
    getActivities(candidateId: number): Observable<CandidateActivities>;
    savePBProfile(cpId: number, pBProfile: PBProfile): Observable<PBProfile>;
    updateCandidateActivity(cpID: number, activityID: number, status: ActivityStatus): Observable<CandidateActivity>;
    createCandidateActivities(): Observable<OperationResultOfInteger>;
    lockDownActivities(pbId: number): Observable<OperationResultOfInteger>;
    amendProfile(profile: PBProfile): Observable<OperationResultOfInteger>;
    getDatesList(type: DateFields, range: DateRange): Observable<KeyValuePairOfStringAndDateTime[]>;
    saveStartdate(pbProfileId: number, cpId: number, newStartDate: Date, mailnotify: boolean, confirmedEndDate: Date | null): Observable<OperationResultOfString>;
    getHMStatus(pbProfileId: number): Observable<boolean>;
    isProfileExists(pbProfileId: number): Observable<boolean>;
    candidateAdditionDetailsSave(details: CandidateProfileAdditionalDetails): Observable<OperationResultOfString>;
    getCandidateAdditionDetails(candidateProfileId: number): Observable<CandidateProfileAdditionalDetails>;
    getPbProfileDetails(candidateProfileId: number): Observable<PBProfile>;
    saveBuddyCounselor(cpId: number, pBProfile: PBProfile): Observable<PBProfile>;
    getRequestType(pbProfileId: number): Observable<boolean>;
    updateCandidateStatus(cpId: number, pBProfile: PBProfile): Observable<PBProfile>;
    getAppConfigValue(key: string | null, cpId: number): Observable<string>;
    updateFlightBookingDate(pbId: number, initDate: Date, compDate: Date): Observable<boolean>;
    updateVendorPODetails(pbId: number, pBProfile: PBProfile): Observable<boolean>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class PBApi implements IPBApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
      this.jsonParseReviver = (key: string, value: any) => {
        let keys = ["pbInitiationdatebyPTC", "marriageEffectiveDate", "lastWorkingday", "epRequestedDate",
          "epCreatedDate", "startdate", "confirmedEnddate", "eyApprovedVisaDate", "entryPermitExpiryDate",
          "empDateOfIntiation", "empDateOfCompletion", "depDateOfIntiation", "depDateOfCompletion", "bookingInitiationDate", "bookingCompletionDate",
          "documentExpectedDate", "educationDocumentProcurementforAttestationRequestInitiatedDate",
          "educationDocumentProcurementforAttestationDocumentscollectedDate",
          "educationDocumentProcurementforAttestationAssesmentDate",
          "educationDocumentProcurementforAttestationCompletedDate",
          "documentProcurementforWorkPermitInitiatedDate",
          "documentProcurementforWorkPermitCollectedDate",
          "documentProcurementforWorkPermitAssesmentDate",
          "documentProcurementforWorkPermitCompletedDate",
          "educationDocumentAttestationInitiatedDate",
          "educationDocumentAttestationUnderProcessDate",
          "educationDocumentAttestationCompletedDate",
          "exceptionApprovalWorkPermitInitiatedDate",
          "exceptionApprovalWorkPermitApprovalReceivedDate",
          "corporateDocumentInitiatedDate",
          "corporateDocumentReceivedByVendorDate",
          "corporateDocumentAssesmentDate",
          "corporateDocumentCompletedDate",
          "visaReTaggingInitiatedDate",
          "visaReTaggingCompletedDate",
          "revisedCorporateDocumentInitiatedDate",
          "revisedCorporateDocumentReceivedByVendorDate",
          "revisedCorporateDocumentAssesmentDate",
          "revisedCorporateDocumentCompletedDate",
          "mosadaqaInitiatedDate",
          "mosadaqaUnderProcessDate",
          "mosadaqaCompletedDate",
          "qvpInitiatedDate",
          "qvpUnderProcessDate",
          "qvpCompletedDate",
          "professionalMembershipCertificateInitiatedDate",
          "professionalMembershipCertificateUnderProcessDate",
          "professionalMembershipCertificateCompletedDate",
          "businessVisaCancellationLetterInitiatedDate",
          "businessVisaCancellationLetterCompletedDate",
          "wpApplicationNJMedicalAppointmentDate",
          "wpApplicationNJMedicalProcessCompletedDate",
          "wpApplicationNJPCCAppointmentDate",
          "wpApplicationNJPCCProcessCompletedDate",
          "wpApplicationNJBiometricsAppointmentDate",
          "wpApplicationNJBiometricsProcessCompletedDate",
          "wpApplicationNJHomeCountryVisaStampingProcessDate",
          "wpApplicationNJHomeVisaStampedIssuedDate",
          "wpApplicationEYInitiatedDate",
          "wpApplicationEYQVCAppointmentDate",
          "wpApplicationEYEmbassyAppointmentDate",
          "wpApplicationEYWorkPermitIssuedDate",
          "laborContractReceivedImmigrationDate",
          "laborContractSharedWithEmployeeDate",
          "laborContractReceivedFromEmployeeDate",
          "laborContractSharedWithImmigrationDate",
          "homeCountryExitFormalityInitiatedDate",
          "homeCountryExitFormalityUnderProcessDate",
          "homeCountryExitFormalityCompletedDate",
          "travelBookingInitiatedDate",
          "travelBookingCompletedDate"
        ]

        if (key && key != "" && keys.includes(key)) {
          return value?.replace('Z', '');
        }
        return value; // TODO: Transform value if necessary
      };

    }

    getActivities(candidateId: number): Observable<CandidateActivities> {
        let url_ = this.baseUrl + "/api/PB/GetActivities?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateActivities>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateActivities>;
        }));
    }

    protected processGetActivities(response: HttpResponseBase): Observable<CandidateActivities> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateActivities.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    savePBProfile(cpId: number, pBProfile: PBProfile): Observable<PBProfile> {
        let url_ = this.baseUrl + "/api/PB/SavePBProfile?";
        if (cpId === undefined || cpId === null)
            throw new Error("The parameter 'cpId' must be defined and cannot be null.");
        else
            url_ += "cpId=" + encodeURIComponent("" + cpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pBProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePBProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePBProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PBProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PBProfile>;
        }));
    }

    protected processSavePBProfile(response: HttpResponseBase): Observable<PBProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PBProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCandidateActivity(cpID: number, activityID: number, status: ActivityStatus): Observable<CandidateActivity> {
        let url_ = this.baseUrl + "/api/PB/UpdateCandidateActivity?";
        if (cpID === undefined || cpID === null)
            throw new Error("The parameter 'cpID' must be defined and cannot be null.");
        else
            url_ += "cpID=" + encodeURIComponent("" + cpID) + "&";
        if (activityID === undefined || activityID === null)
            throw new Error("The parameter 'activityID' must be defined and cannot be null.");
        else
            url_ += "activityID=" + encodeURIComponent("" + activityID) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCandidateActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCandidateActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateActivity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateActivity>;
        }));
    }

    protected processUpdateCandidateActivity(response: HttpResponseBase): Observable<CandidateActivity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCandidateActivities(): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/PB/CreateCandidateActivities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCandidateActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCandidateActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processCreateCandidateActivities(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    lockDownActivities(pbId: number): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/PB/LockDownActivities?";
        if (pbId === undefined || pbId === null)
            throw new Error("The parameter 'pbId' must be defined and cannot be null.");
        else
            url_ += "pbId=" + encodeURIComponent("" + pbId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockDownActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockDownActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processLockDownActivities(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    amendProfile(profile: PBProfile): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/PB/AmendProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAmendProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAmendProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processAmendProfile(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDatesList(type: DateFields, range: DateRange): Observable<KeyValuePairOfStringAndDateTime[]> {
        let url_ = this.baseUrl + "/api/PB/GetDatesList?";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(range);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfStringAndDateTime[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfStringAndDateTime[]>;
        }));
    }

    protected processGetDatesList(response: HttpResponseBase): Observable<KeyValuePairOfStringAndDateTime[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndDateTime.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveStartdate(pbProfileId: number, cpId: number, newStartDate: Date, mailnotify: boolean, confirmedEndDate: Date | null): Observable<OperationResultOfString> {
        let url_ = this.baseUrl + "/api/PB/SaveStartdate?";
        if (pbProfileId === undefined || pbProfileId === null)
            throw new Error("The parameter 'pbProfileId' must be defined and cannot be null.");
        else
            url_ += "pbProfileId=" + encodeURIComponent("" + pbProfileId) + "&";
        if (cpId === undefined || cpId === null)
            throw new Error("The parameter 'cpId' must be defined and cannot be null.");
        else
            url_ += "cpId=" + encodeURIComponent("" + cpId) + "&";
        if (newStartDate === undefined || newStartDate === null)
            throw new Error("The parameter 'newStartDate' must be defined and cannot be null.");
        else
            url_ += "newStartDate=" + encodeURIComponent(newStartDate ? "" + newStartDate.toISOString() : "") + "&";
        if (mailnotify === undefined || mailnotify === null)
            throw new Error("The parameter 'mailnotify' must be defined and cannot be null.");
        else
            url_ += "mailnotify=" + encodeURIComponent("" + mailnotify) + "&";
        if (confirmedEndDate === undefined)
            throw new Error("The parameter 'confirmedEndDate' must be defined.");
        else if(confirmedEndDate !== null)
            url_ += "confirmedEndDate=" + encodeURIComponent(confirmedEndDate ? "" + confirmedEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveStartdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveStartdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfString>;
        }));
    }

    protected processSaveStartdate(response: HttpResponseBase): Observable<OperationResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHMStatus(pbProfileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PB/GetHMStatus?";
        if (pbProfileId === undefined || pbProfileId === null)
            throw new Error("The parameter 'pbProfileId' must be defined and cannot be null.");
        else
            url_ += "pbProfileId=" + encodeURIComponent("" + pbProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHMStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHMStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetHMStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isProfileExists(pbProfileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PB/IsProfileExists?";
        if (pbProfileId === undefined || pbProfileId === null)
            throw new Error("The parameter 'pbProfileId' must be defined and cannot be null.");
        else
            url_ += "pbProfileId=" + encodeURIComponent("" + pbProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsProfileExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsProfileExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsProfileExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    candidateAdditionDetailsSave(details: CandidateProfileAdditionalDetails): Observable<OperationResultOfString> {
        let url_ = this.baseUrl + "/api/PB/CandidateAdditionDetailsSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidateAdditionDetailsSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidateAdditionDetailsSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfString>;
        }));
    }

    protected processCandidateAdditionDetailsSave(response: HttpResponseBase): Observable<OperationResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateAdditionDetails(candidateProfileId: number): Observable<CandidateProfileAdditionalDetails> {
        let url_ = this.baseUrl + "/api/PB/GetCandidateAdditionDetails?";
        if (candidateProfileId === undefined || candidateProfileId === null)
            throw new Error("The parameter 'candidateProfileId' must be defined and cannot be null.");
        else
            url_ += "candidateProfileId=" + encodeURIComponent("" + candidateProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateAdditionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateAdditionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateProfileAdditionalDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateProfileAdditionalDetails>;
        }));
    }

    protected processGetCandidateAdditionDetails(response: HttpResponseBase): Observable<CandidateProfileAdditionalDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidateProfileAdditionalDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPbProfileDetails(candidateProfileId: number): Observable<PBProfile> {
        let url_ = this.baseUrl + "/api/PB/GetPbProfileDetails?";
        if (candidateProfileId === undefined || candidateProfileId === null)
            throw new Error("The parameter 'candidateProfileId' must be defined and cannot be null.");
        else
            url_ += "candidateProfileId=" + encodeURIComponent("" + candidateProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPbProfileDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPbProfileDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PBProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PBProfile>;
        }));
    }

    protected processGetPbProfileDetails(response: HttpResponseBase): Observable<PBProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PBProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveBuddyCounselor(cpId: number, pBProfile: PBProfile): Observable<PBProfile> {
        let url_ = this.baseUrl + "/api/PB/SaveBuddyCounselor?";
        if (cpId === undefined || cpId === null)
            throw new Error("The parameter 'cpId' must be defined and cannot be null.");
        else
            url_ += "cpId=" + encodeURIComponent("" + cpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pBProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBuddyCounselor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBuddyCounselor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PBProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PBProfile>;
        }));
    }

    protected processSaveBuddyCounselor(response: HttpResponseBase): Observable<PBProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PBProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequestType(pbProfileId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PB/GetRequestType?";
        if (pbProfileId === undefined || pbProfileId === null)
            throw new Error("The parameter 'pbProfileId' must be defined and cannot be null.");
        else
            url_ += "pbProfileId=" + encodeURIComponent("" + pbProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetRequestType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCandidateStatus(cpId: number, pBProfile: PBProfile): Observable<PBProfile> {
        let url_ = this.baseUrl + "/api/PB/UpdateCandidateStatus?";
        if (cpId === undefined || cpId === null)
            throw new Error("The parameter 'cpId' must be defined and cannot be null.");
        else
            url_ += "cpId=" + encodeURIComponent("" + cpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pBProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCandidateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCandidateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PBProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PBProfile>;
        }));
    }

    protected processUpdateCandidateStatus(response: HttpResponseBase): Observable<PBProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PBProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppConfigValue(key: string | null, cpId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/PB/GetAppConfigValue?";
        if (key === undefined)
            throw new Error("The parameter 'key' must be defined.");
        else if(key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (cpId === undefined || cpId === null)
            throw new Error("The parameter 'cpId' must be defined and cannot be null.");
        else
            url_ += "cpId=" + encodeURIComponent("" + cpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppConfigValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppConfigValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAppConfigValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFlightBookingDate(pbId: number, initDate: Date, compDate: Date): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PB/UpdateDates?";
        if (pbId === undefined || pbId === null)
            throw new Error("The parameter 'pbId' must be defined and cannot be null.");
        else
            url_ += "pbId=" + encodeURIComponent("" + pbId) + "&";
        if (initDate === undefined || initDate === null)
            throw new Error("The parameter 'initDate' must be defined and cannot be null.");
        else
            url_ += "initDate=" + encodeURIComponent(initDate ? "" + initDate.toISOString() : "") + "&";
        if (compDate === undefined || compDate === null)
            throw new Error("The parameter 'compDate' must be defined and cannot be null.");
        else
            url_ += "compDate=" + encodeURIComponent(compDate ? "" + compDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFlightBookingDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFlightBookingDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateFlightBookingDate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVendorPODetails(pbId: number, pBProfile: PBProfile): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PB/UpdateVendorPODetails?";
        if (pbId === undefined || pbId === null)
            throw new Error("The parameter 'pbId' must be defined and cannot be null.");
        else
            url_ += "pbId=" + encodeURIComponent("" + pbId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pBProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVendorPODetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorPODetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateVendorPODetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/PB?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserApi {
    getEmployeesByRole(roleType: RoleType): Observable<Employee[]>;
    getEmployeesByRoleForGridFilter(roleType: RoleType): Observable<Employee[]>;
    getEmployeesFilteredByRole(filter: string | null, roleType: RoleType[]): Observable<Employee[]>;
    getEmployeesInRoles(roleTypes: RoleType[]): Observable<Employee[]>;
    getAllEmployeesByRoleAndOfficeLocation(roleType: RoleType, countryValue: string | null, filterParam: FilterParams): Observable<Employee[]>;
    getAllEmployeesByRoleInCountry(roleType: RoleType, countryValue: string | null, filterParam: FilterParams): Observable<Employee[]>;
    getAllEmployeesByRoleAndOfficeLegalEntity(roleType: RoleType, countryValue: string | null, filterParam: FilterParams): Observable<Employee[]>;
    getUsersByClaimValue(roleClaimValue: string | null, countryValue: string | null): Observable<Employee[]>;
    getUserDetails(userId: number): Observable<AppUser>;
    saveUserDelegate(userId: number, delegateId: number): Observable<AppUser>;
    saveEmailSignature(user: AppUser): Observable<AppUser>;
    getDefaultEmailSignature(): Observable<string>;
    getUsers(queryParameters: QueryParametersOfUserListFilter): Observable<PagedResultOfUserInfo>;
    getRoles(): Observable<UserRole[]>;
    updateUserRoles(userInfo: UserInfo): Observable<OperationResultOfInteger>;
    addUserWithRoles(userInfo: UserInfo): Observable<OperationResultOfInteger>;
    getPrimaryRole(employeeId: number): Observable<string>;
    getConsultantsByLegalEntity(officeLeId: number[]): Observable<Employee[]>;
    getEmployeeAdditionalInfo(empId: number): Observable<EmployeeAdditionalInfo>;
    getEmployeesByFilter(filter: string | null): Observable<EmployeeProfile[]>;
    customTrim(value: string | null): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class UserApi implements IUserApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEmployeesByRole(roleType: RoleType): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/User/GetUsersByRole?";
        if (roleType === undefined || roleType === null)
            throw new Error("The parameter 'roleType' must be defined and cannot be null.");
        else
            url_ += "roleType=" + encodeURIComponent("" + roleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetEmployeesByRole(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeesByRoleForGridFilter(roleType: RoleType): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/User/GetUsersByRoleForGridFilter?";
        if (roleType === undefined || roleType === null)
            throw new Error("The parameter 'roleType' must be defined and cannot be null.");
        else
            url_ += "roleType=" + encodeURIComponent("" + roleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesByRoleForGridFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesByRoleForGridFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetEmployeesByRoleForGridFilter(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeesFilteredByRole(filter: string | null, roleType: RoleType[]): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/User/GetEmployeesFilteredByRole?";
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesFilteredByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesFilteredByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetEmployeesFilteredByRole(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeesInRoles(roleTypes: RoleType[]): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/User/GetEmployeesInRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleTypes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesInRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesInRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetEmployeesInRoles(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllEmployeesByRoleAndOfficeLocation(roleType: RoleType, countryValue: string | null, filterParam: FilterParams): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/User/GetAllEmployeesByRoleAndOfficeLocation?";
        if (roleType === undefined || roleType === null)
            throw new Error("The parameter 'roleType' must be defined and cannot be null.");
        else
            url_ += "roleType=" + encodeURIComponent("" + roleType) + "&";
        if (countryValue === undefined)
            throw new Error("The parameter 'countryValue' must be defined.");
        else if(countryValue !== null)
            url_ += "countryValue=" + encodeURIComponent("" + countryValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeesByRoleAndOfficeLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeesByRoleAndOfficeLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetAllEmployeesByRoleAndOfficeLocation(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllEmployeesByRoleInCountry(roleType: RoleType, countryValue: string | null, filterParam: FilterParams): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/User/GetAllEmployeesByRoleInCountry?";
        if (roleType === undefined || roleType === null)
            throw new Error("The parameter 'roleType' must be defined and cannot be null.");
        else
            url_ += "roleType=" + encodeURIComponent("" + roleType) + "&";
        if (countryValue === undefined)
            throw new Error("The parameter 'countryValue' must be defined.");
        else if(countryValue !== null)
            url_ += "countryValue=" + encodeURIComponent("" + countryValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeesByRoleInCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeesByRoleInCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetAllEmployeesByRoleInCountry(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllEmployeesByRoleAndOfficeLegalEntity(roleType: RoleType, countryValue: string | null, filterParam: FilterParams): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/User/GetAllEmployeesByRoleAndOfficeLegalEntity?";
        if (roleType === undefined || roleType === null)
            throw new Error("The parameter 'roleType' must be defined and cannot be null.");
        else
            url_ += "roleType=" + encodeURIComponent("" + roleType) + "&";
        if (countryValue === undefined)
            throw new Error("The parameter 'countryValue' must be defined.");
        else if(countryValue !== null)
            url_ += "countryValue=" + encodeURIComponent("" + countryValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeesByRoleAndOfficeLegalEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeesByRoleAndOfficeLegalEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetAllEmployeesByRoleAndOfficeLegalEntity(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersByClaimValue(roleClaimValue: string | null, countryValue: string | null): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/User/GetUsersByClaimValue?";
        if (roleClaimValue === undefined)
            throw new Error("The parameter 'roleClaimValue' must be defined.");
        else if(roleClaimValue !== null)
            url_ += "RoleClaimValue=" + encodeURIComponent("" + roleClaimValue) + "&";
        if (countryValue === undefined)
            throw new Error("The parameter 'countryValue' must be defined.");
        else if(countryValue !== null)
            url_ += "CountryValue=" + encodeURIComponent("" + countryValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByClaimValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByClaimValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetUsersByClaimValue(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserDetails(userId: number): Observable<AppUser> {
        let url_ = this.baseUrl + "/api/User/GetUserDetails?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppUser>;
        }));
    }

    protected processGetUserDetails(response: HttpResponseBase): Observable<AppUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveUserDelegate(userId: number, delegateId: number): Observable<AppUser> {
        let url_ = this.baseUrl + "/api/User/SaveUserDelegate?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (delegateId === undefined || delegateId === null)
            throw new Error("The parameter 'delegateId' must be defined and cannot be null.");
        else
            url_ += "delegateId=" + encodeURIComponent("" + delegateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserDelegate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserDelegate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppUser>;
        }));
    }

    protected processSaveUserDelegate(response: HttpResponseBase): Observable<AppUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveEmailSignature(user: AppUser): Observable<AppUser> {
        let url_ = this.baseUrl + "/api/User/SaveEmailSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmailSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmailSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppUser>;
        }));
    }

    protected processSaveEmailSignature(response: HttpResponseBase): Observable<AppUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDefaultEmailSignature(): Observable<string> {
        let url_ = this.baseUrl + "/api/User/GetDefaultEmailSignature";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEmailSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEmailSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDefaultEmailSignature(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsers(queryParameters: QueryParametersOfUserListFilter): Observable<PagedResultOfUserInfo> {
        let url_ = this.baseUrl + "/api/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfUserInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfUserInfo>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultOfUserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfUserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoles(): Observable<UserRole[]> {
        let url_ = this.baseUrl + "/api/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRole[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRole[]>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<UserRole[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserRoles(userInfo: UserInfo): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/User/UpdateUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processUpdateUserRoles(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUserWithRoles(userInfo: UserInfo): Observable<OperationResultOfInteger> {
        let url_ = this.baseUrl + "/api/User/AddUserWithRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserWithRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserWithRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationResultOfInteger>;
        }));
    }

    protected processAddUserWithRoles(response: HttpResponseBase): Observable<OperationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrimaryRole(employeeId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/User/GetPrimaryRole?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrimaryRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrimaryRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPrimaryRole(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConsultantsByLegalEntity(officeLeId: number[]): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/User/GetConsultantsByLegalEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(officeLeId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultantsByLegalEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultantsByLegalEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetConsultantsByLegalEntity(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeAdditionalInfo(empId: number): Observable<EmployeeAdditionalInfo> {
        let url_ = this.baseUrl + "/api/User/GetEmployeeAdditionalInfo?";
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined and cannot be null.");
        else
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeAdditionalInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeAdditionalInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeAdditionalInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeAdditionalInfo>;
        }));
    }

    protected processGetEmployeeAdditionalInfo(response: HttpResponseBase): Observable<EmployeeAdditionalInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAdditionalInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeesByFilter(filter: string | null): Observable<EmployeeProfile[]> {
        let url_ = this.baseUrl + "/api/User/GetEmployeesByFilter?";
        if (filter === undefined)
            throw new Error("The parameter 'filter' must be defined.");
        else if(filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeProfile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeProfile[]>;
        }));
    }

    protected processGetEmployeesByFilter(response: HttpResponseBase): Observable<EmployeeProfile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeProfile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customTrim(value: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/User?";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomTrim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomTrim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomTrim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = EosApiException.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class OperationResultOfCandidateGridInfo implements IOperationResultOfCandidateGridInfo {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CandidateGridInfo | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfCandidateGridInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? CandidateGridInfo.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfCandidateGridInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfCandidateGridInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfCandidateGridInfo {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CandidateGridInfo | undefined;
    errorCode?: number;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    PermanentRedirect = 308,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    MisdirectedRequest = 421,
    UnprocessableEntity = 422,
    Locked = 423,
    FailedDependency = 424,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    TooManyRequests = 429,
    RequestHeaderFieldsTooLarge = 431,
    UnavailableForLegalReasons = 451,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
    VariantAlsoNegotiates = 506,
    InsufficientStorage = 507,
    LoopDetected = 508,
    NotExtended = 510,
    NetworkAuthenticationRequired = 511,
}

export class CandidateGridInfo implements ICandidateGridInfo {
    candidateProfiles?: CandidateProfile[] | undefined;
    immigrationProfiles?: ImmigrationProfile[] | undefined;
    employeeProfiles?: EmployeeProfile[] | undefined;
    exitRequests?: ExitRequest[] | undefined;
    cwProfiles?: CWProfile[] | undefined;
    sortParameters?: SortParameters | undefined;
    startdatePending?: boolean;
    commentPending?: boolean;
    autoVisaRequestPending?: boolean;
    startDate?: Date | undefined;

    constructor(data?: ICandidateGridInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["candidateProfiles"])) {
                this.candidateProfiles = [] as any;
                for (let item of _data["candidateProfiles"])
                    this.candidateProfiles!.push(CandidateProfile.fromJS(item));
            }
            if (Array.isArray(_data["immigrationProfiles"])) {
                this.immigrationProfiles = [] as any;
                for (let item of _data["immigrationProfiles"])
                    this.immigrationProfiles!.push(ImmigrationProfile.fromJS(item));
            }
            if (Array.isArray(_data["employeeProfiles"])) {
                this.employeeProfiles = [] as any;
                for (let item of _data["employeeProfiles"])
                    this.employeeProfiles!.push(EmployeeProfile.fromJS(item));
            }
            if (Array.isArray(_data["exitRequests"])) {
                this.exitRequests = [] as any;
                for (let item of _data["exitRequests"])
                    this.exitRequests!.push(ExitRequest.fromJS(item));
            }
            if (Array.isArray(_data["cwProfiles"])) {
                this.cwProfiles = [] as any;
                for (let item of _data["cwProfiles"])
                    this.cwProfiles!.push(CWProfile.fromJS(item));
            }
            this.sortParameters = _data["sortParameters"] ? SortParameters.fromJS(_data["sortParameters"]) : <any>undefined;
            this.startdatePending = _data["startdatePending"];
            this.commentPending = _data["commentPending"];
            this.autoVisaRequestPending = _data["autoVisaRequestPending"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CandidateGridInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateGridInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.candidateProfiles)) {
            data["candidateProfiles"] = [];
            for (let item of this.candidateProfiles)
                data["candidateProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.immigrationProfiles)) {
            data["immigrationProfiles"] = [];
            for (let item of this.immigrationProfiles)
                data["immigrationProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeProfiles)) {
            data["employeeProfiles"] = [];
            for (let item of this.employeeProfiles)
                data["employeeProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.exitRequests)) {
            data["exitRequests"] = [];
            for (let item of this.exitRequests)
                data["exitRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.cwProfiles)) {
            data["cwProfiles"] = [];
            for (let item of this.cwProfiles)
                data["cwProfiles"].push(item.toJSON());
        }
        data["sortParameters"] = this.sortParameters ? this.sortParameters.toJSON() : <any>undefined;
        data["startdatePending"] = this.startdatePending;
        data["commentPending"] = this.commentPending;
        data["autoVisaRequestPending"] = this.autoVisaRequestPending;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICandidateGridInfo {
    candidateProfiles?: CandidateProfile[] | undefined;
    immigrationProfiles?: ImmigrationProfile[] | undefined;
    employeeProfiles?: EmployeeProfile[] | undefined;
    exitRequests?: ExitRequest[] | undefined;
    cwProfiles?: CWProfile[] | undefined;
    sortParameters?: SortParameters | undefined;
    startdatePending?: boolean;
    commentPending?: boolean;
    autoVisaRequestPending?: boolean;
    startDate?: Date | undefined;
}

export class CandidateProfile implements ICandidateProfile {
    id?: number;
    docPrefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    onboardingType?: LookupField | undefined;
    nationalityType?: LookupField | undefined;
    officeLocationCountry?: LookupField | undefined;
    referenceSystemID?: string | undefined;
    gui?: string | undefined;
    contactNumber?: string | undefined;
    phoneNumber?: string | undefined;
    countryCode?: string | undefined;
    visanNoAndDesignation?: string | undefined;
    visaNumber?: string | undefined;
    degree?: string | undefined;
    emailID?: string | undefined;
    job?: RankGrade | undefined;
    jobTitle?: string | undefined;
    isBRIT?: LookupField | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    subSubServiceLine?: LookupField | undefined;
    sector?: Sector | undefined;
    smu?: SMU | undefined;
    speciality?: Speciality | undefined;
    officeLocation?: LookupField | undefined;
    officeLegalEntity?: OfficeEntity | undefined;
    pjcAdminId?: number | undefined;
    pjcAdminData?: AdUser | undefined;
    recruitmentAdminId?: number | undefined;
    recruitmentAdminData?: AdUser | undefined;
    hiringManagerId?: number | undefined;
    hiringManagerData?: AdUser | undefined;
    additionalManagerId?: number | undefined;
    additionalManagerData?: AdUser | undefined;
    buddyAllocatorId?: number | undefined;
    buddyAllocatorData?: AdUser | undefined;
    counselorAllocatorId?: number | undefined;
    counselorAllocatorData?: AdUser | undefined;
    eAallocatorId?: number | undefined;
    eAallocatorData?: EAAllocator | undefined;
    additionalEAallocatorId?: number | undefined;
    additionalEAallocatorData?: EAAllocator | undefined;
    referralId?: number | undefined;
    referralData?: AdUser | undefined;
    previousEYExperience?: LookupField | undefined;
    gender?: LookupField | undefined;
    nationality?: LookupField | undefined;
    dateOfBirth?: Date | undefined;
    contractDuration?: number | undefined;
    employeeCategory?: LookupField | undefined;
    contractType?: LookupField | undefined;
    otc?: Employee | undefined;
    prevOTCId?: number | undefined;
    recruiter?: Employee | undefined;
    hireType?: LookupField | undefined;
    biLingual?: LookupField | undefined;
    notes?: string | undefined;
    status?: LookupField | undefined;
    deptCode?: string | undefined;
    recruitmentHandoverDate?: Date | undefined;
    pbProfileId?: number | undefined;
    isActive?: boolean;
    createdBy?: number | undefined;
    createdDate?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    createdByEmployee?: Employee | undefined;
    modifiedByEmployee?: Employee | undefined;
    isActivityInitiated?: boolean;
    isActivityCompleted?: boolean;
    referenceId?: number | undefined;
    signOnBonus?: string | undefined;
    startDate?: Date | undefined;
    startDateStatusId?: number | undefined;
    currentEmploymentStatus?: string | undefined;
    eyVisaLCStatus?: string | undefined;
    academicQualification?: string | undefined;
    authorisedHub?: AuthorisedHub | undefined;
    gpn?: string | undefined;
    createdByRoleId?: number;
    empStatus?: number | undefined;
    createdVia?: string | undefined;
    ptcGUI?: string | undefined;
    isConfidential?: boolean | undefined;
    invitedDate?: Date | undefined;
    probationPeriod?: number | undefined;
    buCode?: string | undefined;
    ouCode?: string | undefined;
    muCode?: string | undefined;
    vaccinationStatus?: LookupField | undefined;
    vaccineType?: LookupField | undefined;
    portOfExitCountryId?: number | undefined;
    portOfExitCityId?: number | undefined;
    otherVaccineName?: string | undefined;
    candidateProfileAdditionalInfo?: CandidateProfileAdditionalDetails | undefined;
    inviteEnabled?: boolean | undefined;
    isDirectMailInvite?: boolean | undefined;
    contractDurationIntern?: string | undefined;
    transferTypeID?: number | undefined;
    transferScenarioID?: number | undefined;
    isBuddyApplicableId?: number | undefined;
    isCounselorChangeRequiredId?: number | undefined;
    isCounseleesRetainedId?: number | undefined;
    currentLocationId?: number | undefined;
    surveyStatus?: number | undefined;
    workLocation?: number | undefined;
    contractDurationCW?: string | undefined;
    durationInCW?: number | undefined;
    noticePeriodCW?: string | undefined;
    contractStatus?: number | undefined;
    isContractWithEYMena?: number | undefined;
    itAsset?: number | undefined;
    assetCourier?: number | undefined;
    accessCard?: number | undefined;
    currentLocationCountryID?: number | undefined;
    lastWorkingday?: Date | undefined;
    isNPNegotiableId?: number | undefined;
    currentEmploymentStatusID?: number | undefined;
    epRequestedDate?: Date | undefined;
    epCreatedDate?: Date | undefined;
    chargeCode?: string | undefined;
    dualCitizenshipId?: number | undefined;
    secondNationalityId?: number | undefined;
    approvedPreHireExceptions?: string | undefined;
    eduDocAttestationId?: number | undefined;
    flightBookingID?: number | undefined;
    hotelBookingID?: number | undefined;
    startDateCW?: Date | undefined;
    startdateStatusIdCW?: number | undefined;
    confirmedEnddateCW?: Date | undefined;
    isProfileSubmittedFirst?: boolean;

    constructor(data?: ICandidateProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.docPrefix = _data["docPrefix"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.onboardingType = _data["onboardingType"] ? LookupField.fromJS(_data["onboardingType"]) : <any>undefined;
            this.nationalityType = _data["nationalityType"] ? LookupField.fromJS(_data["nationalityType"]) : <any>undefined;
            this.officeLocationCountry = _data["officeLocationCountry"] ? LookupField.fromJS(_data["officeLocationCountry"]) : <any>undefined;
            this.referenceSystemID = _data["referenceSystemID"];
            this.gui = _data["gui"];
            this.contactNumber = _data["contactNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.countryCode = _data["countryCode"];
            this.visanNoAndDesignation = _data["visanNoAndDesignation"];
            this.visaNumber = _data["visaNumber"];
            this.degree = _data["degree"];
            this.emailID = _data["emailID"];
            this.job = _data["job"] ? RankGrade.fromJS(_data["job"]) : <any>undefined;
            this.jobTitle = _data["jobTitle"];
            this.isBRIT = _data["isBRIT"] ? LookupField.fromJS(_data["isBRIT"]) : <any>undefined;
            this.serviceLine = _data["serviceLine"] ? ServiceLine.fromJS(_data["serviceLine"]) : <any>undefined;
            this.subServiceLine = _data["subServiceLine"] ? SubServiceLine.fromJS(_data["subServiceLine"]) : <any>undefined;
            this.subSubServiceLine = _data["subSubServiceLine"] ? LookupField.fromJS(_data["subSubServiceLine"]) : <any>undefined;
            this.sector = _data["sector"] ? Sector.fromJS(_data["sector"]) : <any>undefined;
            this.smu = _data["smu"] ? SMU.fromJS(_data["smu"]) : <any>undefined;
            this.speciality = _data["speciality"] ? Speciality.fromJS(_data["speciality"]) : <any>undefined;
            this.officeLocation = _data["officeLocation"] ? LookupField.fromJS(_data["officeLocation"]) : <any>undefined;
            this.officeLegalEntity = _data["officeLegalEntity"] ? OfficeEntity.fromJS(_data["officeLegalEntity"]) : <any>undefined;
            this.pjcAdminId = _data["pjcAdminId"];
            this.pjcAdminData = _data["pjcAdminData"] ? AdUser.fromJS(_data["pjcAdminData"]) : <any>undefined;
            this.recruitmentAdminId = _data["recruitmentAdminId"];
            this.recruitmentAdminData = _data["recruitmentAdminData"] ? AdUser.fromJS(_data["recruitmentAdminData"]) : <any>undefined;
            this.hiringManagerId = _data["hiringManagerId"];
            this.hiringManagerData = _data["hiringManagerData"] ? AdUser.fromJS(_data["hiringManagerData"]) : <any>undefined;
            this.additionalManagerId = _data["additionalManagerId"];
            this.additionalManagerData = _data["additionalManagerData"] ? AdUser.fromJS(_data["additionalManagerData"]) : <any>undefined;
            this.buddyAllocatorId = _data["buddyAllocatorId"];
            this.buddyAllocatorData = _data["buddyAllocatorData"] ? AdUser.fromJS(_data["buddyAllocatorData"]) : <any>undefined;
            this.counselorAllocatorId = _data["counselorAllocatorId"];
            this.counselorAllocatorData = _data["counselorAllocatorData"] ? AdUser.fromJS(_data["counselorAllocatorData"]) : <any>undefined;
            this.eAallocatorId = _data["eAallocatorId"];
            this.eAallocatorData = _data["eAallocatorData"] ? EAAllocator.fromJS(_data["eAallocatorData"]) : <any>undefined;
            this.additionalEAallocatorId = _data["additionalEAallocatorId"];
            this.additionalEAallocatorData = _data["additionalEAallocatorData"] ? EAAllocator.fromJS(_data["additionalEAallocatorData"]) : <any>undefined;
            this.referralId = _data["referralId"];
            this.referralData = _data["referralData"] ? AdUser.fromJS(_data["referralData"]) : <any>undefined;
            this.previousEYExperience = _data["previousEYExperience"] ? LookupField.fromJS(_data["previousEYExperience"]) : <any>undefined;
            this.gender = _data["gender"] ? LookupField.fromJS(_data["gender"]) : <any>undefined;
            this.nationality = _data["nationality"] ? LookupField.fromJS(_data["nationality"]) : <any>undefined;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.contractDuration = _data["contractDuration"];
            this.employeeCategory = _data["employeeCategory"] ? LookupField.fromJS(_data["employeeCategory"]) : <any>undefined;
            this.contractType = _data["contractType"] ? LookupField.fromJS(_data["contractType"]) : <any>undefined;
            this.otc = _data["otc"] ? Employee.fromJS(_data["otc"]) : <any>undefined;
            this.prevOTCId = _data["prevOTCId"];
            this.recruiter = _data["recruiter"] ? Employee.fromJS(_data["recruiter"]) : <any>undefined;
            this.hireType = _data["hireType"] ? LookupField.fromJS(_data["hireType"]) : <any>undefined;
            this.biLingual = _data["biLingual"] ? LookupField.fromJS(_data["biLingual"]) : <any>undefined;
            this.notes = _data["notes"];
            this.status = _data["status"] ? LookupField.fromJS(_data["status"]) : <any>undefined;
            this.deptCode = _data["deptCode"];
            this.recruitmentHandoverDate = _data["recruitmentHandoverDate"] ? new Date(_data["recruitmentHandoverDate"].toString()) : <any>undefined;
            this.pbProfileId = _data["pbProfileId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdByEmployee = _data["createdByEmployee"] ? Employee.fromJS(_data["createdByEmployee"]) : <any>undefined;
            this.modifiedByEmployee = _data["modifiedByEmployee"] ? Employee.fromJS(_data["modifiedByEmployee"]) : <any>undefined;
            this.isActivityInitiated = _data["isActivityInitiated"];
            this.isActivityCompleted = _data["isActivityCompleted"];
            this.referenceId = _data["referenceId"];
            this.signOnBonus = _data["signOnBonus"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.startDateStatusId = _data["startDateStatusId"];
            this.currentEmploymentStatus = _data["currentEmploymentStatus"];
            this.eyVisaLCStatus = _data["eyVisaLCStatus"];
            this.academicQualification = _data["academicQualification"];
            this.authorisedHub = _data["authorisedHub"] ? AuthorisedHub.fromJS(_data["authorisedHub"]) : <any>undefined;
            this.gpn = _data["gpn"];
            this.createdByRoleId = _data["createdByRoleId"];
            this.empStatus = _data["empStatus"];
            this.createdVia = _data["createdVia"];
            this.ptcGUI = _data["ptcGUI"];
            this.isConfidential = _data["isConfidential"];
            this.invitedDate = _data["invitedDate"] ? new Date(_data["invitedDate"].toString()) : <any>undefined;
            this.probationPeriod = _data["probationPeriod"];
            this.buCode = _data["buCode"];
            this.ouCode = _data["ouCode"];
            this.muCode = _data["muCode"];
            this.vaccinationStatus = _data["vaccinationStatus"] ? LookupField.fromJS(_data["vaccinationStatus"]) : <any>undefined;
            this.vaccineType = _data["vaccineType"] ? LookupField.fromJS(_data["vaccineType"]) : <any>undefined;
            this.portOfExitCountryId = _data["portOfExitCountryId"];
            this.portOfExitCityId = _data["portOfExitCityId"];
            this.otherVaccineName = _data["otherVaccineName"];
            this.candidateProfileAdditionalInfo = _data["candidateProfileAdditionalInfo"] ? CandidateProfileAdditionalDetails.fromJS(_data["candidateProfileAdditionalInfo"]) : <any>undefined;
            this.inviteEnabled = _data["inviteEnabled"];
            this.isDirectMailInvite = _data["isDirectMailInvite"];
            this.contractDurationIntern = _data["contractDurationIntern"];
            this.transferTypeID = _data["transferTypeID"];
            this.transferScenarioID = _data["transferScenarioID"];
            this.isBuddyApplicableId = _data["isBuddyApplicableId"];
            this.isCounselorChangeRequiredId = _data["isCounselorChangeRequiredId"];
            this.isCounseleesRetainedId = _data["isCounseleesRetainedId"];
            this.currentLocationId = _data["currentLocationId"];
            this.surveyStatus = _data["surveyStatus"];
            this.workLocation = _data["workLocation"];
            this.contractDurationCW = _data["contractDurationCW"];
            this.durationInCW = _data["durationInCW"];
            this.noticePeriodCW = _data["noticePeriodCW"];
            this.contractStatus = _data["contractStatus"];
            this.isContractWithEYMena = _data["isContractWithEYMena"];
            this.itAsset = _data["itAsset"];
            this.assetCourier = _data["assetCourier"];
            this.accessCard = _data["accessCard"];
            this.currentLocationCountryID = _data["currentLocationCountryID"];
            this.lastWorkingday = _data["lastWorkingday"] ? new Date(_data["lastWorkingday"].toString()) : <any>undefined;
            this.isNPNegotiableId = _data["isNPNegotiableId"];
            this.currentEmploymentStatusID = _data["currentEmploymentStatusID"];
            this.epRequestedDate = _data["epRequestedDate"] ? new Date(_data["epRequestedDate"].toString()) : <any>undefined;
            this.epCreatedDate = _data["epCreatedDate"] ? new Date(_data["epCreatedDate"].toString()) : <any>undefined;
            this.chargeCode = _data["chargeCode"];
            this.dualCitizenshipId = _data["dualCitizenshipId"];
            this.secondNationalityId = _data["secondNationalityId"];
            this.approvedPreHireExceptions = _data["approvedPreHireExceptions"];
            this.eduDocAttestationId = _data["eduDocAttestationId"];
            this.flightBookingID = _data["flightBookingID"];
            this.hotelBookingID = _data["hotelBookingID"];
            this.startDateCW = _data["startDateCW"] ? new Date(_data["startDateCW"].toString()) : <any>undefined;
            this.startdateStatusIdCW = _data["startdateStatusIdCW"];
            this.confirmedEnddateCW = _data["confirmedEnddateCW"] ? new Date(_data["confirmedEnddateCW"].toString()) : <any>undefined;
            this.isProfileSubmittedFirst = _data["isProfileSubmittedFirst"];
        }
    }

    static fromJS(data: any): CandidateProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["docPrefix"] = this.docPrefix;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["onboardingType"] = this.onboardingType ? this.onboardingType.toJSON() : <any>undefined;
        data["nationalityType"] = this.nationalityType ? this.nationalityType.toJSON() : <any>undefined;
        data["officeLocationCountry"] = this.officeLocationCountry ? this.officeLocationCountry.toJSON() : <any>undefined;
        data["referenceSystemID"] = this.referenceSystemID;
        data["gui"] = this.gui;
        data["contactNumber"] = this.contactNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["countryCode"] = this.countryCode;
        data["visanNoAndDesignation"] = this.visanNoAndDesignation;
        data["visaNumber"] = this.visaNumber;
        data["degree"] = this.degree;
        data["emailID"] = this.emailID;
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        data["jobTitle"] = this.jobTitle;
        data["isBRIT"] = this.isBRIT ? this.isBRIT.toJSON() : <any>undefined;
        data["serviceLine"] = this.serviceLine ? this.serviceLine.toJSON() : <any>undefined;
        data["subServiceLine"] = this.subServiceLine ? this.subServiceLine.toJSON() : <any>undefined;
        data["subSubServiceLine"] = this.subSubServiceLine ? this.subSubServiceLine.toJSON() : <any>undefined;
        data["sector"] = this.sector ? this.sector.toJSON() : <any>undefined;
        data["smu"] = this.smu ? this.smu.toJSON() : <any>undefined;
        data["speciality"] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        data["officeLocation"] = this.officeLocation ? this.officeLocation.toJSON() : <any>undefined;
        data["officeLegalEntity"] = this.officeLegalEntity ? this.officeLegalEntity.toJSON() : <any>undefined;
        data["pjcAdminId"] = this.pjcAdminId;
        data["pjcAdminData"] = this.pjcAdminData ? this.pjcAdminData.toJSON() : <any>undefined;
        data["recruitmentAdminId"] = this.recruitmentAdminId;
        data["recruitmentAdminData"] = this.recruitmentAdminData ? this.recruitmentAdminData.toJSON() : <any>undefined;
        data["hiringManagerId"] = this.hiringManagerId;
        data["hiringManagerData"] = this.hiringManagerData ? this.hiringManagerData.toJSON() : <any>undefined;
        data["additionalManagerId"] = this.additionalManagerId;
        data["additionalManagerData"] = this.additionalManagerData ? this.additionalManagerData.toJSON() : <any>undefined;
        data["buddyAllocatorId"] = this.buddyAllocatorId;
        data["buddyAllocatorData"] = this.buddyAllocatorData ? this.buddyAllocatorData.toJSON() : <any>undefined;
        data["counselorAllocatorId"] = this.counselorAllocatorId;
        data["counselorAllocatorData"] = this.counselorAllocatorData ? this.counselorAllocatorData.toJSON() : <any>undefined;
        data["eAallocatorId"] = this.eAallocatorId;
        data["eAallocatorData"] = this.eAallocatorData ? this.eAallocatorData.toJSON() : <any>undefined;
        data["additionalEAallocatorId"] = this.additionalEAallocatorId;
        data["additionalEAallocatorData"] = this.additionalEAallocatorData ? this.additionalEAallocatorData.toJSON() : <any>undefined;
        data["referralId"] = this.referralId;
        data["referralData"] = this.referralData ? this.referralData.toJSON() : <any>undefined;
        data["previousEYExperience"] = this.previousEYExperience ? this.previousEYExperience.toJSON() : <any>undefined;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["contractDuration"] = this.contractDuration;
        data["employeeCategory"] = this.employeeCategory ? this.employeeCategory.toJSON() : <any>undefined;
        data["contractType"] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data["otc"] = this.otc ? this.otc.toJSON() : <any>undefined;
        data["prevOTCId"] = this.prevOTCId;
        data["recruiter"] = this.recruiter ? this.recruiter.toJSON() : <any>undefined;
        data["hireType"] = this.hireType ? this.hireType.toJSON() : <any>undefined;
        data["biLingual"] = this.biLingual ? this.biLingual.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["deptCode"] = this.deptCode;
        data["recruitmentHandoverDate"] = this.recruitmentHandoverDate ? this.recruitmentHandoverDate.toISOString() : <any>undefined;
        data["pbProfileId"] = this.pbProfileId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdByEmployee"] = this.createdByEmployee ? this.createdByEmployee.toJSON() : <any>undefined;
        data["modifiedByEmployee"] = this.modifiedByEmployee ? this.modifiedByEmployee.toJSON() : <any>undefined;
        data["isActivityInitiated"] = this.isActivityInitiated;
        data["isActivityCompleted"] = this.isActivityCompleted;
        data["referenceId"] = this.referenceId;
        data["signOnBonus"] = this.signOnBonus;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["startDateStatusId"] = this.startDateStatusId;
        data["currentEmploymentStatus"] = this.currentEmploymentStatus;
        data["eyVisaLCStatus"] = this.eyVisaLCStatus;
        data["academicQualification"] = this.academicQualification;
        data["authorisedHub"] = this.authorisedHub ? this.authorisedHub.toJSON() : <any>undefined;
        data["gpn"] = this.gpn;
        data["createdByRoleId"] = this.createdByRoleId;
        data["empStatus"] = this.empStatus;
        data["createdVia"] = this.createdVia;
        data["ptcGUI"] = this.ptcGUI;
        data["isConfidential"] = this.isConfidential;
        data["invitedDate"] = this.invitedDate ? this.invitedDate.toISOString() : <any>undefined;
        data["probationPeriod"] = this.probationPeriod;
        data["buCode"] = this.buCode;
        data["ouCode"] = this.ouCode;
        data["muCode"] = this.muCode;
        data["vaccinationStatus"] = this.vaccinationStatus ? this.vaccinationStatus.toJSON() : <any>undefined;
        data["vaccineType"] = this.vaccineType ? this.vaccineType.toJSON() : <any>undefined;
        data["portOfExitCountryId"] = this.portOfExitCountryId;
        data["portOfExitCityId"] = this.portOfExitCityId;
        data["otherVaccineName"] = this.otherVaccineName;
        data["candidateProfileAdditionalInfo"] = this.candidateProfileAdditionalInfo ? this.candidateProfileAdditionalInfo.toJSON() : <any>undefined;
        data["inviteEnabled"] = this.inviteEnabled;
        data["isDirectMailInvite"] = this.isDirectMailInvite;
        data["contractDurationIntern"] = this.contractDurationIntern;
        data["transferTypeID"] = this.transferTypeID;
        data["transferScenarioID"] = this.transferScenarioID;
        data["isBuddyApplicableId"] = this.isBuddyApplicableId;
        data["isCounselorChangeRequiredId"] = this.isCounselorChangeRequiredId;
        data["isCounseleesRetainedId"] = this.isCounseleesRetainedId;
        data["currentLocationId"] = this.currentLocationId;
        data["surveyStatus"] = this.surveyStatus;
        data["workLocation"] = this.workLocation;
        data["contractDurationCW"] = this.contractDurationCW;
        data["durationInCW"] = this.durationInCW;
        data["noticePeriodCW"] = this.noticePeriodCW;
        data["contractStatus"] = this.contractStatus;
        data["isContractWithEYMena"] = this.isContractWithEYMena;
        data["itAsset"] = this.itAsset;
        data["assetCourier"] = this.assetCourier;
        data["accessCard"] = this.accessCard;
        data["currentLocationCountryID"] = this.currentLocationCountryID;
        data["lastWorkingday"] = this.lastWorkingday ? this.lastWorkingday.toISOString() : <any>undefined;
        data["isNPNegotiableId"] = this.isNPNegotiableId;
        data["currentEmploymentStatusID"] = this.currentEmploymentStatusID;
        data["epRequestedDate"] = this.epRequestedDate ? this.epRequestedDate.toISOString() : <any>undefined;
        data["epCreatedDate"] = this.epCreatedDate ? this.epCreatedDate.toISOString() : <any>undefined;
        data["chargeCode"] = this.chargeCode;
        data["dualCitizenshipId"] = this.dualCitizenshipId;
        data["secondNationalityId"] = this.secondNationalityId;
        data["approvedPreHireExceptions"] = this.approvedPreHireExceptions;
        data["eduDocAttestationId"] = this.eduDocAttestationId;
        data["flightBookingID"] = this.flightBookingID;
        data["hotelBookingID"] = this.hotelBookingID;
        data["startDateCW"] = this.startDateCW ? this.startDateCW.toISOString() : <any>undefined;
        data["startdateStatusIdCW"] = this.startdateStatusIdCW;
        data["confirmedEnddateCW"] = this.confirmedEnddateCW ? this.confirmedEnddateCW.toISOString() : <any>undefined;
        data["isProfileSubmittedFirst"] = this.isProfileSubmittedFirst;
        return data;
    }
}

export interface ICandidateProfile {
    id?: number;
    docPrefix?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    onboardingType?: LookupField | undefined;
    nationalityType?: LookupField | undefined;
    officeLocationCountry?: LookupField | undefined;
    referenceSystemID?: string | undefined;
    gui?: string | undefined;
    contactNumber?: string | undefined;
    phoneNumber?: string | undefined;
    countryCode?: string | undefined;
    visanNoAndDesignation?: string | undefined;
    visaNumber?: string | undefined;
    degree?: string | undefined;
    emailID?: string | undefined;
    job?: RankGrade | undefined;
    jobTitle?: string | undefined;
    isBRIT?: LookupField | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    subSubServiceLine?: LookupField | undefined;
    sector?: Sector | undefined;
    smu?: SMU | undefined;
    speciality?: Speciality | undefined;
    officeLocation?: LookupField | undefined;
    officeLegalEntity?: OfficeEntity | undefined;
    pjcAdminId?: number | undefined;
    pjcAdminData?: AdUser | undefined;
    recruitmentAdminId?: number | undefined;
    recruitmentAdminData?: AdUser | undefined;
    hiringManagerId?: number | undefined;
    hiringManagerData?: AdUser | undefined;
    additionalManagerId?: number | undefined;
    additionalManagerData?: AdUser | undefined;
    buddyAllocatorId?: number | undefined;
    buddyAllocatorData?: AdUser | undefined;
    counselorAllocatorId?: number | undefined;
    counselorAllocatorData?: AdUser | undefined;
    eAallocatorId?: number | undefined;
    eAallocatorData?: EAAllocator | undefined;
    additionalEAallocatorId?: number | undefined;
    additionalEAallocatorData?: EAAllocator | undefined;
    referralId?: number | undefined;
    referralData?: AdUser | undefined;
    previousEYExperience?: LookupField | undefined;
    gender?: LookupField | undefined;
    nationality?: LookupField | undefined;
    dateOfBirth?: Date | undefined;
    contractDuration?: number | undefined;
    employeeCategory?: LookupField | undefined;
    contractType?: LookupField | undefined;
    otc?: Employee | undefined;
    prevOTCId?: number | undefined;
    recruiter?: Employee | undefined;
    hireType?: LookupField | undefined;
    biLingual?: LookupField | undefined;
    notes?: string | undefined;
    status?: LookupField | undefined;
    deptCode?: string | undefined;
    recruitmentHandoverDate?: Date | undefined;
    pbProfileId?: number | undefined;
    isActive?: boolean;
    createdBy?: number | undefined;
    createdDate?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    createdByEmployee?: Employee | undefined;
    modifiedByEmployee?: Employee | undefined;
    isActivityInitiated?: boolean;
    isActivityCompleted?: boolean;
    referenceId?: number | undefined;
    signOnBonus?: string | undefined;
    startDate?: Date | undefined;
    startDateStatusId?: number | undefined;
    currentEmploymentStatus?: string | undefined;
    eyVisaLCStatus?: string | undefined;
    academicQualification?: string | undefined;
    authorisedHub?: AuthorisedHub | undefined;
    gpn?: string | undefined;
    createdByRoleId?: number;
    empStatus?: number | undefined;
    createdVia?: string | undefined;
    ptcGUI?: string | undefined;
    isConfidential?: boolean | undefined;
    invitedDate?: Date | undefined;
    probationPeriod?: number | undefined;
    buCode?: string | undefined;
    ouCode?: string | undefined;
    muCode?: string | undefined;
    vaccinationStatus?: LookupField | undefined;
    vaccineType?: LookupField | undefined;
    portOfExitCountryId?: number | undefined;
    portOfExitCityId?: number | undefined;
    otherVaccineName?: string | undefined;
    candidateProfileAdditionalInfo?: CandidateProfileAdditionalDetails | undefined;
    inviteEnabled?: boolean | undefined;
    isDirectMailInvite?: boolean | undefined;
    contractDurationIntern?: string | undefined;
    transferTypeID?: number | undefined;
    transferScenarioID?: number | undefined;
    isBuddyApplicableId?: number | undefined;
    isCounselorChangeRequiredId?: number | undefined;
    isCounseleesRetainedId?: number | undefined;
    currentLocationId?: number | undefined;
    surveyStatus?: number | undefined;
    workLocation?: number | undefined;
    contractDurationCW?: string | undefined;
    durationInCW?: number | undefined;
    noticePeriodCW?: string | undefined;
    contractStatus?: number | undefined;
    isContractWithEYMena?: number | undefined;
    itAsset?: number | undefined;
    assetCourier?: number | undefined;
    accessCard?: number | undefined;
    currentLocationCountryID?: number | undefined;
    lastWorkingday?: Date | undefined;
    isNPNegotiableId?: number | undefined;
    currentEmploymentStatusID?: number | undefined;
    epRequestedDate?: Date | undefined;
    epCreatedDate?: Date | undefined;
    chargeCode?: string | undefined;
    dualCitizenshipId?: number | undefined;
    secondNationalityId?: number | undefined;
    approvedPreHireExceptions?: string | undefined;
    eduDocAttestationId?: number | undefined;
    flightBookingID?: number | undefined;
    hotelBookingID?: number | undefined;
    startDateCW?: Date | undefined;
    startdateStatusIdCW?: number | undefined;
    confirmedEnddateCW?: Date | undefined;
    isProfileSubmittedFirst?: boolean;
}

export class LookupField implements ILookupField {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    parentFieldId?: number | undefined;
    filterKeyId?: number | undefined;
    order?: number;
    lookupTypeId?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    disabled?: boolean;
    jobCode?: string | undefined;
    skillCategory?: string | undefined;
    parentFieldValue?: string | undefined;

    constructor(data?: ILookupField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.parentFieldId = _data["parentFieldId"];
            this.filterKeyId = _data["filterKeyId"];
            this.order = _data["order"];
            this.lookupTypeId = _data["lookupTypeId"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.disabled = _data["disabled"];
            this.jobCode = _data["jobCode"];
            this.skillCategory = _data["skillCategory"];
            this.parentFieldValue = _data["parentFieldValue"];
        }
    }

    static fromJS(data: any): LookupField {
        data = typeof data === 'object' ? data : {};
        let result = new LookupField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["parentFieldId"] = this.parentFieldId;
        data["filterKeyId"] = this.filterKeyId;
        data["order"] = this.order;
        data["lookupTypeId"] = this.lookupTypeId;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["disabled"] = this.disabled;
        data["jobCode"] = this.jobCode;
        data["skillCategory"] = this.skillCategory;
        data["parentFieldValue"] = this.parentFieldValue;
        return data;
    }
}

export interface ILookupField {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    parentFieldId?: number | undefined;
    filterKeyId?: number | undefined;
    order?: number;
    lookupTypeId?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    disabled?: boolean;
    jobCode?: string | undefined;
    skillCategory?: string | undefined;
    parentFieldValue?: string | undefined;
}

export class RankGrade implements IRankGrade {
    sl?: string | undefined;
    country?: string | undefined;
    jobCode?: string | undefined;
    rank?: string | undefined;
    rank_Descr?: string | undefined;
    grade_Descr?: string | undefined;

    constructor(data?: IRankGrade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sl = _data["sl"];
            this.country = _data["country"];
            this.jobCode = _data["jobCode"];
            this.rank = _data["rank"];
            this.rank_Descr = _data["rank_Descr"];
            this.grade_Descr = _data["grade_Descr"];
        }
    }

    static fromJS(data: any): RankGrade {
        data = typeof data === 'object' ? data : {};
        let result = new RankGrade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sl"] = this.sl;
        data["country"] = this.country;
        data["jobCode"] = this.jobCode;
        data["rank"] = this.rank;
        data["rank_Descr"] = this.rank_Descr;
        data["grade_Descr"] = this.grade_Descr;
        return data;
    }
}

export interface IRankGrade {
    sl?: string | undefined;
    country?: string | undefined;
    jobCode?: string | undefined;
    rank?: string | undefined;
    rank_Descr?: string | undefined;
    grade_Descr?: string | undefined;
}

export class ServiceLine implements IServiceLine {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;

    constructor(data?: IServiceLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
        }
    }

    static fromJS(data: any): ServiceLine {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        return data;
    }
}

export interface IServiceLine {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
}

export class SubServiceLine implements ISubServiceLine {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;

    constructor(data?: ISubServiceLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
            this.parentFieldId = _data["parentFieldId"];
        }
    }

    static fromJS(data: any): SubServiceLine {
        data = typeof data === 'object' ? data : {};
        let result = new SubServiceLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        data["parentFieldId"] = this.parentFieldId;
        return data;
    }
}

export interface ISubServiceLine {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
}

export class Sector implements ISector {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;

    constructor(data?: ISector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
            this.parentFieldId = _data["parentFieldId"];
        }
    }

    static fromJS(data: any): Sector {
        data = typeof data === 'object' ? data : {};
        let result = new Sector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        data["parentFieldId"] = this.parentFieldId;
        return data;
    }
}

export interface ISector {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
}

export class SMU implements ISMU {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;

    constructor(data?: ISMU) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
            this.parentFieldId = _data["parentFieldId"];
        }
    }

    static fromJS(data: any): SMU {
        data = typeof data === 'object' ? data : {};
        let result = new SMU();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        data["parentFieldId"] = this.parentFieldId;
        return data;
    }
}

export interface ISMU {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
}

export class Speciality implements ISpeciality {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
    disabled?: boolean;

    constructor(data?: ISpeciality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
            this.parentFieldId = _data["parentFieldId"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): Speciality {
        data = typeof data === 'object' ? data : {};
        let result = new Speciality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        data["parentFieldId"] = this.parentFieldId;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface ISpeciality {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
    disabled?: boolean;
}

export class OfficeEntity implements IOfficeEntity {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
    disabled?: boolean;

    constructor(data?: IOfficeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
            this.parentFieldId = _data["parentFieldId"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): OfficeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        data["parentFieldId"] = this.parentFieldId;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IOfficeEntity {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
    disabled?: boolean;
}

export class AdUser implements IAdUser {
    id?: string | undefined;
    givenName?: string | undefined;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;

    constructor(data?: IAdUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.givenName = _data["givenName"];
            this.displayName = _data["displayName"];
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): AdUser {
        data = typeof data === 'object' ? data : {};
        let result = new AdUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["givenName"] = this.givenName;
        data["displayName"] = this.displayName;
        data["userPrincipalName"] = this.userPrincipalName;
        return data;
    }
}

export interface IAdUser {
    id?: string | undefined;
    givenName?: string | undefined;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;
}

export class EAAllocator implements IEAAllocator {
    id?: number;
    employeeProfileId?: number | undefined;
    officeLocationCountryId?: number;
    name?: string | undefined;
    emailAddress?: string | undefined;
    isDefault?: boolean | undefined;
    isActive?: boolean;

    constructor(data?: IEAAllocator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.officeLocationCountryId = _data["officeLocationCountryId"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EAAllocator {
        data = typeof data === 'object' ? data : {};
        let result = new EAAllocator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeProfileId"] = this.employeeProfileId;
        data["officeLocationCountryId"] = this.officeLocationCountryId;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEAAllocator {
    id?: number;
    employeeProfileId?: number | undefined;
    officeLocationCountryId?: number;
    name?: string | undefined;
    emailAddress?: string | undefined;
    isDefault?: boolean | undefined;
    isActive?: boolean;
}

export class Employee implements IEmployee {
    id?: number | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    isActive?: boolean;
    uid?: string | undefined;
    disabled?: boolean;
    conReference?: string | undefined;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.uid = _data["uid"];
            this.disabled = _data["disabled"];
            this.conReference = _data["conReference"];
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["name"] = this.name;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["uid"] = this.uid;
        data["disabled"] = this.disabled;
        data["conReference"] = this.conReference;
        return data;
    }
}

export interface IEmployee {
    id?: number | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    isActive?: boolean;
    uid?: string | undefined;
    disabled?: boolean;
    conReference?: string | undefined;
}

export class AuthorisedHub implements IAuthorisedHub {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;

    constructor(data?: IAuthorisedHub) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
        }
    }

    static fromJS(data: any): AuthorisedHub {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorisedHub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        return data;
    }
}

export interface IAuthorisedHub {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
}

export class CandidateProfileAdditionalDetails implements ICandidateProfileAdditionalDetails {
    id?: number;
    candidateProfileId?: number | undefined;
    uidNumber?: string | undefined;
    passportNumber?: string | undefined;
    passportExpiryDate?: Date | undefined;
    emiratesIdNumber?: string | undefined;
    placeOfBirth?: string | undefined;
    nationalities?: Nationalities | undefined;
    nationalIdNumber?: string | undefined;
    typeOfMOLId?: number | undefined;
    noticePeriodMOL?: number | undefined;
    khulasatNumber?: string | undefined;
    dataStore?: string | undefined;
    preferredMail?: PreferedName | undefined;
    arabicName?: ArabicNames | undefined;
    address?: Address | undefined;
    bankDetails?: BankDetails | undefined;
    additionalInfo?: EmployeeAdditionalDetails | undefined;
    emergencyDetails?: EmergencyDetailsData | undefined;
    vehicleDetails?: VehicleData | undefined;
    married?: MarriageStatus | undefined;
    insuranceDetils?: MedicalInsuranceDetails | undefined;
    currentEmploymentStatus?: LookupField | undefined;
    travelPlans?: TravelPlans | undefined;
    homePhone?: string | undefined;
    socialSecurityNumber?: string | undefined;
    previousEmployee?: LookupField | undefined;
    previousEyLocation?: LookupField | undefined;
    professionalQualification?: string | undefined;
    personalEmailAddress?: string | undefined;
    earliestJoiningDate?: Date | undefined;
    currentVisaExpiryDate?: Date | undefined;
    academicQualification?: string | undefined;
    religion?: LookupField | undefined;
    travelPlan?: LookupField | undefined;
    professionalQualificationAttested?: LookupField | undefined;
    academicQualificationAttested?: LookupField | undefined;
    localRecruit?: LookupField | undefined;
    overseasRecruit?: LookupField | undefined;
    residentHiringOffice?: LookupField | undefined;
    noticePeriodNegotiable?: LookupField | undefined;
    spouseDetails?: string | undefined;
    childrenDetails?: string | undefined;
    isRejectedForCandidate?: boolean | undefined;
    itPersonalInfo?: ItPersonalInfo | undefined;
    itFinacialInformation?: ItFinacialInformation | undefined;
    itITInformation?: ItITInformation | undefined;
    itLeaveInformation?: ItLeaveInformation | undefined;
    kinDetails?: KinDetails | undefined;
    familyBookDetails?: FamilyBookDetails | undefined;
    choiceOfMedicalInsurance?: LookupField | undefined;
    previousBigFour?: LookupField | undefined;
    attestationCompletedDate?: Date | undefined;
    previousEyEmployee?: LookupField | undefined;
    lastEmployerDetail?: LastEmployer | undefined;
    priorBigFourEmployerDetail?: string | undefined;
    profession?: string | undefined;
    registeredWithUAE?: LookupField | undefined;

    constructor(data?: ICandidateProfileAdditionalDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.candidateProfileId = _data["candidateProfileId"];
            this.uidNumber = _data["uidNumber"];
            this.passportNumber = _data["passportNumber"];
            this.passportExpiryDate = _data["passportExpiryDate"] ? new Date(_data["passportExpiryDate"].toString()) : <any>undefined;
            this.emiratesIdNumber = _data["emiratesIdNumber"];
            this.placeOfBirth = _data["placeOfBirth"];
            this.nationalities = _data["nationalities"] ? Nationalities.fromJS(_data["nationalities"]) : <any>undefined;
            this.nationalIdNumber = _data["nationalIdNumber"];
            this.typeOfMOLId = _data["typeOfMOLId"];
            this.noticePeriodMOL = _data["noticePeriodMOL"];
            this.khulasatNumber = _data["khulasatNumber"];
            this.dataStore = _data["dataStore"];
            this.preferredMail = _data["preferredMail"] ? PreferedName.fromJS(_data["preferredMail"]) : <any>undefined;
            this.arabicName = _data["arabicName"] ? ArabicNames.fromJS(_data["arabicName"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.bankDetails = _data["bankDetails"] ? BankDetails.fromJS(_data["bankDetails"]) : <any>undefined;
            this.additionalInfo = _data["additionalInfo"] ? EmployeeAdditionalDetails.fromJS(_data["additionalInfo"]) : <any>undefined;
            this.emergencyDetails = _data["emergencyDetails"] ? EmergencyDetailsData.fromJS(_data["emergencyDetails"]) : <any>undefined;
            this.vehicleDetails = _data["vehicleDetails"] ? VehicleData.fromJS(_data["vehicleDetails"]) : <any>undefined;
            this.married = _data["married"] ? MarriageStatus.fromJS(_data["married"]) : <any>undefined;
            this.insuranceDetils = _data["insuranceDetils"] ? MedicalInsuranceDetails.fromJS(_data["insuranceDetils"]) : <any>undefined;
            this.currentEmploymentStatus = _data["currentEmploymentStatus"] ? LookupField.fromJS(_data["currentEmploymentStatus"]) : <any>undefined;
            this.travelPlans = _data["travelPlans"] ? TravelPlans.fromJS(_data["travelPlans"]) : <any>undefined;
            this.homePhone = _data["homePhone"];
            this.socialSecurityNumber = _data["socialSecurityNumber"];
            this.previousEmployee = _data["previousEmployee"] ? LookupField.fromJS(_data["previousEmployee"]) : <any>undefined;
            this.previousEyLocation = _data["previousEyLocation"] ? LookupField.fromJS(_data["previousEyLocation"]) : <any>undefined;
            this.professionalQualification = _data["professionalQualification"];
            this.personalEmailAddress = _data["personalEmailAddress"];
            this.earliestJoiningDate = _data["earliestJoiningDate"] ? new Date(_data["earliestJoiningDate"].toString()) : <any>undefined;
            this.currentVisaExpiryDate = _data["currentVisaExpiryDate"] ? new Date(_data["currentVisaExpiryDate"].toString()) : <any>undefined;
            this.academicQualification = _data["academicQualification"];
            this.religion = _data["religion"] ? LookupField.fromJS(_data["religion"]) : <any>undefined;
            this.travelPlan = _data["travelPlan"] ? LookupField.fromJS(_data["travelPlan"]) : <any>undefined;
            this.professionalQualificationAttested = _data["professionalQualificationAttested"] ? LookupField.fromJS(_data["professionalQualificationAttested"]) : <any>undefined;
            this.academicQualificationAttested = _data["academicQualificationAttested"] ? LookupField.fromJS(_data["academicQualificationAttested"]) : <any>undefined;
            this.localRecruit = _data["localRecruit"] ? LookupField.fromJS(_data["localRecruit"]) : <any>undefined;
            this.overseasRecruit = _data["overseasRecruit"] ? LookupField.fromJS(_data["overseasRecruit"]) : <any>undefined;
            this.residentHiringOffice = _data["residentHiringOffice"] ? LookupField.fromJS(_data["residentHiringOffice"]) : <any>undefined;
            this.noticePeriodNegotiable = _data["noticePeriodNegotiable"] ? LookupField.fromJS(_data["noticePeriodNegotiable"]) : <any>undefined;
            this.spouseDetails = _data["spouseDetails"];
            this.childrenDetails = _data["childrenDetails"];
            this.isRejectedForCandidate = _data["isRejectedForCandidate"];
            this.itPersonalInfo = _data["itPersonalInfo"] ? ItPersonalInfo.fromJS(_data["itPersonalInfo"]) : <any>undefined;
            this.itFinacialInformation = _data["itFinacialInformation"] ? ItFinacialInformation.fromJS(_data["itFinacialInformation"]) : <any>undefined;
            this.itITInformation = _data["itITInformation"] ? ItITInformation.fromJS(_data["itITInformation"]) : <any>undefined;
            this.itLeaveInformation = _data["itLeaveInformation"] ? ItLeaveInformation.fromJS(_data["itLeaveInformation"]) : <any>undefined;
            this.kinDetails = _data["kinDetails"] ? KinDetails.fromJS(_data["kinDetails"]) : <any>undefined;
            this.familyBookDetails = _data["familyBookDetails"] ? FamilyBookDetails.fromJS(_data["familyBookDetails"]) : <any>undefined;
            this.choiceOfMedicalInsurance = _data["choiceOfMedicalInsurance"] ? LookupField.fromJS(_data["choiceOfMedicalInsurance"]) : <any>undefined;
            this.previousBigFour = _data["previousBigFour"] ? LookupField.fromJS(_data["previousBigFour"]) : <any>undefined;
            this.attestationCompletedDate = _data["attestationCompletedDate"] ? new Date(_data["attestationCompletedDate"].toString()) : <any>undefined;
            this.previousEyEmployee = _data["previousEyEmployee"] ? LookupField.fromJS(_data["previousEyEmployee"]) : <any>undefined;
            this.lastEmployerDetail = _data["lastEmployerDetail"] ? LastEmployer.fromJS(_data["lastEmployerDetail"]) : <any>undefined;
            this.priorBigFourEmployerDetail = _data["priorBigFourEmployerDetail"];
            this.profession = _data["profession"];
            this.registeredWithUAE = _data["registeredWithUAE"] ? LookupField.fromJS(_data["registeredWithUAE"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CandidateProfileAdditionalDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateProfileAdditionalDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["candidateProfileId"] = this.candidateProfileId;
        data["uidNumber"] = this.uidNumber;
        data["passportNumber"] = this.passportNumber;
        data["passportExpiryDate"] = this.passportExpiryDate ? this.passportExpiryDate.toISOString() : <any>undefined;
        data["emiratesIdNumber"] = this.emiratesIdNumber;
        data["placeOfBirth"] = this.placeOfBirth;
        data["nationalities"] = this.nationalities ? this.nationalities.toJSON() : <any>undefined;
        data["nationalIdNumber"] = this.nationalIdNumber;
        data["typeOfMOLId"] = this.typeOfMOLId;
        data["noticePeriodMOL"] = this.noticePeriodMOL;
        data["khulasatNumber"] = this.khulasatNumber;
        data["dataStore"] = this.dataStore;
        data["preferredMail"] = this.preferredMail ? this.preferredMail.toJSON() : <any>undefined;
        data["arabicName"] = this.arabicName ? this.arabicName.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["bankDetails"] = this.bankDetails ? this.bankDetails.toJSON() : <any>undefined;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : <any>undefined;
        data["emergencyDetails"] = this.emergencyDetails ? this.emergencyDetails.toJSON() : <any>undefined;
        data["vehicleDetails"] = this.vehicleDetails ? this.vehicleDetails.toJSON() : <any>undefined;
        data["married"] = this.married ? this.married.toJSON() : <any>undefined;
        data["insuranceDetils"] = this.insuranceDetils ? this.insuranceDetils.toJSON() : <any>undefined;
        data["currentEmploymentStatus"] = this.currentEmploymentStatus ? this.currentEmploymentStatus.toJSON() : <any>undefined;
        data["travelPlans"] = this.travelPlans ? this.travelPlans.toJSON() : <any>undefined;
        data["homePhone"] = this.homePhone;
        data["socialSecurityNumber"] = this.socialSecurityNumber;
        data["previousEmployee"] = this.previousEmployee ? this.previousEmployee.toJSON() : <any>undefined;
        data["previousEyLocation"] = this.previousEyLocation ? this.previousEyLocation.toJSON() : <any>undefined;
        data["professionalQualification"] = this.professionalQualification;
        data["personalEmailAddress"] = this.personalEmailAddress;
        data["earliestJoiningDate"] = this.earliestJoiningDate ? this.earliestJoiningDate.toISOString() : <any>undefined;
        data["currentVisaExpiryDate"] = this.currentVisaExpiryDate ? this.currentVisaExpiryDate.toISOString() : <any>undefined;
        data["academicQualification"] = this.academicQualification;
        data["religion"] = this.religion ? this.religion.toJSON() : <any>undefined;
        data["travelPlan"] = this.travelPlan ? this.travelPlan.toJSON() : <any>undefined;
        data["professionalQualificationAttested"] = this.professionalQualificationAttested ? this.professionalQualificationAttested.toJSON() : <any>undefined;
        data["academicQualificationAttested"] = this.academicQualificationAttested ? this.academicQualificationAttested.toJSON() : <any>undefined;
        data["localRecruit"] = this.localRecruit ? this.localRecruit.toJSON() : <any>undefined;
        data["overseasRecruit"] = this.overseasRecruit ? this.overseasRecruit.toJSON() : <any>undefined;
        data["residentHiringOffice"] = this.residentHiringOffice ? this.residentHiringOffice.toJSON() : <any>undefined;
        data["noticePeriodNegotiable"] = this.noticePeriodNegotiable ? this.noticePeriodNegotiable.toJSON() : <any>undefined;
        data["spouseDetails"] = this.spouseDetails;
        data["childrenDetails"] = this.childrenDetails;
        data["isRejectedForCandidate"] = this.isRejectedForCandidate;
        data["itPersonalInfo"] = this.itPersonalInfo ? this.itPersonalInfo.toJSON() : <any>undefined;
        data["itFinacialInformation"] = this.itFinacialInformation ? this.itFinacialInformation.toJSON() : <any>undefined;
        data["itITInformation"] = this.itITInformation ? this.itITInformation.toJSON() : <any>undefined;
        data["itLeaveInformation"] = this.itLeaveInformation ? this.itLeaveInformation.toJSON() : <any>undefined;
        data["kinDetails"] = this.kinDetails ? this.kinDetails.toJSON() : <any>undefined;
        data["familyBookDetails"] = this.familyBookDetails ? this.familyBookDetails.toJSON() : <any>undefined;
        data["choiceOfMedicalInsurance"] = this.choiceOfMedicalInsurance ? this.choiceOfMedicalInsurance.toJSON() : <any>undefined;
        data["previousBigFour"] = this.previousBigFour ? this.previousBigFour.toJSON() : <any>undefined;
        data["attestationCompletedDate"] = this.attestationCompletedDate ? this.attestationCompletedDate.toISOString() : <any>undefined;
        data["previousEyEmployee"] = this.previousEyEmployee ? this.previousEyEmployee.toJSON() : <any>undefined;
        data["lastEmployerDetail"] = this.lastEmployerDetail ? this.lastEmployerDetail.toJSON() : <any>undefined;
        data["priorBigFourEmployerDetail"] = this.priorBigFourEmployerDetail;
        data["profession"] = this.profession;
        data["registeredWithUAE"] = this.registeredWithUAE ? this.registeredWithUAE.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICandidateProfileAdditionalDetails {
    id?: number;
    candidateProfileId?: number | undefined;
    uidNumber?: string | undefined;
    passportNumber?: string | undefined;
    passportExpiryDate?: Date | undefined;
    emiratesIdNumber?: string | undefined;
    placeOfBirth?: string | undefined;
    nationalities?: Nationalities | undefined;
    nationalIdNumber?: string | undefined;
    typeOfMOLId?: number | undefined;
    noticePeriodMOL?: number | undefined;
    khulasatNumber?: string | undefined;
    dataStore?: string | undefined;
    preferredMail?: PreferedName | undefined;
    arabicName?: ArabicNames | undefined;
    address?: Address | undefined;
    bankDetails?: BankDetails | undefined;
    additionalInfo?: EmployeeAdditionalDetails | undefined;
    emergencyDetails?: EmergencyDetailsData | undefined;
    vehicleDetails?: VehicleData | undefined;
    married?: MarriageStatus | undefined;
    insuranceDetils?: MedicalInsuranceDetails | undefined;
    currentEmploymentStatus?: LookupField | undefined;
    travelPlans?: TravelPlans | undefined;
    homePhone?: string | undefined;
    socialSecurityNumber?: string | undefined;
    previousEmployee?: LookupField | undefined;
    previousEyLocation?: LookupField | undefined;
    professionalQualification?: string | undefined;
    personalEmailAddress?: string | undefined;
    earliestJoiningDate?: Date | undefined;
    currentVisaExpiryDate?: Date | undefined;
    academicQualification?: string | undefined;
    religion?: LookupField | undefined;
    travelPlan?: LookupField | undefined;
    professionalQualificationAttested?: LookupField | undefined;
    academicQualificationAttested?: LookupField | undefined;
    localRecruit?: LookupField | undefined;
    overseasRecruit?: LookupField | undefined;
    residentHiringOffice?: LookupField | undefined;
    noticePeriodNegotiable?: LookupField | undefined;
    spouseDetails?: string | undefined;
    childrenDetails?: string | undefined;
    isRejectedForCandidate?: boolean | undefined;
    itPersonalInfo?: ItPersonalInfo | undefined;
    itFinacialInformation?: ItFinacialInformation | undefined;
    itITInformation?: ItITInformation | undefined;
    itLeaveInformation?: ItLeaveInformation | undefined;
    kinDetails?: KinDetails | undefined;
    familyBookDetails?: FamilyBookDetails | undefined;
    choiceOfMedicalInsurance?: LookupField | undefined;
    previousBigFour?: LookupField | undefined;
    attestationCompletedDate?: Date | undefined;
    previousEyEmployee?: LookupField | undefined;
    lastEmployerDetail?: LastEmployer | undefined;
    priorBigFourEmployerDetail?: string | undefined;
    profession?: string | undefined;
    registeredWithUAE?: LookupField | undefined;
}

export class Nationalities implements INationalities {
    firstNationality?: LookupField | undefined;
    cnicDetails?: string | undefined;
    cnicExpiryDate?: Date | undefined;

    constructor(data?: INationalities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstNationality = _data["firstNationality"] ? LookupField.fromJS(_data["firstNationality"]) : <any>undefined;
            this.cnicDetails = _data["cnicDetails"];
            this.cnicExpiryDate = _data["cnicExpiryDate"] ? new Date(_data["cnicExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Nationalities {
        data = typeof data === 'object' ? data : {};
        let result = new Nationalities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstNationality"] = this.firstNationality ? this.firstNationality.toJSON() : <any>undefined;
        data["cnicDetails"] = this.cnicDetails;
        data["cnicExpiryDate"] = this.cnicExpiryDate ? this.cnicExpiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface INationalities {
    firstNationality?: LookupField | undefined;
    cnicDetails?: string | undefined;
    cnicExpiryDate?: Date | undefined;
}

export class PreferedName implements IPreferedName {
    pfirstname?: string | undefined;
    psecondname?: string | undefined;
    plastname?: string | undefined;
    isPreferedNameApplicable?: LookupField | undefined;
    selectedPrefName?: string | undefined;

    constructor(data?: IPreferedName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pfirstname = _data["pfirstname"];
            this.psecondname = _data["psecondname"];
            this.plastname = _data["plastname"];
            this.isPreferedNameApplicable = _data["isPreferedNameApplicable"] ? LookupField.fromJS(_data["isPreferedNameApplicable"]) : <any>undefined;
            this.selectedPrefName = _data["selectedPrefName"];
        }
    }

    static fromJS(data: any): PreferedName {
        data = typeof data === 'object' ? data : {};
        let result = new PreferedName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pfirstname"] = this.pfirstname;
        data["psecondname"] = this.psecondname;
        data["plastname"] = this.plastname;
        data["isPreferedNameApplicable"] = this.isPreferedNameApplicable ? this.isPreferedNameApplicable.toJSON() : <any>undefined;
        data["selectedPrefName"] = this.selectedPrefName;
        return data;
    }
}

export interface IPreferedName {
    pfirstname?: string | undefined;
    psecondname?: string | undefined;
    plastname?: string | undefined;
    isPreferedNameApplicable?: LookupField | undefined;
    selectedPrefName?: string | undefined;
}

export class ArabicNames implements IArabicNames {
    arabicFirstName?: string | undefined;
    arabicMiddleName?: string | undefined;
    arabicLastName?: string | undefined;

    constructor(data?: IArabicNames) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arabicFirstName = _data["arabicFirstName"];
            this.arabicMiddleName = _data["arabicMiddleName"];
            this.arabicLastName = _data["arabicLastName"];
        }
    }

    static fromJS(data: any): ArabicNames {
        data = typeof data === 'object' ? data : {};
        let result = new ArabicNames();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arabicFirstName"] = this.arabicFirstName;
        data["arabicMiddleName"] = this.arabicMiddleName;
        data["arabicLastName"] = this.arabicLastName;
        return data;
    }
}

export interface IArabicNames {
    arabicFirstName?: string | undefined;
    arabicMiddleName?: string | undefined;
    arabicLastName?: string | undefined;
}

export class Address implements IAddress {
    building?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.building = _data["building"];
            this.city = _data["city"];
            this.street = _data["street"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["building"] = this.building;
        data["city"] = this.city;
        data["street"] = this.street;
        return data;
    }
}

export interface IAddress {
    building?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
}

export class BankDetails implements IBankDetails {
    isBankAvailable?: LookupField | undefined;
    gccBankName?: string | undefined;
    gccBankAccount?: string | undefined;
    ibanNumber?: string | undefined;

    constructor(data?: IBankDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBankAvailable = _data["isBankAvailable"] ? LookupField.fromJS(_data["isBankAvailable"]) : <any>undefined;
            this.gccBankName = _data["gccBankName"];
            this.gccBankAccount = _data["gccBankAccount"];
            this.ibanNumber = _data["ibanNumber"];
        }
    }

    static fromJS(data: any): BankDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BankDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBankAvailable"] = this.isBankAvailable ? this.isBankAvailable.toJSON() : <any>undefined;
        data["gccBankName"] = this.gccBankName;
        data["gccBankAccount"] = this.gccBankAccount;
        data["ibanNumber"] = this.ibanNumber;
        return data;
    }
}

export interface IBankDetails {
    isBankAvailable?: LookupField | undefined;
    gccBankName?: string | undefined;
    gccBankAccount?: string | undefined;
    ibanNumber?: string | undefined;
}

export class EmployeeAdditionalDetails implements IEmployeeAdditionalDetails {
    fathersFullName?: string | undefined;
    mothersFullName?: string | undefined;
    fathersNationality?: LookupField | undefined;
    mothersNationality?: LookupField | undefined;
    fathersReligion?: LookupField | undefined;
    mothersReligion?: LookupField | undefined;

    constructor(data?: IEmployeeAdditionalDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fathersFullName = _data["fathersFullName"];
            this.mothersFullName = _data["mothersFullName"];
            this.fathersNationality = _data["fathersNationality"] ? LookupField.fromJS(_data["fathersNationality"]) : <any>undefined;
            this.mothersNationality = _data["mothersNationality"] ? LookupField.fromJS(_data["mothersNationality"]) : <any>undefined;
            this.fathersReligion = _data["fathersReligion"] ? LookupField.fromJS(_data["fathersReligion"]) : <any>undefined;
            this.mothersReligion = _data["mothersReligion"] ? LookupField.fromJS(_data["mothersReligion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeAdditionalDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAdditionalDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fathersFullName"] = this.fathersFullName;
        data["mothersFullName"] = this.mothersFullName;
        data["fathersNationality"] = this.fathersNationality ? this.fathersNationality.toJSON() : <any>undefined;
        data["mothersNationality"] = this.mothersNationality ? this.mothersNationality.toJSON() : <any>undefined;
        data["fathersReligion"] = this.fathersReligion ? this.fathersReligion.toJSON() : <any>undefined;
        data["mothersReligion"] = this.mothersReligion ? this.mothersReligion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeAdditionalDetails {
    fathersFullName?: string | undefined;
    mothersFullName?: string | undefined;
    fathersNationality?: LookupField | undefined;
    mothersNationality?: LookupField | undefined;
    fathersReligion?: LookupField | undefined;
    mothersReligion?: LookupField | undefined;
}

export class EmergencyDetailsData implements IEmergencyDetailsData {
    name?: string | undefined;
    relationship?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    name1?: string | undefined;
    relationship1?: string | undefined;
    mobile1?: string | undefined;
    email1?: string | undefined;

    constructor(data?: IEmergencyDetailsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.relationship = _data["relationship"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.name1 = _data["name1"];
            this.relationship1 = _data["relationship1"];
            this.mobile1 = _data["mobile1"];
            this.email1 = _data["email1"];
        }
    }

    static fromJS(data: any): EmergencyDetailsData {
        data = typeof data === 'object' ? data : {};
        let result = new EmergencyDetailsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["relationship"] = this.relationship;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["name1"] = this.name1;
        data["relationship1"] = this.relationship1;
        data["mobile1"] = this.mobile1;
        data["email1"] = this.email1;
        return data;
    }
}

export interface IEmergencyDetailsData {
    name?: string | undefined;
    relationship?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    name1?: string | undefined;
    relationship1?: string | undefined;
    mobile1?: string | undefined;
    email1?: string | undefined;
}

export class VehicleData implements IVehicleData {
    number?: string | undefined;
    type?: string | undefined;
    vehicleColor?: string | undefined;

    constructor(data?: IVehicleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.type = _data["type"];
            this.vehicleColor = _data["vehicleColor"];
        }
    }

    static fromJS(data: any): VehicleData {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["type"] = this.type;
        data["vehicleColor"] = this.vehicleColor;
        return data;
    }
}

export interface IVehicleData {
    number?: string | undefined;
    type?: string | undefined;
    vehicleColor?: string | undefined;
}

export class MarriageStatus implements IMarriageStatus {
    maritalStatus?: LookupField | undefined;
    marriageDate?: Date | undefined;

    constructor(data?: IMarriageStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maritalStatus = _data["maritalStatus"] ? LookupField.fromJS(_data["maritalStatus"]) : <any>undefined;
            this.marriageDate = _data["marriageDate"] ? new Date(_data["marriageDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarriageStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MarriageStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
        data["marriageDate"] = this.marriageDate ? this.marriageDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMarriageStatus {
    maritalStatus?: LookupField | undefined;
    marriageDate?: Date | undefined;
}

export class MedicalInsuranceDetails implements IMedicalInsuranceDetails {
    insuranceExist?: LookupField | undefined;
    isItGovtInsurance?: LookupField | undefined;

    constructor(data?: IMedicalInsuranceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuranceExist = _data["insuranceExist"] ? LookupField.fromJS(_data["insuranceExist"]) : <any>undefined;
            this.isItGovtInsurance = _data["isItGovtInsurance"] ? LookupField.fromJS(_data["isItGovtInsurance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicalInsuranceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalInsuranceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceExist"] = this.insuranceExist ? this.insuranceExist.toJSON() : <any>undefined;
        data["isItGovtInsurance"] = this.isItGovtInsurance ? this.isItGovtInsurance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMedicalInsuranceDetails {
    insuranceExist?: LookupField | undefined;
    isItGovtInsurance?: LookupField | undefined;
}

export class TravelPlans implements ITravelPlans {
    isDependentsTravelling?: LookupField | undefined;
    dependentTravelingCount?: LookupField | undefined;
    familyMembersRelocating?: LookupField | undefined;
    preferredTravelTime?: LookupField | undefined;
    closestInternationalAirport?: AirportDetails | undefined;

    constructor(data?: ITravelPlans) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDependentsTravelling = _data["isDependentsTravelling"] ? LookupField.fromJS(_data["isDependentsTravelling"]) : <any>undefined;
            this.dependentTravelingCount = _data["dependentTravelingCount"] ? LookupField.fromJS(_data["dependentTravelingCount"]) : <any>undefined;
            this.familyMembersRelocating = _data["familyMembersRelocating"] ? LookupField.fromJS(_data["familyMembersRelocating"]) : <any>undefined;
            this.preferredTravelTime = _data["preferredTravelTime"] ? LookupField.fromJS(_data["preferredTravelTime"]) : <any>undefined;
            this.closestInternationalAirport = _data["closestInternationalAirport"] ? AirportDetails.fromJS(_data["closestInternationalAirport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TravelPlans {
        data = typeof data === 'object' ? data : {};
        let result = new TravelPlans();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDependentsTravelling"] = this.isDependentsTravelling ? this.isDependentsTravelling.toJSON() : <any>undefined;
        data["dependentTravelingCount"] = this.dependentTravelingCount ? this.dependentTravelingCount.toJSON() : <any>undefined;
        data["familyMembersRelocating"] = this.familyMembersRelocating ? this.familyMembersRelocating.toJSON() : <any>undefined;
        data["preferredTravelTime"] = this.preferredTravelTime ? this.preferredTravelTime.toJSON() : <any>undefined;
        data["closestInternationalAirport"] = this.closestInternationalAirport ? this.closestInternationalAirport.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITravelPlans {
    isDependentsTravelling?: LookupField | undefined;
    dependentTravelingCount?: LookupField | undefined;
    familyMembersRelocating?: LookupField | undefined;
    preferredTravelTime?: LookupField | undefined;
    closestInternationalAirport?: AirportDetails | undefined;
}

export class AirportDetails implements IAirportDetails {
    id?: number;
    displayText?: string | undefined;

    constructor(data?: IAirportDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): AirportDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AirportDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface IAirportDetails {
    id?: number;
    displayText?: string | undefined;
}

export class ItPersonalInfo implements IItPersonalInfo {
    holdEmploymentVisa?: LookupField | undefined;
    istravellingShortly?: LookupField | undefined;
    travellingDate?: Date | undefined;
    travelLocation?: LookupField | undefined;
    tripDuration?: string | undefined;
    isBusinessTrip?: LookupField | undefined;
    transferDate?: Date | undefined;
    isEngagedInAnyProject?: LookupField | undefined;
    projectName?: string | undefined;

    constructor(data?: IItPersonalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holdEmploymentVisa = _data["holdEmploymentVisa"] ? LookupField.fromJS(_data["holdEmploymentVisa"]) : <any>undefined;
            this.istravellingShortly = _data["istravellingShortly"] ? LookupField.fromJS(_data["istravellingShortly"]) : <any>undefined;
            this.travellingDate = _data["travellingDate"] ? new Date(_data["travellingDate"].toString()) : <any>undefined;
            this.travelLocation = _data["travelLocation"] ? LookupField.fromJS(_data["travelLocation"]) : <any>undefined;
            this.tripDuration = _data["tripDuration"];
            this.isBusinessTrip = _data["isBusinessTrip"] ? LookupField.fromJS(_data["isBusinessTrip"]) : <any>undefined;
            this.transferDate = _data["transferDate"] ? new Date(_data["transferDate"].toString()) : <any>undefined;
            this.isEngagedInAnyProject = _data["isEngagedInAnyProject"] ? LookupField.fromJS(_data["isEngagedInAnyProject"]) : <any>undefined;
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ItPersonalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ItPersonalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holdEmploymentVisa"] = this.holdEmploymentVisa ? this.holdEmploymentVisa.toJSON() : <any>undefined;
        data["istravellingShortly"] = this.istravellingShortly ? this.istravellingShortly.toJSON() : <any>undefined;
        data["travellingDate"] = this.travellingDate ? this.travellingDate.toISOString() : <any>undefined;
        data["travelLocation"] = this.travelLocation ? this.travelLocation.toJSON() : <any>undefined;
        data["tripDuration"] = this.tripDuration;
        data["isBusinessTrip"] = this.isBusinessTrip ? this.isBusinessTrip.toJSON() : <any>undefined;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        data["isEngagedInAnyProject"] = this.isEngagedInAnyProject ? this.isEngagedInAnyProject.toJSON() : <any>undefined;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IItPersonalInfo {
    holdEmploymentVisa?: LookupField | undefined;
    istravellingShortly?: LookupField | undefined;
    travellingDate?: Date | undefined;
    travelLocation?: LookupField | undefined;
    tripDuration?: string | undefined;
    isBusinessTrip?: LookupField | undefined;
    transferDate?: Date | undefined;
    isEngagedInAnyProject?: LookupField | undefined;
    projectName?: string | undefined;
}

export class ItFinacialInformation implements IItFinacialInformation {
    havingOutstandingLoans?: LookupField | undefined;
    eosb?: LookupField | undefined;
    haveOutstandingreimbursements?: LookupField | undefined;
    isAmexCardAvailable?: LookupField | undefined;
    amexCard?: string | undefined;

    constructor(data?: IItFinacialInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.havingOutstandingLoans = _data["havingOutstandingLoans"] ? LookupField.fromJS(_data["havingOutstandingLoans"]) : <any>undefined;
            this.eosb = _data["eosb"] ? LookupField.fromJS(_data["eosb"]) : <any>undefined;
            this.haveOutstandingreimbursements = _data["haveOutstandingreimbursements"] ? LookupField.fromJS(_data["haveOutstandingreimbursements"]) : <any>undefined;
            this.isAmexCardAvailable = _data["isAmexCardAvailable"] ? LookupField.fromJS(_data["isAmexCardAvailable"]) : <any>undefined;
            this.amexCard = _data["amexCard"];
        }
    }

    static fromJS(data: any): ItFinacialInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ItFinacialInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["havingOutstandingLoans"] = this.havingOutstandingLoans ? this.havingOutstandingLoans.toJSON() : <any>undefined;
        data["eosb"] = this.eosb ? this.eosb.toJSON() : <any>undefined;
        data["haveOutstandingreimbursements"] = this.haveOutstandingreimbursements ? this.haveOutstandingreimbursements.toJSON() : <any>undefined;
        data["isAmexCardAvailable"] = this.isAmexCardAvailable ? this.isAmexCardAvailable.toJSON() : <any>undefined;
        data["amexCard"] = this.amexCard;
        return data;
    }
}

export interface IItFinacialInformation {
    havingOutstandingLoans?: LookupField | undefined;
    eosb?: LookupField | undefined;
    haveOutstandingreimbursements?: LookupField | undefined;
    isAmexCardAvailable?: LookupField | undefined;
    amexCard?: string | undefined;
}

export class ItITInformation implements IItITInformation {
    haveCurrentOfficeEquipment?: LookupField | undefined;
    haveAccesstoMailbox?: LookupField | undefined;
    dicussedRequirementWithITteam?: LookupField | undefined;

    constructor(data?: IItITInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haveCurrentOfficeEquipment = _data["haveCurrentOfficeEquipment"] ? LookupField.fromJS(_data["haveCurrentOfficeEquipment"]) : <any>undefined;
            this.haveAccesstoMailbox = _data["haveAccesstoMailbox"] ? LookupField.fromJS(_data["haveAccesstoMailbox"]) : <any>undefined;
            this.dicussedRequirementWithITteam = _data["dicussedRequirementWithITteam"] ? LookupField.fromJS(_data["dicussedRequirementWithITteam"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItITInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ItITInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haveCurrentOfficeEquipment"] = this.haveCurrentOfficeEquipment ? this.haveCurrentOfficeEquipment.toJSON() : <any>undefined;
        data["haveAccesstoMailbox"] = this.haveAccesstoMailbox ? this.haveAccesstoMailbox.toJSON() : <any>undefined;
        data["dicussedRequirementWithITteam"] = this.dicussedRequirementWithITteam ? this.dicussedRequirementWithITteam.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItITInformation {
    haveCurrentOfficeEquipment?: LookupField | undefined;
    haveAccesstoMailbox?: LookupField | undefined;
    dicussedRequirementWithITteam?: LookupField | undefined;
}

export class ItLeaveInformation implements IItLeaveInformation {
    havingOutstandingLeave?: LookupField | undefined;
    totalDaysInFY?: string | undefined;
    howToManageLeave?: LookupField | undefined;

    constructor(data?: IItLeaveInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.havingOutstandingLeave = _data["havingOutstandingLeave"] ? LookupField.fromJS(_data["havingOutstandingLeave"]) : <any>undefined;
            this.totalDaysInFY = _data["totalDaysInFY"];
            this.howToManageLeave = _data["howToManageLeave"] ? LookupField.fromJS(_data["howToManageLeave"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItLeaveInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ItLeaveInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["havingOutstandingLeave"] = this.havingOutstandingLeave ? this.havingOutstandingLeave.toJSON() : <any>undefined;
        data["totalDaysInFY"] = this.totalDaysInFY;
        data["howToManageLeave"] = this.howToManageLeave ? this.howToManageLeave.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItLeaveInformation {
    havingOutstandingLeave?: LookupField | undefined;
    totalDaysInFY?: string | undefined;
    howToManageLeave?: LookupField | undefined;
}

export class KinDetails implements IKinDetails {
    name?: string | undefined;
    relationship?: string | undefined;
    contactInfo?: string | undefined;
    cnic?: string | undefined;
    kiNaddress?: string | undefined;

    constructor(data?: IKinDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.relationship = _data["relationship"];
            this.contactInfo = _data["contactInfo"];
            this.cnic = _data["cnic"];
            this.kiNaddress = _data["kiNaddress"];
        }
    }

    static fromJS(data: any): KinDetails {
        data = typeof data === 'object' ? data : {};
        let result = new KinDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["relationship"] = this.relationship;
        data["contactInfo"] = this.contactInfo;
        data["cnic"] = this.cnic;
        data["kiNaddress"] = this.kiNaddress;
        return data;
    }
}

export interface IKinDetails {
    name?: string | undefined;
    relationship?: string | undefined;
    contactInfo?: string | undefined;
    cnic?: string | undefined;
    kiNaddress?: string | undefined;
}

export class FamilyBookDetails implements IFamilyBookDetails {
    haveFamilyBook?: LookupField | undefined;
    familyNumber?: string | undefined;
    familyBookNumber?: string | undefined;
    cityNumber?: string | undefined;
    passportUIDnumber?: string | undefined;
    idbaraNumber?: string | undefined;

    constructor(data?: IFamilyBookDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haveFamilyBook = _data["haveFamilyBook"] ? LookupField.fromJS(_data["haveFamilyBook"]) : <any>undefined;
            this.familyNumber = _data["familyNumber"];
            this.familyBookNumber = _data["familyBookNumber"];
            this.cityNumber = _data["cityNumber"];
            this.passportUIDnumber = _data["passportUIDnumber"];
            this.idbaraNumber = _data["idbaraNumber"];
        }
    }

    static fromJS(data: any): FamilyBookDetails {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyBookDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haveFamilyBook"] = this.haveFamilyBook ? this.haveFamilyBook.toJSON() : <any>undefined;
        data["familyNumber"] = this.familyNumber;
        data["familyBookNumber"] = this.familyBookNumber;
        data["cityNumber"] = this.cityNumber;
        data["passportUIDnumber"] = this.passportUIDnumber;
        data["idbaraNumber"] = this.idbaraNumber;
        return data;
    }
}

export interface IFamilyBookDetails {
    haveFamilyBook?: LookupField | undefined;
    familyNumber?: string | undefined;
    familyBookNumber?: string | undefined;
    cityNumber?: string | undefined;
    passportUIDnumber?: string | undefined;
    idbaraNumber?: string | undefined;
}

export class LastEmployer implements ILastEmployer {
    lastEmployerName?: string | undefined;
    lastEmployerLocation?: LookupField | undefined;
    lastEmployerStartDate?: Date | undefined;
    lastEmployerEndDate?: Date | undefined;

    constructor(data?: ILastEmployer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastEmployerName = _data["lastEmployerName"];
            this.lastEmployerLocation = _data["lastEmployerLocation"] ? LookupField.fromJS(_data["lastEmployerLocation"]) : <any>undefined;
            this.lastEmployerStartDate = _data["lastEmployerStartDate"] ? new Date(_data["lastEmployerStartDate"].toString()) : <any>undefined;
            this.lastEmployerEndDate = _data["lastEmployerEndDate"] ? new Date(_data["lastEmployerEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LastEmployer {
        data = typeof data === 'object' ? data : {};
        let result = new LastEmployer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastEmployerName"] = this.lastEmployerName;
        data["lastEmployerLocation"] = this.lastEmployerLocation ? this.lastEmployerLocation.toJSON() : <any>undefined;
        data["lastEmployerStartDate"] = this.lastEmployerStartDate ? this.lastEmployerStartDate.toISOString() : <any>undefined;
        data["lastEmployerEndDate"] = this.lastEmployerEndDate ? this.lastEmployerEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILastEmployer {
    lastEmployerName?: string | undefined;
    lastEmployerLocation?: LookupField | undefined;
    lastEmployerStartDate?: Date | undefined;
    lastEmployerEndDate?: Date | undefined;
}

export class ImmigrationProfile implements IImmigrationProfile {
    id?: number;
    visaCountry?: LookupField | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    nationality?: LookupField | undefined;
    passportNumber?: string | undefined;
    placeOfBirth?: string | undefined;
    phoneNumber?: string | undefined;
    countryCode?: string | undefined;
    officeLE?: OfficeEntity | undefined;
    gender?: LookupField | undefined;
    onboardingType?: LookupField | undefined;
    officeLocation?: LookupField | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    globalRank?: GlobalRank | undefined;
    globalGrade?: GlobalGrade | undefined;
    withdrawnDate?: Date | undefined;
    job?: RankGrade | undefined;
    ksaOfficeToBeVisited?: LookupField | undefined;
    requestor?: Employee | undefined;
    processor?: Employee | undefined;
    prevProcessorId?: number;
    onBehalfRequestor?: AdUser | undefined;
    onBehalfRequestorId?: number | undefined;
    globalEmployeeLocation?: LookupField | undefined;
    employeeCurrentLocation?: LookupField | undefined;
    employeeCurrentLocationCountry?: LookupField | undefined;
    completedUAEPassRegistration?: LookupField | undefined;
    dependentFinalExitDeadline?: Date | undefined;
    immigrationCaseType?: LookupField | undefined;
    visaType?: LookupField | undefined;
    additionalDocs?: number[] | undefined;
    dateOfBirth?: Date | undefined;
    officeToBeVisited?: LookupField | undefined;
    gccResidencyTitle?: string | undefined;
    nonGCCResidencyTitle?: string | undefined;
    gccSponsorName?: string | undefined;
    durationOfStayId?: number | undefined;
    durationOfStay?: LookupField | undefined;
    embassyId?: number | undefined;
    embassy?: LookupField | undefined;
    cityOfEmbassy?: string | undefined;
    currentCity?: string | undefined;
    visaAgentName?: string | undefined;
    chargeCode?: string | undefined;
    dateOfTravel?: Date | undefined;
    travelPurpose?: LookupField | undefined;
    dateOfExit?: Date | undefined;
    reason?: string | undefined;
    projectName?: string | undefined;
    projectManagerId?: number | undefined;
    projectManager?: AdUser | undefined;
    letterAddressedTo?: string | undefined;
    gpn?: string | undefined;
    gui?: string | undefined;
    involuntaryExitTeam?: TeamInfo | undefined;
    voluntaryExitTeam?: TeamInfo | undefined;
    legalEntitiesTeam?: TeamInfo | undefined;
    involuntaryExitId?: number | undefined;
    voluntaryExitId?: number | undefined;
    legalEntitiesId?: number | undefined;
    involuntaryExitComment?: string | undefined;
    voluntaryExitComment?: string | undefined;
    legalEntitiesComment?: string | undefined;
    isActive?: boolean;
    isAutoGenerated?: boolean;
    isAutoCreatedAfterJoin?: boolean;
    createdBy?: number | undefined;
    createdDate?: Date | undefined;
    visaApprovedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    createdByEmployee?: Employee | undefined;
    modifiedByEmployee?: Employee | undefined;
    immigrationStatus?: LookupField | undefined;
    status?: LookupField | undefined;
    entryTypeId?: number | undefined;
    entryType?: LookupField | undefined;
    visaNumber?: string | undefined;
    visaDesignation?: string | undefined;
    academicQualification?: string | undefined;
    residencyDesignation?: string | undefined;
    passportExpiryDate?: Date | undefined;
    nationalityIdNumber?: string | undefined;
    travelDate?: Date | undefined;
    permissionDuration?: string | undefined;
    dateOfPayment?: Date | undefined;
    specialExpat?: boolean | undefined;
    startDate?: Date | undefined;
    attestationCompletedDate?: Date | undefined;
    entryDate?: Date | undefined;
    borderNumber?: string | undefined;
    medicalExamCompletionDate?: Date | undefined;
    bioMetricCompletedDate?: Date | undefined;
    agentCourierAddress?: string | undefined;
    iqamaId?: string | undefined;
    iqamaExpiryDate?: Date | undefined;
    residencyExpiryDate?: Date | undefined;
    detailsToBeUpdated?: string | undefined;
    wantToUpdateDependentPassport?: LookupField | undefined;
    nameOfNewEmployer?: string | undefined;
    lastWorkingDay?: Date | undefined;
    ksaFinalExitDate?: Date | undefined;
    spouseDetails?: string | undefined;
    childrenDetails?: string | undefined;
    sponsorDepsInKSA?: LookupField | undefined;
    depsAlreadyInKSA?: LookupField | undefined;
    newJoinerNameInArabic?: string | undefined;
    residencyStatus?: LookupField | undefined;
    tentativeStartDate?: Date | undefined;
    ptc?: Employee | undefined;
    recruiter?: Employee | undefined;
    vaccinationStatus?: LookupField | undefined;
    lastVaccineDate?: Date | undefined;
    vaccineType?: LookupField | undefined;
    otherVaccineName?: string | undefined;
    iqamaNumber?: string | undefined;
    trackingNumber?: string | undefined;
    dataStore?: any;
    notes?: string | undefined;
    dualCitizenship?: LookupField | undefined;
    secondNationality?: LookupField | undefined;
    distanceLearning?: LookupField | undefined;
    emailAddress?: string | undefined;
    currentEyEmployee?: LookupField | undefined;
    currentGccResident?: LookupField | undefined;
    prevCurrentGccResident?: LookupField | undefined;
    preboardingType?: LookupField | undefined;
    passportType?: LookupField | undefined;
    reasonForVisit?: LookupField | undefined;
    employeeSearchTerm?: string | undefined;
    otherReasonForCancellation?: string | undefined;
    labourCardCancellationType?: LookupField | undefined;
    terminationType?: LookupField | undefined;
    contactNumber?: string | undefined;
    enrollmentType?: LookupField | undefined;
    workTimings?: LookupField | undefined;
    language?: LookupField | undefined;
    workWeek?: LookupField | undefined;
    jobBenefits?: LookupField | undefined;
    entity?: string | undefined;
    department?: string | undefined;
    jobDescription?: string | undefined;
    yearsOfService?: string | undefined;
    generalSkills?: string | undefined;
    vocationalSkills?: string | undefined;
    specialization?: string | undefined;
    ageFrom?: string | undefined;
    ageTo?: string | undefined;
    remuneration?: string | undefined;
    basicSalary?: string | undefined;
    otherAllowance?: string | undefined;
    totalSalary?: string | undefined;
    tawteenJobOfferDesignation?: string | undefined;
    tgNumber?: string | undefined;
    visaIssuanceDate?: Date | undefined;
    homeAddress?: string | undefined;
    mothersName?: string | undefined;
    maritalStatus?: LookupField | undefined;
    religion?: LookupField | undefined;
    sect?: LookupField | undefined;
    attrestedDegree?: LookupField | undefined;
    alreadyHaveGoldenVisa?: LookupField | undefined;
    attestedByUAE?: LookupField | undefined;
    registeredWithUAE?: LookupField | undefined;
    visaStatus?: LookupField | undefined;
    uid?: string | undefined;
    missionExpiryDate?: Date | undefined;
    missionExpiryCancellation?: Date | undefined;
    missionVisaCategory?: LookupField | undefined;
    originalEducation?: LookupField | undefined;
    visaRenewal?: Date | undefined;
    originalDegreeCertificate?: string | undefined;
    fileNumber?: string | undefined;
    laborCardNumber?: string | undefined;
    laborCardExpiryDate?: Date | undefined;
    laborCardCancellationDate?: Date | undefined;
    noticePeriod?: number | undefined;
    contractDuration?: number | undefined;
    molContract?: LookupField | undefined;
    visaAlignment?: LookupField | undefined;
    emiratesIdNumber?: string | undefined;
    khulasatNumber?: string | undefined;
    pensionRegistrationNo?: string | undefined;
    pensionRegistrationDate?: Date | undefined;
    emergencyContact?: string | undefined;
    emergencyContactName?: string | undefined;
    emergencyContactCode?: string | undefined;
    workPermitDesignation?: string | undefined;
    securityPermitNumber?: string | undefined;
    securityPermitIssuanceDate?: Date | undefined;
    securityPermitExpiryDate?: Date | undefined;
    securityPermitCancellationDate?: Date | undefined;
    pensionCancellationDate?: Date | undefined;
    oldNationality?: LookupField | undefined;
    jobTitle?: string | undefined;
    numberOfQuotaRequired?: string | undefined;
    visaCategory?: string | undefined;
    vpNumber?: string | undefined;
    labourPersonCode?: string | undefined;
    mohreJobTitle?: string | undefined;
    mohreJobTitleId?: LookupField | undefined;
    workPermitCategory?: string | undefined;
    workPermitJobCode?: string | undefined;
    typeOfVisa?: LookupField | undefined;
    typeOfWorkPermit?: LookupField | undefined;
    workPermitPreApprovalDate?: Date | undefined;
    workPermitApprovalDate?: Date | undefined;
    visaExpiryDate?: Date | undefined;
    rpIssuanceDate?: Date | undefined;
    cprIssuanceDate?: Date | undefined;
    rpExpiryDate?: Date | undefined;
    newRPExpiryDate?: Date | undefined;
    quotaValidityDate?: Date | undefined;
    rpRenewalDate?: Date | undefined;
    cprExpiryDate?: Date | undefined;
    civilIdExpiryDate?: Date | undefined;
    rpNumber?: string | undefined;
    departureDate?: Date | undefined;
    newSponsorName?: string | undefined;
    rpCancellationDate?: Date | undefined;
    rpTransferDate?: Date | undefined;
    visaTransferDate?: Date | undefined;
    molContractCancellationDate?: Date | undefined;
    pasiContractCancellationRequestDate?: Date | undefined;
    shortTermVisa?: LookupField | undefined;
    statusDate?: Date | undefined;
    numberOfVisasRequired?: number | undefined;
    relationship?: LookupField | undefined;
    otherRelationshipName?: string | undefined;
    dependentDetails?: string | undefined;
    issuingCountryId?: LookupField | undefined;
    issuingCountry?: string | undefined;
    govtAuthority?: string | undefined;
    durationOfStayInDays?: number | undefined;
    typeOfRequest?: LookupField | undefined;
    isYourMarriageOrBirthCertificateAttested?: LookupField | undefined;
    tentativeTravelDate?: Date | undefined;
    previousSponsorName?: string | undefined;
    currentProfession?: string | undefined;
    newProfession?: string | undefined;
    gatePassDuration?: string | undefined;
    employeeCategory?: LookupField | undefined;
    cancellationReason?: LookupField | undefined;
    acceptedDate?: Date | undefined;
    declinedDate?: Date | undefined;
    approvedDate?: Date | undefined;
    rejectedDate?: Date | undefined;
    submissionDate?: Date | undefined;
    completionDate?: Date | undefined;
    initiationDate?: Date | undefined;
    employeeProfileId?: number | undefined;
    employeeId?: number | undefined;
    referenceId?: number | undefined;
    childReferenceId?: number | undefined;
    referenceVisaType?: string | undefined;
    createdByRoleId?: number;
    menaEmployee?: number | undefined;
    dependentCurrentLocation?: LookupField | undefined;
    oldPassportNumber?: string | undefined;
    onBehalfOfAnotherEYEmployee?: LookupField | undefined;
    onEntryBusinessVisa?: LookupField | undefined;
    visaCancellationRequired?: LookupField | undefined;
    visaCancellationExtensionDate?: Date | undefined;
    dependentsUnderSponsorship?: LookupField | undefined;
    dependentsUnderSponsorshipInUAE?: LookupField | undefined;
    dependentsVisaOnHold?: LookupField | undefined;
    dependentVisaCancellationDate?: Date | undefined;
    employmentVisaCancellationDate?: Date | undefined;
    gvExpiryDate?: Date | undefined;
    visaCancellationDate?: Date | undefined;
    cprNumber?: string | undefined;
    gosiTerminationDate?: Date | undefined;
    cprCaseType?: LookupField | undefined;
    cprType?: LookupField | undefined;
    bahrainResidentialAddress?: string | undefined;
    dateOfInvitationLetterIssuance?: Date | undefined;
    doYouHaveValidKSABusinessVisa?: LookupField | undefined;
    dateKSABusinessVisaExpiry?: Date | undefined;
    hireType?: LookupField | undefined;
    permitType?: LookupField | undefined;
    moiClientCode?: string | undefined;
    areaCode?: string | undefined;
    bloodGroup?: LookupField | undefined;
    typeOfSupport?: LookupField | undefined;
    dateOfGatePassIssuance?: Date | undefined;
    transferApprovalDate?: Date | undefined;
    visaExtensionDate?: Date | undefined;
    reasonForProfessionChange?: string | undefined;
    dependentsInKuwait?: LookupField | undefined;
    currentRPDesignation?: string | undefined;
    currentSponcerName?: string | undefined;
    workPermitExpiryDate?: Date | undefined;
    workPermitNumber?: string | undefined;
    civilIDNumber?: string | undefined;
    documentType?: string | undefined;
    transferScenario?: LookupField | undefined;
    attestedbyKwait?: LookupField | undefined;
    isParentKwaitNational?: LookupField | undefined;
    isImmediateRealativeKwaitNational?: LookupField | undefined;
    kwaitProfessionalQualification?: LookupField | undefined;
    currentlyInKuwait?: LookupField | undefined;
    gracePeriodExpiryDate?: Date | undefined;
    workPermitIssuanceDate?: Date | undefined;
    modificationDetails?: string | undefined;
    newResidencePACINumber?: string | undefined;
    typeOfModification?: LookupField | undefined;
    pifssCancellationDate?: Date | undefined;
    workPermitCancellationDate?: Date | undefined;
    qualification?: LookupField | undefined;
    categoryOfJobOffer?: LookupField | undefined;
    reasonForVisitUAEBusinessVisa?: LookupField | undefined;
    reasonForRenewal?: LookupField | undefined;
    autorequestCompleted?: string | undefined;
    medicalApplicationNumber?: string | undefined;
    visaValidity?: string | undefined;
    travelType?: LookupField | undefined;
    realtiveUAENumber?: string | undefined;
    nomination?: LookupField | undefined;
    eyInternalTransfer?: LookupField | undefined;
    ibanNumber?: string | undefined;
    bankName?: string | undefined;
    saSerialNumber?: string | undefined;
    candidateProfileId?: number | undefined;
    pbActivityId?: number | undefined;
    visaValidityDate?: Date | undefined;
    requestorEmailAddress?: string | undefined;
    requestorName?: string | undefined;
    personalEmailAddress?: string | undefined;
    eyEmailAddress?: string | undefined;
    currentBahrainResident?: LookupField | undefined;
    isBahrainResident?: LookupField | undefined;
    isdependentsUnderSponsorship?: LookupField | undefined;
    perDiem?: string | undefined;
    engagementName?: string | undefined;
    engPartnerName?: string | undefined;
    reasonForExit?: LookupField | undefined;
    otherReasonForExit?: string | undefined;
    noOfExtensionTimes?: LookupField | undefined;
    reasonForExtension?: string | undefined;
    extensionIssuanceDate?: Date | undefined;
    loiNumber?: string | undefined;
    loiIssueDate?: Date | undefined;
    loiVisaDuration?: string | undefined;
    loiVisaType?: string | undefined;
    loiJobTiteInArabic?: string | undefined;
    typeOfDocRequested?: number[] | undefined;
    otherTypeOfDocRequested?: string | undefined;
    newResidencyExpirydate?: Date | undefined;
    documentSupportType?: LookupField | undefined;
    arabicJobGroup?: string | undefined;
    arabicVisaDesignation?: string | undefined;
    citizenshipId?: number | undefined;
    sponsorID?: string | undefined;
    socialInsuranceNumber?: string | undefined;
    typeOfEmployment?: LookupField | undefined;
    isEYFirstEmployer?: LookupField | undefined;
    siRegistrationDate?: Date | undefined;
    purposeOfRequest?: string | undefined;
    dateDocumentAttestationCompleted?: Date | undefined;
    siCancellationDate?: Date | undefined;
    iqamaCancellationDate?: Date | undefined;
    iqamaExpiryDateRenewed?: Date | undefined;
    lastWorkingDate?: Date | undefined;
    dependentRPIssuanceDate?: Date | undefined;
    dependentRPExpiryDate?: Date | undefined;
    dependentsRPCancellationDate?: Date | undefined;
    previousNationality?: LookupField | undefined;
    specialty?: string | undefined;
    durationofstudy?: string | undefined;
    issuingEntity?: string | undefined;
    nationalityType?: LookupField | undefined;
    currentKSAbusinessvisa?: LookupField | undefined;
    currentKSABusinessVisaExpiryDate?: Date | undefined;
    dateSoftcopyVisaDocumentsSent?: Date | undefined;
    dateHardcopyVisaDocumentsSent?: Date | undefined;
    dateCourierTrackingNumberSent?: Date | undefined;
    dateHardCopyVisaDocumentsReceivedByVendorOrNJ?: Date | undefined;
    ewakalaAgent?: LookupField | undefined;
    courierDispatchDate?: Date | undefined;
    parentImmProfileId?: number | undefined;
    immEmployee?: AdUser | undefined;
    immEmployeeId?: number | undefined;
    isFirstVisitToPakistan?: LookupField | undefined;
    isFirstVisitToJordan?: LookupField | undefined;
    mothersFullName?: string | undefined;
    reasonForVisitPAKBusinessVisa?: LookupField | undefined;
    gcCresidentExpiryDate?: Date | undefined;
    pakOfficeToVisit?: LookupField | undefined;
    labourContractNoticePeriod?: number | undefined;
    isQualifiedInAccounting?: LookupField | undefined;
    isFirstEmployedInEgypt?: LookupField | undefined;
    docPrefix?: string | undefined;
    parentExitProfileId?: number | undefined;
    exitActivityId?: number | undefined;
    onHoldDate?: Date | undefined;
    editCompletedProfile?: boolean;
    scpMembership?: LookupField | undefined;
    specificWorkLocationduringTrip?: string | undefined;
    workLocationDuringTrip?: number[] | undefined;
    performingBillableWork?: LookupField | undefined;
    requestedService?: LookupField | undefined;
    countryToBeVisited?: LookupField | undefined;
    cityToBeVisited?: LookupField | undefined;
    visaDuration?: LookupField | undefined;
    purposeOfVisit?: number[] | undefined;
    specifyPurposeOfVisit?: string | undefined;
    isMenaSponsoringPartner?: LookupField | undefined;
    menaSponsoringPartnerName?: string | undefined;
    previousDateOfExit?: Date | undefined;
    revisedDateOfExit?: Date | undefined;
    currentVisaExpiryDate?: Date | undefined;
    purposeOfExtension?: string | undefined;
    currentTypeOfVisa?: LookupField | undefined;
    currentEntryType?: LookupField | undefined;
    currentVisaDuration?: LookupField | undefined;
    officeLocationCountry?: LookupField | undefined;
    processingTeam?: LookupField | undefined;
    processedBy?: LookupField | undefined;
    processedByOther?: string | undefined;
    exceptionalApprovalRequired?: LookupField | undefined;
    approverName?: string | undefined;
    recommendedVisaType?: LookupField | undefined;
    recommendedEntryType?: LookupField | undefined;
    recommendedVisaDuration?: LookupField | undefined;
    bTdurationOfStay?: string | undefined;
    primeType?: LookupField | undefined;
    issuedVisaExpiryDate?: Date | undefined;
    universityDegree?: LookupField | undefined;
    accomodationSupportRequired?: LookupField | undefined;
    accommodationRequired?: LookupField | undefined;
    degreeAttestationRequired?: LookupField | undefined;
    degreeAttestationCompletedDate?: Date | undefined;
    documentReceiptDate?: Date | undefined;
    quotationIssuanceDate?: Date | undefined;
    entryPermitIssueDate?: Date | undefined;
    invoiceIssuanceDate?: Date | undefined;
    purchaseOrderIssuanceDate?: Date | undefined;
    payroll?: LookupField | undefined;
    salaryAmount?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceMonth?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceCurrency?: string | undefined;
    invoiceAmount?: string | undefined;
    poNumber?: string | undefined;
    loiJobTiteInEnglish?: string | undefined;

    constructor(data?: IImmigrationProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.visaCountry = _data["visaCountry"] ? LookupField.fromJS(_data["visaCountry"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"] ? LookupField.fromJS(_data["nationality"]) : <any>undefined;
            this.passportNumber = _data["passportNumber"];
            this.placeOfBirth = _data["placeOfBirth"];
            this.phoneNumber = _data["phoneNumber"];
            this.countryCode = _data["countryCode"];
            this.officeLE = _data["officeLE"] ? OfficeEntity.fromJS(_data["officeLE"]) : <any>undefined;
            this.gender = _data["gender"] ? LookupField.fromJS(_data["gender"]) : <any>undefined;
            this.onboardingType = _data["onboardingType"] ? LookupField.fromJS(_data["onboardingType"]) : <any>undefined;
            this.officeLocation = _data["officeLocation"] ? LookupField.fromJS(_data["officeLocation"]) : <any>undefined;
            this.serviceLine = _data["serviceLine"] ? ServiceLine.fromJS(_data["serviceLine"]) : <any>undefined;
            this.subServiceLine = _data["subServiceLine"] ? SubServiceLine.fromJS(_data["subServiceLine"]) : <any>undefined;
            this.globalRank = _data["globalRank"] ? GlobalRank.fromJS(_data["globalRank"]) : <any>undefined;
            this.globalGrade = _data["globalGrade"] ? GlobalGrade.fromJS(_data["globalGrade"]) : <any>undefined;
            this.withdrawnDate = _data["withdrawnDate"] ? new Date(_data["withdrawnDate"].toString()) : <any>undefined;
            this.job = _data["job"] ? RankGrade.fromJS(_data["job"]) : <any>undefined;
            this.ksaOfficeToBeVisited = _data["ksaOfficeToBeVisited"] ? LookupField.fromJS(_data["ksaOfficeToBeVisited"]) : <any>undefined;
            this.requestor = _data["requestor"] ? Employee.fromJS(_data["requestor"]) : <any>undefined;
            this.processor = _data["processor"] ? Employee.fromJS(_data["processor"]) : <any>undefined;
            this.prevProcessorId = _data["prevProcessorId"];
            this.onBehalfRequestor = _data["onBehalfRequestor"] ? AdUser.fromJS(_data["onBehalfRequestor"]) : <any>undefined;
            this.onBehalfRequestorId = _data["onBehalfRequestorId"];
            this.globalEmployeeLocation = _data["globalEmployeeLocation"] ? LookupField.fromJS(_data["globalEmployeeLocation"]) : <any>undefined;
            this.employeeCurrentLocation = _data["employeeCurrentLocation"] ? LookupField.fromJS(_data["employeeCurrentLocation"]) : <any>undefined;
            this.employeeCurrentLocationCountry = _data["employeeCurrentLocationCountry"] ? LookupField.fromJS(_data["employeeCurrentLocationCountry"]) : <any>undefined;
            this.completedUAEPassRegistration = _data["completedUAEPassRegistration"] ? LookupField.fromJS(_data["completedUAEPassRegistration"]) : <any>undefined;
            this.dependentFinalExitDeadline = _data["dependentFinalExitDeadline"] ? new Date(_data["dependentFinalExitDeadline"].toString()) : <any>undefined;
            this.immigrationCaseType = _data["immigrationCaseType"] ? LookupField.fromJS(_data["immigrationCaseType"]) : <any>undefined;
            this.visaType = _data["visaType"] ? LookupField.fromJS(_data["visaType"]) : <any>undefined;
            if (Array.isArray(_data["additionalDocs"])) {
                this.additionalDocs = [] as any;
                for (let item of _data["additionalDocs"])
                    this.additionalDocs!.push(item);
            }
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.officeToBeVisited = _data["officeToBeVisited"] ? LookupField.fromJS(_data["officeToBeVisited"]) : <any>undefined;
            this.gccResidencyTitle = _data["gccResidencyTitle"];
            this.nonGCCResidencyTitle = _data["nonGCCResidencyTitle"];
            this.gccSponsorName = _data["gccSponsorName"];
            this.durationOfStayId = _data["durationOfStayId"];
            this.durationOfStay = _data["durationOfStay"] ? LookupField.fromJS(_data["durationOfStay"]) : <any>undefined;
            this.embassyId = _data["embassyId"];
            this.embassy = _data["embassy"] ? LookupField.fromJS(_data["embassy"]) : <any>undefined;
            this.cityOfEmbassy = _data["cityOfEmbassy"];
            this.currentCity = _data["currentCity"];
            this.visaAgentName = _data["visaAgentName"];
            this.chargeCode = _data["chargeCode"];
            this.dateOfTravel = _data["dateOfTravel"] ? new Date(_data["dateOfTravel"].toString()) : <any>undefined;
            this.travelPurpose = _data["travelPurpose"] ? LookupField.fromJS(_data["travelPurpose"]) : <any>undefined;
            this.dateOfExit = _data["dateOfExit"] ? new Date(_data["dateOfExit"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.projectName = _data["projectName"];
            this.projectManagerId = _data["projectManagerId"];
            this.projectManager = _data["projectManager"] ? AdUser.fromJS(_data["projectManager"]) : <any>undefined;
            this.letterAddressedTo = _data["letterAddressedTo"];
            this.gpn = _data["gpn"];
            this.gui = _data["gui"];
            this.involuntaryExitTeam = _data["involuntaryExitTeam"] ? TeamInfo.fromJS(_data["involuntaryExitTeam"]) : <any>undefined;
            this.voluntaryExitTeam = _data["voluntaryExitTeam"] ? TeamInfo.fromJS(_data["voluntaryExitTeam"]) : <any>undefined;
            this.legalEntitiesTeam = _data["legalEntitiesTeam"] ? TeamInfo.fromJS(_data["legalEntitiesTeam"]) : <any>undefined;
            this.involuntaryExitId = _data["involuntaryExitId"];
            this.voluntaryExitId = _data["voluntaryExitId"];
            this.legalEntitiesId = _data["legalEntitiesId"];
            this.involuntaryExitComment = _data["involuntaryExitComment"];
            this.voluntaryExitComment = _data["voluntaryExitComment"];
            this.legalEntitiesComment = _data["legalEntitiesComment"];
            this.isActive = _data["isActive"];
            this.isAutoGenerated = _data["isAutoGenerated"];
            this.isAutoCreatedAfterJoin = _data["isAutoCreatedAfterJoin"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.visaApprovedDate = _data["visaApprovedDate"] ? new Date(_data["visaApprovedDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdByEmployee = _data["createdByEmployee"] ? Employee.fromJS(_data["createdByEmployee"]) : <any>undefined;
            this.modifiedByEmployee = _data["modifiedByEmployee"] ? Employee.fromJS(_data["modifiedByEmployee"]) : <any>undefined;
            this.immigrationStatus = _data["immigrationStatus"] ? LookupField.fromJS(_data["immigrationStatus"]) : <any>undefined;
            this.status = _data["status"] ? LookupField.fromJS(_data["status"]) : <any>undefined;
            this.entryTypeId = _data["entryTypeId"];
            this.entryType = _data["entryType"] ? LookupField.fromJS(_data["entryType"]) : <any>undefined;
            this.visaNumber = _data["visaNumber"];
            this.visaDesignation = _data["visaDesignation"];
            this.academicQualification = _data["academicQualification"];
            this.residencyDesignation = _data["residencyDesignation"];
            this.passportExpiryDate = _data["passportExpiryDate"] ? new Date(_data["passportExpiryDate"].toString()) : <any>undefined;
            this.nationalityIdNumber = _data["nationalityIdNumber"];
            this.travelDate = _data["travelDate"] ? new Date(_data["travelDate"].toString()) : <any>undefined;
            this.permissionDuration = _data["permissionDuration"];
            this.dateOfPayment = _data["dateOfPayment"] ? new Date(_data["dateOfPayment"].toString()) : <any>undefined;
            this.specialExpat = _data["specialExpat"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.attestationCompletedDate = _data["attestationCompletedDate"] ? new Date(_data["attestationCompletedDate"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.borderNumber = _data["borderNumber"];
            this.medicalExamCompletionDate = _data["medicalExamCompletionDate"] ? new Date(_data["medicalExamCompletionDate"].toString()) : <any>undefined;
            this.bioMetricCompletedDate = _data["bioMetricCompletedDate"] ? new Date(_data["bioMetricCompletedDate"].toString()) : <any>undefined;
            this.agentCourierAddress = _data["agentCourierAddress"];
            this.iqamaId = _data["iqamaId"];
            this.iqamaExpiryDate = _data["iqamaExpiryDate"] ? new Date(_data["iqamaExpiryDate"].toString()) : <any>undefined;
            this.residencyExpiryDate = _data["residencyExpiryDate"] ? new Date(_data["residencyExpiryDate"].toString()) : <any>undefined;
            this.detailsToBeUpdated = _data["detailsToBeUpdated"];
            this.wantToUpdateDependentPassport = _data["wantToUpdateDependentPassport"] ? LookupField.fromJS(_data["wantToUpdateDependentPassport"]) : <any>undefined;
            this.nameOfNewEmployer = _data["nameOfNewEmployer"];
            this.lastWorkingDay = _data["lastWorkingDay"] ? new Date(_data["lastWorkingDay"].toString()) : <any>undefined;
            this.ksaFinalExitDate = _data["ksaFinalExitDate"] ? new Date(_data["ksaFinalExitDate"].toString()) : <any>undefined;
            this.spouseDetails = _data["spouseDetails"];
            this.childrenDetails = _data["childrenDetails"];
            this.sponsorDepsInKSA = _data["sponsorDepsInKSA"] ? LookupField.fromJS(_data["sponsorDepsInKSA"]) : <any>undefined;
            this.depsAlreadyInKSA = _data["depsAlreadyInKSA"] ? LookupField.fromJS(_data["depsAlreadyInKSA"]) : <any>undefined;
            this.newJoinerNameInArabic = _data["newJoinerNameInArabic"];
            this.residencyStatus = _data["residencyStatus"] ? LookupField.fromJS(_data["residencyStatus"]) : <any>undefined;
            this.tentativeStartDate = _data["tentativeStartDate"] ? new Date(_data["tentativeStartDate"].toString()) : <any>undefined;
            this.ptc = _data["ptc"] ? Employee.fromJS(_data["ptc"]) : <any>undefined;
            this.recruiter = _data["recruiter"] ? Employee.fromJS(_data["recruiter"]) : <any>undefined;
            this.vaccinationStatus = _data["vaccinationStatus"] ? LookupField.fromJS(_data["vaccinationStatus"]) : <any>undefined;
            this.lastVaccineDate = _data["lastVaccineDate"] ? new Date(_data["lastVaccineDate"].toString()) : <any>undefined;
            this.vaccineType = _data["vaccineType"] ? LookupField.fromJS(_data["vaccineType"]) : <any>undefined;
            this.otherVaccineName = _data["otherVaccineName"];
            this.iqamaNumber = _data["iqamaNumber"];
            this.trackingNumber = _data["trackingNumber"];
            this.dataStore = _data["dataStore"];
            this.notes = _data["notes"];
            this.dualCitizenship = _data["dualCitizenship"] ? LookupField.fromJS(_data["dualCitizenship"]) : <any>undefined;
            this.secondNationality = _data["secondNationality"] ? LookupField.fromJS(_data["secondNationality"]) : <any>undefined;
            this.distanceLearning = _data["distanceLearning"] ? LookupField.fromJS(_data["distanceLearning"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.currentEyEmployee = _data["currentEyEmployee"] ? LookupField.fromJS(_data["currentEyEmployee"]) : <any>undefined;
            this.currentGccResident = _data["currentGccResident"] ? LookupField.fromJS(_data["currentGccResident"]) : <any>undefined;
            this.prevCurrentGccResident = _data["prevCurrentGccResident"] ? LookupField.fromJS(_data["prevCurrentGccResident"]) : <any>undefined;
            this.preboardingType = _data["preboardingType"] ? LookupField.fromJS(_data["preboardingType"]) : <any>undefined;
            this.passportType = _data["passportType"] ? LookupField.fromJS(_data["passportType"]) : <any>undefined;
            this.reasonForVisit = _data["reasonForVisit"] ? LookupField.fromJS(_data["reasonForVisit"]) : <any>undefined;
            this.employeeSearchTerm = _data["employeeSearchTerm"];
            this.otherReasonForCancellation = _data["otherReasonForCancellation"];
            this.labourCardCancellationType = _data["labourCardCancellationType"] ? LookupField.fromJS(_data["labourCardCancellationType"]) : <any>undefined;
            this.terminationType = _data["terminationType"] ? LookupField.fromJS(_data["terminationType"]) : <any>undefined;
            this.contactNumber = _data["contactNumber"];
            this.enrollmentType = _data["enrollmentType"] ? LookupField.fromJS(_data["enrollmentType"]) : <any>undefined;
            this.workTimings = _data["workTimings"] ? LookupField.fromJS(_data["workTimings"]) : <any>undefined;
            this.language = _data["language"] ? LookupField.fromJS(_data["language"]) : <any>undefined;
            this.workWeek = _data["workWeek"] ? LookupField.fromJS(_data["workWeek"]) : <any>undefined;
            this.jobBenefits = _data["jobBenefits"] ? LookupField.fromJS(_data["jobBenefits"]) : <any>undefined;
            this.entity = _data["entity"];
            this.department = _data["department"];
            this.jobDescription = _data["jobDescription"];
            this.yearsOfService = _data["yearsOfService"];
            this.generalSkills = _data["generalSkills"];
            this.vocationalSkills = _data["vocationalSkills"];
            this.specialization = _data["specialization"];
            this.ageFrom = _data["ageFrom"];
            this.ageTo = _data["ageTo"];
            this.remuneration = _data["remuneration"];
            this.basicSalary = _data["basicSalary"];
            this.otherAllowance = _data["otherAllowance"];
            this.totalSalary = _data["totalSalary"];
            this.tawteenJobOfferDesignation = _data["tawteenJobOfferDesignation"];
            this.tgNumber = _data["tgNumber"];
            this.visaIssuanceDate = _data["visaIssuanceDate"] ? new Date(_data["visaIssuanceDate"].toString()) : <any>undefined;
            this.homeAddress = _data["homeAddress"];
            this.mothersName = _data["mothersName"];
            this.maritalStatus = _data["maritalStatus"] ? LookupField.fromJS(_data["maritalStatus"]) : <any>undefined;
            this.religion = _data["religion"] ? LookupField.fromJS(_data["religion"]) : <any>undefined;
            this.sect = _data["sect"] ? LookupField.fromJS(_data["sect"]) : <any>undefined;
            this.attrestedDegree = _data["attrestedDegree"] ? LookupField.fromJS(_data["attrestedDegree"]) : <any>undefined;
            this.alreadyHaveGoldenVisa = _data["alreadyHaveGoldenVisa"] ? LookupField.fromJS(_data["alreadyHaveGoldenVisa"]) : <any>undefined;
            this.attestedByUAE = _data["attestedByUAE"] ? LookupField.fromJS(_data["attestedByUAE"]) : <any>undefined;
            this.registeredWithUAE = _data["registeredWithUAE"] ? LookupField.fromJS(_data["registeredWithUAE"]) : <any>undefined;
            this.visaStatus = _data["visaStatus"] ? LookupField.fromJS(_data["visaStatus"]) : <any>undefined;
            this.uid = _data["uid"];
            this.missionExpiryDate = _data["missionExpiryDate"] ? new Date(_data["missionExpiryDate"].toString()) : <any>undefined;
            this.missionExpiryCancellation = _data["missionExpiryCancellation"] ? new Date(_data["missionExpiryCancellation"].toString()) : <any>undefined;
            this.missionVisaCategory = _data["missionVisaCategory"] ? LookupField.fromJS(_data["missionVisaCategory"]) : <any>undefined;
            this.originalEducation = _data["originalEducation"] ? LookupField.fromJS(_data["originalEducation"]) : <any>undefined;
            this.visaRenewal = _data["visaRenewal"] ? new Date(_data["visaRenewal"].toString()) : <any>undefined;
            this.originalDegreeCertificate = _data["originalDegreeCertificate"];
            this.fileNumber = _data["fileNumber"];
            this.laborCardNumber = _data["laborCardNumber"];
            this.laborCardExpiryDate = _data["laborCardExpiryDate"] ? new Date(_data["laborCardExpiryDate"].toString()) : <any>undefined;
            this.laborCardCancellationDate = _data["laborCardCancellationDate"] ? new Date(_data["laborCardCancellationDate"].toString()) : <any>undefined;
            this.noticePeriod = _data["noticePeriod"];
            this.contractDuration = _data["contractDuration"];
            this.molContract = _data["molContract"] ? LookupField.fromJS(_data["molContract"]) : <any>undefined;
            this.visaAlignment = _data["visaAlignment"] ? LookupField.fromJS(_data["visaAlignment"]) : <any>undefined;
            this.emiratesIdNumber = _data["emiratesIdNumber"];
            this.khulasatNumber = _data["khulasatNumber"];
            this.pensionRegistrationNo = _data["pensionRegistrationNo"];
            this.pensionRegistrationDate = _data["pensionRegistrationDate"] ? new Date(_data["pensionRegistrationDate"].toString()) : <any>undefined;
            this.emergencyContact = _data["emergencyContact"];
            this.emergencyContactName = _data["emergencyContactName"];
            this.emergencyContactCode = _data["emergencyContactCode"];
            this.workPermitDesignation = _data["workPermitDesignation"];
            this.securityPermitNumber = _data["securityPermitNumber"];
            this.securityPermitIssuanceDate = _data["securityPermitIssuanceDate"] ? new Date(_data["securityPermitIssuanceDate"].toString()) : <any>undefined;
            this.securityPermitExpiryDate = _data["securityPermitExpiryDate"] ? new Date(_data["securityPermitExpiryDate"].toString()) : <any>undefined;
            this.securityPermitCancellationDate = _data["securityPermitCancellationDate"] ? new Date(_data["securityPermitCancellationDate"].toString()) : <any>undefined;
            this.pensionCancellationDate = _data["pensionCancellationDate"] ? new Date(_data["pensionCancellationDate"].toString()) : <any>undefined;
            this.oldNationality = _data["oldNationality"] ? LookupField.fromJS(_data["oldNationality"]) : <any>undefined;
            this.jobTitle = _data["jobTitle"];
            this.numberOfQuotaRequired = _data["numberOfQuotaRequired"];
            this.visaCategory = _data["visaCategory"];
            this.vpNumber = _data["vpNumber"];
            this.labourPersonCode = _data["labourPersonCode"];
            this.mohreJobTitle = _data["mohreJobTitle"];
            this.mohreJobTitleId = _data["mohreJobTitleId"] ? LookupField.fromJS(_data["mohreJobTitleId"]) : <any>undefined;
            this.workPermitCategory = _data["workPermitCategory"];
            this.workPermitJobCode = _data["workPermitJobCode"];
            this.typeOfVisa = _data["typeOfVisa"] ? LookupField.fromJS(_data["typeOfVisa"]) : <any>undefined;
            this.typeOfWorkPermit = _data["typeOfWorkPermit"] ? LookupField.fromJS(_data["typeOfWorkPermit"]) : <any>undefined;
            this.workPermitPreApprovalDate = _data["workPermitPreApprovalDate"] ? new Date(_data["workPermitPreApprovalDate"].toString()) : <any>undefined;
            this.workPermitApprovalDate = _data["workPermitApprovalDate"] ? new Date(_data["workPermitApprovalDate"].toString()) : <any>undefined;
            this.visaExpiryDate = _data["visaExpiryDate"] ? new Date(_data["visaExpiryDate"].toString()) : <any>undefined;
            this.rpIssuanceDate = _data["rpIssuanceDate"] ? new Date(_data["rpIssuanceDate"].toString()) : <any>undefined;
            this.cprIssuanceDate = _data["cprIssuanceDate"] ? new Date(_data["cprIssuanceDate"].toString()) : <any>undefined;
            this.rpExpiryDate = _data["rpExpiryDate"] ? new Date(_data["rpExpiryDate"].toString()) : <any>undefined;
            this.newRPExpiryDate = _data["newRPExpiryDate"] ? new Date(_data["newRPExpiryDate"].toString()) : <any>undefined;
            this.quotaValidityDate = _data["quotaValidityDate"] ? new Date(_data["quotaValidityDate"].toString()) : <any>undefined;
            this.rpRenewalDate = _data["rpRenewalDate"] ? new Date(_data["rpRenewalDate"].toString()) : <any>undefined;
            this.cprExpiryDate = _data["cprExpiryDate"] ? new Date(_data["cprExpiryDate"].toString()) : <any>undefined;
            this.civilIdExpiryDate = _data["civilIdExpiryDate"] ? new Date(_data["civilIdExpiryDate"].toString()) : <any>undefined;
            this.rpNumber = _data["rpNumber"];
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : <any>undefined;
            this.newSponsorName = _data["newSponsorName"];
            this.rpCancellationDate = _data["rpCancellationDate"] ? new Date(_data["rpCancellationDate"].toString()) : <any>undefined;
            this.rpTransferDate = _data["rpTransferDate"] ? new Date(_data["rpTransferDate"].toString()) : <any>undefined;
            this.visaTransferDate = _data["visaTransferDate"] ? new Date(_data["visaTransferDate"].toString()) : <any>undefined;
            this.molContractCancellationDate = _data["molContractCancellationDate"] ? new Date(_data["molContractCancellationDate"].toString()) : <any>undefined;
            this.pasiContractCancellationRequestDate = _data["pasiContractCancellationRequestDate"] ? new Date(_data["pasiContractCancellationRequestDate"].toString()) : <any>undefined;
            this.shortTermVisa = _data["shortTermVisa"] ? LookupField.fromJS(_data["shortTermVisa"]) : <any>undefined;
            this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : <any>undefined;
            this.numberOfVisasRequired = _data["numberOfVisasRequired"];
            this.relationship = _data["relationship"] ? LookupField.fromJS(_data["relationship"]) : <any>undefined;
            this.otherRelationshipName = _data["otherRelationshipName"];
            this.dependentDetails = _data["dependentDetails"];
            this.issuingCountryId = _data["issuingCountryId"] ? LookupField.fromJS(_data["issuingCountryId"]) : <any>undefined;
            this.issuingCountry = _data["issuingCountry"];
            this.govtAuthority = _data["govtAuthority"];
            this.durationOfStayInDays = _data["durationOfStayInDays"];
            this.typeOfRequest = _data["typeOfRequest"] ? LookupField.fromJS(_data["typeOfRequest"]) : <any>undefined;
            this.isYourMarriageOrBirthCertificateAttested = _data["isYourMarriageOrBirthCertificateAttested"] ? LookupField.fromJS(_data["isYourMarriageOrBirthCertificateAttested"]) : <any>undefined;
            this.tentativeTravelDate = _data["tentativeTravelDate"] ? new Date(_data["tentativeTravelDate"].toString()) : <any>undefined;
            this.previousSponsorName = _data["previousSponsorName"];
            this.currentProfession = _data["currentProfession"];
            this.newProfession = _data["newProfession"];
            this.gatePassDuration = _data["gatePassDuration"];
            this.employeeCategory = _data["employeeCategory"] ? LookupField.fromJS(_data["employeeCategory"]) : <any>undefined;
            this.cancellationReason = _data["cancellationReason"] ? LookupField.fromJS(_data["cancellationReason"]) : <any>undefined;
            this.acceptedDate = _data["acceptedDate"] ? new Date(_data["acceptedDate"].toString()) : <any>undefined;
            this.declinedDate = _data["declinedDate"] ? new Date(_data["declinedDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.rejectedDate = _data["rejectedDate"] ? new Date(_data["rejectedDate"].toString()) : <any>undefined;
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : <any>undefined;
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>undefined;
            this.initiationDate = _data["initiationDate"] ? new Date(_data["initiationDate"].toString()) : <any>undefined;
            this.employeeProfileId = _data["employeeProfileId"];
            this.employeeId = _data["employeeId"];
            this.referenceId = _data["referenceId"];
            this.childReferenceId = _data["childReferenceId"];
            this.referenceVisaType = _data["referenceVisaType"];
            this.createdByRoleId = _data["createdByRoleId"];
            this.menaEmployee = _data["menaEmployee"];
            this.dependentCurrentLocation = _data["dependentCurrentLocation"] ? LookupField.fromJS(_data["dependentCurrentLocation"]) : <any>undefined;
            this.oldPassportNumber = _data["oldPassportNumber"];
            this.onBehalfOfAnotherEYEmployee = _data["onBehalfOfAnotherEYEmployee"] ? LookupField.fromJS(_data["onBehalfOfAnotherEYEmployee"]) : <any>undefined;
            this.onEntryBusinessVisa = _data["onEntryBusinessVisa"] ? LookupField.fromJS(_data["onEntryBusinessVisa"]) : <any>undefined;
            this.visaCancellationRequired = _data["visaCancellationRequired"] ? LookupField.fromJS(_data["visaCancellationRequired"]) : <any>undefined;
            this.visaCancellationExtensionDate = _data["visaCancellationExtensionDate"] ? new Date(_data["visaCancellationExtensionDate"].toString()) : <any>undefined;
            this.dependentsUnderSponsorship = _data["dependentsUnderSponsorship"] ? LookupField.fromJS(_data["dependentsUnderSponsorship"]) : <any>undefined;
            this.dependentsUnderSponsorshipInUAE = _data["dependentsUnderSponsorshipInUAE"] ? LookupField.fromJS(_data["dependentsUnderSponsorshipInUAE"]) : <any>undefined;
            this.dependentsVisaOnHold = _data["dependentsVisaOnHold"] ? LookupField.fromJS(_data["dependentsVisaOnHold"]) : <any>undefined;
            this.dependentVisaCancellationDate = _data["dependentVisaCancellationDate"] ? new Date(_data["dependentVisaCancellationDate"].toString()) : <any>undefined;
            this.employmentVisaCancellationDate = _data["employmentVisaCancellationDate"] ? new Date(_data["employmentVisaCancellationDate"].toString()) : <any>undefined;
            this.gvExpiryDate = _data["gvExpiryDate"] ? new Date(_data["gvExpiryDate"].toString()) : <any>undefined;
            this.visaCancellationDate = _data["visaCancellationDate"] ? new Date(_data["visaCancellationDate"].toString()) : <any>undefined;
            this.cprNumber = _data["cprNumber"];
            this.gosiTerminationDate = _data["gosiTerminationDate"] ? new Date(_data["gosiTerminationDate"].toString()) : <any>undefined;
            this.cprCaseType = _data["cprCaseType"] ? LookupField.fromJS(_data["cprCaseType"]) : <any>undefined;
            this.cprType = _data["cprType"] ? LookupField.fromJS(_data["cprType"]) : <any>undefined;
            this.bahrainResidentialAddress = _data["bahrainResidentialAddress"];
            this.dateOfInvitationLetterIssuance = _data["dateOfInvitationLetterIssuance"] ? new Date(_data["dateOfInvitationLetterIssuance"].toString()) : <any>undefined;
            this.doYouHaveValidKSABusinessVisa = _data["doYouHaveValidKSABusinessVisa"] ? LookupField.fromJS(_data["doYouHaveValidKSABusinessVisa"]) : <any>undefined;
            this.dateKSABusinessVisaExpiry = _data["dateKSABusinessVisaExpiry"] ? new Date(_data["dateKSABusinessVisaExpiry"].toString()) : <any>undefined;
            this.hireType = _data["hireType"] ? LookupField.fromJS(_data["hireType"]) : <any>undefined;
            this.permitType = _data["permitType"] ? LookupField.fromJS(_data["permitType"]) : <any>undefined;
            this.moiClientCode = _data["moiClientCode"];
            this.areaCode = _data["areaCode"];
            this.bloodGroup = _data["bloodGroup"] ? LookupField.fromJS(_data["bloodGroup"]) : <any>undefined;
            this.typeOfSupport = _data["typeOfSupport"] ? LookupField.fromJS(_data["typeOfSupport"]) : <any>undefined;
            this.dateOfGatePassIssuance = _data["dateOfGatePassIssuance"] ? new Date(_data["dateOfGatePassIssuance"].toString()) : <any>undefined;
            this.transferApprovalDate = _data["transferApprovalDate"] ? new Date(_data["transferApprovalDate"].toString()) : <any>undefined;
            this.visaExtensionDate = _data["visaExtensionDate"] ? new Date(_data["visaExtensionDate"].toString()) : <any>undefined;
            this.reasonForProfessionChange = _data["reasonForProfessionChange"];
            this.dependentsInKuwait = _data["dependentsInKuwait"] ? LookupField.fromJS(_data["dependentsInKuwait"]) : <any>undefined;
            this.currentRPDesignation = _data["currentRPDesignation"];
            this.currentSponcerName = _data["currentSponcerName"];
            this.workPermitExpiryDate = _data["workPermitExpiryDate"] ? new Date(_data["workPermitExpiryDate"].toString()) : <any>undefined;
            this.workPermitNumber = _data["workPermitNumber"];
            this.civilIDNumber = _data["civilIDNumber"];
            this.documentType = _data["documentType"];
            this.transferScenario = _data["transferScenario"] ? LookupField.fromJS(_data["transferScenario"]) : <any>undefined;
            this.attestedbyKwait = _data["attestedbyKwait"] ? LookupField.fromJS(_data["attestedbyKwait"]) : <any>undefined;
            this.isParentKwaitNational = _data["isParentKwaitNational"] ? LookupField.fromJS(_data["isParentKwaitNational"]) : <any>undefined;
            this.isImmediateRealativeKwaitNational = _data["isImmediateRealativeKwaitNational"] ? LookupField.fromJS(_data["isImmediateRealativeKwaitNational"]) : <any>undefined;
            this.kwaitProfessionalQualification = _data["kwaitProfessionalQualification"] ? LookupField.fromJS(_data["kwaitProfessionalQualification"]) : <any>undefined;
            this.currentlyInKuwait = _data["currentlyInKuwait"] ? LookupField.fromJS(_data["currentlyInKuwait"]) : <any>undefined;
            this.gracePeriodExpiryDate = _data["gracePeriodExpiryDate"] ? new Date(_data["gracePeriodExpiryDate"].toString()) : <any>undefined;
            this.workPermitIssuanceDate = _data["workPermitIssuanceDate"] ? new Date(_data["workPermitIssuanceDate"].toString()) : <any>undefined;
            this.modificationDetails = _data["modificationDetails"];
            this.newResidencePACINumber = _data["newResidencePACINumber"];
            this.typeOfModification = _data["typeOfModification"] ? LookupField.fromJS(_data["typeOfModification"]) : <any>undefined;
            this.pifssCancellationDate = _data["pifssCancellationDate"] ? new Date(_data["pifssCancellationDate"].toString()) : <any>undefined;
            this.workPermitCancellationDate = _data["workPermitCancellationDate"] ? new Date(_data["workPermitCancellationDate"].toString()) : <any>undefined;
            this.qualification = _data["qualification"] ? LookupField.fromJS(_data["qualification"]) : <any>undefined;
            this.categoryOfJobOffer = _data["categoryOfJobOffer"] ? LookupField.fromJS(_data["categoryOfJobOffer"]) : <any>undefined;
            this.reasonForVisitUAEBusinessVisa = _data["reasonForVisitUAEBusinessVisa"] ? LookupField.fromJS(_data["reasonForVisitUAEBusinessVisa"]) : <any>undefined;
            this.reasonForRenewal = _data["reasonForRenewal"] ? LookupField.fromJS(_data["reasonForRenewal"]) : <any>undefined;
            this.autorequestCompleted = _data["autorequestCompleted"];
            this.medicalApplicationNumber = _data["medicalApplicationNumber"];
            this.visaValidity = _data["visaValidity"];
            this.travelType = _data["travelType"] ? LookupField.fromJS(_data["travelType"]) : <any>undefined;
            this.realtiveUAENumber = _data["realtiveUAENumber"];
            this.nomination = _data["nomination"] ? LookupField.fromJS(_data["nomination"]) : <any>undefined;
            this.eyInternalTransfer = _data["eyInternalTransfer"] ? LookupField.fromJS(_data["eyInternalTransfer"]) : <any>undefined;
            this.ibanNumber = _data["ibanNumber"];
            this.bankName = _data["bankName"];
            this.saSerialNumber = _data["saSerialNumber"];
            this.candidateProfileId = _data["candidateProfileId"];
            this.pbActivityId = _data["pbActivityId"];
            this.visaValidityDate = _data["visaValidityDate"] ? new Date(_data["visaValidityDate"].toString()) : <any>undefined;
            this.requestorEmailAddress = _data["requestorEmailAddress"];
            this.requestorName = _data["requestorName"];
            this.personalEmailAddress = _data["personalEmailAddress"];
            this.eyEmailAddress = _data["eyEmailAddress"];
            this.currentBahrainResident = _data["currentBahrainResident"] ? LookupField.fromJS(_data["currentBahrainResident"]) : <any>undefined;
            this.isBahrainResident = _data["isBahrainResident"] ? LookupField.fromJS(_data["isBahrainResident"]) : <any>undefined;
            this.isdependentsUnderSponsorship = _data["isdependentsUnderSponsorship"] ? LookupField.fromJS(_data["isdependentsUnderSponsorship"]) : <any>undefined;
            this.perDiem = _data["perDiem"];
            this.engagementName = _data["engagementName"];
            this.engPartnerName = _data["engPartnerName"];
            this.reasonForExit = _data["reasonForExit"] ? LookupField.fromJS(_data["reasonForExit"]) : <any>undefined;
            this.otherReasonForExit = _data["otherReasonForExit"];
            this.noOfExtensionTimes = _data["noOfExtensionTimes"] ? LookupField.fromJS(_data["noOfExtensionTimes"]) : <any>undefined;
            this.reasonForExtension = _data["reasonForExtension"];
            this.extensionIssuanceDate = _data["extensionIssuanceDate"] ? new Date(_data["extensionIssuanceDate"].toString()) : <any>undefined;
            this.loiNumber = _data["loiNumber"];
            this.loiIssueDate = _data["loiIssueDate"] ? new Date(_data["loiIssueDate"].toString()) : <any>undefined;
            this.loiVisaDuration = _data["loiVisaDuration"];
            this.loiVisaType = _data["loiVisaType"];
            this.loiJobTiteInArabic = _data["loiJobTiteInArabic"];
            if (Array.isArray(_data["typeOfDocRequested"])) {
                this.typeOfDocRequested = [] as any;
                for (let item of _data["typeOfDocRequested"])
                    this.typeOfDocRequested!.push(item);
            }
            this.otherTypeOfDocRequested = _data["otherTypeOfDocRequested"];
            this.newResidencyExpirydate = _data["newResidencyExpirydate"] ? new Date(_data["newResidencyExpirydate"].toString()) : <any>undefined;
            this.documentSupportType = _data["documentSupportType"] ? LookupField.fromJS(_data["documentSupportType"]) : <any>undefined;
            this.arabicJobGroup = _data["arabicJobGroup"];
            this.arabicVisaDesignation = _data["arabicVisaDesignation"];
            this.citizenshipId = _data["citizenshipId"];
            this.sponsorID = _data["sponsorID"];
            this.socialInsuranceNumber = _data["socialInsuranceNumber"];
            this.typeOfEmployment = _data["typeOfEmployment"] ? LookupField.fromJS(_data["typeOfEmployment"]) : <any>undefined;
            this.isEYFirstEmployer = _data["isEYFirstEmployer"] ? LookupField.fromJS(_data["isEYFirstEmployer"]) : <any>undefined;
            this.siRegistrationDate = _data["siRegistrationDate"] ? new Date(_data["siRegistrationDate"].toString()) : <any>undefined;
            this.purposeOfRequest = _data["purposeOfRequest"];
            this.dateDocumentAttestationCompleted = _data["dateDocumentAttestationCompleted"] ? new Date(_data["dateDocumentAttestationCompleted"].toString()) : <any>undefined;
            this.siCancellationDate = _data["siCancellationDate"] ? new Date(_data["siCancellationDate"].toString()) : <any>undefined;
            this.iqamaCancellationDate = _data["iqamaCancellationDate"] ? new Date(_data["iqamaCancellationDate"].toString()) : <any>undefined;
            this.iqamaExpiryDateRenewed = _data["iqamaExpiryDateRenewed"] ? new Date(_data["iqamaExpiryDateRenewed"].toString()) : <any>undefined;
            this.lastWorkingDate = _data["lastWorkingDate"] ? new Date(_data["lastWorkingDate"].toString()) : <any>undefined;
            this.dependentRPIssuanceDate = _data["dependentRPIssuanceDate"] ? new Date(_data["dependentRPIssuanceDate"].toString()) : <any>undefined;
            this.dependentRPExpiryDate = _data["dependentRPExpiryDate"] ? new Date(_data["dependentRPExpiryDate"].toString()) : <any>undefined;
            this.dependentsRPCancellationDate = _data["dependentsRPCancellationDate"] ? new Date(_data["dependentsRPCancellationDate"].toString()) : <any>undefined;
            this.previousNationality = _data["previousNationality"] ? LookupField.fromJS(_data["previousNationality"]) : <any>undefined;
            this.specialty = _data["specialty"];
            this.durationofstudy = _data["durationofstudy"];
            this.issuingEntity = _data["issuingEntity"];
            this.nationalityType = _data["nationalityType"] ? LookupField.fromJS(_data["nationalityType"]) : <any>undefined;
            this.currentKSAbusinessvisa = _data["currentKSAbusinessvisa"] ? LookupField.fromJS(_data["currentKSAbusinessvisa"]) : <any>undefined;
            this.currentKSABusinessVisaExpiryDate = _data["currentKSABusinessVisaExpiryDate"] ? new Date(_data["currentKSABusinessVisaExpiryDate"].toString()) : <any>undefined;
            this.dateSoftcopyVisaDocumentsSent = _data["dateSoftcopyVisaDocumentsSent"] ? new Date(_data["dateSoftcopyVisaDocumentsSent"].toString()) : <any>undefined;
            this.dateHardcopyVisaDocumentsSent = _data["dateHardcopyVisaDocumentsSent"] ? new Date(_data["dateHardcopyVisaDocumentsSent"].toString()) : <any>undefined;
            this.dateCourierTrackingNumberSent = _data["dateCourierTrackingNumberSent"] ? new Date(_data["dateCourierTrackingNumberSent"].toString()) : <any>undefined;
            this.dateHardCopyVisaDocumentsReceivedByVendorOrNJ = _data["dateHardCopyVisaDocumentsReceivedByVendorOrNJ"] ? new Date(_data["dateHardCopyVisaDocumentsReceivedByVendorOrNJ"].toString()) : <any>undefined;
            this.ewakalaAgent = _data["ewakalaAgent"] ? LookupField.fromJS(_data["ewakalaAgent"]) : <any>undefined;
            this.courierDispatchDate = _data["courierDispatchDate"] ? new Date(_data["courierDispatchDate"].toString()) : <any>undefined;
            this.parentImmProfileId = _data["parentImmProfileId"];
            this.immEmployee = _data["immEmployee"] ? AdUser.fromJS(_data["immEmployee"]) : <any>undefined;
            this.immEmployeeId = _data["immEmployeeId"];
            this.isFirstVisitToPakistan = _data["isFirstVisitToPakistan"] ? LookupField.fromJS(_data["isFirstVisitToPakistan"]) : <any>undefined;
            this.isFirstVisitToJordan = _data["isFirstVisitToJordan"] ? LookupField.fromJS(_data["isFirstVisitToJordan"]) : <any>undefined;
            this.mothersFullName = _data["mothersFullName"];
            this.reasonForVisitPAKBusinessVisa = _data["reasonForVisitPAKBusinessVisa"] ? LookupField.fromJS(_data["reasonForVisitPAKBusinessVisa"]) : <any>undefined;
            this.gcCresidentExpiryDate = _data["gcCresidentExpiryDate"] ? new Date(_data["gcCresidentExpiryDate"].toString()) : <any>undefined;
            this.pakOfficeToVisit = _data["pakOfficeToVisit"] ? LookupField.fromJS(_data["pakOfficeToVisit"]) : <any>undefined;
            this.labourContractNoticePeriod = _data["labourContractNoticePeriod"];
            this.isQualifiedInAccounting = _data["isQualifiedInAccounting"] ? LookupField.fromJS(_data["isQualifiedInAccounting"]) : <any>undefined;
            this.isFirstEmployedInEgypt = _data["isFirstEmployedInEgypt"] ? LookupField.fromJS(_data["isFirstEmployedInEgypt"]) : <any>undefined;
            this.docPrefix = _data["docPrefix"];
            this.parentExitProfileId = _data["parentExitProfileId"];
            this.exitActivityId = _data["exitActivityId"];
            this.onHoldDate = _data["onHoldDate"] ? new Date(_data["onHoldDate"].toString()) : <any>undefined;
            this.editCompletedProfile = _data["editCompletedProfile"];
            this.scpMembership = _data["scpMembership"] ? LookupField.fromJS(_data["scpMembership"]) : <any>undefined;
            this.specificWorkLocationduringTrip = _data["specificWorkLocationduringTrip"];
            if (Array.isArray(_data["workLocationDuringTrip"])) {
                this.workLocationDuringTrip = [] as any;
                for (let item of _data["workLocationDuringTrip"])
                    this.workLocationDuringTrip!.push(item);
            }
            this.performingBillableWork = _data["performingBillableWork"] ? LookupField.fromJS(_data["performingBillableWork"]) : <any>undefined;
            this.requestedService = _data["requestedService"] ? LookupField.fromJS(_data["requestedService"]) : <any>undefined;
            this.countryToBeVisited = _data["countryToBeVisited"] ? LookupField.fromJS(_data["countryToBeVisited"]) : <any>undefined;
            this.cityToBeVisited = _data["cityToBeVisited"] ? LookupField.fromJS(_data["cityToBeVisited"]) : <any>undefined;
            this.visaDuration = _data["visaDuration"] ? LookupField.fromJS(_data["visaDuration"]) : <any>undefined;
            if (Array.isArray(_data["purposeOfVisit"])) {
                this.purposeOfVisit = [] as any;
                for (let item of _data["purposeOfVisit"])
                    this.purposeOfVisit!.push(item);
            }
            this.specifyPurposeOfVisit = _data["specifyPurposeOfVisit"];
            this.isMenaSponsoringPartner = _data["isMenaSponsoringPartner"] ? LookupField.fromJS(_data["isMenaSponsoringPartner"]) : <any>undefined;
            this.menaSponsoringPartnerName = _data["menaSponsoringPartnerName"];
            this.previousDateOfExit = _data["previousDateOfExit"] ? new Date(_data["previousDateOfExit"].toString()) : <any>undefined;
            this.revisedDateOfExit = _data["revisedDateOfExit"] ? new Date(_data["revisedDateOfExit"].toString()) : <any>undefined;
            this.currentVisaExpiryDate = _data["currentVisaExpiryDate"] ? new Date(_data["currentVisaExpiryDate"].toString()) : <any>undefined;
            this.purposeOfExtension = _data["purposeOfExtension"];
            this.currentTypeOfVisa = _data["currentTypeOfVisa"] ? LookupField.fromJS(_data["currentTypeOfVisa"]) : <any>undefined;
            this.currentEntryType = _data["currentEntryType"] ? LookupField.fromJS(_data["currentEntryType"]) : <any>undefined;
            this.currentVisaDuration = _data["currentVisaDuration"] ? LookupField.fromJS(_data["currentVisaDuration"]) : <any>undefined;
            this.officeLocationCountry = _data["officeLocationCountry"] ? LookupField.fromJS(_data["officeLocationCountry"]) : <any>undefined;
            this.processingTeam = _data["processingTeam"] ? LookupField.fromJS(_data["processingTeam"]) : <any>undefined;
            this.processedBy = _data["processedBy"] ? LookupField.fromJS(_data["processedBy"]) : <any>undefined;
            this.processedByOther = _data["processedByOther"];
            this.exceptionalApprovalRequired = _data["exceptionalApprovalRequired"] ? LookupField.fromJS(_data["exceptionalApprovalRequired"]) : <any>undefined;
            this.approverName = _data["approverName"];
            this.recommendedVisaType = _data["recommendedVisaType"] ? LookupField.fromJS(_data["recommendedVisaType"]) : <any>undefined;
            this.recommendedEntryType = _data["recommendedEntryType"] ? LookupField.fromJS(_data["recommendedEntryType"]) : <any>undefined;
            this.recommendedVisaDuration = _data["recommendedVisaDuration"] ? LookupField.fromJS(_data["recommendedVisaDuration"]) : <any>undefined;
            this.bTdurationOfStay = _data["bTdurationOfStay"];
            this.primeType = _data["primeType"] ? LookupField.fromJS(_data["primeType"]) : <any>undefined;
            this.issuedVisaExpiryDate = _data["issuedVisaExpiryDate"] ? new Date(_data["issuedVisaExpiryDate"].toString()) : <any>undefined;
            this.universityDegree = _data["universityDegree"] ? LookupField.fromJS(_data["universityDegree"]) : <any>undefined;
            this.accomodationSupportRequired = _data["accomodationSupportRequired"] ? LookupField.fromJS(_data["accomodationSupportRequired"]) : <any>undefined;
            this.accommodationRequired = _data["accommodationRequired"] ? LookupField.fromJS(_data["accommodationRequired"]) : <any>undefined;
            this.degreeAttestationRequired = _data["degreeAttestationRequired"] ? LookupField.fromJS(_data["degreeAttestationRequired"]) : <any>undefined;
            this.degreeAttestationCompletedDate = _data["degreeAttestationCompletedDate"] ? new Date(_data["degreeAttestationCompletedDate"].toString()) : <any>undefined;
            this.documentReceiptDate = _data["documentReceiptDate"] ? new Date(_data["documentReceiptDate"].toString()) : <any>undefined;
            this.quotationIssuanceDate = _data["quotationIssuanceDate"] ? new Date(_data["quotationIssuanceDate"].toString()) : <any>undefined;
            this.entryPermitIssueDate = _data["entryPermitIssueDate"] ? new Date(_data["entryPermitIssueDate"].toString()) : <any>undefined;
            this.invoiceIssuanceDate = _data["invoiceIssuanceDate"] ? new Date(_data["invoiceIssuanceDate"].toString()) : <any>undefined;
            this.purchaseOrderIssuanceDate = _data["purchaseOrderIssuanceDate"] ? new Date(_data["purchaseOrderIssuanceDate"].toString()) : <any>undefined;
            this.payroll = _data["payroll"] ? LookupField.fromJS(_data["payroll"]) : <any>undefined;
            this.salaryAmount = _data["salaryAmount"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceMonth = _data["invoiceMonth"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.invoiceCurrency = _data["invoiceCurrency"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.poNumber = _data["poNumber"];
            this.loiJobTiteInEnglish = _data["loiJobTiteInEnglish"];
        }
    }

    static fromJS(data: any): ImmigrationProfile {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["visaCountry"] = this.visaCountry ? this.visaCountry.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["passportNumber"] = this.passportNumber;
        data["placeOfBirth"] = this.placeOfBirth;
        data["phoneNumber"] = this.phoneNumber;
        data["countryCode"] = this.countryCode;
        data["officeLE"] = this.officeLE ? this.officeLE.toJSON() : <any>undefined;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["onboardingType"] = this.onboardingType ? this.onboardingType.toJSON() : <any>undefined;
        data["officeLocation"] = this.officeLocation ? this.officeLocation.toJSON() : <any>undefined;
        data["serviceLine"] = this.serviceLine ? this.serviceLine.toJSON() : <any>undefined;
        data["subServiceLine"] = this.subServiceLine ? this.subServiceLine.toJSON() : <any>undefined;
        data["globalRank"] = this.globalRank ? this.globalRank.toJSON() : <any>undefined;
        data["globalGrade"] = this.globalGrade ? this.globalGrade.toJSON() : <any>undefined;
        data["withdrawnDate"] = this.withdrawnDate ? this.withdrawnDate.toISOString() : <any>undefined;
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        data["ksaOfficeToBeVisited"] = this.ksaOfficeToBeVisited ? this.ksaOfficeToBeVisited.toJSON() : <any>undefined;
        data["requestor"] = this.requestor ? this.requestor.toJSON() : <any>undefined;
        data["processor"] = this.processor ? this.processor.toJSON() : <any>undefined;
        data["prevProcessorId"] = this.prevProcessorId;
        data["onBehalfRequestor"] = this.onBehalfRequestor ? this.onBehalfRequestor.toJSON() : <any>undefined;
        data["onBehalfRequestorId"] = this.onBehalfRequestorId;
        data["globalEmployeeLocation"] = this.globalEmployeeLocation ? this.globalEmployeeLocation.toJSON() : <any>undefined;
        data["employeeCurrentLocation"] = this.employeeCurrentLocation ? this.employeeCurrentLocation.toJSON() : <any>undefined;
        data["employeeCurrentLocationCountry"] = this.employeeCurrentLocationCountry ? this.employeeCurrentLocationCountry.toJSON() : <any>undefined;
        data["completedUAEPassRegistration"] = this.completedUAEPassRegistration ? this.completedUAEPassRegistration.toJSON() : <any>undefined;
        data["dependentFinalExitDeadline"] = this.dependentFinalExitDeadline ? this.dependentFinalExitDeadline.toISOString() : <any>undefined;
        data["immigrationCaseType"] = this.immigrationCaseType ? this.immigrationCaseType.toJSON() : <any>undefined;
        data["visaType"] = this.visaType ? this.visaType.toJSON() : <any>undefined;
        if (Array.isArray(this.additionalDocs)) {
            data["additionalDocs"] = [];
            for (let item of this.additionalDocs)
                data["additionalDocs"].push(item);
        }
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["officeToBeVisited"] = this.officeToBeVisited ? this.officeToBeVisited.toJSON() : <any>undefined;
        data["gccResidencyTitle"] = this.gccResidencyTitle;
        data["nonGCCResidencyTitle"] = this.nonGCCResidencyTitle;
        data["gccSponsorName"] = this.gccSponsorName;
        data["durationOfStayId"] = this.durationOfStayId;
        data["durationOfStay"] = this.durationOfStay ? this.durationOfStay.toJSON() : <any>undefined;
        data["embassyId"] = this.embassyId;
        data["embassy"] = this.embassy ? this.embassy.toJSON() : <any>undefined;
        data["cityOfEmbassy"] = this.cityOfEmbassy;
        data["currentCity"] = this.currentCity;
        data["visaAgentName"] = this.visaAgentName;
        data["chargeCode"] = this.chargeCode;
        data["dateOfTravel"] = this.dateOfTravel ? this.dateOfTravel.toISOString() : <any>undefined;
        data["travelPurpose"] = this.travelPurpose ? this.travelPurpose.toJSON() : <any>undefined;
        data["dateOfExit"] = this.dateOfExit ? this.dateOfExit.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["projectName"] = this.projectName;
        data["projectManagerId"] = this.projectManagerId;
        data["projectManager"] = this.projectManager ? this.projectManager.toJSON() : <any>undefined;
        data["letterAddressedTo"] = this.letterAddressedTo;
        data["gpn"] = this.gpn;
        data["gui"] = this.gui;
        data["involuntaryExitTeam"] = this.involuntaryExitTeam ? this.involuntaryExitTeam.toJSON() : <any>undefined;
        data["voluntaryExitTeam"] = this.voluntaryExitTeam ? this.voluntaryExitTeam.toJSON() : <any>undefined;
        data["legalEntitiesTeam"] = this.legalEntitiesTeam ? this.legalEntitiesTeam.toJSON() : <any>undefined;
        data["involuntaryExitId"] = this.involuntaryExitId;
        data["voluntaryExitId"] = this.voluntaryExitId;
        data["legalEntitiesId"] = this.legalEntitiesId;
        data["involuntaryExitComment"] = this.involuntaryExitComment;
        data["voluntaryExitComment"] = this.voluntaryExitComment;
        data["legalEntitiesComment"] = this.legalEntitiesComment;
        data["isActive"] = this.isActive;
        data["isAutoGenerated"] = this.isAutoGenerated;
        data["isAutoCreatedAfterJoin"] = this.isAutoCreatedAfterJoin;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["visaApprovedDate"] = this.visaApprovedDate ? this.visaApprovedDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdByEmployee"] = this.createdByEmployee ? this.createdByEmployee.toJSON() : <any>undefined;
        data["modifiedByEmployee"] = this.modifiedByEmployee ? this.modifiedByEmployee.toJSON() : <any>undefined;
        data["immigrationStatus"] = this.immigrationStatus ? this.immigrationStatus.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["entryTypeId"] = this.entryTypeId;
        data["entryType"] = this.entryType ? this.entryType.toJSON() : <any>undefined;
        data["visaNumber"] = this.visaNumber;
        data["visaDesignation"] = this.visaDesignation;
        data["academicQualification"] = this.academicQualification;
        data["residencyDesignation"] = this.residencyDesignation;
        data["passportExpiryDate"] = this.passportExpiryDate ? this.passportExpiryDate.toISOString() : <any>undefined;
        data["nationalityIdNumber"] = this.nationalityIdNumber;
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : <any>undefined;
        data["permissionDuration"] = this.permissionDuration;
        data["dateOfPayment"] = this.dateOfPayment ? this.dateOfPayment.toISOString() : <any>undefined;
        data["specialExpat"] = this.specialExpat;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["attestationCompletedDate"] = this.attestationCompletedDate ? this.attestationCompletedDate.toISOString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["borderNumber"] = this.borderNumber;
        data["medicalExamCompletionDate"] = this.medicalExamCompletionDate ? this.medicalExamCompletionDate.toISOString() : <any>undefined;
        data["bioMetricCompletedDate"] = this.bioMetricCompletedDate ? this.bioMetricCompletedDate.toISOString() : <any>undefined;
        data["agentCourierAddress"] = this.agentCourierAddress;
        data["iqamaId"] = this.iqamaId;
        data["iqamaExpiryDate"] = this.iqamaExpiryDate ? this.iqamaExpiryDate.toISOString() : <any>undefined;
        data["residencyExpiryDate"] = this.residencyExpiryDate ? this.residencyExpiryDate.toISOString() : <any>undefined;
        data["detailsToBeUpdated"] = this.detailsToBeUpdated;
        data["wantToUpdateDependentPassport"] = this.wantToUpdateDependentPassport ? this.wantToUpdateDependentPassport.toJSON() : <any>undefined;
        data["nameOfNewEmployer"] = this.nameOfNewEmployer;
        data["lastWorkingDay"] = this.lastWorkingDay ? this.lastWorkingDay.toISOString() : <any>undefined;
        data["ksaFinalExitDate"] = this.ksaFinalExitDate ? this.ksaFinalExitDate.toISOString() : <any>undefined;
        data["spouseDetails"] = this.spouseDetails;
        data["childrenDetails"] = this.childrenDetails;
        data["sponsorDepsInKSA"] = this.sponsorDepsInKSA ? this.sponsorDepsInKSA.toJSON() : <any>undefined;
        data["depsAlreadyInKSA"] = this.depsAlreadyInKSA ? this.depsAlreadyInKSA.toJSON() : <any>undefined;
        data["newJoinerNameInArabic"] = this.newJoinerNameInArabic;
        data["residencyStatus"] = this.residencyStatus ? this.residencyStatus.toJSON() : <any>undefined;
        data["tentativeStartDate"] = this.tentativeStartDate ? this.tentativeStartDate.toISOString() : <any>undefined;
        data["ptc"] = this.ptc ? this.ptc.toJSON() : <any>undefined;
        data["recruiter"] = this.recruiter ? this.recruiter.toJSON() : <any>undefined;
        data["vaccinationStatus"] = this.vaccinationStatus ? this.vaccinationStatus.toJSON() : <any>undefined;
        data["lastVaccineDate"] = this.lastVaccineDate ? this.lastVaccineDate.toISOString() : <any>undefined;
        data["vaccineType"] = this.vaccineType ? this.vaccineType.toJSON() : <any>undefined;
        data["otherVaccineName"] = this.otherVaccineName;
        data["iqamaNumber"] = this.iqamaNumber;
        data["trackingNumber"] = this.trackingNumber;
        data["dataStore"] = this.dataStore;
        data["notes"] = this.notes;
        data["dualCitizenship"] = this.dualCitizenship ? this.dualCitizenship.toJSON() : <any>undefined;
        data["secondNationality"] = this.secondNationality ? this.secondNationality.toJSON() : <any>undefined;
        data["distanceLearning"] = this.distanceLearning ? this.distanceLearning.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["currentEyEmployee"] = this.currentEyEmployee ? this.currentEyEmployee.toJSON() : <any>undefined;
        data["currentGccResident"] = this.currentGccResident ? this.currentGccResident.toJSON() : <any>undefined;
        data["prevCurrentGccResident"] = this.prevCurrentGccResident ? this.prevCurrentGccResident.toJSON() : <any>undefined;
        data["preboardingType"] = this.preboardingType ? this.preboardingType.toJSON() : <any>undefined;
        data["passportType"] = this.passportType ? this.passportType.toJSON() : <any>undefined;
        data["reasonForVisit"] = this.reasonForVisit ? this.reasonForVisit.toJSON() : <any>undefined;
        data["employeeSearchTerm"] = this.employeeSearchTerm;
        data["otherReasonForCancellation"] = this.otherReasonForCancellation;
        data["labourCardCancellationType"] = this.labourCardCancellationType ? this.labourCardCancellationType.toJSON() : <any>undefined;
        data["terminationType"] = this.terminationType ? this.terminationType.toJSON() : <any>undefined;
        data["contactNumber"] = this.contactNumber;
        data["enrollmentType"] = this.enrollmentType ? this.enrollmentType.toJSON() : <any>undefined;
        data["workTimings"] = this.workTimings ? this.workTimings.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["workWeek"] = this.workWeek ? this.workWeek.toJSON() : <any>undefined;
        data["jobBenefits"] = this.jobBenefits ? this.jobBenefits.toJSON() : <any>undefined;
        data["entity"] = this.entity;
        data["department"] = this.department;
        data["jobDescription"] = this.jobDescription;
        data["yearsOfService"] = this.yearsOfService;
        data["generalSkills"] = this.generalSkills;
        data["vocationalSkills"] = this.vocationalSkills;
        data["specialization"] = this.specialization;
        data["ageFrom"] = this.ageFrom;
        data["ageTo"] = this.ageTo;
        data["remuneration"] = this.remuneration;
        data["basicSalary"] = this.basicSalary;
        data["otherAllowance"] = this.otherAllowance;
        data["totalSalary"] = this.totalSalary;
        data["tawteenJobOfferDesignation"] = this.tawteenJobOfferDesignation;
        data["tgNumber"] = this.tgNumber;
        data["visaIssuanceDate"] = this.visaIssuanceDate ? this.visaIssuanceDate.toISOString() : <any>undefined;
        data["homeAddress"] = this.homeAddress;
        data["mothersName"] = this.mothersName;
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
        data["religion"] = this.religion ? this.religion.toJSON() : <any>undefined;
        data["sect"] = this.sect ? this.sect.toJSON() : <any>undefined;
        data["attrestedDegree"] = this.attrestedDegree ? this.attrestedDegree.toJSON() : <any>undefined;
        data["alreadyHaveGoldenVisa"] = this.alreadyHaveGoldenVisa ? this.alreadyHaveGoldenVisa.toJSON() : <any>undefined;
        data["attestedByUAE"] = this.attestedByUAE ? this.attestedByUAE.toJSON() : <any>undefined;
        data["registeredWithUAE"] = this.registeredWithUAE ? this.registeredWithUAE.toJSON() : <any>undefined;
        data["visaStatus"] = this.visaStatus ? this.visaStatus.toJSON() : <any>undefined;
        data["uid"] = this.uid;
        data["missionExpiryDate"] = this.missionExpiryDate ? this.missionExpiryDate.toISOString() : <any>undefined;
        data["missionExpiryCancellation"] = this.missionExpiryCancellation ? this.missionExpiryCancellation.toISOString() : <any>undefined;
        data["missionVisaCategory"] = this.missionVisaCategory ? this.missionVisaCategory.toJSON() : <any>undefined;
        data["originalEducation"] = this.originalEducation ? this.originalEducation.toJSON() : <any>undefined;
        data["visaRenewal"] = this.visaRenewal ? this.visaRenewal.toISOString() : <any>undefined;
        data["originalDegreeCertificate"] = this.originalDegreeCertificate;
        data["fileNumber"] = this.fileNumber;
        data["laborCardNumber"] = this.laborCardNumber;
        data["laborCardExpiryDate"] = this.laborCardExpiryDate ? this.laborCardExpiryDate.toISOString() : <any>undefined;
        data["laborCardCancellationDate"] = this.laborCardCancellationDate ? this.laborCardCancellationDate.toISOString() : <any>undefined;
        data["noticePeriod"] = this.noticePeriod;
        data["contractDuration"] = this.contractDuration;
        data["molContract"] = this.molContract ? this.molContract.toJSON() : <any>undefined;
        data["visaAlignment"] = this.visaAlignment ? this.visaAlignment.toJSON() : <any>undefined;
        data["emiratesIdNumber"] = this.emiratesIdNumber;
        data["khulasatNumber"] = this.khulasatNumber;
        data["pensionRegistrationNo"] = this.pensionRegistrationNo;
        data["pensionRegistrationDate"] = this.pensionRegistrationDate ? this.pensionRegistrationDate.toISOString() : <any>undefined;
        data["emergencyContact"] = this.emergencyContact;
        data["emergencyContactName"] = this.emergencyContactName;
        data["emergencyContactCode"] = this.emergencyContactCode;
        data["workPermitDesignation"] = this.workPermitDesignation;
        data["securityPermitNumber"] = this.securityPermitNumber;
        data["securityPermitIssuanceDate"] = this.securityPermitIssuanceDate ? this.securityPermitIssuanceDate.toISOString() : <any>undefined;
        data["securityPermitExpiryDate"] = this.securityPermitExpiryDate ? this.securityPermitExpiryDate.toISOString() : <any>undefined;
        data["securityPermitCancellationDate"] = this.securityPermitCancellationDate ? this.securityPermitCancellationDate.toISOString() : <any>undefined;
        data["pensionCancellationDate"] = this.pensionCancellationDate ? this.pensionCancellationDate.toISOString() : <any>undefined;
        data["oldNationality"] = this.oldNationality ? this.oldNationality.toJSON() : <any>undefined;
        data["jobTitle"] = this.jobTitle;
        data["numberOfQuotaRequired"] = this.numberOfQuotaRequired;
        data["visaCategory"] = this.visaCategory;
        data["vpNumber"] = this.vpNumber;
        data["labourPersonCode"] = this.labourPersonCode;
        data["mohreJobTitle"] = this.mohreJobTitle;
        data["mohreJobTitleId"] = this.mohreJobTitleId ? this.mohreJobTitleId.toJSON() : <any>undefined;
        data["workPermitCategory"] = this.workPermitCategory;
        data["workPermitJobCode"] = this.workPermitJobCode;
        data["typeOfVisa"] = this.typeOfVisa ? this.typeOfVisa.toJSON() : <any>undefined;
        data["typeOfWorkPermit"] = this.typeOfWorkPermit ? this.typeOfWorkPermit.toJSON() : <any>undefined;
        data["workPermitPreApprovalDate"] = this.workPermitPreApprovalDate ? this.workPermitPreApprovalDate.toISOString() : <any>undefined;
        data["workPermitApprovalDate"] = this.workPermitApprovalDate ? this.workPermitApprovalDate.toISOString() : <any>undefined;
        data["visaExpiryDate"] = this.visaExpiryDate ? this.visaExpiryDate.toISOString() : <any>undefined;
        data["rpIssuanceDate"] = this.rpIssuanceDate ? this.rpIssuanceDate.toISOString() : <any>undefined;
        data["cprIssuanceDate"] = this.cprIssuanceDate ? this.cprIssuanceDate.toISOString() : <any>undefined;
        data["rpExpiryDate"] = this.rpExpiryDate ? this.rpExpiryDate.toISOString() : <any>undefined;
        data["newRPExpiryDate"] = this.newRPExpiryDate ? this.newRPExpiryDate.toISOString() : <any>undefined;
        data["quotaValidityDate"] = this.quotaValidityDate ? this.quotaValidityDate.toISOString() : <any>undefined;
        data["rpRenewalDate"] = this.rpRenewalDate ? this.rpRenewalDate.toISOString() : <any>undefined;
        data["cprExpiryDate"] = this.cprExpiryDate ? this.cprExpiryDate.toISOString() : <any>undefined;
        data["civilIdExpiryDate"] = this.civilIdExpiryDate ? this.civilIdExpiryDate.toISOString() : <any>undefined;
        data["rpNumber"] = this.rpNumber;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["newSponsorName"] = this.newSponsorName;
        data["rpCancellationDate"] = this.rpCancellationDate ? this.rpCancellationDate.toISOString() : <any>undefined;
        data["rpTransferDate"] = this.rpTransferDate ? this.rpTransferDate.toISOString() : <any>undefined;
        data["visaTransferDate"] = this.visaTransferDate ? this.visaTransferDate.toISOString() : <any>undefined;
        data["molContractCancellationDate"] = this.molContractCancellationDate ? this.molContractCancellationDate.toISOString() : <any>undefined;
        data["pasiContractCancellationRequestDate"] = this.pasiContractCancellationRequestDate ? this.pasiContractCancellationRequestDate.toISOString() : <any>undefined;
        data["shortTermVisa"] = this.shortTermVisa ? this.shortTermVisa.toJSON() : <any>undefined;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["numberOfVisasRequired"] = this.numberOfVisasRequired;
        data["relationship"] = this.relationship ? this.relationship.toJSON() : <any>undefined;
        data["otherRelationshipName"] = this.otherRelationshipName;
        data["dependentDetails"] = this.dependentDetails;
        data["issuingCountryId"] = this.issuingCountryId ? this.issuingCountryId.toJSON() : <any>undefined;
        data["issuingCountry"] = this.issuingCountry;
        data["govtAuthority"] = this.govtAuthority;
        data["durationOfStayInDays"] = this.durationOfStayInDays;
        data["typeOfRequest"] = this.typeOfRequest ? this.typeOfRequest.toJSON() : <any>undefined;
        data["isYourMarriageOrBirthCertificateAttested"] = this.isYourMarriageOrBirthCertificateAttested ? this.isYourMarriageOrBirthCertificateAttested.toJSON() : <any>undefined;
        data["tentativeTravelDate"] = this.tentativeTravelDate ? this.tentativeTravelDate.toISOString() : <any>undefined;
        data["previousSponsorName"] = this.previousSponsorName;
        data["currentProfession"] = this.currentProfession;
        data["newProfession"] = this.newProfession;
        data["gatePassDuration"] = this.gatePassDuration;
        data["employeeCategory"] = this.employeeCategory ? this.employeeCategory.toJSON() : <any>undefined;
        data["cancellationReason"] = this.cancellationReason ? this.cancellationReason.toJSON() : <any>undefined;
        data["acceptedDate"] = this.acceptedDate ? this.acceptedDate.toISOString() : <any>undefined;
        data["declinedDate"] = this.declinedDate ? this.declinedDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["rejectedDate"] = this.rejectedDate ? this.rejectedDate.toISOString() : <any>undefined;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["initiationDate"] = this.initiationDate ? this.initiationDate.toISOString() : <any>undefined;
        data["employeeProfileId"] = this.employeeProfileId;
        data["employeeId"] = this.employeeId;
        data["referenceId"] = this.referenceId;
        data["childReferenceId"] = this.childReferenceId;
        data["referenceVisaType"] = this.referenceVisaType;
        data["createdByRoleId"] = this.createdByRoleId;
        data["menaEmployee"] = this.menaEmployee;
        data["dependentCurrentLocation"] = this.dependentCurrentLocation ? this.dependentCurrentLocation.toJSON() : <any>undefined;
        data["oldPassportNumber"] = this.oldPassportNumber;
        data["onBehalfOfAnotherEYEmployee"] = this.onBehalfOfAnotherEYEmployee ? this.onBehalfOfAnotherEYEmployee.toJSON() : <any>undefined;
        data["onEntryBusinessVisa"] = this.onEntryBusinessVisa ? this.onEntryBusinessVisa.toJSON() : <any>undefined;
        data["visaCancellationRequired"] = this.visaCancellationRequired ? this.visaCancellationRequired.toJSON() : <any>undefined;
        data["visaCancellationExtensionDate"] = this.visaCancellationExtensionDate ? this.visaCancellationExtensionDate.toISOString() : <any>undefined;
        data["dependentsUnderSponsorship"] = this.dependentsUnderSponsorship ? this.dependentsUnderSponsorship.toJSON() : <any>undefined;
        data["dependentsUnderSponsorshipInUAE"] = this.dependentsUnderSponsorshipInUAE ? this.dependentsUnderSponsorshipInUAE.toJSON() : <any>undefined;
        data["dependentsVisaOnHold"] = this.dependentsVisaOnHold ? this.dependentsVisaOnHold.toJSON() : <any>undefined;
        data["dependentVisaCancellationDate"] = this.dependentVisaCancellationDate ? this.dependentVisaCancellationDate.toISOString() : <any>undefined;
        data["employmentVisaCancellationDate"] = this.employmentVisaCancellationDate ? this.employmentVisaCancellationDate.toISOString() : <any>undefined;
        data["gvExpiryDate"] = this.gvExpiryDate ? this.gvExpiryDate.toISOString() : <any>undefined;
        data["visaCancellationDate"] = this.visaCancellationDate ? this.visaCancellationDate.toISOString() : <any>undefined;
        data["cprNumber"] = this.cprNumber;
        data["gosiTerminationDate"] = this.gosiTerminationDate ? this.gosiTerminationDate.toISOString() : <any>undefined;
        data["cprCaseType"] = this.cprCaseType ? this.cprCaseType.toJSON() : <any>undefined;
        data["cprType"] = this.cprType ? this.cprType.toJSON() : <any>undefined;
        data["bahrainResidentialAddress"] = this.bahrainResidentialAddress;
        data["dateOfInvitationLetterIssuance"] = this.dateOfInvitationLetterIssuance ? this.dateOfInvitationLetterIssuance.toISOString() : <any>undefined;
        data["doYouHaveValidKSABusinessVisa"] = this.doYouHaveValidKSABusinessVisa ? this.doYouHaveValidKSABusinessVisa.toJSON() : <any>undefined;
        data["dateKSABusinessVisaExpiry"] = this.dateKSABusinessVisaExpiry ? this.dateKSABusinessVisaExpiry.toISOString() : <any>undefined;
        data["hireType"] = this.hireType ? this.hireType.toJSON() : <any>undefined;
        data["permitType"] = this.permitType ? this.permitType.toJSON() : <any>undefined;
        data["moiClientCode"] = this.moiClientCode;
        data["areaCode"] = this.areaCode;
        data["bloodGroup"] = this.bloodGroup ? this.bloodGroup.toJSON() : <any>undefined;
        data["typeOfSupport"] = this.typeOfSupport ? this.typeOfSupport.toJSON() : <any>undefined;
        data["dateOfGatePassIssuance"] = this.dateOfGatePassIssuance ? this.dateOfGatePassIssuance.toISOString() : <any>undefined;
        data["transferApprovalDate"] = this.transferApprovalDate ? this.transferApprovalDate.toISOString() : <any>undefined;
        data["visaExtensionDate"] = this.visaExtensionDate ? this.visaExtensionDate.toISOString() : <any>undefined;
        data["reasonForProfessionChange"] = this.reasonForProfessionChange;
        data["dependentsInKuwait"] = this.dependentsInKuwait ? this.dependentsInKuwait.toJSON() : <any>undefined;
        data["currentRPDesignation"] = this.currentRPDesignation;
        data["currentSponcerName"] = this.currentSponcerName;
        data["workPermitExpiryDate"] = this.workPermitExpiryDate ? this.workPermitExpiryDate.toISOString() : <any>undefined;
        data["workPermitNumber"] = this.workPermitNumber;
        data["civilIDNumber"] = this.civilIDNumber;
        data["documentType"] = this.documentType;
        data["transferScenario"] = this.transferScenario ? this.transferScenario.toJSON() : <any>undefined;
        data["attestedbyKwait"] = this.attestedbyKwait ? this.attestedbyKwait.toJSON() : <any>undefined;
        data["isParentKwaitNational"] = this.isParentKwaitNational ? this.isParentKwaitNational.toJSON() : <any>undefined;
        data["isImmediateRealativeKwaitNational"] = this.isImmediateRealativeKwaitNational ? this.isImmediateRealativeKwaitNational.toJSON() : <any>undefined;
        data["kwaitProfessionalQualification"] = this.kwaitProfessionalQualification ? this.kwaitProfessionalQualification.toJSON() : <any>undefined;
        data["currentlyInKuwait"] = this.currentlyInKuwait ? this.currentlyInKuwait.toJSON() : <any>undefined;
        data["gracePeriodExpiryDate"] = this.gracePeriodExpiryDate ? this.gracePeriodExpiryDate.toISOString() : <any>undefined;
        data["workPermitIssuanceDate"] = this.workPermitIssuanceDate ? this.workPermitIssuanceDate.toISOString() : <any>undefined;
        data["modificationDetails"] = this.modificationDetails;
        data["newResidencePACINumber"] = this.newResidencePACINumber;
        data["typeOfModification"] = this.typeOfModification ? this.typeOfModification.toJSON() : <any>undefined;
        data["pifssCancellationDate"] = this.pifssCancellationDate ? this.pifssCancellationDate.toISOString() : <any>undefined;
        data["workPermitCancellationDate"] = this.workPermitCancellationDate ? this.workPermitCancellationDate.toISOString() : <any>undefined;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["categoryOfJobOffer"] = this.categoryOfJobOffer ? this.categoryOfJobOffer.toJSON() : <any>undefined;
        data["reasonForVisitUAEBusinessVisa"] = this.reasonForVisitUAEBusinessVisa ? this.reasonForVisitUAEBusinessVisa.toJSON() : <any>undefined;
        data["reasonForRenewal"] = this.reasonForRenewal ? this.reasonForRenewal.toJSON() : <any>undefined;
        data["autorequestCompleted"] = this.autorequestCompleted;
        data["medicalApplicationNumber"] = this.medicalApplicationNumber;
        data["visaValidity"] = this.visaValidity;
        data["travelType"] = this.travelType ? this.travelType.toJSON() : <any>undefined;
        data["realtiveUAENumber"] = this.realtiveUAENumber;
        data["nomination"] = this.nomination ? this.nomination.toJSON() : <any>undefined;
        data["eyInternalTransfer"] = this.eyInternalTransfer ? this.eyInternalTransfer.toJSON() : <any>undefined;
        data["ibanNumber"] = this.ibanNumber;
        data["bankName"] = this.bankName;
        data["saSerialNumber"] = this.saSerialNumber;
        data["candidateProfileId"] = this.candidateProfileId;
        data["pbActivityId"] = this.pbActivityId;
        data["visaValidityDate"] = this.visaValidityDate ? this.visaValidityDate.toISOString() : <any>undefined;
        data["requestorEmailAddress"] = this.requestorEmailAddress;
        data["requestorName"] = this.requestorName;
        data["personalEmailAddress"] = this.personalEmailAddress;
        data["eyEmailAddress"] = this.eyEmailAddress;
        data["currentBahrainResident"] = this.currentBahrainResident ? this.currentBahrainResident.toJSON() : <any>undefined;
        data["isBahrainResident"] = this.isBahrainResident ? this.isBahrainResident.toJSON() : <any>undefined;
        data["isdependentsUnderSponsorship"] = this.isdependentsUnderSponsorship ? this.isdependentsUnderSponsorship.toJSON() : <any>undefined;
        data["perDiem"] = this.perDiem;
        data["engagementName"] = this.engagementName;
        data["engPartnerName"] = this.engPartnerName;
        data["reasonForExit"] = this.reasonForExit ? this.reasonForExit.toJSON() : <any>undefined;
        data["otherReasonForExit"] = this.otherReasonForExit;
        data["noOfExtensionTimes"] = this.noOfExtensionTimes ? this.noOfExtensionTimes.toJSON() : <any>undefined;
        data["reasonForExtension"] = this.reasonForExtension;
        data["extensionIssuanceDate"] = this.extensionIssuanceDate ? this.extensionIssuanceDate.toISOString() : <any>undefined;
        data["loiNumber"] = this.loiNumber;
        data["loiIssueDate"] = this.loiIssueDate ? this.loiIssueDate.toISOString() : <any>undefined;
        data["loiVisaDuration"] = this.loiVisaDuration;
        data["loiVisaType"] = this.loiVisaType;
        data["loiJobTiteInArabic"] = this.loiJobTiteInArabic;
        if (Array.isArray(this.typeOfDocRequested)) {
            data["typeOfDocRequested"] = [];
            for (let item of this.typeOfDocRequested)
                data["typeOfDocRequested"].push(item);
        }
        data["otherTypeOfDocRequested"] = this.otherTypeOfDocRequested;
        data["newResidencyExpirydate"] = this.newResidencyExpirydate ? this.newResidencyExpirydate.toISOString() : <any>undefined;
        data["documentSupportType"] = this.documentSupportType ? this.documentSupportType.toJSON() : <any>undefined;
        data["arabicJobGroup"] = this.arabicJobGroup;
        data["arabicVisaDesignation"] = this.arabicVisaDesignation;
        data["citizenshipId"] = this.citizenshipId;
        data["sponsorID"] = this.sponsorID;
        data["socialInsuranceNumber"] = this.socialInsuranceNumber;
        data["typeOfEmployment"] = this.typeOfEmployment ? this.typeOfEmployment.toJSON() : <any>undefined;
        data["isEYFirstEmployer"] = this.isEYFirstEmployer ? this.isEYFirstEmployer.toJSON() : <any>undefined;
        data["siRegistrationDate"] = this.siRegistrationDate ? this.siRegistrationDate.toISOString() : <any>undefined;
        data["purposeOfRequest"] = this.purposeOfRequest;
        data["dateDocumentAttestationCompleted"] = this.dateDocumentAttestationCompleted ? this.dateDocumentAttestationCompleted.toISOString() : <any>undefined;
        data["siCancellationDate"] = this.siCancellationDate ? this.siCancellationDate.toISOString() : <any>undefined;
        data["iqamaCancellationDate"] = this.iqamaCancellationDate ? this.iqamaCancellationDate.toISOString() : <any>undefined;
        data["iqamaExpiryDateRenewed"] = this.iqamaExpiryDateRenewed ? this.iqamaExpiryDateRenewed.toISOString() : <any>undefined;
        data["lastWorkingDate"] = this.lastWorkingDate ? this.lastWorkingDate.toISOString() : <any>undefined;
        data["dependentRPIssuanceDate"] = this.dependentRPIssuanceDate ? this.dependentRPIssuanceDate.toISOString() : <any>undefined;
        data["dependentRPExpiryDate"] = this.dependentRPExpiryDate ? this.dependentRPExpiryDate.toISOString() : <any>undefined;
        data["dependentsRPCancellationDate"] = this.dependentsRPCancellationDate ? this.dependentsRPCancellationDate.toISOString() : <any>undefined;
        data["previousNationality"] = this.previousNationality ? this.previousNationality.toJSON() : <any>undefined;
        data["specialty"] = this.specialty;
        data["durationofstudy"] = this.durationofstudy;
        data["issuingEntity"] = this.issuingEntity;
        data["nationalityType"] = this.nationalityType ? this.nationalityType.toJSON() : <any>undefined;
        data["currentKSAbusinessvisa"] = this.currentKSAbusinessvisa ? this.currentKSAbusinessvisa.toJSON() : <any>undefined;
        data["currentKSABusinessVisaExpiryDate"] = this.currentKSABusinessVisaExpiryDate ? this.currentKSABusinessVisaExpiryDate.toISOString() : <any>undefined;
        data["dateSoftcopyVisaDocumentsSent"] = this.dateSoftcopyVisaDocumentsSent ? this.dateSoftcopyVisaDocumentsSent.toISOString() : <any>undefined;
        data["dateHardcopyVisaDocumentsSent"] = this.dateHardcopyVisaDocumentsSent ? this.dateHardcopyVisaDocumentsSent.toISOString() : <any>undefined;
        data["dateCourierTrackingNumberSent"] = this.dateCourierTrackingNumberSent ? this.dateCourierTrackingNumberSent.toISOString() : <any>undefined;
        data["dateHardCopyVisaDocumentsReceivedByVendorOrNJ"] = this.dateHardCopyVisaDocumentsReceivedByVendorOrNJ ? this.dateHardCopyVisaDocumentsReceivedByVendorOrNJ.toISOString() : <any>undefined;
        data["ewakalaAgent"] = this.ewakalaAgent ? this.ewakalaAgent.toJSON() : <any>undefined;
        data["courierDispatchDate"] = this.courierDispatchDate ? this.courierDispatchDate.toISOString() : <any>undefined;
        data["parentImmProfileId"] = this.parentImmProfileId;
        data["immEmployee"] = this.immEmployee ? this.immEmployee.toJSON() : <any>undefined;
        data["immEmployeeId"] = this.immEmployeeId;
        data["isFirstVisitToPakistan"] = this.isFirstVisitToPakistan ? this.isFirstVisitToPakistan.toJSON() : <any>undefined;
        data["isFirstVisitToJordan"] = this.isFirstVisitToJordan ? this.isFirstVisitToJordan.toJSON() : <any>undefined;
        data["mothersFullName"] = this.mothersFullName;
        data["reasonForVisitPAKBusinessVisa"] = this.reasonForVisitPAKBusinessVisa ? this.reasonForVisitPAKBusinessVisa.toJSON() : <any>undefined;
        data["gcCresidentExpiryDate"] = this.gcCresidentExpiryDate ? this.gcCresidentExpiryDate.toISOString() : <any>undefined;
        data["pakOfficeToVisit"] = this.pakOfficeToVisit ? this.pakOfficeToVisit.toJSON() : <any>undefined;
        data["labourContractNoticePeriod"] = this.labourContractNoticePeriod;
        data["isQualifiedInAccounting"] = this.isQualifiedInAccounting ? this.isQualifiedInAccounting.toJSON() : <any>undefined;
        data["isFirstEmployedInEgypt"] = this.isFirstEmployedInEgypt ? this.isFirstEmployedInEgypt.toJSON() : <any>undefined;
        data["docPrefix"] = this.docPrefix;
        data["parentExitProfileId"] = this.parentExitProfileId;
        data["exitActivityId"] = this.exitActivityId;
        data["onHoldDate"] = this.onHoldDate ? this.onHoldDate.toISOString() : <any>undefined;
        data["editCompletedProfile"] = this.editCompletedProfile;
        data["scpMembership"] = this.scpMembership ? this.scpMembership.toJSON() : <any>undefined;
        data["specificWorkLocationduringTrip"] = this.specificWorkLocationduringTrip;
        if (Array.isArray(this.workLocationDuringTrip)) {
            data["workLocationDuringTrip"] = [];
            for (let item of this.workLocationDuringTrip)
                data["workLocationDuringTrip"].push(item);
        }
        data["performingBillableWork"] = this.performingBillableWork ? this.performingBillableWork.toJSON() : <any>undefined;
        data["requestedService"] = this.requestedService ? this.requestedService.toJSON() : <any>undefined;
        data["countryToBeVisited"] = this.countryToBeVisited ? this.countryToBeVisited.toJSON() : <any>undefined;
        data["cityToBeVisited"] = this.cityToBeVisited ? this.cityToBeVisited.toJSON() : <any>undefined;
        data["visaDuration"] = this.visaDuration ? this.visaDuration.toJSON() : <any>undefined;
        if (Array.isArray(this.purposeOfVisit)) {
            data["purposeOfVisit"] = [];
            for (let item of this.purposeOfVisit)
                data["purposeOfVisit"].push(item);
        }
        data["specifyPurposeOfVisit"] = this.specifyPurposeOfVisit;
        data["isMenaSponsoringPartner"] = this.isMenaSponsoringPartner ? this.isMenaSponsoringPartner.toJSON() : <any>undefined;
        data["menaSponsoringPartnerName"] = this.menaSponsoringPartnerName;
        data["previousDateOfExit"] = this.previousDateOfExit ? this.previousDateOfExit.toISOString() : <any>undefined;
        data["revisedDateOfExit"] = this.revisedDateOfExit ? this.revisedDateOfExit.toISOString() : <any>undefined;
        data["currentVisaExpiryDate"] = this.currentVisaExpiryDate ? this.currentVisaExpiryDate.toISOString() : <any>undefined;
        data["purposeOfExtension"] = this.purposeOfExtension;
        data["currentTypeOfVisa"] = this.currentTypeOfVisa ? this.currentTypeOfVisa.toJSON() : <any>undefined;
        data["currentEntryType"] = this.currentEntryType ? this.currentEntryType.toJSON() : <any>undefined;
        data["currentVisaDuration"] = this.currentVisaDuration ? this.currentVisaDuration.toJSON() : <any>undefined;
        data["officeLocationCountry"] = this.officeLocationCountry ? this.officeLocationCountry.toJSON() : <any>undefined;
        data["processingTeam"] = this.processingTeam ? this.processingTeam.toJSON() : <any>undefined;
        data["processedBy"] = this.processedBy ? this.processedBy.toJSON() : <any>undefined;
        data["processedByOther"] = this.processedByOther;
        data["exceptionalApprovalRequired"] = this.exceptionalApprovalRequired ? this.exceptionalApprovalRequired.toJSON() : <any>undefined;
        data["approverName"] = this.approverName;
        data["recommendedVisaType"] = this.recommendedVisaType ? this.recommendedVisaType.toJSON() : <any>undefined;
        data["recommendedEntryType"] = this.recommendedEntryType ? this.recommendedEntryType.toJSON() : <any>undefined;
        data["recommendedVisaDuration"] = this.recommendedVisaDuration ? this.recommendedVisaDuration.toJSON() : <any>undefined;
        data["bTdurationOfStay"] = this.bTdurationOfStay;
        data["primeType"] = this.primeType ? this.primeType.toJSON() : <any>undefined;
        data["issuedVisaExpiryDate"] = this.issuedVisaExpiryDate ? this.issuedVisaExpiryDate.toISOString() : <any>undefined;
        data["universityDegree"] = this.universityDegree ? this.universityDegree.toJSON() : <any>undefined;
        data["accomodationSupportRequired"] = this.accomodationSupportRequired ? this.accomodationSupportRequired.toJSON() : <any>undefined;
        data["accommodationRequired"] = this.accommodationRequired ? this.accommodationRequired.toJSON() : <any>undefined;
        data["degreeAttestationRequired"] = this.degreeAttestationRequired ? this.degreeAttestationRequired.toJSON() : <any>undefined;
        data["degreeAttestationCompletedDate"] = this.degreeAttestationCompletedDate ? this.degreeAttestationCompletedDate.toISOString() : <any>undefined;
        data["documentReceiptDate"] = this.documentReceiptDate ? this.documentReceiptDate.toISOString() : <any>undefined;
        data["quotationIssuanceDate"] = this.quotationIssuanceDate ? this.quotationIssuanceDate.toISOString() : <any>undefined;
        data["entryPermitIssueDate"] = this.entryPermitIssueDate ? this.entryPermitIssueDate.toISOString() : <any>undefined;
        data["invoiceIssuanceDate"] = this.invoiceIssuanceDate ? this.invoiceIssuanceDate.toISOString() : <any>undefined;
        data["purchaseOrderIssuanceDate"] = this.purchaseOrderIssuanceDate ? this.purchaseOrderIssuanceDate.toISOString() : <any>undefined;
        data["payroll"] = this.payroll ? this.payroll.toJSON() : <any>undefined;
        data["salaryAmount"] = this.salaryAmount;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceMonth"] = this.invoiceMonth;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["invoiceCurrency"] = this.invoiceCurrency;
        data["invoiceAmount"] = this.invoiceAmount;
        data["poNumber"] = this.poNumber;
        data["loiJobTiteInEnglish"] = this.loiJobTiteInEnglish;
        return data;
    }
}

export interface IImmigrationProfile {
    id?: number;
    visaCountry?: LookupField | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    nationality?: LookupField | undefined;
    passportNumber?: string | undefined;
    placeOfBirth?: string | undefined;
    phoneNumber?: string | undefined;
    countryCode?: string | undefined;
    officeLE?: OfficeEntity | undefined;
    gender?: LookupField | undefined;
    onboardingType?: LookupField | undefined;
    officeLocation?: LookupField | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    globalRank?: GlobalRank | undefined;
    globalGrade?: GlobalGrade | undefined;
    withdrawnDate?: Date | undefined;
    job?: RankGrade | undefined;
    ksaOfficeToBeVisited?: LookupField | undefined;
    requestor?: Employee | undefined;
    processor?: Employee | undefined;
    prevProcessorId?: number;
    onBehalfRequestor?: AdUser | undefined;
    onBehalfRequestorId?: number | undefined;
    globalEmployeeLocation?: LookupField | undefined;
    employeeCurrentLocation?: LookupField | undefined;
    employeeCurrentLocationCountry?: LookupField | undefined;
    completedUAEPassRegistration?: LookupField | undefined;
    dependentFinalExitDeadline?: Date | undefined;
    immigrationCaseType?: LookupField | undefined;
    visaType?: LookupField | undefined;
    additionalDocs?: number[] | undefined;
    dateOfBirth?: Date | undefined;
    officeToBeVisited?: LookupField | undefined;
    gccResidencyTitle?: string | undefined;
    nonGCCResidencyTitle?: string | undefined;
    gccSponsorName?: string | undefined;
    durationOfStayId?: number | undefined;
    durationOfStay?: LookupField | undefined;
    embassyId?: number | undefined;
    embassy?: LookupField | undefined;
    cityOfEmbassy?: string | undefined;
    currentCity?: string | undefined;
    visaAgentName?: string | undefined;
    chargeCode?: string | undefined;
    dateOfTravel?: Date | undefined;
    travelPurpose?: LookupField | undefined;
    dateOfExit?: Date | undefined;
    reason?: string | undefined;
    projectName?: string | undefined;
    projectManagerId?: number | undefined;
    projectManager?: AdUser | undefined;
    letterAddressedTo?: string | undefined;
    gpn?: string | undefined;
    gui?: string | undefined;
    involuntaryExitTeam?: TeamInfo | undefined;
    voluntaryExitTeam?: TeamInfo | undefined;
    legalEntitiesTeam?: TeamInfo | undefined;
    involuntaryExitId?: number | undefined;
    voluntaryExitId?: number | undefined;
    legalEntitiesId?: number | undefined;
    involuntaryExitComment?: string | undefined;
    voluntaryExitComment?: string | undefined;
    legalEntitiesComment?: string | undefined;
    isActive?: boolean;
    isAutoGenerated?: boolean;
    isAutoCreatedAfterJoin?: boolean;
    createdBy?: number | undefined;
    createdDate?: Date | undefined;
    visaApprovedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    createdByEmployee?: Employee | undefined;
    modifiedByEmployee?: Employee | undefined;
    immigrationStatus?: LookupField | undefined;
    status?: LookupField | undefined;
    entryTypeId?: number | undefined;
    entryType?: LookupField | undefined;
    visaNumber?: string | undefined;
    visaDesignation?: string | undefined;
    academicQualification?: string | undefined;
    residencyDesignation?: string | undefined;
    passportExpiryDate?: Date | undefined;
    nationalityIdNumber?: string | undefined;
    travelDate?: Date | undefined;
    permissionDuration?: string | undefined;
    dateOfPayment?: Date | undefined;
    specialExpat?: boolean | undefined;
    startDate?: Date | undefined;
    attestationCompletedDate?: Date | undefined;
    entryDate?: Date | undefined;
    borderNumber?: string | undefined;
    medicalExamCompletionDate?: Date | undefined;
    bioMetricCompletedDate?: Date | undefined;
    agentCourierAddress?: string | undefined;
    iqamaId?: string | undefined;
    iqamaExpiryDate?: Date | undefined;
    residencyExpiryDate?: Date | undefined;
    detailsToBeUpdated?: string | undefined;
    wantToUpdateDependentPassport?: LookupField | undefined;
    nameOfNewEmployer?: string | undefined;
    lastWorkingDay?: Date | undefined;
    ksaFinalExitDate?: Date | undefined;
    spouseDetails?: string | undefined;
    childrenDetails?: string | undefined;
    sponsorDepsInKSA?: LookupField | undefined;
    depsAlreadyInKSA?: LookupField | undefined;
    newJoinerNameInArabic?: string | undefined;
    residencyStatus?: LookupField | undefined;
    tentativeStartDate?: Date | undefined;
    ptc?: Employee | undefined;
    recruiter?: Employee | undefined;
    vaccinationStatus?: LookupField | undefined;
    lastVaccineDate?: Date | undefined;
    vaccineType?: LookupField | undefined;
    otherVaccineName?: string | undefined;
    iqamaNumber?: string | undefined;
    trackingNumber?: string | undefined;
    dataStore?: any;
    notes?: string | undefined;
    dualCitizenship?: LookupField | undefined;
    secondNationality?: LookupField | undefined;
    distanceLearning?: LookupField | undefined;
    emailAddress?: string | undefined;
    currentEyEmployee?: LookupField | undefined;
    currentGccResident?: LookupField | undefined;
    prevCurrentGccResident?: LookupField | undefined;
    preboardingType?: LookupField | undefined;
    passportType?: LookupField | undefined;
    reasonForVisit?: LookupField | undefined;
    employeeSearchTerm?: string | undefined;
    otherReasonForCancellation?: string | undefined;
    labourCardCancellationType?: LookupField | undefined;
    terminationType?: LookupField | undefined;
    contactNumber?: string | undefined;
    enrollmentType?: LookupField | undefined;
    workTimings?: LookupField | undefined;
    language?: LookupField | undefined;
    workWeek?: LookupField | undefined;
    jobBenefits?: LookupField | undefined;
    entity?: string | undefined;
    department?: string | undefined;
    jobDescription?: string | undefined;
    yearsOfService?: string | undefined;
    generalSkills?: string | undefined;
    vocationalSkills?: string | undefined;
    specialization?: string | undefined;
    ageFrom?: string | undefined;
    ageTo?: string | undefined;
    remuneration?: string | undefined;
    basicSalary?: string | undefined;
    otherAllowance?: string | undefined;
    totalSalary?: string | undefined;
    tawteenJobOfferDesignation?: string | undefined;
    tgNumber?: string | undefined;
    visaIssuanceDate?: Date | undefined;
    homeAddress?: string | undefined;
    mothersName?: string | undefined;
    maritalStatus?: LookupField | undefined;
    religion?: LookupField | undefined;
    sect?: LookupField | undefined;
    attrestedDegree?: LookupField | undefined;
    alreadyHaveGoldenVisa?: LookupField | undefined;
    attestedByUAE?: LookupField | undefined;
    registeredWithUAE?: LookupField | undefined;
    visaStatus?: LookupField | undefined;
    uid?: string | undefined;
    missionExpiryDate?: Date | undefined;
    missionExpiryCancellation?: Date | undefined;
    missionVisaCategory?: LookupField | undefined;
    originalEducation?: LookupField | undefined;
    visaRenewal?: Date | undefined;
    originalDegreeCertificate?: string | undefined;
    fileNumber?: string | undefined;
    laborCardNumber?: string | undefined;
    laborCardExpiryDate?: Date | undefined;
    laborCardCancellationDate?: Date | undefined;
    noticePeriod?: number | undefined;
    contractDuration?: number | undefined;
    molContract?: LookupField | undefined;
    visaAlignment?: LookupField | undefined;
    emiratesIdNumber?: string | undefined;
    khulasatNumber?: string | undefined;
    pensionRegistrationNo?: string | undefined;
    pensionRegistrationDate?: Date | undefined;
    emergencyContact?: string | undefined;
    emergencyContactName?: string | undefined;
    emergencyContactCode?: string | undefined;
    workPermitDesignation?: string | undefined;
    securityPermitNumber?: string | undefined;
    securityPermitIssuanceDate?: Date | undefined;
    securityPermitExpiryDate?: Date | undefined;
    securityPermitCancellationDate?: Date | undefined;
    pensionCancellationDate?: Date | undefined;
    oldNationality?: LookupField | undefined;
    jobTitle?: string | undefined;
    numberOfQuotaRequired?: string | undefined;
    visaCategory?: string | undefined;
    vpNumber?: string | undefined;
    labourPersonCode?: string | undefined;
    mohreJobTitle?: string | undefined;
    mohreJobTitleId?: LookupField | undefined;
    workPermitCategory?: string | undefined;
    workPermitJobCode?: string | undefined;
    typeOfVisa?: LookupField | undefined;
    typeOfWorkPermit?: LookupField | undefined;
    workPermitPreApprovalDate?: Date | undefined;
    workPermitApprovalDate?: Date | undefined;
    visaExpiryDate?: Date | undefined;
    rpIssuanceDate?: Date | undefined;
    cprIssuanceDate?: Date | undefined;
    rpExpiryDate?: Date | undefined;
    newRPExpiryDate?: Date | undefined;
    quotaValidityDate?: Date | undefined;
    rpRenewalDate?: Date | undefined;
    cprExpiryDate?: Date | undefined;
    civilIdExpiryDate?: Date | undefined;
    rpNumber?: string | undefined;
    departureDate?: Date | undefined;
    newSponsorName?: string | undefined;
    rpCancellationDate?: Date | undefined;
    rpTransferDate?: Date | undefined;
    visaTransferDate?: Date | undefined;
    molContractCancellationDate?: Date | undefined;
    pasiContractCancellationRequestDate?: Date | undefined;
    shortTermVisa?: LookupField | undefined;
    statusDate?: Date | undefined;
    numberOfVisasRequired?: number | undefined;
    relationship?: LookupField | undefined;
    otherRelationshipName?: string | undefined;
    dependentDetails?: string | undefined;
    issuingCountryId?: LookupField | undefined;
    issuingCountry?: string | undefined;
    govtAuthority?: string | undefined;
    durationOfStayInDays?: number | undefined;
    typeOfRequest?: LookupField | undefined;
    isYourMarriageOrBirthCertificateAttested?: LookupField | undefined;
    tentativeTravelDate?: Date | undefined;
    previousSponsorName?: string | undefined;
    currentProfession?: string | undefined;
    newProfession?: string | undefined;
    gatePassDuration?: string | undefined;
    employeeCategory?: LookupField | undefined;
    cancellationReason?: LookupField | undefined;
    acceptedDate?: Date | undefined;
    declinedDate?: Date | undefined;
    approvedDate?: Date | undefined;
    rejectedDate?: Date | undefined;
    submissionDate?: Date | undefined;
    completionDate?: Date | undefined;
    initiationDate?: Date | undefined;
    employeeProfileId?: number | undefined;
    employeeId?: number | undefined;
    referenceId?: number | undefined;
    childReferenceId?: number | undefined;
    referenceVisaType?: string | undefined;
    createdByRoleId?: number;
    menaEmployee?: number | undefined;
    dependentCurrentLocation?: LookupField | undefined;
    oldPassportNumber?: string | undefined;
    onBehalfOfAnotherEYEmployee?: LookupField | undefined;
    onEntryBusinessVisa?: LookupField | undefined;
    visaCancellationRequired?: LookupField | undefined;
    visaCancellationExtensionDate?: Date | undefined;
    dependentsUnderSponsorship?: LookupField | undefined;
    dependentsUnderSponsorshipInUAE?: LookupField | undefined;
    dependentsVisaOnHold?: LookupField | undefined;
    dependentVisaCancellationDate?: Date | undefined;
    employmentVisaCancellationDate?: Date | undefined;
    gvExpiryDate?: Date | undefined;
    visaCancellationDate?: Date | undefined;
    cprNumber?: string | undefined;
    gosiTerminationDate?: Date | undefined;
    cprCaseType?: LookupField | undefined;
    cprType?: LookupField | undefined;
    bahrainResidentialAddress?: string | undefined;
    dateOfInvitationLetterIssuance?: Date | undefined;
    doYouHaveValidKSABusinessVisa?: LookupField | undefined;
    dateKSABusinessVisaExpiry?: Date | undefined;
    hireType?: LookupField | undefined;
    permitType?: LookupField | undefined;
    moiClientCode?: string | undefined;
    areaCode?: string | undefined;
    bloodGroup?: LookupField | undefined;
    typeOfSupport?: LookupField | undefined;
    dateOfGatePassIssuance?: Date | undefined;
    transferApprovalDate?: Date | undefined;
    visaExtensionDate?: Date | undefined;
    reasonForProfessionChange?: string | undefined;
    dependentsInKuwait?: LookupField | undefined;
    currentRPDesignation?: string | undefined;
    currentSponcerName?: string | undefined;
    workPermitExpiryDate?: Date | undefined;
    workPermitNumber?: string | undefined;
    civilIDNumber?: string | undefined;
    documentType?: string | undefined;
    transferScenario?: LookupField | undefined;
    attestedbyKwait?: LookupField | undefined;
    isParentKwaitNational?: LookupField | undefined;
    isImmediateRealativeKwaitNational?: LookupField | undefined;
    kwaitProfessionalQualification?: LookupField | undefined;
    currentlyInKuwait?: LookupField | undefined;
    gracePeriodExpiryDate?: Date | undefined;
    workPermitIssuanceDate?: Date | undefined;
    modificationDetails?: string | undefined;
    newResidencePACINumber?: string | undefined;
    typeOfModification?: LookupField | undefined;
    pifssCancellationDate?: Date | undefined;
    workPermitCancellationDate?: Date | undefined;
    qualification?: LookupField | undefined;
    categoryOfJobOffer?: LookupField | undefined;
    reasonForVisitUAEBusinessVisa?: LookupField | undefined;
    reasonForRenewal?: LookupField | undefined;
    autorequestCompleted?: string | undefined;
    medicalApplicationNumber?: string | undefined;
    visaValidity?: string | undefined;
    travelType?: LookupField | undefined;
    realtiveUAENumber?: string | undefined;
    nomination?: LookupField | undefined;
    eyInternalTransfer?: LookupField | undefined;
    ibanNumber?: string | undefined;
    bankName?: string | undefined;
    saSerialNumber?: string | undefined;
    candidateProfileId?: number | undefined;
    pbActivityId?: number | undefined;
    visaValidityDate?: Date | undefined;
    requestorEmailAddress?: string | undefined;
    requestorName?: string | undefined;
    personalEmailAddress?: string | undefined;
    eyEmailAddress?: string | undefined;
    currentBahrainResident?: LookupField | undefined;
    isBahrainResident?: LookupField | undefined;
    isdependentsUnderSponsorship?: LookupField | undefined;
    perDiem?: string | undefined;
    engagementName?: string | undefined;
    engPartnerName?: string | undefined;
    reasonForExit?: LookupField | undefined;
    otherReasonForExit?: string | undefined;
    noOfExtensionTimes?: LookupField | undefined;
    reasonForExtension?: string | undefined;
    extensionIssuanceDate?: Date | undefined;
    loiNumber?: string | undefined;
    loiIssueDate?: Date | undefined;
    loiVisaDuration?: string | undefined;
    loiVisaType?: string | undefined;
    loiJobTiteInArabic?: string | undefined;
    typeOfDocRequested?: number[] | undefined;
    otherTypeOfDocRequested?: string | undefined;
    newResidencyExpirydate?: Date | undefined;
    documentSupportType?: LookupField | undefined;
    arabicJobGroup?: string | undefined;
    arabicVisaDesignation?: string | undefined;
    citizenshipId?: number | undefined;
    sponsorID?: string | undefined;
    socialInsuranceNumber?: string | undefined;
    typeOfEmployment?: LookupField | undefined;
    isEYFirstEmployer?: LookupField | undefined;
    siRegistrationDate?: Date | undefined;
    purposeOfRequest?: string | undefined;
    dateDocumentAttestationCompleted?: Date | undefined;
    siCancellationDate?: Date | undefined;
    iqamaCancellationDate?: Date | undefined;
    iqamaExpiryDateRenewed?: Date | undefined;
    lastWorkingDate?: Date | undefined;
    dependentRPIssuanceDate?: Date | undefined;
    dependentRPExpiryDate?: Date | undefined;
    dependentsRPCancellationDate?: Date | undefined;
    previousNationality?: LookupField | undefined;
    specialty?: string | undefined;
    durationofstudy?: string | undefined;
    issuingEntity?: string | undefined;
    nationalityType?: LookupField | undefined;
    currentKSAbusinessvisa?: LookupField | undefined;
    currentKSABusinessVisaExpiryDate?: Date | undefined;
    dateSoftcopyVisaDocumentsSent?: Date | undefined;
    dateHardcopyVisaDocumentsSent?: Date | undefined;
    dateCourierTrackingNumberSent?: Date | undefined;
    dateHardCopyVisaDocumentsReceivedByVendorOrNJ?: Date | undefined;
    ewakalaAgent?: LookupField | undefined;
    courierDispatchDate?: Date | undefined;
    parentImmProfileId?: number | undefined;
    immEmployee?: AdUser | undefined;
    immEmployeeId?: number | undefined;
    isFirstVisitToPakistan?: LookupField | undefined;
    isFirstVisitToJordan?: LookupField | undefined;
    mothersFullName?: string | undefined;
    reasonForVisitPAKBusinessVisa?: LookupField | undefined;
    gcCresidentExpiryDate?: Date | undefined;
    pakOfficeToVisit?: LookupField | undefined;
    labourContractNoticePeriod?: number | undefined;
    isQualifiedInAccounting?: LookupField | undefined;
    isFirstEmployedInEgypt?: LookupField | undefined;
    docPrefix?: string | undefined;
    parentExitProfileId?: number | undefined;
    exitActivityId?: number | undefined;
    onHoldDate?: Date | undefined;
    editCompletedProfile?: boolean;
    scpMembership?: LookupField | undefined;
    specificWorkLocationduringTrip?: string | undefined;
    workLocationDuringTrip?: number[] | undefined;
    performingBillableWork?: LookupField | undefined;
    requestedService?: LookupField | undefined;
    countryToBeVisited?: LookupField | undefined;
    cityToBeVisited?: LookupField | undefined;
    visaDuration?: LookupField | undefined;
    purposeOfVisit?: number[] | undefined;
    specifyPurposeOfVisit?: string | undefined;
    isMenaSponsoringPartner?: LookupField | undefined;
    menaSponsoringPartnerName?: string | undefined;
    previousDateOfExit?: Date | undefined;
    revisedDateOfExit?: Date | undefined;
    currentVisaExpiryDate?: Date | undefined;
    purposeOfExtension?: string | undefined;
    currentTypeOfVisa?: LookupField | undefined;
    currentEntryType?: LookupField | undefined;
    currentVisaDuration?: LookupField | undefined;
    officeLocationCountry?: LookupField | undefined;
    processingTeam?: LookupField | undefined;
    processedBy?: LookupField | undefined;
    processedByOther?: string | undefined;
    exceptionalApprovalRequired?: LookupField | undefined;
    approverName?: string | undefined;
    recommendedVisaType?: LookupField | undefined;
    recommendedEntryType?: LookupField | undefined;
    recommendedVisaDuration?: LookupField | undefined;
    bTdurationOfStay?: string | undefined;
    primeType?: LookupField | undefined;
    issuedVisaExpiryDate?: Date | undefined;
    universityDegree?: LookupField | undefined;
    accomodationSupportRequired?: LookupField | undefined;
    accommodationRequired?: LookupField | undefined;
    degreeAttestationRequired?: LookupField | undefined;
    degreeAttestationCompletedDate?: Date | undefined;
    documentReceiptDate?: Date | undefined;
    quotationIssuanceDate?: Date | undefined;
    entryPermitIssueDate?: Date | undefined;
    invoiceIssuanceDate?: Date | undefined;
    purchaseOrderIssuanceDate?: Date | undefined;
    payroll?: LookupField | undefined;
    salaryAmount?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceMonth?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceCurrency?: string | undefined;
    invoiceAmount?: string | undefined;
    poNumber?: string | undefined;
    loiJobTiteInEnglish?: string | undefined;
}

export class GlobalRank implements IGlobalRank {
    id?: number | undefined;
    rankCode?: string | undefined;
    rankName?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IGlobalRank) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rankCode = _data["rankCode"];
            this.rankName = _data["rankName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GlobalRank {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalRank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rankCode"] = this.rankCode;
        data["rankName"] = this.rankName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGlobalRank {
    id?: number | undefined;
    rankCode?: string | undefined;
    rankName?: string | undefined;
    isActive?: boolean | undefined;
}

export class GlobalGrade implements IGlobalGrade {
    id?: number | undefined;
    rankCode?: string | undefined;
    gradeCode?: string | undefined;
    grade?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IGlobalGrade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rankCode = _data["rankCode"];
            this.gradeCode = _data["gradeCode"];
            this.grade = _data["grade"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GlobalGrade {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalGrade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rankCode"] = this.rankCode;
        data["gradeCode"] = this.gradeCode;
        data["grade"] = this.grade;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGlobalGrade {
    id?: number | undefined;
    rankCode?: string | undefined;
    gradeCode?: string | undefined;
    grade?: string | undefined;
    isActive?: boolean | undefined;
}

export class TeamInfo implements ITeamInfo {
    updatedBy?: number | undefined;
    submittedDate?: Date | undefined;
    submittedStatus?: string | undefined;

    constructor(data?: ITeamInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedBy = _data["updatedBy"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.submittedStatus = _data["submittedStatus"];
        }
    }

    static fromJS(data: any): TeamInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TeamInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedBy"] = this.updatedBy;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["submittedStatus"] = this.submittedStatus;
        return data;
    }
}

export interface ITeamInfo {
    updatedBy?: number | undefined;
    submittedDate?: Date | undefined;
    submittedStatus?: string | undefined;
}

export class EmployeeProfile implements IEmployeeProfile {
    labourCardExpiryDate?: Date | undefined;
    employeeVisaExpiryDate?: Date | undefined;
    missionVisaExpiryDate?: Date | undefined;
    workPermitExpiryDate?: Date | undefined;
    id?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    nationality?: LookupField | undefined;
    passportType?: LookupField | undefined;
    onboardingType?: LookupField | undefined;
    profileStatus?: LookupField | undefined;
    employeeId?: number | undefined;
    gpn?: string | undefined;
    gui?: string | undefined;
    officeLocation?: LookupField | undefined;
    officeLocationCountry?: LookupField | undefined;
    passportNumber?: string | undefined;
    passportExpiryDate?: Date | undefined;
    iqamaExpiryDate?: Date | undefined;
    lastWorkingDay?: Date | undefined;
    dateOfExit?: Date | undefined;
    dateOfBirth?: Date | undefined;
    createdBy?: number | undefined;
    createdDate?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    job?: RankGrade | undefined;
    officeLE?: OfficeEntity | undefined;
    secondNationality?: LookupField | undefined;
    profileApprovedDate?: Date | undefined;
    isApproved?: boolean;
    isActive?: boolean;
    email?: string | undefined;
    lpn?: string | undefined;
    status?: string | undefined;
    merrPuldate?: Date | undefined;
    merrModifieddate?: Date | undefined;
    officeJoiningDate?: Date | undefined;
    firmJoiningDate?: Date | undefined;
    dualCitizenship?: LookupField | undefined;
    officeLocationName?: string | undefined;
    gender?: LookupField | undefined;
    submissionDate?: Date | undefined;
    fullName?: string | undefined;
    placeofBirth?: string | undefined;
    maritalStatus?: LookupField | undefined;
    nationalityType?: LookupField | undefined;
    workPermitType?: LookupField | undefined;
    contractType?: LookupField | undefined;
    employeeStatus?: LookupField | undefined;
    labourCardDuration?: number | undefined;
    dependentsHaveValidVisa?: LookupField | undefined;
    nationalityTypeId?: LookupField | undefined;
    numberOfdependents?: number | undefined;
    labourContractNoticePeriod?: number | undefined;
    visanNoAndDesignation?: string | undefined;
    isGCCNational?: LookupField | undefined;
    spouseDetails?: string | undefined;
    childrenDetails?: string | undefined;
    dataStore?: any;
    cprExpiryDate?: Date | undefined;
    rpExpiryDate?: Date | undefined;
    civilIdExpiryDate?: Date | undefined;
    phoneNumber?: string | undefined;
    countryCode?: string | undefined;
    pensionRegistrationNo?: string | undefined;
    pensionRegistrationDate?: Date | undefined;
    labourCardNumber?: string | undefined;
    employeeCategory?: LookupField | undefined;
    categoryOfJobOffer?: LookupField | undefined;
    profileConfirmedDate?: Date | undefined;
    bulkUploadedDate?: Date | undefined;
    isMailRequired?: boolean;
    visaAlignment?: LookupField | undefined;
    emiratesId?: string | undefined;
    contractDuration?: number | undefined;
    labourPersonCode?: string | undefined;
    mohreJobTitleId?: LookupField | undefined;
    workPermitCategory?: string | undefined;
    workPermitJobCode?: string | undefined;
    typeOfVisa?: LookupField | undefined;
    noticePeriod?: string | undefined;

    constructor(data?: IEmployeeProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labourCardExpiryDate = _data["labourCardExpiryDate"] ? new Date(_data["labourCardExpiryDate"].toString()) : <any>undefined;
            this.employeeVisaExpiryDate = _data["employeeVisaExpiryDate"] ? new Date(_data["employeeVisaExpiryDate"].toString()) : <any>undefined;
            this.missionVisaExpiryDate = _data["missionVisaExpiryDate"] ? new Date(_data["missionVisaExpiryDate"].toString()) : <any>undefined;
            this.workPermitExpiryDate = _data["workPermitExpiryDate"] ? new Date(_data["workPermitExpiryDate"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"] ? LookupField.fromJS(_data["nationality"]) : <any>undefined;
            this.passportType = _data["passportType"] ? LookupField.fromJS(_data["passportType"]) : <any>undefined;
            this.onboardingType = _data["onboardingType"] ? LookupField.fromJS(_data["onboardingType"]) : <any>undefined;
            this.profileStatus = _data["profileStatus"] ? LookupField.fromJS(_data["profileStatus"]) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.gpn = _data["gpn"];
            this.gui = _data["gui"];
            this.officeLocation = _data["officeLocation"] ? LookupField.fromJS(_data["officeLocation"]) : <any>undefined;
            this.officeLocationCountry = _data["officeLocationCountry"] ? LookupField.fromJS(_data["officeLocationCountry"]) : <any>undefined;
            this.passportNumber = _data["passportNumber"];
            this.passportExpiryDate = _data["passportExpiryDate"] ? new Date(_data["passportExpiryDate"].toString()) : <any>undefined;
            this.iqamaExpiryDate = _data["iqamaExpiryDate"] ? new Date(_data["iqamaExpiryDate"].toString()) : <any>undefined;
            this.lastWorkingDay = _data["lastWorkingDay"] ? new Date(_data["lastWorkingDay"].toString()) : <any>undefined;
            this.dateOfExit = _data["dateOfExit"] ? new Date(_data["dateOfExit"].toString()) : <any>undefined;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.serviceLine = _data["serviceLine"] ? ServiceLine.fromJS(_data["serviceLine"]) : <any>undefined;
            this.subServiceLine = _data["subServiceLine"] ? SubServiceLine.fromJS(_data["subServiceLine"]) : <any>undefined;
            this.job = _data["job"] ? RankGrade.fromJS(_data["job"]) : <any>undefined;
            this.officeLE = _data["officeLE"] ? OfficeEntity.fromJS(_data["officeLE"]) : <any>undefined;
            this.secondNationality = _data["secondNationality"] ? LookupField.fromJS(_data["secondNationality"]) : <any>undefined;
            this.profileApprovedDate = _data["profileApprovedDate"] ? new Date(_data["profileApprovedDate"].toString()) : <any>undefined;
            this.isApproved = _data["isApproved"];
            this.isActive = _data["isActive"];
            this.email = _data["email"];
            this.lpn = _data["lpn"];
            this.status = _data["status"];
            this.merrPuldate = _data["merrPuldate"] ? new Date(_data["merrPuldate"].toString()) : <any>undefined;
            this.merrModifieddate = _data["merrModifieddate"] ? new Date(_data["merrModifieddate"].toString()) : <any>undefined;
            this.officeJoiningDate = _data["officeJoiningDate"] ? new Date(_data["officeJoiningDate"].toString()) : <any>undefined;
            this.firmJoiningDate = _data["firmJoiningDate"] ? new Date(_data["firmJoiningDate"].toString()) : <any>undefined;
            this.dualCitizenship = _data["dualCitizenship"] ? LookupField.fromJS(_data["dualCitizenship"]) : <any>undefined;
            this.officeLocationName = _data["officeLocationName"];
            this.gender = _data["gender"] ? LookupField.fromJS(_data["gender"]) : <any>undefined;
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : <any>undefined;
            this.fullName = _data["fullName"];
            this.placeofBirth = _data["placeofBirth"];
            this.maritalStatus = _data["maritalStatus"] ? LookupField.fromJS(_data["maritalStatus"]) : <any>undefined;
            this.nationalityType = _data["nationalityType"] ? LookupField.fromJS(_data["nationalityType"]) : <any>undefined;
            this.workPermitType = _data["workPermitType"] ? LookupField.fromJS(_data["workPermitType"]) : <any>undefined;
            this.contractType = _data["contractType"] ? LookupField.fromJS(_data["contractType"]) : <any>undefined;
            this.employeeStatus = _data["employeeStatus"] ? LookupField.fromJS(_data["employeeStatus"]) : <any>undefined;
            this.labourCardDuration = _data["labourCardDuration"];
            this.dependentsHaveValidVisa = _data["dependentsHaveValidVisa"] ? LookupField.fromJS(_data["dependentsHaveValidVisa"]) : <any>undefined;
            this.nationalityTypeId = _data["nationalityTypeId"] ? LookupField.fromJS(_data["nationalityTypeId"]) : <any>undefined;
            this.numberOfdependents = _data["numberOfdependents"];
            this.labourContractNoticePeriod = _data["labourContractNoticePeriod"];
            this.visanNoAndDesignation = _data["visanNoAndDesignation"];
            this.isGCCNational = _data["isGCCNational"] ? LookupField.fromJS(_data["isGCCNational"]) : <any>undefined;
            this.spouseDetails = _data["spouseDetails"];
            this.childrenDetails = _data["childrenDetails"];
            this.dataStore = _data["dataStore"];
            this.cprExpiryDate = _data["cprExpiryDate"] ? new Date(_data["cprExpiryDate"].toString()) : <any>undefined;
            this.rpExpiryDate = _data["rpExpiryDate"] ? new Date(_data["rpExpiryDate"].toString()) : <any>undefined;
            this.civilIdExpiryDate = _data["civilIdExpiryDate"] ? new Date(_data["civilIdExpiryDate"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.countryCode = _data["countryCode"];
            this.pensionRegistrationNo = _data["pensionRegistrationNo"];
            this.pensionRegistrationDate = _data["pensionRegistrationDate"] ? new Date(_data["pensionRegistrationDate"].toString()) : <any>undefined;
            this.labourCardNumber = _data["labourCardNumber"];
            this.employeeCategory = _data["employeeCategory"] ? LookupField.fromJS(_data["employeeCategory"]) : <any>undefined;
            this.categoryOfJobOffer = _data["categoryOfJobOffer"] ? LookupField.fromJS(_data["categoryOfJobOffer"]) : <any>undefined;
            this.profileConfirmedDate = _data["profileConfirmedDate"] ? new Date(_data["profileConfirmedDate"].toString()) : <any>undefined;
            this.bulkUploadedDate = _data["bulkUploadedDate"] ? new Date(_data["bulkUploadedDate"].toString()) : <any>undefined;
            this.isMailRequired = _data["isMailRequired"];
            this.visaAlignment = _data["visaAlignment"] ? LookupField.fromJS(_data["visaAlignment"]) : <any>undefined;
            this.emiratesId = _data["emiratesId"];
            this.contractDuration = _data["contractDuration"];
            this.labourPersonCode = _data["labourPersonCode"];
            this.mohreJobTitleId = _data["mohreJobTitleId"] ? LookupField.fromJS(_data["mohreJobTitleId"]) : <any>undefined;
            this.workPermitCategory = _data["workPermitCategory"];
            this.workPermitJobCode = _data["workPermitJobCode"];
            this.typeOfVisa = _data["typeOfVisa"] ? LookupField.fromJS(_data["typeOfVisa"]) : <any>undefined;
            this.noticePeriod = _data["noticePeriod"];
        }
    }

    static fromJS(data: any): EmployeeProfile {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labourCardExpiryDate"] = this.labourCardExpiryDate ? this.labourCardExpiryDate.toISOString() : <any>undefined;
        data["employeeVisaExpiryDate"] = this.employeeVisaExpiryDate ? this.employeeVisaExpiryDate.toISOString() : <any>undefined;
        data["missionVisaExpiryDate"] = this.missionVisaExpiryDate ? this.missionVisaExpiryDate.toISOString() : <any>undefined;
        data["workPermitExpiryDate"] = this.workPermitExpiryDate ? this.workPermitExpiryDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["passportType"] = this.passportType ? this.passportType.toJSON() : <any>undefined;
        data["onboardingType"] = this.onboardingType ? this.onboardingType.toJSON() : <any>undefined;
        data["profileStatus"] = this.profileStatus ? this.profileStatus.toJSON() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["gpn"] = this.gpn;
        data["gui"] = this.gui;
        data["officeLocation"] = this.officeLocation ? this.officeLocation.toJSON() : <any>undefined;
        data["officeLocationCountry"] = this.officeLocationCountry ? this.officeLocationCountry.toJSON() : <any>undefined;
        data["passportNumber"] = this.passportNumber;
        data["passportExpiryDate"] = this.passportExpiryDate ? this.passportExpiryDate.toISOString() : <any>undefined;
        data["iqamaExpiryDate"] = this.iqamaExpiryDate ? this.iqamaExpiryDate.toISOString() : <any>undefined;
        data["lastWorkingDay"] = this.lastWorkingDay ? this.lastWorkingDay.toISOString() : <any>undefined;
        data["dateOfExit"] = this.dateOfExit ? this.dateOfExit.toISOString() : <any>undefined;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["serviceLine"] = this.serviceLine ? this.serviceLine.toJSON() : <any>undefined;
        data["subServiceLine"] = this.subServiceLine ? this.subServiceLine.toJSON() : <any>undefined;
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        data["officeLE"] = this.officeLE ? this.officeLE.toJSON() : <any>undefined;
        data["secondNationality"] = this.secondNationality ? this.secondNationality.toJSON() : <any>undefined;
        data["profileApprovedDate"] = this.profileApprovedDate ? this.profileApprovedDate.toISOString() : <any>undefined;
        data["isApproved"] = this.isApproved;
        data["isActive"] = this.isActive;
        data["email"] = this.email;
        data["lpn"] = this.lpn;
        data["status"] = this.status;
        data["merrPuldate"] = this.merrPuldate ? this.merrPuldate.toISOString() : <any>undefined;
        data["merrModifieddate"] = this.merrModifieddate ? this.merrModifieddate.toISOString() : <any>undefined;
        data["officeJoiningDate"] = this.officeJoiningDate ? this.officeJoiningDate.toISOString() : <any>undefined;
        data["firmJoiningDate"] = this.firmJoiningDate ? this.firmJoiningDate.toISOString() : <any>undefined;
        data["dualCitizenship"] = this.dualCitizenship ? this.dualCitizenship.toJSON() : <any>undefined;
        data["officeLocationName"] = this.officeLocationName;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["placeofBirth"] = this.placeofBirth;
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
        data["nationalityType"] = this.nationalityType ? this.nationalityType.toJSON() : <any>undefined;
        data["workPermitType"] = this.workPermitType ? this.workPermitType.toJSON() : <any>undefined;
        data["contractType"] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data["employeeStatus"] = this.employeeStatus ? this.employeeStatus.toJSON() : <any>undefined;
        data["labourCardDuration"] = this.labourCardDuration;
        data["dependentsHaveValidVisa"] = this.dependentsHaveValidVisa ? this.dependentsHaveValidVisa.toJSON() : <any>undefined;
        data["nationalityTypeId"] = this.nationalityTypeId ? this.nationalityTypeId.toJSON() : <any>undefined;
        data["numberOfdependents"] = this.numberOfdependents;
        data["labourContractNoticePeriod"] = this.labourContractNoticePeriod;
        data["visanNoAndDesignation"] = this.visanNoAndDesignation;
        data["isGCCNational"] = this.isGCCNational ? this.isGCCNational.toJSON() : <any>undefined;
        data["spouseDetails"] = this.spouseDetails;
        data["childrenDetails"] = this.childrenDetails;
        data["dataStore"] = this.dataStore;
        data["cprExpiryDate"] = this.cprExpiryDate ? this.cprExpiryDate.toISOString() : <any>undefined;
        data["rpExpiryDate"] = this.rpExpiryDate ? this.rpExpiryDate.toISOString() : <any>undefined;
        data["civilIdExpiryDate"] = this.civilIdExpiryDate ? this.civilIdExpiryDate.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["countryCode"] = this.countryCode;
        data["pensionRegistrationNo"] = this.pensionRegistrationNo;
        data["pensionRegistrationDate"] = this.pensionRegistrationDate ? this.pensionRegistrationDate.toISOString() : <any>undefined;
        data["labourCardNumber"] = this.labourCardNumber;
        data["employeeCategory"] = this.employeeCategory ? this.employeeCategory.toJSON() : <any>undefined;
        data["categoryOfJobOffer"] = this.categoryOfJobOffer ? this.categoryOfJobOffer.toJSON() : <any>undefined;
        data["profileConfirmedDate"] = this.profileConfirmedDate ? this.profileConfirmedDate.toISOString() : <any>undefined;
        data["bulkUploadedDate"] = this.bulkUploadedDate ? this.bulkUploadedDate.toISOString() : <any>undefined;
        data["isMailRequired"] = this.isMailRequired;
        data["visaAlignment"] = this.visaAlignment ? this.visaAlignment.toJSON() : <any>undefined;
        data["emiratesId"] = this.emiratesId;
        data["contractDuration"] = this.contractDuration;
        data["labourPersonCode"] = this.labourPersonCode;
        data["mohreJobTitleId"] = this.mohreJobTitleId ? this.mohreJobTitleId.toJSON() : <any>undefined;
        data["workPermitCategory"] = this.workPermitCategory;
        data["workPermitJobCode"] = this.workPermitJobCode;
        data["typeOfVisa"] = this.typeOfVisa ? this.typeOfVisa.toJSON() : <any>undefined;
        data["noticePeriod"] = this.noticePeriod;
        return data;
    }
}

export interface IEmployeeProfile {
    labourCardExpiryDate?: Date | undefined;
    employeeVisaExpiryDate?: Date | undefined;
    missionVisaExpiryDate?: Date | undefined;
    workPermitExpiryDate?: Date | undefined;
    id?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    nationality?: LookupField | undefined;
    passportType?: LookupField | undefined;
    onboardingType?: LookupField | undefined;
    profileStatus?: LookupField | undefined;
    employeeId?: number | undefined;
    gpn?: string | undefined;
    gui?: string | undefined;
    officeLocation?: LookupField | undefined;
    officeLocationCountry?: LookupField | undefined;
    passportNumber?: string | undefined;
    passportExpiryDate?: Date | undefined;
    iqamaExpiryDate?: Date | undefined;
    lastWorkingDay?: Date | undefined;
    dateOfExit?: Date | undefined;
    dateOfBirth?: Date | undefined;
    createdBy?: number | undefined;
    createdDate?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    job?: RankGrade | undefined;
    officeLE?: OfficeEntity | undefined;
    secondNationality?: LookupField | undefined;
    profileApprovedDate?: Date | undefined;
    isApproved?: boolean;
    isActive?: boolean;
    email?: string | undefined;
    lpn?: string | undefined;
    status?: string | undefined;
    merrPuldate?: Date | undefined;
    merrModifieddate?: Date | undefined;
    officeJoiningDate?: Date | undefined;
    firmJoiningDate?: Date | undefined;
    dualCitizenship?: LookupField | undefined;
    officeLocationName?: string | undefined;
    gender?: LookupField | undefined;
    submissionDate?: Date | undefined;
    fullName?: string | undefined;
    placeofBirth?: string | undefined;
    maritalStatus?: LookupField | undefined;
    nationalityType?: LookupField | undefined;
    workPermitType?: LookupField | undefined;
    contractType?: LookupField | undefined;
    employeeStatus?: LookupField | undefined;
    labourCardDuration?: number | undefined;
    dependentsHaveValidVisa?: LookupField | undefined;
    nationalityTypeId?: LookupField | undefined;
    numberOfdependents?: number | undefined;
    labourContractNoticePeriod?: number | undefined;
    visanNoAndDesignation?: string | undefined;
    isGCCNational?: LookupField | undefined;
    spouseDetails?: string | undefined;
    childrenDetails?: string | undefined;
    dataStore?: any;
    cprExpiryDate?: Date | undefined;
    rpExpiryDate?: Date | undefined;
    civilIdExpiryDate?: Date | undefined;
    phoneNumber?: string | undefined;
    countryCode?: string | undefined;
    pensionRegistrationNo?: string | undefined;
    pensionRegistrationDate?: Date | undefined;
    labourCardNumber?: string | undefined;
    employeeCategory?: LookupField | undefined;
    categoryOfJobOffer?: LookupField | undefined;
    profileConfirmedDate?: Date | undefined;
    bulkUploadedDate?: Date | undefined;
    isMailRequired?: boolean;
    visaAlignment?: LookupField | undefined;
    emiratesId?: string | undefined;
    contractDuration?: number | undefined;
    labourPersonCode?: string | undefined;
    mohreJobTitleId?: LookupField | undefined;
    workPermitCategory?: string | undefined;
    workPermitJobCode?: string | undefined;
    typeOfVisa?: LookupField | undefined;
    noticePeriod?: string | undefined;
}

export class ExitRequest implements IExitRequest {
    id?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    job?: RankGrade | undefined;
    dateOfExit?: Date | undefined;
    exitDateChanged?: LookupField | undefined;
    miCancellationDate?: Date | undefined;
    gpn?: string | undefined;
    gui?: string | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    status?: LookupField | undefined;
    createdBy?: number | undefined;
    createdByEmployee?: Employee | undefined;
    modifiedBy?: number | undefined;
    modifiedByEmployee?: Employee | undefined;
    acceptedDate?: Date | undefined;
    declinedDate?: Date | undefined;
    submissionDate?: Date | undefined;
    completionDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    createdDate?: Date | undefined;
    createdByRoleId?: number | undefined;
    exitTypeId?: number | undefined;
    exitType?: LookupField | undefined;
    isActive?: boolean;
    jobName?: LookupField | undefined;
    lpn?: string | undefined;
    officeLocation?: LookupField | undefined;
    nationality?: LookupField | undefined;
    offboardingMember?: Employee | undefined;
    itAssetDetails?: string | undefined;
    pqDetails?: string | undefined;
    lmsBalance?: string | undefined;
    amexCardBalance?: string | undefined;
    leadRating?: string | undefined;
    hrccComment?: string | undefined;
    financeTeamComment?: string | undefined;
    visaApproverComment?: string | undefined;
    guidanceMailComment?: string | undefined;
    arcAndCanvasComment?: string | undefined;
    exitSubType?: LookupField | undefined;
    shortNotice?: LookupField | undefined;
    ticketNumber?: string | undefined;
    itTeam?: TeamInfo | undefined;
    expense?: TeamInfo | undefined;
    lms?: TeamInfo | undefined;
    amex?: TeamInfo | undefined;
    leadsTeam?: TeamInfo | undefined;
    arcAndCanvas?: TeamInfo | undefined;
    financeTeam?: TeamInfo | undefined;
    visaApprover?: TeamInfo | undefined;
    guidanceMail?: TeamInfo | undefined;
    hrcc?: TeamInfo | undefined;
    nationalityType?: LookupField | undefined;
    nationalityTypeId?: LookupField | undefined;
    notes?: string | undefined;
    createdIn?: string | undefined;
    legalEntity?: OfficeEntity | undefined;
    allTeamUpdated?: boolean;
    genderCode?: LookupField | undefined;
    company?: Companies | undefined;
    department?: LookupField | undefined;
    competency?: SMU | undefined;
    speciality?: Speciality | undefined;
    industryData?: LookupField | undefined;
    employeeCategory?: ExitJobCategory | undefined;
    seniorityDate?: Date | undefined;
    counsellor?: AdUser | undefined;
    counsellorId?: number | undefined;
    exitReason?: LookupField | undefined;
    volInvolIndicator?: string | undefined;
    pocTalent?: AdUser | undefined;
    exGratiaEYSettlement?: LookupField | undefined;
    exGratiaAmount?: number | undefined;
    exGratiaCurrency?: string | undefined;
    applicationOfNotice?: LookupField | undefined;
    durationOfNoticeInDays?: number | undefined;
    dateTerminationCommunicated?: Date | undefined;
    paymentInLieu?: LookupField | undefined;
    paymentInLieuAmount?: number | undefined;
    paymentInLieuCurrency?: string | undefined;
    lastDateOfEmployment?: Date | undefined;
    lastWorkingDate?: Date | undefined;
    gardenLeaveStartDate?: Date | undefined;
    gardenLeaveEndDate?: Date | undefined;
    letterToBeUsed?: LookupField | undefined;
    reasonOfSeperation?: LookupField | undefined;
    exitEmployee?: Employee | undefined;
    employeeSearchTerm?: string | undefined;
    isExitDateMailSent?: boolean | undefined;
    isWithdrawalMailSent?: boolean | undefined;
    queueDataSyncDate?: Date | undefined;
    previousDateOfExit?: Date | undefined;
    isIndividualHasAmexCard?: LookupField | undefined;
    amexComment?: string | undefined;
    emailAddress?: string | undefined;
    emailID?: string | undefined;
    selected?: boolean;
    docPrefix?: string | undefined;
    cancellationVisa?: LookupField | undefined;

    constructor(data?: IExitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.job = _data["job"] ? RankGrade.fromJS(_data["job"]) : <any>undefined;
            this.dateOfExit = _data["dateOfExit"] ? new Date(_data["dateOfExit"].toString()) : <any>undefined;
            this.exitDateChanged = _data["exitDateChanged"] ? LookupField.fromJS(_data["exitDateChanged"]) : <any>undefined;
            this.miCancellationDate = _data["miCancellationDate"] ? new Date(_data["miCancellationDate"].toString()) : <any>undefined;
            this.gpn = _data["gpn"];
            this.gui = _data["gui"];
            this.serviceLine = _data["serviceLine"] ? ServiceLine.fromJS(_data["serviceLine"]) : <any>undefined;
            this.subServiceLine = _data["subServiceLine"] ? SubServiceLine.fromJS(_data["subServiceLine"]) : <any>undefined;
            this.status = _data["status"] ? LookupField.fromJS(_data["status"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdByEmployee = _data["createdByEmployee"] ? Employee.fromJS(_data["createdByEmployee"]) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedByEmployee = _data["modifiedByEmployee"] ? Employee.fromJS(_data["modifiedByEmployee"]) : <any>undefined;
            this.acceptedDate = _data["acceptedDate"] ? new Date(_data["acceptedDate"].toString()) : <any>undefined;
            this.declinedDate = _data["declinedDate"] ? new Date(_data["declinedDate"].toString()) : <any>undefined;
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : <any>undefined;
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdByRoleId = _data["createdByRoleId"];
            this.exitTypeId = _data["exitTypeId"];
            this.exitType = _data["exitType"] ? LookupField.fromJS(_data["exitType"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.jobName = _data["jobName"] ? LookupField.fromJS(_data["jobName"]) : <any>undefined;
            this.lpn = _data["lpn"];
            this.officeLocation = _data["officeLocation"] ? LookupField.fromJS(_data["officeLocation"]) : <any>undefined;
            this.nationality = _data["nationality"] ? LookupField.fromJS(_data["nationality"]) : <any>undefined;
            this.offboardingMember = _data["offboardingMember"] ? Employee.fromJS(_data["offboardingMember"]) : <any>undefined;
            this.itAssetDetails = _data["itAssetDetails"];
            this.pqDetails = _data["pqDetails"];
            this.lmsBalance = _data["lmsBalance"];
            this.amexCardBalance = _data["amexCardBalance"];
            this.leadRating = _data["leadRating"];
            this.hrccComment = _data["hrccComment"];
            this.financeTeamComment = _data["financeTeamComment"];
            this.visaApproverComment = _data["visaApproverComment"];
            this.guidanceMailComment = _data["guidanceMailComment"];
            this.arcAndCanvasComment = _data["arcAndCanvasComment"];
            this.exitSubType = _data["exitSubType"] ? LookupField.fromJS(_data["exitSubType"]) : <any>undefined;
            this.shortNotice = _data["shortNotice"] ? LookupField.fromJS(_data["shortNotice"]) : <any>undefined;
            this.ticketNumber = _data["ticketNumber"];
            this.itTeam = _data["itTeam"] ? TeamInfo.fromJS(_data["itTeam"]) : <any>undefined;
            this.expense = _data["expense"] ? TeamInfo.fromJS(_data["expense"]) : <any>undefined;
            this.lms = _data["lms"] ? TeamInfo.fromJS(_data["lms"]) : <any>undefined;
            this.amex = _data["amex"] ? TeamInfo.fromJS(_data["amex"]) : <any>undefined;
            this.leadsTeam = _data["leadsTeam"] ? TeamInfo.fromJS(_data["leadsTeam"]) : <any>undefined;
            this.arcAndCanvas = _data["arcAndCanvas"] ? TeamInfo.fromJS(_data["arcAndCanvas"]) : <any>undefined;
            this.financeTeam = _data["financeTeam"] ? TeamInfo.fromJS(_data["financeTeam"]) : <any>undefined;
            this.visaApprover = _data["visaApprover"] ? TeamInfo.fromJS(_data["visaApprover"]) : <any>undefined;
            this.guidanceMail = _data["guidanceMail"] ? TeamInfo.fromJS(_data["guidanceMail"]) : <any>undefined;
            this.hrcc = _data["hrcc"] ? TeamInfo.fromJS(_data["hrcc"]) : <any>undefined;
            this.nationalityType = _data["nationalityType"] ? LookupField.fromJS(_data["nationalityType"]) : <any>undefined;
            this.nationalityTypeId = _data["nationalityTypeId"] ? LookupField.fromJS(_data["nationalityTypeId"]) : <any>undefined;
            this.notes = _data["notes"];
            this.createdIn = _data["createdIn"];
            this.legalEntity = _data["legalEntity"] ? OfficeEntity.fromJS(_data["legalEntity"]) : <any>undefined;
            this.allTeamUpdated = _data["allTeamUpdated"];
            this.genderCode = _data["genderCode"] ? LookupField.fromJS(_data["genderCode"]) : <any>undefined;
            this.company = _data["company"] ? Companies.fromJS(_data["company"]) : <any>undefined;
            this.department = _data["department"] ? LookupField.fromJS(_data["department"]) : <any>undefined;
            this.competency = _data["competency"] ? SMU.fromJS(_data["competency"]) : <any>undefined;
            this.speciality = _data["speciality"] ? Speciality.fromJS(_data["speciality"]) : <any>undefined;
            this.industryData = _data["industryData"] ? LookupField.fromJS(_data["industryData"]) : <any>undefined;
            this.employeeCategory = _data["employeeCategory"] ? ExitJobCategory.fromJS(_data["employeeCategory"]) : <any>undefined;
            this.seniorityDate = _data["seniorityDate"] ? new Date(_data["seniorityDate"].toString()) : <any>undefined;
            this.counsellor = _data["counsellor"] ? AdUser.fromJS(_data["counsellor"]) : <any>undefined;
            this.counsellorId = _data["counsellorId"];
            this.exitReason = _data["exitReason"] ? LookupField.fromJS(_data["exitReason"]) : <any>undefined;
            this.volInvolIndicator = _data["volInvolIndicator"];
            this.pocTalent = _data["pocTalent"] ? AdUser.fromJS(_data["pocTalent"]) : <any>undefined;
            this.exGratiaEYSettlement = _data["exGratiaEYSettlement"] ? LookupField.fromJS(_data["exGratiaEYSettlement"]) : <any>undefined;
            this.exGratiaAmount = _data["exGratiaAmount"];
            this.exGratiaCurrency = _data["exGratiaCurrency"];
            this.applicationOfNotice = _data["applicationOfNotice"] ? LookupField.fromJS(_data["applicationOfNotice"]) : <any>undefined;
            this.durationOfNoticeInDays = _data["durationOfNoticeInDays"];
            this.dateTerminationCommunicated = _data["dateTerminationCommunicated"] ? new Date(_data["dateTerminationCommunicated"].toString()) : <any>undefined;
            this.paymentInLieu = _data["paymentInLieu"] ? LookupField.fromJS(_data["paymentInLieu"]) : <any>undefined;
            this.paymentInLieuAmount = _data["paymentInLieuAmount"];
            this.paymentInLieuCurrency = _data["paymentInLieuCurrency"];
            this.lastDateOfEmployment = _data["lastDateOfEmployment"] ? new Date(_data["lastDateOfEmployment"].toString()) : <any>undefined;
            this.lastWorkingDate = _data["lastWorkingDate"] ? new Date(_data["lastWorkingDate"].toString()) : <any>undefined;
            this.gardenLeaveStartDate = _data["gardenLeaveStartDate"] ? new Date(_data["gardenLeaveStartDate"].toString()) : <any>undefined;
            this.gardenLeaveEndDate = _data["gardenLeaveEndDate"] ? new Date(_data["gardenLeaveEndDate"].toString()) : <any>undefined;
            this.letterToBeUsed = _data["letterToBeUsed"] ? LookupField.fromJS(_data["letterToBeUsed"]) : <any>undefined;
            this.reasonOfSeperation = _data["reasonOfSeperation"] ? LookupField.fromJS(_data["reasonOfSeperation"]) : <any>undefined;
            this.exitEmployee = _data["exitEmployee"] ? Employee.fromJS(_data["exitEmployee"]) : <any>undefined;
            this.employeeSearchTerm = _data["employeeSearchTerm"];
            this.isExitDateMailSent = _data["isExitDateMailSent"];
            this.isWithdrawalMailSent = _data["isWithdrawalMailSent"];
            this.queueDataSyncDate = _data["queueDataSyncDate"] ? new Date(_data["queueDataSyncDate"].toString()) : <any>undefined;
            this.previousDateOfExit = _data["previousDateOfExit"] ? new Date(_data["previousDateOfExit"].toString()) : <any>undefined;
            this.isIndividualHasAmexCard = _data["isIndividualHasAmexCard"] ? LookupField.fromJS(_data["isIndividualHasAmexCard"]) : <any>undefined;
            this.amexComment = _data["amexComment"];
            this.emailAddress = _data["emailAddress"];
            this.emailID = _data["emailID"];
            this.selected = _data["selected"];
            this.docPrefix = _data["docPrefix"];
            this.cancellationVisa = _data["cancellationVisa"] ? LookupField.fromJS(_data["cancellationVisa"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        data["dateOfExit"] = this.dateOfExit ? this.dateOfExit.toISOString() : <any>undefined;
        data["exitDateChanged"] = this.exitDateChanged ? this.exitDateChanged.toJSON() : <any>undefined;
        data["miCancellationDate"] = this.miCancellationDate ? this.miCancellationDate.toISOString() : <any>undefined;
        data["gpn"] = this.gpn;
        data["gui"] = this.gui;
        data["serviceLine"] = this.serviceLine ? this.serviceLine.toJSON() : <any>undefined;
        data["subServiceLine"] = this.subServiceLine ? this.subServiceLine.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdByEmployee"] = this.createdByEmployee ? this.createdByEmployee.toJSON() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedByEmployee"] = this.modifiedByEmployee ? this.modifiedByEmployee.toJSON() : <any>undefined;
        data["acceptedDate"] = this.acceptedDate ? this.acceptedDate.toISOString() : <any>undefined;
        data["declinedDate"] = this.declinedDate ? this.declinedDate.toISOString() : <any>undefined;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdByRoleId"] = this.createdByRoleId;
        data["exitTypeId"] = this.exitTypeId;
        data["exitType"] = this.exitType ? this.exitType.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["jobName"] = this.jobName ? this.jobName.toJSON() : <any>undefined;
        data["lpn"] = this.lpn;
        data["officeLocation"] = this.officeLocation ? this.officeLocation.toJSON() : <any>undefined;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["offboardingMember"] = this.offboardingMember ? this.offboardingMember.toJSON() : <any>undefined;
        data["itAssetDetails"] = this.itAssetDetails;
        data["pqDetails"] = this.pqDetails;
        data["lmsBalance"] = this.lmsBalance;
        data["amexCardBalance"] = this.amexCardBalance;
        data["leadRating"] = this.leadRating;
        data["hrccComment"] = this.hrccComment;
        data["financeTeamComment"] = this.financeTeamComment;
        data["visaApproverComment"] = this.visaApproverComment;
        data["guidanceMailComment"] = this.guidanceMailComment;
        data["arcAndCanvasComment"] = this.arcAndCanvasComment;
        data["exitSubType"] = this.exitSubType ? this.exitSubType.toJSON() : <any>undefined;
        data["shortNotice"] = this.shortNotice ? this.shortNotice.toJSON() : <any>undefined;
        data["ticketNumber"] = this.ticketNumber;
        data["itTeam"] = this.itTeam ? this.itTeam.toJSON() : <any>undefined;
        data["expense"] = this.expense ? this.expense.toJSON() : <any>undefined;
        data["lms"] = this.lms ? this.lms.toJSON() : <any>undefined;
        data["amex"] = this.amex ? this.amex.toJSON() : <any>undefined;
        data["leadsTeam"] = this.leadsTeam ? this.leadsTeam.toJSON() : <any>undefined;
        data["arcAndCanvas"] = this.arcAndCanvas ? this.arcAndCanvas.toJSON() : <any>undefined;
        data["financeTeam"] = this.financeTeam ? this.financeTeam.toJSON() : <any>undefined;
        data["visaApprover"] = this.visaApprover ? this.visaApprover.toJSON() : <any>undefined;
        data["guidanceMail"] = this.guidanceMail ? this.guidanceMail.toJSON() : <any>undefined;
        data["hrcc"] = this.hrcc ? this.hrcc.toJSON() : <any>undefined;
        data["nationalityType"] = this.nationalityType ? this.nationalityType.toJSON() : <any>undefined;
        data["nationalityTypeId"] = this.nationalityTypeId ? this.nationalityTypeId.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["createdIn"] = this.createdIn;
        data["legalEntity"] = this.legalEntity ? this.legalEntity.toJSON() : <any>undefined;
        data["allTeamUpdated"] = this.allTeamUpdated;
        data["genderCode"] = this.genderCode ? this.genderCode.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["competency"] = this.competency ? this.competency.toJSON() : <any>undefined;
        data["speciality"] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        data["industryData"] = this.industryData ? this.industryData.toJSON() : <any>undefined;
        data["employeeCategory"] = this.employeeCategory ? this.employeeCategory.toJSON() : <any>undefined;
        data["seniorityDate"] = this.seniorityDate ? this.seniorityDate.toISOString() : <any>undefined;
        data["counsellor"] = this.counsellor ? this.counsellor.toJSON() : <any>undefined;
        data["counsellorId"] = this.counsellorId;
        data["exitReason"] = this.exitReason ? this.exitReason.toJSON() : <any>undefined;
        data["volInvolIndicator"] = this.volInvolIndicator;
        data["pocTalent"] = this.pocTalent ? this.pocTalent.toJSON() : <any>undefined;
        data["exGratiaEYSettlement"] = this.exGratiaEYSettlement ? this.exGratiaEYSettlement.toJSON() : <any>undefined;
        data["exGratiaAmount"] = this.exGratiaAmount;
        data["exGratiaCurrency"] = this.exGratiaCurrency;
        data["applicationOfNotice"] = this.applicationOfNotice ? this.applicationOfNotice.toJSON() : <any>undefined;
        data["durationOfNoticeInDays"] = this.durationOfNoticeInDays;
        data["dateTerminationCommunicated"] = this.dateTerminationCommunicated ? this.dateTerminationCommunicated.toISOString() : <any>undefined;
        data["paymentInLieu"] = this.paymentInLieu ? this.paymentInLieu.toJSON() : <any>undefined;
        data["paymentInLieuAmount"] = this.paymentInLieuAmount;
        data["paymentInLieuCurrency"] = this.paymentInLieuCurrency;
        data["lastDateOfEmployment"] = this.lastDateOfEmployment ? this.lastDateOfEmployment.toISOString() : <any>undefined;
        data["lastWorkingDate"] = this.lastWorkingDate ? this.lastWorkingDate.toISOString() : <any>undefined;
        data["gardenLeaveStartDate"] = this.gardenLeaveStartDate ? this.gardenLeaveStartDate.toISOString() : <any>undefined;
        data["gardenLeaveEndDate"] = this.gardenLeaveEndDate ? this.gardenLeaveEndDate.toISOString() : <any>undefined;
        data["letterToBeUsed"] = this.letterToBeUsed ? this.letterToBeUsed.toJSON() : <any>undefined;
        data["reasonOfSeperation"] = this.reasonOfSeperation ? this.reasonOfSeperation.toJSON() : <any>undefined;
        data["exitEmployee"] = this.exitEmployee ? this.exitEmployee.toJSON() : <any>undefined;
        data["employeeSearchTerm"] = this.employeeSearchTerm;
        data["isExitDateMailSent"] = this.isExitDateMailSent;
        data["isWithdrawalMailSent"] = this.isWithdrawalMailSent;
        data["queueDataSyncDate"] = this.queueDataSyncDate ? this.queueDataSyncDate.toISOString() : <any>undefined;
        data["previousDateOfExit"] = this.previousDateOfExit ? this.previousDateOfExit.toISOString() : <any>undefined;
        data["isIndividualHasAmexCard"] = this.isIndividualHasAmexCard ? this.isIndividualHasAmexCard.toJSON() : <any>undefined;
        data["amexComment"] = this.amexComment;
        data["emailAddress"] = this.emailAddress;
        data["emailID"] = this.emailID;
        data["selected"] = this.selected;
        data["docPrefix"] = this.docPrefix;
        data["cancellationVisa"] = this.cancellationVisa ? this.cancellationVisa.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExitRequest {
    id?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    job?: RankGrade | undefined;
    dateOfExit?: Date | undefined;
    exitDateChanged?: LookupField | undefined;
    miCancellationDate?: Date | undefined;
    gpn?: string | undefined;
    gui?: string | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    status?: LookupField | undefined;
    createdBy?: number | undefined;
    createdByEmployee?: Employee | undefined;
    modifiedBy?: number | undefined;
    modifiedByEmployee?: Employee | undefined;
    acceptedDate?: Date | undefined;
    declinedDate?: Date | undefined;
    submissionDate?: Date | undefined;
    completionDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    createdDate?: Date | undefined;
    createdByRoleId?: number | undefined;
    exitTypeId?: number | undefined;
    exitType?: LookupField | undefined;
    isActive?: boolean;
    jobName?: LookupField | undefined;
    lpn?: string | undefined;
    officeLocation?: LookupField | undefined;
    nationality?: LookupField | undefined;
    offboardingMember?: Employee | undefined;
    itAssetDetails?: string | undefined;
    pqDetails?: string | undefined;
    lmsBalance?: string | undefined;
    amexCardBalance?: string | undefined;
    leadRating?: string | undefined;
    hrccComment?: string | undefined;
    financeTeamComment?: string | undefined;
    visaApproverComment?: string | undefined;
    guidanceMailComment?: string | undefined;
    arcAndCanvasComment?: string | undefined;
    exitSubType?: LookupField | undefined;
    shortNotice?: LookupField | undefined;
    ticketNumber?: string | undefined;
    itTeam?: TeamInfo | undefined;
    expense?: TeamInfo | undefined;
    lms?: TeamInfo | undefined;
    amex?: TeamInfo | undefined;
    leadsTeam?: TeamInfo | undefined;
    arcAndCanvas?: TeamInfo | undefined;
    financeTeam?: TeamInfo | undefined;
    visaApprover?: TeamInfo | undefined;
    guidanceMail?: TeamInfo | undefined;
    hrcc?: TeamInfo | undefined;
    nationalityType?: LookupField | undefined;
    nationalityTypeId?: LookupField | undefined;
    notes?: string | undefined;
    createdIn?: string | undefined;
    legalEntity?: OfficeEntity | undefined;
    allTeamUpdated?: boolean;
    genderCode?: LookupField | undefined;
    company?: Companies | undefined;
    department?: LookupField | undefined;
    competency?: SMU | undefined;
    speciality?: Speciality | undefined;
    industryData?: LookupField | undefined;
    employeeCategory?: ExitJobCategory | undefined;
    seniorityDate?: Date | undefined;
    counsellor?: AdUser | undefined;
    counsellorId?: number | undefined;
    exitReason?: LookupField | undefined;
    volInvolIndicator?: string | undefined;
    pocTalent?: AdUser | undefined;
    exGratiaEYSettlement?: LookupField | undefined;
    exGratiaAmount?: number | undefined;
    exGratiaCurrency?: string | undefined;
    applicationOfNotice?: LookupField | undefined;
    durationOfNoticeInDays?: number | undefined;
    dateTerminationCommunicated?: Date | undefined;
    paymentInLieu?: LookupField | undefined;
    paymentInLieuAmount?: number | undefined;
    paymentInLieuCurrency?: string | undefined;
    lastDateOfEmployment?: Date | undefined;
    lastWorkingDate?: Date | undefined;
    gardenLeaveStartDate?: Date | undefined;
    gardenLeaveEndDate?: Date | undefined;
    letterToBeUsed?: LookupField | undefined;
    reasonOfSeperation?: LookupField | undefined;
    exitEmployee?: Employee | undefined;
    employeeSearchTerm?: string | undefined;
    isExitDateMailSent?: boolean | undefined;
    isWithdrawalMailSent?: boolean | undefined;
    queueDataSyncDate?: Date | undefined;
    previousDateOfExit?: Date | undefined;
    isIndividualHasAmexCard?: LookupField | undefined;
    amexComment?: string | undefined;
    emailAddress?: string | undefined;
    emailID?: string | undefined;
    selected?: boolean;
    docPrefix?: string | undefined;
    cancellationVisa?: LookupField | undefined;
}

export class Companies implements ICompanies {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;

    constructor(data?: ICompanies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): Companies {
        data = typeof data === 'object' ? data : {};
        let result = new Companies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICompanies {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
}

export class ExitJobCategory implements IExitJobCategory {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;

    constructor(data?: IExitJobCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ExitJobCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ExitJobCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IExitJobCategory {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
}

export class CWProfile implements ICWProfile {
    id?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailId?: string | undefined;
    personalemailId?: string | undefined;
    contactNumber?: string | undefined;
    countryCode?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedDateOfExit?: Date | undefined;
    gender?: LookupField | undefined;
    address?: string | undefined;
    nationalityType?: LookupField | undefined;
    nationality?: LookupField | undefined;
    officeLocationCountry?: LookupField | undefined;
    officeLocation?: LookupField | undefined;
    officeLegalEntity?: OfficeEntity | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    ssslId?: number | undefined;
    speciality?: Speciality | undefined;
    recruiter?: Employee | undefined;
    hiringManagerId?: number | undefined;
    hiringManagerData?: AdUser | undefined;
    gui?: string | undefined;
    job?: RankGrade | undefined;
    hireType?: LookupField | undefined;
    contractDuration?: number | undefined;
    requestor?: Employee | undefined;
    isTimesheetRequired?: LookupField | undefined;
    isLOIndutionRequired?: LookupField | undefined;
    isEYLaptopRequired?: LookupField | undefined;
    isVDIAccessRequired?: LookupField | undefined;
    vdiChargeCode?: string | undefined;
    chargeCode?: string | undefined;
    engagementName?: string | undefined;
    engPartnerName?: AdUser | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    isActive?: boolean | undefined;
    status?: LookupField | undefined;
    submissionDate?: Date | undefined;
    itTeam?: TeamInfo | undefined;
    itAssetDetails?: string | undefined;
    industrySector?: Sector | undefined;
    previousUpdatedEndDate?: Date | undefined;
    supplierName?: string | undefined;
    engManagerName?: AdUser | undefined;
    engManagerId?: number | undefined;
    engPartnerId?: number | undefined;
    extendedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    compltedDate?: Date | undefined;

    constructor(data?: ICWProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.emailId = _data["emailId"];
            this.personalemailId = _data["personalemailId"];
            this.contactNumber = _data["contactNumber"];
            this.countryCode = _data["countryCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedDateOfExit = _data["updatedDateOfExit"] ? new Date(_data["updatedDateOfExit"].toString()) : <any>undefined;
            this.gender = _data["gender"] ? LookupField.fromJS(_data["gender"]) : <any>undefined;
            this.address = _data["address"];
            this.nationalityType = _data["nationalityType"] ? LookupField.fromJS(_data["nationalityType"]) : <any>undefined;
            this.nationality = _data["nationality"] ? LookupField.fromJS(_data["nationality"]) : <any>undefined;
            this.officeLocationCountry = _data["officeLocationCountry"] ? LookupField.fromJS(_data["officeLocationCountry"]) : <any>undefined;
            this.officeLocation = _data["officeLocation"] ? LookupField.fromJS(_data["officeLocation"]) : <any>undefined;
            this.officeLegalEntity = _data["officeLegalEntity"] ? OfficeEntity.fromJS(_data["officeLegalEntity"]) : <any>undefined;
            this.serviceLine = _data["serviceLine"] ? ServiceLine.fromJS(_data["serviceLine"]) : <any>undefined;
            this.subServiceLine = _data["subServiceLine"] ? SubServiceLine.fromJS(_data["subServiceLine"]) : <any>undefined;
            this.ssslId = _data["ssslId"];
            this.speciality = _data["speciality"] ? Speciality.fromJS(_data["speciality"]) : <any>undefined;
            this.recruiter = _data["recruiter"] ? Employee.fromJS(_data["recruiter"]) : <any>undefined;
            this.hiringManagerId = _data["hiringManagerId"];
            this.hiringManagerData = _data["hiringManagerData"] ? AdUser.fromJS(_data["hiringManagerData"]) : <any>undefined;
            this.gui = _data["gui"];
            this.job = _data["job"] ? RankGrade.fromJS(_data["job"]) : <any>undefined;
            this.hireType = _data["hireType"] ? LookupField.fromJS(_data["hireType"]) : <any>undefined;
            this.contractDuration = _data["contractDuration"];
            this.requestor = _data["requestor"] ? Employee.fromJS(_data["requestor"]) : <any>undefined;
            this.isTimesheetRequired = _data["isTimesheetRequired"] ? LookupField.fromJS(_data["isTimesheetRequired"]) : <any>undefined;
            this.isLOIndutionRequired = _data["isLOIndutionRequired"] ? LookupField.fromJS(_data["isLOIndutionRequired"]) : <any>undefined;
            this.isEYLaptopRequired = _data["isEYLaptopRequired"] ? LookupField.fromJS(_data["isEYLaptopRequired"]) : <any>undefined;
            this.isVDIAccessRequired = _data["isVDIAccessRequired"] ? LookupField.fromJS(_data["isVDIAccessRequired"]) : <any>undefined;
            this.vdiChargeCode = _data["vdiChargeCode"];
            this.chargeCode = _data["chargeCode"];
            this.engagementName = _data["engagementName"];
            this.engPartnerName = _data["engPartnerName"] ? AdUser.fromJS(_data["engPartnerName"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.isActive = _data["isActive"];
            this.status = _data["status"] ? LookupField.fromJS(_data["status"]) : <any>undefined;
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : <any>undefined;
            this.itTeam = _data["itTeam"] ? TeamInfo.fromJS(_data["itTeam"]) : <any>undefined;
            this.itAssetDetails = _data["itAssetDetails"];
            this.industrySector = _data["industrySector"] ? Sector.fromJS(_data["industrySector"]) : <any>undefined;
            this.previousUpdatedEndDate = _data["previousUpdatedEndDate"] ? new Date(_data["previousUpdatedEndDate"].toString()) : <any>undefined;
            this.supplierName = _data["supplierName"];
            this.engManagerName = _data["engManagerName"] ? AdUser.fromJS(_data["engManagerName"]) : <any>undefined;
            this.engManagerId = _data["engManagerId"];
            this.engPartnerId = _data["engPartnerId"];
            this.extendedDate = _data["extendedDate"] ? new Date(_data["extendedDate"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.compltedDate = _data["compltedDate"] ? new Date(_data["compltedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CWProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CWProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["emailId"] = this.emailId;
        data["personalemailId"] = this.personalemailId;
        data["contactNumber"] = this.contactNumber;
        data["countryCode"] = this.countryCode;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedDateOfExit"] = this.updatedDateOfExit ? this.updatedDateOfExit.toISOString() : <any>undefined;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["nationalityType"] = this.nationalityType ? this.nationalityType.toJSON() : <any>undefined;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["officeLocationCountry"] = this.officeLocationCountry ? this.officeLocationCountry.toJSON() : <any>undefined;
        data["officeLocation"] = this.officeLocation ? this.officeLocation.toJSON() : <any>undefined;
        data["officeLegalEntity"] = this.officeLegalEntity ? this.officeLegalEntity.toJSON() : <any>undefined;
        data["serviceLine"] = this.serviceLine ? this.serviceLine.toJSON() : <any>undefined;
        data["subServiceLine"] = this.subServiceLine ? this.subServiceLine.toJSON() : <any>undefined;
        data["ssslId"] = this.ssslId;
        data["speciality"] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        data["recruiter"] = this.recruiter ? this.recruiter.toJSON() : <any>undefined;
        data["hiringManagerId"] = this.hiringManagerId;
        data["hiringManagerData"] = this.hiringManagerData ? this.hiringManagerData.toJSON() : <any>undefined;
        data["gui"] = this.gui;
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        data["hireType"] = this.hireType ? this.hireType.toJSON() : <any>undefined;
        data["contractDuration"] = this.contractDuration;
        data["requestor"] = this.requestor ? this.requestor.toJSON() : <any>undefined;
        data["isTimesheetRequired"] = this.isTimesheetRequired ? this.isTimesheetRequired.toJSON() : <any>undefined;
        data["isLOIndutionRequired"] = this.isLOIndutionRequired ? this.isLOIndutionRequired.toJSON() : <any>undefined;
        data["isEYLaptopRequired"] = this.isEYLaptopRequired ? this.isEYLaptopRequired.toJSON() : <any>undefined;
        data["isVDIAccessRequired"] = this.isVDIAccessRequired ? this.isVDIAccessRequired.toJSON() : <any>undefined;
        data["vdiChargeCode"] = this.vdiChargeCode;
        data["chargeCode"] = this.chargeCode;
        data["engagementName"] = this.engagementName;
        data["engPartnerName"] = this.engPartnerName ? this.engPartnerName.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["isActive"] = this.isActive;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        data["itTeam"] = this.itTeam ? this.itTeam.toJSON() : <any>undefined;
        data["itAssetDetails"] = this.itAssetDetails;
        data["industrySector"] = this.industrySector ? this.industrySector.toJSON() : <any>undefined;
        data["previousUpdatedEndDate"] = this.previousUpdatedEndDate ? this.previousUpdatedEndDate.toISOString() : <any>undefined;
        data["supplierName"] = this.supplierName;
        data["engManagerName"] = this.engManagerName ? this.engManagerName.toJSON() : <any>undefined;
        data["engManagerId"] = this.engManagerId;
        data["engPartnerId"] = this.engPartnerId;
        data["extendedDate"] = this.extendedDate ? this.extendedDate.toISOString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["compltedDate"] = this.compltedDate ? this.compltedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICWProfile {
    id?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailId?: string | undefined;
    personalemailId?: string | undefined;
    contactNumber?: string | undefined;
    countryCode?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedDateOfExit?: Date | undefined;
    gender?: LookupField | undefined;
    address?: string | undefined;
    nationalityType?: LookupField | undefined;
    nationality?: LookupField | undefined;
    officeLocationCountry?: LookupField | undefined;
    officeLocation?: LookupField | undefined;
    officeLegalEntity?: OfficeEntity | undefined;
    serviceLine?: ServiceLine | undefined;
    subServiceLine?: SubServiceLine | undefined;
    ssslId?: number | undefined;
    speciality?: Speciality | undefined;
    recruiter?: Employee | undefined;
    hiringManagerId?: number | undefined;
    hiringManagerData?: AdUser | undefined;
    gui?: string | undefined;
    job?: RankGrade | undefined;
    hireType?: LookupField | undefined;
    contractDuration?: number | undefined;
    requestor?: Employee | undefined;
    isTimesheetRequired?: LookupField | undefined;
    isLOIndutionRequired?: LookupField | undefined;
    isEYLaptopRequired?: LookupField | undefined;
    isVDIAccessRequired?: LookupField | undefined;
    vdiChargeCode?: string | undefined;
    chargeCode?: string | undefined;
    engagementName?: string | undefined;
    engPartnerName?: AdUser | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    isActive?: boolean | undefined;
    status?: LookupField | undefined;
    submissionDate?: Date | undefined;
    itTeam?: TeamInfo | undefined;
    itAssetDetails?: string | undefined;
    industrySector?: Sector | undefined;
    previousUpdatedEndDate?: Date | undefined;
    supplierName?: string | undefined;
    engManagerName?: AdUser | undefined;
    engManagerId?: number | undefined;
    engPartnerId?: number | undefined;
    extendedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    compltedDate?: Date | undefined;
}

export class SortParameters implements ISortParameters {
    page?: number;
    itemsPerPage?: number;
    sortBy?: string | undefined;
    reverse?: boolean;
    filterParams?: FilterParams | undefined;
    totalRecords?: number;
    firstRecord?: number;
    lastRecord?: number;
    tileRefreshNeeded?: boolean;
    officeLocation?: string | undefined;
    candidateStatuslist?: CandidateStatusCount[] | undefined;

    constructor(data?: ISortParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.itemsPerPage = _data["itemsPerPage"];
            this.sortBy = _data["sortBy"];
            this.reverse = _data["reverse"];
            this.filterParams = _data["filterParams"] ? FilterParams.fromJS(_data["filterParams"]) : <any>undefined;
            this.totalRecords = _data["totalRecords"];
            this.firstRecord = _data["firstRecord"];
            this.lastRecord = _data["lastRecord"];
            this.tileRefreshNeeded = _data["tileRefreshNeeded"];
            this.officeLocation = _data["officeLocation"];
            if (Array.isArray(_data["candidateStatuslist"])) {
                this.candidateStatuslist = [] as any;
                for (let item of _data["candidateStatuslist"])
                    this.candidateStatuslist!.push(CandidateStatusCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SortParameters {
        data = typeof data === 'object' ? data : {};
        let result = new SortParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["itemsPerPage"] = this.itemsPerPage;
        data["sortBy"] = this.sortBy;
        data["reverse"] = this.reverse;
        data["filterParams"] = this.filterParams ? this.filterParams.toJSON() : <any>undefined;
        data["totalRecords"] = this.totalRecords;
        data["firstRecord"] = this.firstRecord;
        data["lastRecord"] = this.lastRecord;
        data["tileRefreshNeeded"] = this.tileRefreshNeeded;
        data["officeLocation"] = this.officeLocation;
        if (Array.isArray(this.candidateStatuslist)) {
            data["candidateStatuslist"] = [];
            for (let item of this.candidateStatuslist)
                data["candidateStatuslist"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISortParameters {
    page?: number;
    itemsPerPage?: number;
    sortBy?: string | undefined;
    reverse?: boolean;
    filterParams?: FilterParams | undefined;
    totalRecords?: number;
    firstRecord?: number;
    lastRecord?: number;
    tileRefreshNeeded?: boolean;
    officeLocation?: string | undefined;
    candidateStatuslist?: CandidateStatusCount[] | undefined;
}

export class FilterParams implements IFilterParams {
    firstName?: string | undefined;
    lastName?: string | undefined;
    servicLineId?: number[] | undefined;
    locationId?: number[] | undefined;
    recruiterId?: number[] | undefined;
    consultantId?: number[] | undefined;
    visaTypeId?: number[] | undefined;
    ptcId?: number[] | undefined;
    pbStatusIds?: number[] | undefined;
    startDates?: Date[] | undefined;
    startDateStatuses?: number[] | undefined;
    subServiceLineIds?: number[] | undefined;
    profileSubmittedDates?: Date[] | undefined;
    immigrationStatus?: number[] | undefined;
    legalEntityId?: number[] | undefined;
    officeLocationId?: number[] | undefined;
    employeeCategoryId?: number[] | undefined;
    searchParameter?: string | undefined;
    nationalityId?: (number | undefined)[] | undefined;
    officeToBeVisitedId?: number[] | undefined;
    pbTypeId?: number[] | undefined;
    hireTypeId?: number[] | undefined;
    transferTypeID?: number[] | undefined;
    immigrationCaseTypeID?: number[] | undefined;
    isWSO?: boolean;
    onTileClick?: boolean;
    statusId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    submissionstartDate?: Date | undefined;
    submissionendDate?: Date | undefined;
    datacount?: number;
    visaCountry?: string | undefined;
    isAllVisa?: boolean;
    exitStatus?: number[] | undefined;
    exitTypeId?: number[] | undefined;
    exitLocations?: number[] | undefined;
    exitServiceLines?: number[] | undefined;
    offboardingMemberId?: number[] | undefined;
    exitDateLowerBound?: Date | undefined;
    exitDateUpperBound?: Date | undefined;
    employeeEmailId?: string | undefined;
    isVendorReport?: boolean;
    countryId?: number[] | undefined;

    constructor(data?: IFilterParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["servicLineId"])) {
                this.servicLineId = [] as any;
                for (let item of _data["servicLineId"])
                    this.servicLineId!.push(item);
            }
            if (Array.isArray(_data["locationId"])) {
                this.locationId = [] as any;
                for (let item of _data["locationId"])
                    this.locationId!.push(item);
            }
            if (Array.isArray(_data["recruiterId"])) {
                this.recruiterId = [] as any;
                for (let item of _data["recruiterId"])
                    this.recruiterId!.push(item);
            }
            if (Array.isArray(_data["consultantId"])) {
                this.consultantId = [] as any;
                for (let item of _data["consultantId"])
                    this.consultantId!.push(item);
            }
            if (Array.isArray(_data["visaTypeId"])) {
                this.visaTypeId = [] as any;
                for (let item of _data["visaTypeId"])
                    this.visaTypeId!.push(item);
            }
            if (Array.isArray(_data["ptcId"])) {
                this.ptcId = [] as any;
                for (let item of _data["ptcId"])
                    this.ptcId!.push(item);
            }
            if (Array.isArray(_data["pbStatusIds"])) {
                this.pbStatusIds = [] as any;
                for (let item of _data["pbStatusIds"])
                    this.pbStatusIds!.push(item);
            }
            if (Array.isArray(_data["startDates"])) {
                this.startDates = [] as any;
                for (let item of _data["startDates"])
                    this.startDates!.push(new Date(item));
            }
            if (Array.isArray(_data["startDateStatuses"])) {
                this.startDateStatuses = [] as any;
                for (let item of _data["startDateStatuses"])
                    this.startDateStatuses!.push(item);
            }
            if (Array.isArray(_data["subServiceLineIds"])) {
                this.subServiceLineIds = [] as any;
                for (let item of _data["subServiceLineIds"])
                    this.subServiceLineIds!.push(item);
            }
            if (Array.isArray(_data["profileSubmittedDates"])) {
                this.profileSubmittedDates = [] as any;
                for (let item of _data["profileSubmittedDates"])
                    this.profileSubmittedDates!.push(new Date(item));
            }
            if (Array.isArray(_data["immigrationStatus"])) {
                this.immigrationStatus = [] as any;
                for (let item of _data["immigrationStatus"])
                    this.immigrationStatus!.push(item);
            }
            if (Array.isArray(_data["legalEntityId"])) {
                this.legalEntityId = [] as any;
                for (let item of _data["legalEntityId"])
                    this.legalEntityId!.push(item);
            }
            if (Array.isArray(_data["officeLocationId"])) {
                this.officeLocationId = [] as any;
                for (let item of _data["officeLocationId"])
                    this.officeLocationId!.push(item);
            }
            if (Array.isArray(_data["employeeCategoryId"])) {
                this.employeeCategoryId = [] as any;
                for (let item of _data["employeeCategoryId"])
                    this.employeeCategoryId!.push(item);
            }
            this.searchParameter = _data["searchParameter"];
            if (Array.isArray(_data["nationalityId"])) {
                this.nationalityId = [] as any;
                for (let item of _data["nationalityId"])
                    this.nationalityId!.push(item);
            }
            if (Array.isArray(_data["officeToBeVisitedId"])) {
                this.officeToBeVisitedId = [] as any;
                for (let item of _data["officeToBeVisitedId"])
                    this.officeToBeVisitedId!.push(item);
            }
            if (Array.isArray(_data["pbTypeId"])) {
                this.pbTypeId = [] as any;
                for (let item of _data["pbTypeId"])
                    this.pbTypeId!.push(item);
            }
            if (Array.isArray(_data["hireTypeId"])) {
                this.hireTypeId = [] as any;
                for (let item of _data["hireTypeId"])
                    this.hireTypeId!.push(item);
            }
            if (Array.isArray(_data["transferTypeID"])) {
                this.transferTypeID = [] as any;
                for (let item of _data["transferTypeID"])
                    this.transferTypeID!.push(item);
            }
            if (Array.isArray(_data["immigrationCaseTypeID"])) {
                this.immigrationCaseTypeID = [] as any;
                for (let item of _data["immigrationCaseTypeID"])
                    this.immigrationCaseTypeID!.push(item);
            }
            this.isWSO = _data["isWSO"];
            this.onTileClick = _data["onTileClick"];
            this.statusId = _data["statusId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.submissionstartDate = _data["submissionstartDate"] ? new Date(_data["submissionstartDate"].toString()) : <any>undefined;
            this.submissionendDate = _data["submissionendDate"] ? new Date(_data["submissionendDate"].toString()) : <any>undefined;
            this.datacount = _data["datacount"];
            this.visaCountry = _data["visaCountry"];
            this.isAllVisa = _data["isAllVisa"];
            if (Array.isArray(_data["exitStatus"])) {
                this.exitStatus = [] as any;
                for (let item of _data["exitStatus"])
                    this.exitStatus!.push(item);
            }
            if (Array.isArray(_data["exitTypeId"])) {
                this.exitTypeId = [] as any;
                for (let item of _data["exitTypeId"])
                    this.exitTypeId!.push(item);
            }
            if (Array.isArray(_data["exitLocations"])) {
                this.exitLocations = [] as any;
                for (let item of _data["exitLocations"])
                    this.exitLocations!.push(item);
            }
            if (Array.isArray(_data["exitServiceLines"])) {
                this.exitServiceLines = [] as any;
                for (let item of _data["exitServiceLines"])
                    this.exitServiceLines!.push(item);
            }
            if (Array.isArray(_data["offboardingMemberId"])) {
                this.offboardingMemberId = [] as any;
                for (let item of _data["offboardingMemberId"])
                    this.offboardingMemberId!.push(item);
            }
            this.exitDateLowerBound = _data["exitDateLowerBound"] ? new Date(_data["exitDateLowerBound"].toString()) : <any>undefined;
            this.exitDateUpperBound = _data["exitDateUpperBound"] ? new Date(_data["exitDateUpperBound"].toString()) : <any>undefined;
            this.employeeEmailId = _data["employeeEmailId"];
            this.isVendorReport = _data["isVendorReport"];
            if (Array.isArray(_data["countryId"])) {
                this.countryId = [] as any;
                for (let item of _data["countryId"])
                    this.countryId!.push(item);
            }
        }
    }

    static fromJS(data: any): FilterParams {
        data = typeof data === 'object' ? data : {};
        let result = new FilterParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.servicLineId)) {
            data["servicLineId"] = [];
            for (let item of this.servicLineId)
                data["servicLineId"].push(item);
        }
        if (Array.isArray(this.locationId)) {
            data["locationId"] = [];
            for (let item of this.locationId)
                data["locationId"].push(item);
        }
        if (Array.isArray(this.recruiterId)) {
            data["recruiterId"] = [];
            for (let item of this.recruiterId)
                data["recruiterId"].push(item);
        }
        if (Array.isArray(this.consultantId)) {
            data["consultantId"] = [];
            for (let item of this.consultantId)
                data["consultantId"].push(item);
        }
        if (Array.isArray(this.visaTypeId)) {
            data["visaTypeId"] = [];
            for (let item of this.visaTypeId)
                data["visaTypeId"].push(item);
        }
        if (Array.isArray(this.ptcId)) {
            data["ptcId"] = [];
            for (let item of this.ptcId)
                data["ptcId"].push(item);
        }
        if (Array.isArray(this.pbStatusIds)) {
            data["pbStatusIds"] = [];
            for (let item of this.pbStatusIds)
                data["pbStatusIds"].push(item);
        }
        if (Array.isArray(this.startDates)) {
            data["startDates"] = [];
            for (let item of this.startDates)
                data["startDates"].push(item.toISOString());
        }
        if (Array.isArray(this.startDateStatuses)) {
            data["startDateStatuses"] = [];
            for (let item of this.startDateStatuses)
                data["startDateStatuses"].push(item);
        }
        if (Array.isArray(this.subServiceLineIds)) {
            data["subServiceLineIds"] = [];
            for (let item of this.subServiceLineIds)
                data["subServiceLineIds"].push(item);
        }
        if (Array.isArray(this.profileSubmittedDates)) {
            data["profileSubmittedDates"] = [];
            for (let item of this.profileSubmittedDates)
                data["profileSubmittedDates"].push(item.toISOString());
        }
        if (Array.isArray(this.immigrationStatus)) {
            data["immigrationStatus"] = [];
            for (let item of this.immigrationStatus)
                data["immigrationStatus"].push(item);
        }
        if (Array.isArray(this.legalEntityId)) {
            data["legalEntityId"] = [];
            for (let item of this.legalEntityId)
                data["legalEntityId"].push(item);
        }
        if (Array.isArray(this.officeLocationId)) {
            data["officeLocationId"] = [];
            for (let item of this.officeLocationId)
                data["officeLocationId"].push(item);
        }
        if (Array.isArray(this.employeeCategoryId)) {
            data["employeeCategoryId"] = [];
            for (let item of this.employeeCategoryId)
                data["employeeCategoryId"].push(item);
        }
        data["searchParameter"] = this.searchParameter;
        if (Array.isArray(this.nationalityId)) {
            data["nationalityId"] = [];
            for (let item of this.nationalityId)
                data["nationalityId"].push(item);
        }
        if (Array.isArray(this.officeToBeVisitedId)) {
            data["officeToBeVisitedId"] = [];
            for (let item of this.officeToBeVisitedId)
                data["officeToBeVisitedId"].push(item);
        }
        if (Array.isArray(this.pbTypeId)) {
            data["pbTypeId"] = [];
            for (let item of this.pbTypeId)
                data["pbTypeId"].push(item);
        }
        if (Array.isArray(this.hireTypeId)) {
            data["hireTypeId"] = [];
            for (let item of this.hireTypeId)
                data["hireTypeId"].push(item);
        }
        if (Array.isArray(this.transferTypeID)) {
            data["transferTypeID"] = [];
            for (let item of this.transferTypeID)
                data["transferTypeID"].push(item);
        }
        if (Array.isArray(this.immigrationCaseTypeID)) {
            data["immigrationCaseTypeID"] = [];
            for (let item of this.immigrationCaseTypeID)
                data["immigrationCaseTypeID"].push(item);
        }
        data["isWSO"] = this.isWSO;
        data["onTileClick"] = this.onTileClick;
        data["statusId"] = this.statusId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["submissionstartDate"] = this.submissionstartDate ? this.submissionstartDate.toISOString() : <any>undefined;
        data["submissionendDate"] = this.submissionendDate ? this.submissionendDate.toISOString() : <any>undefined;
        data["datacount"] = this.datacount;
        data["visaCountry"] = this.visaCountry;
        data["isAllVisa"] = this.isAllVisa;
        if (Array.isArray(this.exitStatus)) {
            data["exitStatus"] = [];
            for (let item of this.exitStatus)
                data["exitStatus"].push(item);
        }
        if (Array.isArray(this.exitTypeId)) {
            data["exitTypeId"] = [];
            for (let item of this.exitTypeId)
                data["exitTypeId"].push(item);
        }
        if (Array.isArray(this.exitLocations)) {
            data["exitLocations"] = [];
            for (let item of this.exitLocations)
                data["exitLocations"].push(item);
        }
        if (Array.isArray(this.exitServiceLines)) {
            data["exitServiceLines"] = [];
            for (let item of this.exitServiceLines)
                data["exitServiceLines"].push(item);
        }
        if (Array.isArray(this.offboardingMemberId)) {
            data["offboardingMemberId"] = [];
            for (let item of this.offboardingMemberId)
                data["offboardingMemberId"].push(item);
        }
        data["exitDateLowerBound"] = this.exitDateLowerBound ? this.exitDateLowerBound.toISOString() : <any>undefined;
        data["exitDateUpperBound"] = this.exitDateUpperBound ? this.exitDateUpperBound.toISOString() : <any>undefined;
        data["employeeEmailId"] = this.employeeEmailId;
        data["isVendorReport"] = this.isVendorReport;
        if (Array.isArray(this.countryId)) {
            data["countryId"] = [];
            for (let item of this.countryId)
                data["countryId"].push(item);
        }
        return data;
    }
}

export interface IFilterParams {
    firstName?: string | undefined;
    lastName?: string | undefined;
    servicLineId?: number[] | undefined;
    locationId?: number[] | undefined;
    recruiterId?: number[] | undefined;
    consultantId?: number[] | undefined;
    visaTypeId?: number[] | undefined;
    ptcId?: number[] | undefined;
    pbStatusIds?: number[] | undefined;
    startDates?: Date[] | undefined;
    startDateStatuses?: number[] | undefined;
    subServiceLineIds?: number[] | undefined;
    profileSubmittedDates?: Date[] | undefined;
    immigrationStatus?: number[] | undefined;
    legalEntityId?: number[] | undefined;
    officeLocationId?: number[] | undefined;
    employeeCategoryId?: number[] | undefined;
    searchParameter?: string | undefined;
    nationalityId?: (number | undefined)[] | undefined;
    officeToBeVisitedId?: number[] | undefined;
    pbTypeId?: number[] | undefined;
    hireTypeId?: number[] | undefined;
    transferTypeID?: number[] | undefined;
    immigrationCaseTypeID?: number[] | undefined;
    isWSO?: boolean;
    onTileClick?: boolean;
    statusId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    submissionstartDate?: Date | undefined;
    submissionendDate?: Date | undefined;
    datacount?: number;
    visaCountry?: string | undefined;
    isAllVisa?: boolean;
    exitStatus?: number[] | undefined;
    exitTypeId?: number[] | undefined;
    exitLocations?: number[] | undefined;
    exitServiceLines?: number[] | undefined;
    offboardingMemberId?: number[] | undefined;
    exitDateLowerBound?: Date | undefined;
    exitDateUpperBound?: Date | undefined;
    employeeEmailId?: string | undefined;
    isVendorReport?: boolean;
    countryId?: number[] | undefined;
}

export class CandidateStatusCount implements ICandidateStatusCount {
    statusId?: number | undefined;
    status?: string | undefined;
    count?: number;
    selected?: boolean;

    constructor(data?: ICandidateStatusCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.count = _data["count"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): CandidateStatusCount {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateStatusCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["count"] = this.count;
        data["selected"] = this.selected;
        return data;
    }
}

export interface ICandidateStatusCount {
    statusId?: number | undefined;
    status?: string | undefined;
    count?: number;
    selected?: boolean;
}

export class EosApiException implements IEosApiException {
    type?: string | undefined;
    errorCode?: number;
    errorInfo?: string | undefined;

    constructor(data?: IEosApiException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.errorCode = _data["errorCode"];
            this.errorInfo = _data["errorInfo"];
        }
    }

    static fromJS(data: any): EosApiException {
        data = typeof data === 'object' ? data : {};
        let result = new EosApiException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["errorCode"] = this.errorCode;
        data["errorInfo"] = this.errorInfo;
        return data;
    }
}

export interface IEosApiException {
    type?: string | undefined;
    errorCode?: number;
    errorInfo?: string | undefined;
}

export class OperationResultOfInteger implements IOperationResultOfInteger {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: number;
    errorCode?: number;

    constructor(data?: IOperationResultOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfInteger {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: number;
    errorCode?: number;
}

export class OperationResultOfExitRequest implements IOperationResultOfExitRequest {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ExitRequest | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfExitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? ExitRequest.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfExitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfExitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfExitRequest {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ExitRequest | undefined;
    errorCode?: number;
}

export class ExitCandidate implements IExitCandidate {
    profile?: ExitRequest | undefined;
    exitType?: string | undefined;
    comment?: ExitComment | undefined;
    roleName?: string | undefined;
    roleId?: string | undefined;

    constructor(data?: IExitCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"] ? ExitRequest.fromJS(_data["profile"]) : <any>undefined;
            this.exitType = _data["exitType"];
            this.comment = _data["comment"] ? ExitComment.fromJS(_data["comment"]) : <any>undefined;
            this.roleName = _data["roleName"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): ExitCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new ExitCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["exitType"] = this.exitType;
        data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
        data["roleName"] = this.roleName;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IExitCandidate {
    profile?: ExitRequest | undefined;
    exitType?: string | undefined;
    comment?: ExitComment | undefined;
    roleName?: string | undefined;
    roleId?: string | undefined;
}

export class ExitComment implements IExitComment {
    id?: number;
    comment?: string | undefined;
    exitRequestId?: number | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    commentType?: ExitCommentTypes;
    statusId?: number | undefined;
    createdDate?: Date;
    modifiedDate?: Date | undefined;

    constructor(data?: IExitComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.exitRequestId = _data["exitRequestId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.commentType = _data["commentType"];
            this.statusId = _data["statusId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExitComment {
        data = typeof data === 'object' ? data : {};
        let result = new ExitComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["exitRequestId"] = this.exitRequestId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["commentType"] = this.commentType;
        data["statusId"] = this.statusId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExitComment {
    id?: number;
    comment?: string | undefined;
    exitRequestId?: number | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    commentType?: ExitCommentTypes;
    statusId?: number | undefined;
    createdDate?: Date;
    modifiedDate?: Date | undefined;
}

export enum ExitCommentTypes {
    Accept = 0,
    Decline = 1,
    General = 2,
    Notes = 3,
    Submission = 4,
}

export class DocumentType implements IDocumentType {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    value?: string | undefined;
    checks?: string | undefined;
    additionalReqId?: number | undefined;

    constructor(data?: IDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNameId = _data["docNameId"];
            this.docNameDisplayText = _data["docNameDisplayText"];
            this.docTypeId = _data["docTypeId"];
            this.docTypeDisplayText = _data["docTypeDisplayText"];
            this.isMandatory = _data["isMandatory"];
            this.mandatoryType = _data["mandatoryType"];
            this.value = _data["value"];
            this.checks = _data["checks"];
            this.additionalReqId = _data["additionalReqId"];
        }
    }

    static fromJS(data: any): DocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNameId"] = this.docNameId;
        data["docNameDisplayText"] = this.docNameDisplayText;
        data["docTypeId"] = this.docTypeId;
        data["docTypeDisplayText"] = this.docTypeDisplayText;
        data["isMandatory"] = this.isMandatory;
        data["mandatoryType"] = this.mandatoryType;
        data["value"] = this.value;
        data["checks"] = this.checks;
        data["additionalReqId"] = this.additionalReqId;
        return data;
    }
}

export interface IDocumentType {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    value?: string | undefined;
    checks?: string | undefined;
    additionalReqId?: number | undefined;
}

export class OperationResultOfExitDocument implements IOperationResultOfExitDocument {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ExitDocument | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfExitDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? ExitDocument.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfExitDocument {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfExitDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfExitDocument {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ExitDocument | undefined;
    errorCode?: number;
}

export class ExitDocument implements IExitDocument {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    exitRequestId?: number;
    createdById?: number;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;
    type?: number;
    disabled?: boolean;

    constructor(data?: IExitDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? LookupField.fromJS(_data["documentType"]) : <any>undefined;
            this.exitRequestId = _data["exitRequestId"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.documentName = _data["documentName"];
            this.description = _data["description"];
            this.documentNameId = _data["documentNameId"];
            this.type = _data["type"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): ExitDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ExitDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["exitRequestId"] = this.exitRequestId;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["documentName"] = this.documentName;
        data["description"] = this.description;
        data["documentNameId"] = this.documentNameId;
        data["type"] = this.type;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IExitDocument {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    exitRequestId?: number;
    createdById?: number;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;
    type?: number;
    disabled?: boolean;
}

export class RequestActivities implements IRequestActivities {
    activities?: ExitRequestActivity[] | undefined;
    profileStatus?: number | undefined;

    constructor(data?: IRequestActivities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(ExitRequestActivity.fromJS(item));
            }
            this.profileStatus = _data["profileStatus"];
        }
    }

    static fromJS(data: any): RequestActivities {
        data = typeof data === 'object' ? data : {};
        let result = new RequestActivities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["profileStatus"] = this.profileStatus;
        return data;
    }
}

export interface IRequestActivities {
    activities?: ExitRequestActivity[] | undefined;
    profileStatus?: number | undefined;
}

export class ExitRequestActivity implements IExitRequestActivity {
    id?: number;
    header?: string | undefined;
    description?: string | undefined;
    exitTypeId?: number;
    order?: number;
    filterKeyId?: number;
    additionalInfo?: string | undefined;
    additionalInfoObject?: AdditionalInfo | undefined;
    activityType?: ActivityTypes;
    status?: ActivityStatus;
    isActive?: boolean;
    activityCompletedDate?: Date | undefined;
    exitRequestId?: number;
    activityId?: number;
    previousStatus?: ActivityStatus | undefined;
    completedDate?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    isReset?: boolean;
    initiatedDate?: Date | undefined;
    modifiedByName?: string | undefined;
    additionalInfoObj?: AdditionalInfoObject | undefined;
    modifiedDate?: Date | undefined;

    constructor(data?: IExitRequestActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.header = _data["header"];
            this.description = _data["description"];
            this.exitTypeId = _data["exitTypeId"];
            this.order = _data["order"];
            this.filterKeyId = _data["filterKeyId"];
            this.additionalInfo = _data["additionalInfo"];
            this.additionalInfoObject = _data["additionalInfoObject"] ? AdditionalInfo.fromJS(_data["additionalInfoObject"]) : <any>undefined;
            this.activityType = _data["activityType"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.activityCompletedDate = _data["activityCompletedDate"] ? new Date(_data["activityCompletedDate"].toString()) : <any>undefined;
            this.exitRequestId = _data["exitRequestId"];
            this.activityId = _data["activityId"];
            this.previousStatus = _data["previousStatus"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.isReset = _data["isReset"];
            this.initiatedDate = _data["initiatedDate"] ? new Date(_data["initiatedDate"].toString()) : <any>undefined;
            this.modifiedByName = _data["modifiedByName"];
            this.additionalInfoObj = _data["additionalInfoObj"] ? AdditionalInfoObject.fromJS(_data["additionalInfoObj"]) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExitRequestActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ExitRequestActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["header"] = this.header;
        data["description"] = this.description;
        data["exitTypeId"] = this.exitTypeId;
        data["order"] = this.order;
        data["filterKeyId"] = this.filterKeyId;
        data["additionalInfo"] = this.additionalInfo;
        data["additionalInfoObject"] = this.additionalInfoObject ? this.additionalInfoObject.toJSON() : <any>undefined;
        data["activityType"] = this.activityType;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["activityCompletedDate"] = this.activityCompletedDate ? this.activityCompletedDate.toISOString() : <any>undefined;
        data["exitRequestId"] = this.exitRequestId;
        data["activityId"] = this.activityId;
        data["previousStatus"] = this.previousStatus;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["isReset"] = this.isReset;
        data["initiatedDate"] = this.initiatedDate ? this.initiatedDate.toISOString() : <any>undefined;
        data["modifiedByName"] = this.modifiedByName;
        data["additionalInfoObj"] = this.additionalInfoObj ? this.additionalInfoObj.toJSON() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExitRequestActivity {
    id?: number;
    header?: string | undefined;
    description?: string | undefined;
    exitTypeId?: number;
    order?: number;
    filterKeyId?: number;
    additionalInfo?: string | undefined;
    additionalInfoObject?: AdditionalInfo | undefined;
    activityType?: ActivityTypes;
    status?: ActivityStatus;
    isActive?: boolean;
    activityCompletedDate?: Date | undefined;
    exitRequestId?: number;
    activityId?: number;
    previousStatus?: ActivityStatus | undefined;
    completedDate?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    isReset?: boolean;
    initiatedDate?: Date | undefined;
    modifiedByName?: string | undefined;
    additionalInfoObj?: AdditionalInfoObject | undefined;
    modifiedDate?: Date | undefined;
}

export class AdditionalInfo implements IAdditionalInfo {
    immigrationCaseTypeId?: (number | undefined)[] | undefined;
    residencyStatusId?: (number | undefined)[] | undefined;
    preboardingStatusId?: (number | undefined)[] | undefined;
    specialExpat?: boolean | undefined;
    currentGccResident?: number | undefined;
    depsAlreadyInKSA?: number | undefined;
    preboardingTypeId?: (number | undefined)[] | undefined;
    nationality?: (number | undefined)[] | undefined;
    officeToBeVisited?: (number | undefined)[] | undefined;
    officeLocation?: (number | undefined)[] | undefined;
    excludedNationality?: (number | undefined)[] | undefined;
    currentVisaStatusId?: (number | undefined)[] | undefined;
    shortTermVisa?: (number | undefined)[] | undefined;
    typeOfRequest?: (number | undefined)[] | undefined;
    officeLE?: (number | undefined)[] | undefined;
    gender?: (number | undefined)[] | undefined;
    employeeCurrentLocation?: (number | undefined)[] | undefined;
    typeOfSupport?: (number | undefined)[] | undefined;
    ranks?: string[] | undefined;
    nationalityType?: (number | undefined)[] | undefined;

    constructor(data?: IAdditionalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["immigrationCaseTypeId"])) {
                this.immigrationCaseTypeId = [] as any;
                for (let item of _data["immigrationCaseTypeId"])
                    this.immigrationCaseTypeId!.push(item);
            }
            if (Array.isArray(_data["residencyStatusId"])) {
                this.residencyStatusId = [] as any;
                for (let item of _data["residencyStatusId"])
                    this.residencyStatusId!.push(item);
            }
            if (Array.isArray(_data["preboardingStatusId"])) {
                this.preboardingStatusId = [] as any;
                for (let item of _data["preboardingStatusId"])
                    this.preboardingStatusId!.push(item);
            }
            this.specialExpat = _data["specialExpat"];
            this.currentGccResident = _data["currentGccResident"];
            this.depsAlreadyInKSA = _data["depsAlreadyInKSA"];
            if (Array.isArray(_data["preboardingTypeId"])) {
                this.preboardingTypeId = [] as any;
                for (let item of _data["preboardingTypeId"])
                    this.preboardingTypeId!.push(item);
            }
            if (Array.isArray(_data["nationality"])) {
                this.nationality = [] as any;
                for (let item of _data["nationality"])
                    this.nationality!.push(item);
            }
            if (Array.isArray(_data["officeToBeVisited"])) {
                this.officeToBeVisited = [] as any;
                for (let item of _data["officeToBeVisited"])
                    this.officeToBeVisited!.push(item);
            }
            if (Array.isArray(_data["officeLocation"])) {
                this.officeLocation = [] as any;
                for (let item of _data["officeLocation"])
                    this.officeLocation!.push(item);
            }
            if (Array.isArray(_data["excludedNationality"])) {
                this.excludedNationality = [] as any;
                for (let item of _data["excludedNationality"])
                    this.excludedNationality!.push(item);
            }
            if (Array.isArray(_data["currentVisaStatusId"])) {
                this.currentVisaStatusId = [] as any;
                for (let item of _data["currentVisaStatusId"])
                    this.currentVisaStatusId!.push(item);
            }
            if (Array.isArray(_data["shortTermVisa"])) {
                this.shortTermVisa = [] as any;
                for (let item of _data["shortTermVisa"])
                    this.shortTermVisa!.push(item);
            }
            if (Array.isArray(_data["typeOfRequest"])) {
                this.typeOfRequest = [] as any;
                for (let item of _data["typeOfRequest"])
                    this.typeOfRequest!.push(item);
            }
            if (Array.isArray(_data["officeLE"])) {
                this.officeLE = [] as any;
                for (let item of _data["officeLE"])
                    this.officeLE!.push(item);
            }
            if (Array.isArray(_data["gender"])) {
                this.gender = [] as any;
                for (let item of _data["gender"])
                    this.gender!.push(item);
            }
            if (Array.isArray(_data["employeeCurrentLocation"])) {
                this.employeeCurrentLocation = [] as any;
                for (let item of _data["employeeCurrentLocation"])
                    this.employeeCurrentLocation!.push(item);
            }
            if (Array.isArray(_data["typeOfSupport"])) {
                this.typeOfSupport = [] as any;
                for (let item of _data["typeOfSupport"])
                    this.typeOfSupport!.push(item);
            }
            if (Array.isArray(_data["ranks"])) {
                this.ranks = [] as any;
                for (let item of _data["ranks"])
                    this.ranks!.push(item);
            }
            if (Array.isArray(_data["nationalityType"])) {
                this.nationalityType = [] as any;
                for (let item of _data["nationalityType"])
                    this.nationalityType!.push(item);
            }
        }
    }

    static fromJS(data: any): AdditionalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.immigrationCaseTypeId)) {
            data["immigrationCaseTypeId"] = [];
            for (let item of this.immigrationCaseTypeId)
                data["immigrationCaseTypeId"].push(item);
        }
        if (Array.isArray(this.residencyStatusId)) {
            data["residencyStatusId"] = [];
            for (let item of this.residencyStatusId)
                data["residencyStatusId"].push(item);
        }
        if (Array.isArray(this.preboardingStatusId)) {
            data["preboardingStatusId"] = [];
            for (let item of this.preboardingStatusId)
                data["preboardingStatusId"].push(item);
        }
        data["specialExpat"] = this.specialExpat;
        data["currentGccResident"] = this.currentGccResident;
        data["depsAlreadyInKSA"] = this.depsAlreadyInKSA;
        if (Array.isArray(this.preboardingTypeId)) {
            data["preboardingTypeId"] = [];
            for (let item of this.preboardingTypeId)
                data["preboardingTypeId"].push(item);
        }
        if (Array.isArray(this.nationality)) {
            data["nationality"] = [];
            for (let item of this.nationality)
                data["nationality"].push(item);
        }
        if (Array.isArray(this.officeToBeVisited)) {
            data["officeToBeVisited"] = [];
            for (let item of this.officeToBeVisited)
                data["officeToBeVisited"].push(item);
        }
        if (Array.isArray(this.officeLocation)) {
            data["officeLocation"] = [];
            for (let item of this.officeLocation)
                data["officeLocation"].push(item);
        }
        if (Array.isArray(this.excludedNationality)) {
            data["excludedNationality"] = [];
            for (let item of this.excludedNationality)
                data["excludedNationality"].push(item);
        }
        if (Array.isArray(this.currentVisaStatusId)) {
            data["currentVisaStatusId"] = [];
            for (let item of this.currentVisaStatusId)
                data["currentVisaStatusId"].push(item);
        }
        if (Array.isArray(this.shortTermVisa)) {
            data["shortTermVisa"] = [];
            for (let item of this.shortTermVisa)
                data["shortTermVisa"].push(item);
        }
        if (Array.isArray(this.typeOfRequest)) {
            data["typeOfRequest"] = [];
            for (let item of this.typeOfRequest)
                data["typeOfRequest"].push(item);
        }
        if (Array.isArray(this.officeLE)) {
            data["officeLE"] = [];
            for (let item of this.officeLE)
                data["officeLE"].push(item);
        }
        if (Array.isArray(this.gender)) {
            data["gender"] = [];
            for (let item of this.gender)
                data["gender"].push(item);
        }
        if (Array.isArray(this.employeeCurrentLocation)) {
            data["employeeCurrentLocation"] = [];
            for (let item of this.employeeCurrentLocation)
                data["employeeCurrentLocation"].push(item);
        }
        if (Array.isArray(this.typeOfSupport)) {
            data["typeOfSupport"] = [];
            for (let item of this.typeOfSupport)
                data["typeOfSupport"].push(item);
        }
        if (Array.isArray(this.ranks)) {
            data["ranks"] = [];
            for (let item of this.ranks)
                data["ranks"].push(item);
        }
        if (Array.isArray(this.nationalityType)) {
            data["nationalityType"] = [];
            for (let item of this.nationalityType)
                data["nationalityType"].push(item);
        }
        return data;
    }
}

export interface IAdditionalInfo {
    immigrationCaseTypeId?: (number | undefined)[] | undefined;
    residencyStatusId?: (number | undefined)[] | undefined;
    preboardingStatusId?: (number | undefined)[] | undefined;
    specialExpat?: boolean | undefined;
    currentGccResident?: number | undefined;
    depsAlreadyInKSA?: number | undefined;
    preboardingTypeId?: (number | undefined)[] | undefined;
    nationality?: (number | undefined)[] | undefined;
    officeToBeVisited?: (number | undefined)[] | undefined;
    officeLocation?: (number | undefined)[] | undefined;
    excludedNationality?: (number | undefined)[] | undefined;
    currentVisaStatusId?: (number | undefined)[] | undefined;
    shortTermVisa?: (number | undefined)[] | undefined;
    typeOfRequest?: (number | undefined)[] | undefined;
    officeLE?: (number | undefined)[] | undefined;
    gender?: (number | undefined)[] | undefined;
    employeeCurrentLocation?: (number | undefined)[] | undefined;
    typeOfSupport?: (number | undefined)[] | undefined;
    ranks?: string[] | undefined;
    nationalityType?: (number | undefined)[] | undefined;
}

export enum ActivityTypes {
    EMAIL_ACTIVITY = 100,
    PROFILE_UPDATE_ACTIVITY = 101,
    EXTERNAL_ACTIVITY = 102,
    REQUEST_ACTIVITY = 103,
    UPLOAD_ACTIVITY = 104,
    EMPLOYEE_PROFILE_UPLOAD_ACTIVITY = 105,
    STATUS_REQUEST_ACTIVITY = 106,
    UPLOAD_ADDITIONAL_DOCUMENT_ACTIVITY = 107,
}

export enum ActivityStatus {
    Pending = 0,
    Initiated = 1,
    Skipped = 2,
    Done = 3,
    Unskipped = 4,
    Reset = 5,
}

export class AdditionalInfoObject implements IAdditionalInfoObject {
    exitSubTypes?: (number | undefined)[] | undefined;
    isPartner?: number | undefined;
    nationalityType?: (number | undefined)[] | undefined;
    officeLocation?: (number | undefined)[] | undefined;
    rank?: string[] | undefined;
    excludedExitSubTypes?: (number | undefined)[] | undefined;

    constructor(data?: IAdditionalInfoObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["exitSubTypes"])) {
                this.exitSubTypes = [] as any;
                for (let item of _data["exitSubTypes"])
                    this.exitSubTypes!.push(item);
            }
            this.isPartner = _data["isPartner"];
            if (Array.isArray(_data["nationalityType"])) {
                this.nationalityType = [] as any;
                for (let item of _data["nationalityType"])
                    this.nationalityType!.push(item);
            }
            if (Array.isArray(_data["officeLocation"])) {
                this.officeLocation = [] as any;
                for (let item of _data["officeLocation"])
                    this.officeLocation!.push(item);
            }
            if (Array.isArray(_data["rank"])) {
                this.rank = [] as any;
                for (let item of _data["rank"])
                    this.rank!.push(item);
            }
            if (Array.isArray(_data["excludedExitSubTypes"])) {
                this.excludedExitSubTypes = [] as any;
                for (let item of _data["excludedExitSubTypes"])
                    this.excludedExitSubTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): AdditionalInfoObject {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInfoObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exitSubTypes)) {
            data["exitSubTypes"] = [];
            for (let item of this.exitSubTypes)
                data["exitSubTypes"].push(item);
        }
        data["isPartner"] = this.isPartner;
        if (Array.isArray(this.nationalityType)) {
            data["nationalityType"] = [];
            for (let item of this.nationalityType)
                data["nationalityType"].push(item);
        }
        if (Array.isArray(this.officeLocation)) {
            data["officeLocation"] = [];
            for (let item of this.officeLocation)
                data["officeLocation"].push(item);
        }
        if (Array.isArray(this.rank)) {
            data["rank"] = [];
            for (let item of this.rank)
                data["rank"].push(item);
        }
        if (Array.isArray(this.excludedExitSubTypes)) {
            data["excludedExitSubTypes"] = [];
            for (let item of this.excludedExitSubTypes)
                data["excludedExitSubTypes"].push(item);
        }
        return data;
    }
}

export interface IAdditionalInfoObject {
    exitSubTypes?: (number | undefined)[] | undefined;
    isPartner?: number | undefined;
    nationalityType?: (number | undefined)[] | undefined;
    officeLocation?: (number | undefined)[] | undefined;
    rank?: string[] | undefined;
    excludedExitSubTypes?: (number | undefined)[] | undefined;
}

export class OperationResultOfExitEmailAttachments implements IOperationResultOfExitEmailAttachments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ExitEmailAttachments | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfExitEmailAttachments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? ExitEmailAttachments.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfExitEmailAttachments {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfExitEmailAttachments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfExitEmailAttachments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ExitEmailAttachments | undefined;
    errorCode?: number;
}

export class ExitEmailAttachments implements IExitEmailAttachments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    exitRequestActivityId?: number;
    emailTemplateId?: number;
    activityId?: number;
    exitRequestActivity?: ExitRequestActivity | undefined;
    requestId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedBy?: Employee | undefined;
    modifiedDate?: Date | undefined;

    constructor(data?: IExitEmailAttachments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.exitRequestActivityId = _data["exitRequestActivityId"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.activityId = _data["activityId"];
            this.exitRequestActivity = _data["exitRequestActivity"] ? ExitRequestActivity.fromJS(_data["exitRequestActivity"]) : <any>undefined;
            this.requestId = _data["requestId"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? Employee.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"] ? Employee.fromJS(_data["modifiedBy"]) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExitEmailAttachments {
        data = typeof data === 'object' ? data : {};
        let result = new ExitEmailAttachments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["exitRequestActivityId"] = this.exitRequestActivityId;
        data["emailTemplateId"] = this.emailTemplateId;
        data["activityId"] = this.activityId;
        data["exitRequestActivity"] = this.exitRequestActivity ? this.exitRequestActivity.toJSON() : <any>undefined;
        data["requestId"] = this.requestId;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExitEmailAttachments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    exitRequestActivityId?: number;
    emailTemplateId?: number;
    activityId?: number;
    exitRequestActivity?: ExitRequestActivity | undefined;
    requestId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedBy?: Employee | undefined;
    modifiedDate?: Date | undefined;
}

export class NotificationGrdiInfo implements INotificationGrdiInfo {
    notificationGridList?: NotificationInfo[] | undefined;
    sortParams?: SortParameters | undefined;

    constructor(data?: INotificationGrdiInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationGridList"])) {
                this.notificationGridList = [] as any;
                for (let item of _data["notificationGridList"])
                    this.notificationGridList!.push(NotificationInfo.fromJS(item));
            }
            this.sortParams = _data["sortParams"] ? SortParameters.fromJS(_data["sortParams"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationGrdiInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationGrdiInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationGridList)) {
            data["notificationGridList"] = [];
            for (let item of this.notificationGridList)
                data["notificationGridList"].push(item.toJSON());
        }
        data["sortParams"] = this.sortParams ? this.sortParams.toJSON() : <any>undefined;
        return data;
    }
}

export interface INotificationGrdiInfo {
    notificationGridList?: NotificationInfo[] | undefined;
    sortParams?: SortParameters | undefined;
}

export class NotificationInfo implements INotificationInfo {
    id?: number;
    name?: string | undefined;
    message?: string | undefined;
    url?: string | undefined;
    dateAdded?: string | undefined;

    constructor(data?: INotificationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.message = _data["message"];
            this.url = _data["url"];
            this.dateAdded = _data["dateAdded"];
        }
    }

    static fromJS(data: any): NotificationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["message"] = this.message;
        data["url"] = this.url;
        data["dateAdded"] = this.dateAdded;
        return data;
    }
}

export interface INotificationInfo {
    id?: number;
    name?: string | undefined;
    message?: string | undefined;
    url?: string | undefined;
    dateAdded?: string | undefined;
}

export class OperationResultOfString implements IOperationResultOfString {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: string | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfString {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfString {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: string | undefined;
    errorCode?: number;
}

export class OperationResultOfListOfInternExitBulkUpload implements IOperationResultOfListOfInternExitBulkUpload {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: InternExitBulkUpload[] | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfListOfInternExitBulkUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InternExitBulkUpload.fromJS(item));
            }
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfListOfInternExitBulkUpload {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfListOfInternExitBulkUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfListOfInternExitBulkUpload {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: InternExitBulkUpload[] | undefined;
    errorCode?: number;
}

export class InternExitBulkUpload implements IInternExitBulkUpload {
    gpn?: string | undefined;
    gui?: string | undefined;

    constructor(data?: IInternExitBulkUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gpn = _data["gpn"];
            this.gui = _data["gui"];
        }
    }

    static fromJS(data: any): InternExitBulkUpload {
        data = typeof data === 'object' ? data : {};
        let result = new InternExitBulkUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gpn"] = this.gpn;
        data["gui"] = this.gui;
        return data;
    }
}

export interface IInternExitBulkUpload {
    gpn?: string | undefined;
    gui?: string | undefined;
}

export class ExitKPIReportFilter implements IExitKPIReportFilter {
    exitType?: LookupField | undefined;
    officeLocation?: LookupField | undefined;

    constructor(data?: IExitKPIReportFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exitType = _data["exitType"] ? LookupField.fromJS(_data["exitType"]) : <any>undefined;
            this.officeLocation = _data["officeLocation"] ? LookupField.fromJS(_data["officeLocation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExitKPIReportFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ExitKPIReportFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exitType"] = this.exitType ? this.exitType.toJSON() : <any>undefined;
        data["officeLocation"] = this.officeLocation ? this.officeLocation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExitKPIReportFilter {
    exitType?: LookupField | undefined;
    officeLocation?: LookupField | undefined;
}

export class ImmigrationAutoRequest implements IImmigrationAutoRequest {
    immigrationProfileId?: number;
    immigrationRequestStatus?: string | undefined;
    activityId?: number;
    propertyExtensions?: string | undefined;
    visaTypeId?: number;
    visaType?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: IImmigrationAutoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.immigrationProfileId = _data["immigrationProfileId"];
            this.immigrationRequestStatus = _data["immigrationRequestStatus"];
            this.activityId = _data["activityId"];
            this.propertyExtensions = _data["propertyExtensions"];
            this.visaTypeId = _data["visaTypeId"];
            this.visaType = _data["visaType"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): ImmigrationAutoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationAutoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immigrationProfileId"] = this.immigrationProfileId;
        data["immigrationRequestStatus"] = this.immigrationRequestStatus;
        data["activityId"] = this.activityId;
        data["propertyExtensions"] = this.propertyExtensions;
        data["visaTypeId"] = this.visaTypeId;
        data["visaType"] = this.visaType;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IImmigrationAutoRequest {
    immigrationProfileId?: number;
    immigrationRequestStatus?: string | undefined;
    activityId?: number;
    propertyExtensions?: string | undefined;
    visaTypeId?: number;
    visaType?: string | undefined;
    countryCode?: string | undefined;
}

export class ImmigrationExitVisa implements IImmigrationExitVisa {
    immigrationProfileId?: number;
    visaTypeValue?: string | undefined;
    errorState?: number;
    errorMessage?: string | undefined;
    visaTypeName?: string | undefined;
    immigrationStatus?: number | undefined;
    visaCountry?: string | undefined;

    constructor(data?: IImmigrationExitVisa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.immigrationProfileId = _data["immigrationProfileId"];
            this.visaTypeValue = _data["visaTypeValue"];
            this.errorState = _data["errorState"];
            this.errorMessage = _data["errorMessage"];
            this.visaTypeName = _data["visaTypeName"];
            this.immigrationStatus = _data["immigrationStatus"];
            this.visaCountry = _data["visaCountry"];
        }
    }

    static fromJS(data: any): ImmigrationExitVisa {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationExitVisa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immigrationProfileId"] = this.immigrationProfileId;
        data["visaTypeValue"] = this.visaTypeValue;
        data["errorState"] = this.errorState;
        data["errorMessage"] = this.errorMessage;
        data["visaTypeName"] = this.visaTypeName;
        data["immigrationStatus"] = this.immigrationStatus;
        data["visaCountry"] = this.visaCountry;
        return data;
    }
}

export interface IImmigrationExitVisa {
    immigrationProfileId?: number;
    visaTypeValue?: string | undefined;
    errorState?: number;
    errorMessage?: string | undefined;
    visaTypeName?: string | undefined;
    immigrationStatus?: number | undefined;
    visaCountry?: string | undefined;
}

export class OperationResultOfImmigrationProfile implements IOperationResultOfImmigrationProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationProfile | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfImmigrationProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? ImmigrationProfile.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfImmigrationProfile {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfImmigrationProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfImmigrationProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationProfile | undefined;
    errorCode?: number;
}

export class ImmigrationCandidate implements IImmigrationCandidate {
    profile?: ImmigrationProfile | undefined;
    countryCode?: string | undefined;
    visaType?: string | undefined;
    immigrationComment?: ImmigrationComment | undefined;
    noofCopies?: number;

    constructor(data?: IImmigrationCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"] ? ImmigrationProfile.fromJS(_data["profile"]) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.visaType = _data["visaType"];
            this.immigrationComment = _data["immigrationComment"] ? ImmigrationComment.fromJS(_data["immigrationComment"]) : <any>undefined;
            this.noofCopies = _data["noofCopies"];
        }
    }

    static fromJS(data: any): ImmigrationCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["visaType"] = this.visaType;
        data["immigrationComment"] = this.immigrationComment ? this.immigrationComment.toJSON() : <any>undefined;
        data["noofCopies"] = this.noofCopies;
        return data;
    }
}

export interface IImmigrationCandidate {
    profile?: ImmigrationProfile | undefined;
    countryCode?: string | undefined;
    visaType?: string | undefined;
    immigrationComment?: ImmigrationComment | undefined;
    noofCopies?: number;
}

export class ImmigrationComment implements IImmigrationComment {
    id?: number;
    comment?: string | undefined;
    profileId?: number | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    commentType?: ImmigrationCommentTypes;
    statusId?: number | undefined;
    createdDate?: Date;
    modifiedDate?: Date | undefined;

    constructor(data?: IImmigrationComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.profileId = _data["profileId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.commentType = _data["commentType"];
            this.statusId = _data["statusId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImmigrationComment {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["profileId"] = this.profileId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["commentType"] = this.commentType;
        data["statusId"] = this.statusId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IImmigrationComment {
    id?: number;
    comment?: string | undefined;
    profileId?: number | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    commentType?: ImmigrationCommentTypes;
    statusId?: number | undefined;
    createdDate?: Date;
    modifiedDate?: Date | undefined;
}

export enum ImmigrationCommentTypes {
    Accept = 0,
    Approve = 1,
    Reject = 2,
    Decline = 3,
    General = 4,
    Notes = 5,
    Submission = 6,
    Withdraw = 7,
    InProcess = 8,
    OnHold = 9,
}

export class OperationResultOfImmigrationDocument implements IOperationResultOfImmigrationDocument {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationDocument | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfImmigrationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? ImmigrationDocument.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfImmigrationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfImmigrationDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfImmigrationDocument {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationDocument | undefined;
    errorCode?: number;
}

export class ImmigrationDocument implements IImmigrationDocument {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    immigrationProfileId?: number;
    visaTypeValue?: string | undefined;
    createdById?: number;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;
    synced?: boolean;
    moduleType?: number;
    disabled?: boolean;
    checks?: string | undefined;
    tmT_Check_Status?: string | undefined;
    documentChecks?: DocumentConfigLookupMapping[] | undefined;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;

    constructor(data?: IImmigrationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? LookupField.fromJS(_data["documentType"]) : <any>undefined;
            this.immigrationProfileId = _data["immigrationProfileId"];
            this.visaTypeValue = _data["visaTypeValue"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.documentName = _data["documentName"];
            this.description = _data["description"];
            this.documentNameId = _data["documentNameId"];
            this.synced = _data["synced"];
            this.moduleType = _data["moduleType"];
            this.disabled = _data["disabled"];
            this.checks = _data["checks"];
            this.tmT_Check_Status = _data["tmT_Check_Status"];
            if (Array.isArray(_data["documentChecks"])) {
                this.documentChecks = [] as any;
                for (let item of _data["documentChecks"])
                    this.documentChecks!.push(DocumentConfigLookupMapping.fromJS(item));
            }
            this.additionalReqId = _data["additionalReqId"];
            this.dependentId = _data["dependentId"];
        }
    }

    static fromJS(data: any): ImmigrationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["immigrationProfileId"] = this.immigrationProfileId;
        data["visaTypeValue"] = this.visaTypeValue;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["documentName"] = this.documentName;
        data["description"] = this.description;
        data["documentNameId"] = this.documentNameId;
        data["synced"] = this.synced;
        data["moduleType"] = this.moduleType;
        data["disabled"] = this.disabled;
        data["checks"] = this.checks;
        data["tmT_Check_Status"] = this.tmT_Check_Status;
        if (Array.isArray(this.documentChecks)) {
            data["documentChecks"] = [];
            for (let item of this.documentChecks)
                data["documentChecks"].push(item.toJSON());
        }
        data["additionalReqId"] = this.additionalReqId;
        data["dependentId"] = this.dependentId;
        return data;
    }
}

export interface IImmigrationDocument {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    immigrationProfileId?: number;
    visaTypeValue?: string | undefined;
    createdById?: number;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;
    synced?: boolean;
    moduleType?: number;
    disabled?: boolean;
    checks?: string | undefined;
    tmT_Check_Status?: string | undefined;
    documentChecks?: DocumentConfigLookupMapping[] | undefined;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;
}

export class DocumentConfigLookupMapping implements IDocumentConfigLookupMapping {
    id?: number;
    errorMessage?: string | undefined;
    checkCode?: string | undefined;
    documentCheckConfig?: DocumentCheckConfigs | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    isActive?: boolean;
    isStrict?: boolean;
    canUpload?: boolean;

    constructor(data?: IDocumentConfigLookupMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.errorMessage = _data["errorMessage"];
            this.checkCode = _data["checkCode"];
            this.documentCheckConfig = _data["documentCheckConfig"] ? DocumentCheckConfigs.fromJS(_data["documentCheckConfig"]) : <any>undefined;
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? LookupField.fromJS(_data["documentType"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isStrict = _data["isStrict"];
            this.canUpload = _data["canUpload"];
        }
    }

    static fromJS(data: any): DocumentConfigLookupMapping {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentConfigLookupMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["errorMessage"] = this.errorMessage;
        data["checkCode"] = this.checkCode;
        data["documentCheckConfig"] = this.documentCheckConfig ? this.documentCheckConfig.toJSON() : <any>undefined;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isStrict"] = this.isStrict;
        data["canUpload"] = this.canUpload;
        return data;
    }
}

export interface IDocumentConfigLookupMapping {
    id?: number;
    errorMessage?: string | undefined;
    checkCode?: string | undefined;
    documentCheckConfig?: DocumentCheckConfigs | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    isActive?: boolean;
    isStrict?: boolean;
    canUpload?: boolean;
}

export class DocumentCheckConfigs implements IDocumentCheckConfigs {
    check?: DocumentChecks | undefined;
    country?: LookupField | undefined;
    message?: string | undefined;
    additionalInfo?: string | undefined;
    isActive?: boolean;
    isStrict?: boolean;

    constructor(data?: IDocumentCheckConfigs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.check = _data["check"] ? DocumentChecks.fromJS(_data["check"]) : <any>undefined;
            this.country = _data["country"] ? LookupField.fromJS(_data["country"]) : <any>undefined;
            this.message = _data["message"];
            this.additionalInfo = _data["additionalInfo"];
            this.isActive = _data["isActive"];
            this.isStrict = _data["isStrict"];
        }
    }

    static fromJS(data: any): DocumentCheckConfigs {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCheckConfigs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["check"] = this.check ? this.check.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["additionalInfo"] = this.additionalInfo;
        data["isActive"] = this.isActive;
        data["isStrict"] = this.isStrict;
        return data;
    }
}

export interface IDocumentCheckConfigs {
    check?: DocumentChecks | undefined;
    country?: LookupField | undefined;
    message?: string | undefined;
    additionalInfo?: string | undefined;
    isActive?: boolean;
    isStrict?: boolean;
}

export class DocumentChecks implements IDocumentChecks {
    description?: string | undefined;
    checkCode?: string | undefined;
    typeOfDocument?: number;
    isActive?: boolean;
    modifiedBy?: number | undefined;
    modifiedOn?: Date | undefined;

    constructor(data?: IDocumentChecks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.checkCode = _data["checkCode"];
            this.typeOfDocument = _data["typeOfDocument"];
            this.isActive = _data["isActive"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentChecks {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentChecks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["checkCode"] = this.checkCode;
        data["typeOfDocument"] = this.typeOfDocument;
        data["isActive"] = this.isActive;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentChecks {
    description?: string | undefined;
    checkCode?: string | undefined;
    typeOfDocument?: number;
    isActive?: boolean;
    modifiedBy?: number | undefined;
    modifiedOn?: Date | undefined;
}

export class ImmigrationEmailAttachments implements IImmigrationEmailAttachments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    immigrationProfileActivityId?: number;
    emailTemplateId?: number;
    activityId?: number;
    immigrationProfileActivity?: ImmigrationProfileActivity | undefined;
    candidateId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedBy?: Employee | undefined;
    modifiedDate?: Date | undefined;

    constructor(data?: IImmigrationEmailAttachments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.immigrationProfileActivityId = _data["immigrationProfileActivityId"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.activityId = _data["activityId"];
            this.immigrationProfileActivity = _data["immigrationProfileActivity"] ? ImmigrationProfileActivity.fromJS(_data["immigrationProfileActivity"]) : <any>undefined;
            this.candidateId = _data["candidateId"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? Employee.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"] ? Employee.fromJS(_data["modifiedBy"]) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImmigrationEmailAttachments {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationEmailAttachments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["immigrationProfileActivityId"] = this.immigrationProfileActivityId;
        data["emailTemplateId"] = this.emailTemplateId;
        data["activityId"] = this.activityId;
        data["immigrationProfileActivity"] = this.immigrationProfileActivity ? this.immigrationProfileActivity.toJSON() : <any>undefined;
        data["candidateId"] = this.candidateId;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IImmigrationEmailAttachments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    immigrationProfileActivityId?: number;
    emailTemplateId?: number;
    activityId?: number;
    immigrationProfileActivity?: ImmigrationProfileActivity | undefined;
    candidateId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedBy?: Employee | undefined;
    modifiedDate?: Date | undefined;
}

export class ImmigrationProfileActivity implements IImmigrationProfileActivity {
    id?: number;
    header?: string | undefined;
    description?: string | undefined;
    visaTypeId?: number;
    order?: number;
    filterKeyId?: number;
    additionalInfo?: string | undefined;
    additionalInfoObject?: AdditionalInfo | undefined;
    activityType?: ActivityTypes;
    status?: ActivityStatus;
    isActive?: boolean;
    activityCompletedDate?: Date | undefined;
    countryId?: number | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    propertyExtensions?: string | undefined;
    immigrationProfileId?: number;
    activityId?: number;
    previousStatus?: ActivityStatus | undefined;
    completedDate?: Date | undefined;
    createdBy?: number | undefined;
    initiatedDate?: Date | undefined;
    modifiedByNm?: string | undefined;
    initiatedByNm?: string | undefined;
    isMilestone?: boolean | undefined;
    canInitiate?: boolean | undefined;
    isKPI?: boolean | undefined;

    constructor(data?: IImmigrationProfileActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.header = _data["header"];
            this.description = _data["description"];
            this.visaTypeId = _data["visaTypeId"];
            this.order = _data["order"];
            this.filterKeyId = _data["filterKeyId"];
            this.additionalInfo = _data["additionalInfo"];
            this.additionalInfoObject = _data["additionalInfoObject"] ? AdditionalInfo.fromJS(_data["additionalInfoObject"]) : <any>undefined;
            this.activityType = _data["activityType"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.activityCompletedDate = _data["activityCompletedDate"] ? new Date(_data["activityCompletedDate"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.propertyExtensions = _data["propertyExtensions"];
            this.immigrationProfileId = _data["immigrationProfileId"];
            this.activityId = _data["activityId"];
            this.previousStatus = _data["previousStatus"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.initiatedDate = _data["initiatedDate"] ? new Date(_data["initiatedDate"].toString()) : <any>undefined;
            this.modifiedByNm = _data["modifiedByNm"];
            this.initiatedByNm = _data["initiatedByNm"];
            this.isMilestone = _data["isMilestone"];
            this.canInitiate = _data["canInitiate"];
            this.isKPI = _data["isKPI"];
        }
    }

    static fromJS(data: any): ImmigrationProfileActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationProfileActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["header"] = this.header;
        data["description"] = this.description;
        data["visaTypeId"] = this.visaTypeId;
        data["order"] = this.order;
        data["filterKeyId"] = this.filterKeyId;
        data["additionalInfo"] = this.additionalInfo;
        data["additionalInfoObject"] = this.additionalInfoObject ? this.additionalInfoObject.toJSON() : <any>undefined;
        data["activityType"] = this.activityType;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["activityCompletedDate"] = this.activityCompletedDate ? this.activityCompletedDate.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["propertyExtensions"] = this.propertyExtensions;
        data["immigrationProfileId"] = this.immigrationProfileId;
        data["activityId"] = this.activityId;
        data["previousStatus"] = this.previousStatus;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["initiatedDate"] = this.initiatedDate ? this.initiatedDate.toISOString() : <any>undefined;
        data["modifiedByNm"] = this.modifiedByNm;
        data["initiatedByNm"] = this.initiatedByNm;
        data["isMilestone"] = this.isMilestone;
        data["canInitiate"] = this.canInitiate;
        data["isKPI"] = this.isKPI;
        return data;
    }
}

export interface IImmigrationProfileActivity {
    id?: number;
    header?: string | undefined;
    description?: string | undefined;
    visaTypeId?: number;
    order?: number;
    filterKeyId?: number;
    additionalInfo?: string | undefined;
    additionalInfoObject?: AdditionalInfo | undefined;
    activityType?: ActivityTypes;
    status?: ActivityStatus;
    isActive?: boolean;
    activityCompletedDate?: Date | undefined;
    countryId?: number | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    propertyExtensions?: string | undefined;
    immigrationProfileId?: number;
    activityId?: number;
    previousStatus?: ActivityStatus | undefined;
    completedDate?: Date | undefined;
    createdBy?: number | undefined;
    initiatedDate?: Date | undefined;
    modifiedByNm?: string | undefined;
    initiatedByNm?: string | undefined;
    isMilestone?: boolean | undefined;
    canInitiate?: boolean | undefined;
    isKPI?: boolean | undefined;
}

export class ImmigrationDocumentType implements IImmigrationDocumentType {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    value?: string | undefined;
    checks?: string | undefined;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;

    constructor(data?: IImmigrationDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNameId = _data["docNameId"];
            this.docNameDisplayText = _data["docNameDisplayText"];
            this.docTypeId = _data["docTypeId"];
            this.docTypeDisplayText = _data["docTypeDisplayText"];
            this.isMandatory = _data["isMandatory"];
            this.mandatoryType = _data["mandatoryType"];
            this.value = _data["value"];
            this.checks = _data["checks"];
            this.additionalReqId = _data["additionalReqId"];
            this.dependentId = _data["dependentId"];
        }
    }

    static fromJS(data: any): ImmigrationDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationDocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNameId"] = this.docNameId;
        data["docNameDisplayText"] = this.docNameDisplayText;
        data["docTypeId"] = this.docTypeId;
        data["docTypeDisplayText"] = this.docTypeDisplayText;
        data["isMandatory"] = this.isMandatory;
        data["mandatoryType"] = this.mandatoryType;
        data["value"] = this.value;
        data["checks"] = this.checks;
        data["additionalReqId"] = this.additionalReqId;
        data["dependentId"] = this.dependentId;
        return data;
    }
}

export interface IImmigrationDocumentType {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    value?: string | undefined;
    checks?: string | undefined;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;
}

export class ImmigrationDocCombined implements IImmigrationDocCombined {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    immigrationProfileId?: number;
    visaTypeValue?: string | undefined;
    createdById?: number;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;
    synced?: boolean | undefined;
    moduleType?: number;
    disabled?: boolean;
    checks?: string | undefined;
    instruction?: string | undefined;
    dependentId?: number | undefined;
    dependentName?: string | undefined;
    isUploaded?: boolean;
    isEditMode?: boolean;
    isMandatory?: boolean;
    mandatoryType?: number | undefined;
    validationResults?: string | undefined;
    tmT_Check_Status?: string | undefined;
    documentChecks?: DocumentConfigLookupMapping[] | undefined;
    additionalReqId?: number | undefined;

    constructor(data?: IImmigrationDocCombined) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.immigrationProfileId = _data["immigrationProfileId"];
            this.visaTypeValue = _data["visaTypeValue"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.documentName = _data["documentName"];
            this.description = _data["description"];
            this.documentNameId = _data["documentNameId"];
            this.synced = _data["synced"];
            this.moduleType = _data["moduleType"];
            this.disabled = _data["disabled"];
            this.checks = _data["checks"];
            this.instruction = _data["instruction"];
            this.dependentId = _data["dependentId"];
            this.dependentName = _data["dependentName"];
            this.isUploaded = _data["isUploaded"];
            this.isEditMode = _data["isEditMode"];
            this.isMandatory = _data["isMandatory"];
            this.mandatoryType = _data["mandatoryType"];
            this.validationResults = _data["validationResults"];
            this.tmT_Check_Status = _data["tmT_Check_Status"];
            if (Array.isArray(_data["documentChecks"])) {
                this.documentChecks = [] as any;
                for (let item of _data["documentChecks"])
                    this.documentChecks!.push(DocumentConfigLookupMapping.fromJS(item));
            }
            this.additionalReqId = _data["additionalReqId"];
        }
    }

    static fromJS(data: any): ImmigrationDocCombined {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationDocCombined();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["immigrationProfileId"] = this.immigrationProfileId;
        data["visaTypeValue"] = this.visaTypeValue;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["documentName"] = this.documentName;
        data["description"] = this.description;
        data["documentNameId"] = this.documentNameId;
        data["synced"] = this.synced;
        data["moduleType"] = this.moduleType;
        data["disabled"] = this.disabled;
        data["checks"] = this.checks;
        data["instruction"] = this.instruction;
        data["dependentId"] = this.dependentId;
        data["dependentName"] = this.dependentName;
        data["isUploaded"] = this.isUploaded;
        data["isEditMode"] = this.isEditMode;
        data["isMandatory"] = this.isMandatory;
        data["mandatoryType"] = this.mandatoryType;
        data["validationResults"] = this.validationResults;
        data["tmT_Check_Status"] = this.tmT_Check_Status;
        if (Array.isArray(this.documentChecks)) {
            data["documentChecks"] = [];
            for (let item of this.documentChecks)
                data["documentChecks"].push(item.toJSON());
        }
        data["additionalReqId"] = this.additionalReqId;
        return data;
    }
}

export interface IImmigrationDocCombined {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    immigrationProfileId?: number;
    visaTypeValue?: string | undefined;
    createdById?: number;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;
    synced?: boolean | undefined;
    moduleType?: number;
    disabled?: boolean;
    checks?: string | undefined;
    instruction?: string | undefined;
    dependentId?: number | undefined;
    dependentName?: string | undefined;
    isUploaded?: boolean;
    isEditMode?: boolean;
    isMandatory?: boolean;
    mandatoryType?: number | undefined;
    validationResults?: string | undefined;
    tmT_Check_Status?: string | undefined;
    documentChecks?: DocumentConfigLookupMapping[] | undefined;
    additionalReqId?: number | undefined;
}

export class ProfileActivities implements IProfileActivities {
    activities?: ImmigrationProfileActivity[] | undefined;
    profileStatus?: number | undefined;

    constructor(data?: IProfileActivities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(ImmigrationProfileActivity.fromJS(item));
            }
            this.profileStatus = _data["profileStatus"];
        }
    }

    static fromJS(data: any): ProfileActivities {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileActivities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["profileStatus"] = this.profileStatus;
        return data;
    }
}

export interface IProfileActivities {
    activities?: ImmigrationProfileActivity[] | undefined;
    profileStatus?: number | undefined;
}

export class OperationResultOfImmigrationEmailAttachments implements IOperationResultOfImmigrationEmailAttachments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationEmailAttachments | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfImmigrationEmailAttachments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? ImmigrationEmailAttachments.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfImmigrationEmailAttachments {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfImmigrationEmailAttachments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfImmigrationEmailAttachments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationEmailAttachments | undefined;
    errorCode?: number;
}

export class DocumentInstructions implements IDocumentInstructions {
    docNameId?: number | undefined;
    documentInstruction?: string | undefined;

    constructor(data?: IDocumentInstructions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNameId = _data["docNameId"];
            this.documentInstruction = _data["documentInstruction"];
        }
    }

    static fromJS(data: any): DocumentInstructions {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentInstructions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNameId"] = this.docNameId;
        data["documentInstruction"] = this.documentInstruction;
        return data;
    }
}

export interface IDocumentInstructions {
    docNameId?: number | undefined;
    documentInstruction?: string | undefined;
}

export class ImmigrationProfileMiletones implements IImmigrationProfileMiletones {
    activityId?: number;
    compeletedDate?: Date | undefined;
    milestoneTimeline?: number | undefined;
    milestoneName?: string | undefined;
    activityStatusId?: number | undefined;
    exceptedProcessDate?: Date | undefined;
    activityStatus?: string | undefined;

    constructor(data?: IImmigrationProfileMiletones) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.compeletedDate = _data["compeletedDate"] ? new Date(_data["compeletedDate"].toString()) : <any>undefined;
            this.milestoneTimeline = _data["milestoneTimeline"];
            this.milestoneName = _data["milestoneName"];
            this.activityStatusId = _data["activityStatusId"];
            this.exceptedProcessDate = _data["exceptedProcessDate"] ? new Date(_data["exceptedProcessDate"].toString()) : <any>undefined;
            this.activityStatus = _data["activityStatus"];
        }
    }

    static fromJS(data: any): ImmigrationProfileMiletones {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationProfileMiletones();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["compeletedDate"] = this.compeletedDate ? this.compeletedDate.toISOString() : <any>undefined;
        data["milestoneTimeline"] = this.milestoneTimeline;
        data["milestoneName"] = this.milestoneName;
        data["activityStatusId"] = this.activityStatusId;
        data["exceptedProcessDate"] = this.exceptedProcessDate ? this.exceptedProcessDate.toISOString() : <any>undefined;
        data["activityStatus"] = this.activityStatus;
        return data;
    }
}

export interface IImmigrationProfileMiletones {
    activityId?: number;
    compeletedDate?: Date | undefined;
    milestoneTimeline?: number | undefined;
    milestoneName?: string | undefined;
    activityStatusId?: number | undefined;
    exceptedProcessDate?: Date | undefined;
    activityStatus?: string | undefined;
}

export class ImmigrationInfoMin implements IImmigrationInfoMin {
    visatypeName?: string | undefined;
    candidateName?: string | undefined;
    id?: number;

    constructor(data?: IImmigrationInfoMin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visatypeName = _data["visatypeName"];
            this.candidateName = _data["candidateName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ImmigrationInfoMin {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationInfoMin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visatypeName"] = this.visatypeName;
        data["candidateName"] = this.candidateName;
        data["id"] = this.id;
        return data;
    }
}

export interface IImmigrationInfoMin {
    visatypeName?: string | undefined;
    candidateName?: string | undefined;
    id?: number;
}

export class ImmAdditionalDocRequests implements IImmAdditionalDocRequests {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    candidateProfileId?: number;
    requestorEmployeeId?: number;
    createDate?: Date | undefined;
    isUploaded?: boolean | undefined;
    comment?: string | undefined;
    dependentId?: number | undefined;

    constructor(data?: IImmAdditionalDocRequests) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNameId = _data["docNameId"];
            this.docNameDisplayText = _data["docNameDisplayText"];
            this.docTypeId = _data["docTypeId"];
            this.docTypeDisplayText = _data["docTypeDisplayText"];
            this.isMandatory = _data["isMandatory"];
            this.mandatoryType = _data["mandatoryType"];
            this.candidateProfileId = _data["candidateProfileId"];
            this.requestorEmployeeId = _data["requestorEmployeeId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.isUploaded = _data["isUploaded"];
            this.comment = _data["comment"];
            this.dependentId = _data["dependentId"];
        }
    }

    static fromJS(data: any): ImmAdditionalDocRequests {
        data = typeof data === 'object' ? data : {};
        let result = new ImmAdditionalDocRequests();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNameId"] = this.docNameId;
        data["docNameDisplayText"] = this.docNameDisplayText;
        data["docTypeId"] = this.docTypeId;
        data["docTypeDisplayText"] = this.docTypeDisplayText;
        data["isMandatory"] = this.isMandatory;
        data["mandatoryType"] = this.mandatoryType;
        data["candidateProfileId"] = this.candidateProfileId;
        data["requestorEmployeeId"] = this.requestorEmployeeId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["isUploaded"] = this.isUploaded;
        data["comment"] = this.comment;
        data["dependentId"] = this.dependentId;
        return data;
    }
}

export interface IImmAdditionalDocRequests {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    candidateProfileId?: number;
    requestorEmployeeId?: number;
    createDate?: Date | undefined;
    isUploaded?: boolean | undefined;
    comment?: string | undefined;
    dependentId?: number | undefined;
}

export class OperationResultOfBoolean implements IOperationResultOfBoolean {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: boolean;
    errorCode?: number;

    constructor(data?: IOperationResultOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfBoolean {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: boolean;
    errorCode?: number;
}

export class ExitVisaRequest implements IExitVisaRequest {
    visaTypeId?: number;
    officeLEId?: number | undefined;
    labourCardCancellationTypeId?: number | undefined;
    exitRequest?: ExitRequest | undefined;
    activityId?: number | undefined;

    constructor(data?: IExitVisaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visaTypeId = _data["visaTypeId"];
            this.officeLEId = _data["officeLEId"];
            this.labourCardCancellationTypeId = _data["labourCardCancellationTypeId"];
            this.exitRequest = _data["exitRequest"] ? ExitRequest.fromJS(_data["exitRequest"]) : <any>undefined;
            this.activityId = _data["activityId"];
        }
    }

    static fromJS(data: any): ExitVisaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExitVisaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visaTypeId"] = this.visaTypeId;
        data["officeLEId"] = this.officeLEId;
        data["labourCardCancellationTypeId"] = this.labourCardCancellationTypeId;
        data["exitRequest"] = this.exitRequest ? this.exitRequest.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        return data;
    }
}

export interface IExitVisaRequest {
    visaTypeId?: number;
    officeLEId?: number | undefined;
    labourCardCancellationTypeId?: number | undefined;
    exitRequest?: ExitRequest | undefined;
    activityId?: number | undefined;
}

export class ImmigrationActivity implements IImmigrationActivity {
    id?: number;
    header?: string | undefined;
    description?: string | undefined;
    visaTypeId?: number;
    order?: number;
    filterKeyId?: number;
    additionalInfo?: string | undefined;
    additionalInfoObject?: AdditionalInfo | undefined;
    activityType?: ActivityTypes;
    status?: ActivityStatus;
    isActive?: boolean;
    activityCompletedDate?: Date | undefined;
    countryId?: number | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    propertyExtensions?: string | undefined;

    constructor(data?: IImmigrationActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.header = _data["header"];
            this.description = _data["description"];
            this.visaTypeId = _data["visaTypeId"];
            this.order = _data["order"];
            this.filterKeyId = _data["filterKeyId"];
            this.additionalInfo = _data["additionalInfo"];
            this.additionalInfoObject = _data["additionalInfoObject"] ? AdditionalInfo.fromJS(_data["additionalInfoObject"]) : <any>undefined;
            this.activityType = _data["activityType"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.activityCompletedDate = _data["activityCompletedDate"] ? new Date(_data["activityCompletedDate"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.propertyExtensions = _data["propertyExtensions"];
        }
    }

    static fromJS(data: any): ImmigrationActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["header"] = this.header;
        data["description"] = this.description;
        data["visaTypeId"] = this.visaTypeId;
        data["order"] = this.order;
        data["filterKeyId"] = this.filterKeyId;
        data["additionalInfo"] = this.additionalInfo;
        data["additionalInfoObject"] = this.additionalInfoObject ? this.additionalInfoObject.toJSON() : <any>undefined;
        data["activityType"] = this.activityType;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["activityCompletedDate"] = this.activityCompletedDate ? this.activityCompletedDate.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["propertyExtensions"] = this.propertyExtensions;
        return data;
    }
}

export interface IImmigrationActivity {
    id?: number;
    header?: string | undefined;
    description?: string | undefined;
    visaTypeId?: number;
    order?: number;
    filterKeyId?: number;
    additionalInfo?: string | undefined;
    additionalInfoObject?: AdditionalInfo | undefined;
    activityType?: ActivityTypes;
    status?: ActivityStatus;
    isActive?: boolean;
    activityCompletedDate?: Date | undefined;
    countryId?: number | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    propertyExtensions?: string | undefined;
}

export class ImmigrationDocumentCheck implements IImmigrationDocumentCheck {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    isUploaded?: boolean;

    constructor(data?: IImmigrationDocumentCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNameId = _data["docNameId"];
            this.docNameDisplayText = _data["docNameDisplayText"];
            this.isUploaded = _data["isUploaded"];
        }
    }

    static fromJS(data: any): ImmigrationDocumentCheck {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationDocumentCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNameId"] = this.docNameId;
        data["docNameDisplayText"] = this.docNameDisplayText;
        data["isUploaded"] = this.isUploaded;
        return data;
    }
}

export interface IImmigrationDocumentCheck {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    isUploaded?: boolean;
}

export class OperationResultOfImmigrationProfileActivity implements IOperationResultOfImmigrationProfileActivity {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationProfileActivity | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfImmigrationProfileActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? ImmigrationProfileActivity.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfImmigrationProfileActivity {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfImmigrationProfileActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfImmigrationProfileActivity {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationProfileActivity | undefined;
    errorCode?: number;
}

export class LocationFieldAccessibility implements ILocationFieldAccessibility {
    id?: number;
    module?: string | undefined;
    fieldName?: string | undefined;
    bahrain?: boolean;
    egypt?: boolean;
    jordan?: boolean;
    kuwait?: boolean;
    oman?: boolean;
    pakistan?: boolean;
    qatar?: boolean;
    saudiArabia?: boolean;
    unitedArabEmirates?: boolean;
    iraq?: boolean;
    lebanon?: boolean;
    libya?: boolean;
    middleEastFirm?: boolean;
    palestine?: boolean;

    constructor(data?: ILocationFieldAccessibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.module = _data["module"];
            this.fieldName = _data["fieldName"];
            this.bahrain = _data["bahrain"];
            this.egypt = _data["egypt"];
            this.jordan = _data["jordan"];
            this.kuwait = _data["kuwait"];
            this.oman = _data["oman"];
            this.pakistan = _data["pakistan"];
            this.qatar = _data["qatar"];
            this.saudiArabia = _data["saudiArabia"];
            this.unitedArabEmirates = _data["unitedArabEmirates"];
            this.iraq = _data["iraq"];
            this.lebanon = _data["lebanon"];
            this.libya = _data["libya"];
            this.middleEastFirm = _data["middleEastFirm"];
            this.palestine = _data["palestine"];
        }
    }

    static fromJS(data: any): LocationFieldAccessibility {
        data = typeof data === 'object' ? data : {};
        let result = new LocationFieldAccessibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["module"] = this.module;
        data["fieldName"] = this.fieldName;
        data["bahrain"] = this.bahrain;
        data["egypt"] = this.egypt;
        data["jordan"] = this.jordan;
        data["kuwait"] = this.kuwait;
        data["oman"] = this.oman;
        data["pakistan"] = this.pakistan;
        data["qatar"] = this.qatar;
        data["saudiArabia"] = this.saudiArabia;
        data["unitedArabEmirates"] = this.unitedArabEmirates;
        data["iraq"] = this.iraq;
        data["lebanon"] = this.lebanon;
        data["libya"] = this.libya;
        data["middleEastFirm"] = this.middleEastFirm;
        data["palestine"] = this.palestine;
        return data;
    }
}

export interface ILocationFieldAccessibility {
    id?: number;
    module?: string | undefined;
    fieldName?: string | undefined;
    bahrain?: boolean;
    egypt?: boolean;
    jordan?: boolean;
    kuwait?: boolean;
    oman?: boolean;
    pakistan?: boolean;
    qatar?: boolean;
    saudiArabia?: boolean;
    unitedArabEmirates?: boolean;
    iraq?: boolean;
    lebanon?: boolean;
    libya?: boolean;
    middleEastFirm?: boolean;
    palestine?: boolean;
}

export class ChargeCodes implements IChargeCodes {
    id?: number;
    chargeCode?: string | undefined;
    isActive?: number;
    engagementName?: string | undefined;
    engPartnerName?: string | undefined;
    engManagerName?: string | undefined;
    statusId?: number;
    status?: string | undefined;

    constructor(data?: IChargeCodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chargeCode = _data["chargeCode"];
            this.isActive = _data["isActive"];
            this.engagementName = _data["engagementName"];
            this.engPartnerName = _data["engPartnerName"];
            this.engManagerName = _data["engManagerName"];
            this.statusId = _data["statusId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChargeCodes {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCodes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chargeCode"] = this.chargeCode;
        data["isActive"] = this.isActive;
        data["engagementName"] = this.engagementName;
        data["engPartnerName"] = this.engPartnerName;
        data["engManagerName"] = this.engManagerName;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        return data;
    }
}

export interface IChargeCodes {
    id?: number;
    chargeCode?: string | undefined;
    isActive?: number;
    engagementName?: string | undefined;
    engPartnerName?: string | undefined;
    engManagerName?: string | undefined;
    statusId?: number;
    status?: string | undefined;
}

export class ChargeCodeDetails implements IChargeCodeDetails {
    id?: number;
    chargeCode?: string | undefined;
    isActive?: number;
    engagementName?: string | undefined;
    engPartnerName?: AdUser | undefined;
    engManagerName?: AdUser | undefined;

    constructor(data?: IChargeCodeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chargeCode = _data["chargeCode"];
            this.isActive = _data["isActive"];
            this.engagementName = _data["engagementName"];
            this.engPartnerName = _data["engPartnerName"] ? AdUser.fromJS(_data["engPartnerName"]) : <any>undefined;
            this.engManagerName = _data["engManagerName"] ? AdUser.fromJS(_data["engManagerName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChargeCodeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCodeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chargeCode"] = this.chargeCode;
        data["isActive"] = this.isActive;
        data["engagementName"] = this.engagementName;
        data["engPartnerName"] = this.engPartnerName ? this.engPartnerName.toJSON() : <any>undefined;
        data["engManagerName"] = this.engManagerName ? this.engManagerName.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChargeCodeDetails {
    id?: number;
    chargeCode?: string | undefined;
    isActive?: number;
    engagementName?: string | undefined;
    engPartnerName?: AdUser | undefined;
    engManagerName?: AdUser | undefined;
}

export class AuditHistoryData implements IAuditHistoryData {
    auditHistoryList?: AuditHistory[] | undefined;
    amendedDataList?: AmendedData[] | undefined;
    isSizeExceeds?: boolean;

    constructor(data?: IAuditHistoryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["auditHistoryList"])) {
                this.auditHistoryList = [] as any;
                for (let item of _data["auditHistoryList"])
                    this.auditHistoryList!.push(AuditHistory.fromJS(item));
            }
            if (Array.isArray(_data["amendedDataList"])) {
                this.amendedDataList = [] as any;
                for (let item of _data["amendedDataList"])
                    this.amendedDataList!.push(AmendedData.fromJS(item));
            }
            this.isSizeExceeds = _data["isSizeExceeds"];
        }
    }

    static fromJS(data: any): AuditHistoryData {
        data = typeof data === 'object' ? data : {};
        let result = new AuditHistoryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.auditHistoryList)) {
            data["auditHistoryList"] = [];
            for (let item of this.auditHistoryList)
                data["auditHistoryList"].push(item.toJSON());
        }
        if (Array.isArray(this.amendedDataList)) {
            data["amendedDataList"] = [];
            for (let item of this.amendedDataList)
                data["amendedDataList"].push(item.toJSON());
        }
        data["isSizeExceeds"] = this.isSizeExceeds;
        return data;
    }
}

export interface IAuditHistoryData {
    auditHistoryList?: AuditHistory[] | undefined;
    amendedDataList?: AmendedData[] | undefined;
    isSizeExceeds?: boolean;
}

export class AuditHistory implements IAuditHistory {
    id?: number;
    metadata?: string | undefined;
    oldData?: string | undefined;
    newData?: string | undefined;
    difference?: string | undefined;
    candidateProfileId?: number;
    operation?: string | undefined;
    modifiedDate?: Date;
    modifiedById?: number;
    userName?: string | undefined;
    normalizedUsername?: string | undefined;
    duplicate?: boolean;
    module?: string | undefined;

    constructor(data?: IAuditHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.metadata = _data["metadata"];
            this.oldData = _data["oldData"];
            this.newData = _data["newData"];
            this.difference = _data["difference"];
            this.candidateProfileId = _data["candidateProfileId"];
            this.operation = _data["operation"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.userName = _data["userName"];
            this.normalizedUsername = _data["normalizedUsername"];
            this.duplicate = _data["duplicate"];
            this.module = _data["module"];
        }
    }

    static fromJS(data: any): AuditHistory {
        data = typeof data === 'object' ? data : {};
        let result = new AuditHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["metadata"] = this.metadata;
        data["oldData"] = this.oldData;
        data["newData"] = this.newData;
        data["difference"] = this.difference;
        data["candidateProfileId"] = this.candidateProfileId;
        data["operation"] = this.operation;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["userName"] = this.userName;
        data["normalizedUsername"] = this.normalizedUsername;
        data["duplicate"] = this.duplicate;
        data["module"] = this.module;
        return data;
    }
}

export interface IAuditHistory {
    id?: number;
    metadata?: string | undefined;
    oldData?: string | undefined;
    newData?: string | undefined;
    difference?: string | undefined;
    candidateProfileId?: number;
    operation?: string | undefined;
    modifiedDate?: Date;
    modifiedById?: number;
    userName?: string | undefined;
    normalizedUsername?: string | undefined;
    duplicate?: boolean;
    module?: string | undefined;
}

export class AmendedData implements IAmendedData {
    candidateProfileId?: number;
    name?: string | undefined;
    amendedDate?: Date | undefined;

    constructor(data?: IAmendedData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateProfileId = _data["candidateProfileId"];
            this.name = _data["name"];
            this.amendedDate = _data["amendedDate"] ? new Date(_data["amendedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AmendedData {
        data = typeof data === 'object' ? data : {};
        let result = new AmendedData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateProfileId"] = this.candidateProfileId;
        data["name"] = this.name;
        data["amendedDate"] = this.amendedDate ? this.amendedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAmendedData {
    candidateProfileId?: number;
    name?: string | undefined;
    amendedDate?: Date | undefined;
}

export class EmailAttachments implements IEmailAttachments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    candidateActivityId?: number;
    emailTemplateId?: number;
    activityId?: number;
    candidateActivity?: CandidateActivity | undefined;
    candidateId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedBy?: Employee | undefined;
    modifiedDate?: Date | undefined;

    constructor(data?: IEmailAttachments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.candidateActivityId = _data["candidateActivityId"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.activityId = _data["activityId"];
            this.candidateActivity = _data["candidateActivity"] ? CandidateActivity.fromJS(_data["candidateActivity"]) : <any>undefined;
            this.candidateId = _data["candidateId"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? Employee.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"] ? Employee.fromJS(_data["modifiedBy"]) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailAttachments {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["candidateActivityId"] = this.candidateActivityId;
        data["emailTemplateId"] = this.emailTemplateId;
        data["activityId"] = this.activityId;
        data["candidateActivity"] = this.candidateActivity ? this.candidateActivity.toJSON() : <any>undefined;
        data["candidateId"] = this.candidateId;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmailAttachments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    candidateActivityId?: number;
    emailTemplateId?: number;
    activityId?: number;
    candidateActivity?: CandidateActivity | undefined;
    candidateId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedBy?: Employee | undefined;
    modifiedDate?: Date | undefined;
}

export class CandidateActivity implements ICandidateActivity {
    id?: number;
    candidateProfileId?: number;
    activityId?: number;
    status?: ActivityStatus;
    activityType?: ActivityTypes;
    completedDate?: Date | undefined;
    previousStatus?: ActivityStatus | undefined;
    modifiedBy?: number | undefined;
    modifiedByNm?: string | undefined;

    constructor(data?: ICandidateActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.candidateProfileId = _data["candidateProfileId"];
            this.activityId = _data["activityId"];
            this.status = _data["status"];
            this.activityType = _data["activityType"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.previousStatus = _data["previousStatus"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedByNm = _data["modifiedByNm"];
        }
    }

    static fromJS(data: any): CandidateActivity {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["candidateProfileId"] = this.candidateProfileId;
        data["activityId"] = this.activityId;
        data["status"] = this.status;
        data["activityType"] = this.activityType;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["previousStatus"] = this.previousStatus;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedByNm"] = this.modifiedByNm;
        return data;
    }
}

export interface ICandidateActivity {
    id?: number;
    candidateProfileId?: number;
    activityId?: number;
    status?: ActivityStatus;
    activityType?: ActivityTypes;
    completedDate?: Date | undefined;
    previousStatus?: ActivityStatus | undefined;
    modifiedBy?: number | undefined;
    modifiedByNm?: string | undefined;
}

export class OperationResultOfCandidateProfile implements IOperationResultOfCandidateProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CandidateProfile | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfCandidateProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? CandidateProfile.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfCandidateProfile {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfCandidateProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfCandidateProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CandidateProfile | undefined;
    errorCode?: number;
}

export class CandidateDocuments implements ICandidateDocuments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    candidateProfileId?: number;
    createdById?: number;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentId?: number;
    document?: LookupField | undefined;
    documentName?: string | undefined;
    moduleType?: number;
    disabled?: boolean;
    checks?: string | undefined;
    tmT_Check_Status?: string | undefined;
    documentChecks?: DocumentConfigLookupMapping[] | undefined;

    constructor(data?: ICandidateDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? LookupField.fromJS(_data["documentType"]) : <any>undefined;
            this.candidateProfileId = _data["candidateProfileId"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? LookupField.fromJS(_data["document"]) : <any>undefined;
            this.documentName = _data["documentName"];
            this.moduleType = _data["moduleType"];
            this.disabled = _data["disabled"];
            this.checks = _data["checks"];
            this.tmT_Check_Status = _data["tmT_Check_Status"];
            if (Array.isArray(_data["documentChecks"])) {
                this.documentChecks = [] as any;
                for (let item of _data["documentChecks"])
                    this.documentChecks!.push(DocumentConfigLookupMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidateDocuments {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateDocuments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["candidateProfileId"] = this.candidateProfileId;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentName"] = this.documentName;
        data["moduleType"] = this.moduleType;
        data["disabled"] = this.disabled;
        data["checks"] = this.checks;
        data["tmT_Check_Status"] = this.tmT_Check_Status;
        if (Array.isArray(this.documentChecks)) {
            data["documentChecks"] = [];
            for (let item of this.documentChecks)
                data["documentChecks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICandidateDocuments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    candidateProfileId?: number;
    createdById?: number;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentId?: number;
    document?: LookupField | undefined;
    documentName?: string | undefined;
    moduleType?: number;
    disabled?: boolean;
    checks?: string | undefined;
    tmT_Check_Status?: string | undefined;
    documentChecks?: DocumentConfigLookupMapping[] | undefined;
}

export class OperationResultOfCandidateDocuments implements IOperationResultOfCandidateDocuments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CandidateDocuments | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfCandidateDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? CandidateDocuments.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfCandidateDocuments {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfCandidateDocuments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfCandidateDocuments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CandidateDocuments | undefined;
    errorCode?: number;
}

export class OperationResultOfEmailAttachments implements IOperationResultOfEmailAttachments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: EmailAttachments | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfEmailAttachments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? EmailAttachments.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfEmailAttachments {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfEmailAttachments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfEmailAttachments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: EmailAttachments | undefined;
    errorCode?: number;
}

export class OperationResultOfCombainedProfile implements IOperationResultOfCombainedProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CombainedProfile | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfCombainedProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? CombainedProfile.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfCombainedProfile {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfCombainedProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfCombainedProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CombainedProfile | undefined;
    errorCode?: number;
}

export class CombainedProfile implements ICombainedProfile {
    candidateProfile?: CandidateProfile | undefined;
    pbProfile?: PBProfile | undefined;
    comment?: Comments | undefined;

    constructor(data?: ICombainedProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateProfile = _data["candidateProfile"] ? CandidateProfile.fromJS(_data["candidateProfile"]) : <any>undefined;
            this.pbProfile = _data["pbProfile"] ? PBProfile.fromJS(_data["pbProfile"]) : <any>undefined;
            this.comment = _data["comment"] ? Comments.fromJS(_data["comment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CombainedProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CombainedProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateProfile"] = this.candidateProfile ? this.candidateProfile.toJSON() : <any>undefined;
        data["pbProfile"] = this.pbProfile ? this.pbProfile.toJSON() : <any>undefined;
        data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICombainedProfile {
    candidateProfile?: CandidateProfile | undefined;
    pbProfile?: PBProfile | undefined;
    comment?: Comments | undefined;
}

export class PBProfile implements IPBProfile {
    id?: number;
    candidateProfile?: CandidateProfile | undefined;
    pbStatus?: LookupField | undefined;
    currentLocation?: string | undefined;
    currentLocationId?: number | undefined;
    currentLocationCountryID?: number | undefined;
    noticePeriod?: string | undefined;
    maritalStatusId?: number | undefined;
    marriageEffectiveDate?: Date | undefined;
    dependentsId?: number | undefined;
    lastWorkingday?: Date | undefined;
    startdate?: Date | undefined;
    startdateStatusID?: number | undefined;
    confirmedEnddate?: Date | undefined;
    pbInitiationdatebyPTC?: Date | undefined;
    pbStatusID?: number | undefined;
    currentEmploymentStatusID?: number | undefined;
    transferTypeID?: number | undefined;
    transferScenarioID?: number | undefined;
    epRequestedDate?: Date | undefined;
    epCreatedDate?: Date | undefined;
    gpn?: string | undefined;
    immigrationCaseTypeID?: number | undefined;
    currentVisaStatusID?: number | undefined;
    flightBookingID?: number | undefined;
    flightBookingstatusIDEmp?: number | undefined;
    flightBookingstatusIDDep?: number | undefined;
    empDateOfIntiation?: Date | undefined;
    empDateOfCompletion?: Date | undefined;
    depDateOfIntiation?: Date | undefined;
    depDateOfCompletion?: Date | undefined;
    hotelBookingID?: number | undefined;
    reallocationBenefitID?: number | undefined;
    chargeCode?: string | undefined;
    buddyId?: number | undefined;
    buddyData?: AdUser | undefined;
    counselorId?: number | undefined;
    counselorData?: AdUser | undefined;
    executiveAssistantId?: number | undefined;
    executiveAssistantData?: AdUser | undefined;
    ccgLeadId?: number | undefined;
    ccgLeadData?: AdUser | undefined;
    cftLeadId?: number | undefined;
    cftLeadData?: AdUser | undefined;
    approvedPreHireExceptions?: string | undefined;
    createdBy?: number | undefined;
    createdDate?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    isNPNegotiableId?: number | undefined;
    isActivitiesCompleted?: number | undefined;
    completedDate?: Date | undefined;
    profileSubmittedDate?: Date | undefined;
    dualCitizenshipId?: number | undefined;
    eyVisaLCStatusID?: number | undefined;
    previousPBStatusID?: number | undefined;
    secondNationalityId?: number | undefined;
    visaAgentName?: string | undefined;
    isMerrSync?: boolean | undefined;
    autoEmails?: AutoEmail[] | undefined;
    previousStartdate?: Date | undefined;
    previousStartdateStatusID?: number | undefined;
    autoAssignedBuddyId?: number | undefined;
    autoAssignedCounselorId?: number | undefined;
    arabicJobGroup?: string | undefined;
    arabicVisaDesignation?: string | undefined;
    citizenshipId?: number | undefined;
    eduDocAttestationId?: number | undefined;
    famDocAttestationId?: number | undefined;
    vendorDetails?: string | undefined;
    isLowerJobTitle?: number | undefined;
    reasonForLowerJobTitle?: number | undefined;
    reasonForLowerJobTitleComment?: string | undefined;
    jobTitleUpdateAfterJoining?: number | undefined;
    isJobTitleUpdated?: number | undefined;
    eyApprovedVisaDate?: Date | undefined;
    entryPermitExpiryDate?: Date | undefined;
    joinedDate?: Date | undefined;
    withdrawnDate?: Date | undefined;
    declinedDate?: Date | undefined;
    inprocessDate?: Date | undefined;
    hotelBookingStatusID?: number | undefined;
    bookingInitiationDate?: Date | undefined;
    bookingCompletionDate?: Date | undefined;
    hotelBookingExceptions?: string | undefined;
    exceptionStatusId?: number | undefined;
    exceptionValidityDocAttestStatus?: Date | undefined;
    isJoiningWithoutValidWorkPermit?: number | undefined;
    exceptionValidityJoiningWithoutValidWorkPermit?: Date | undefined;
    visaJobTitleChangeStatus?: number | undefined;
    exceptionValidityVisaJobTitleChangeStatus?: Date | undefined;
    currentLegalEntity?: number | undefined;
    newJoinerWorkPermit?: number | undefined;
    immigrationCaseTypeCurrentLocation?: number | undefined;
    newJoinerCurrentLocationVisa?: number | undefined;
    activeVisa?: number | undefined;
    doesNewJoinerSponsorDep?: number | undefined;
    depVisaCancellationStatus?: number | undefined;
    gdaProcessRequirement?: number | undefined;
    gdaProcessStatus?: number | undefined;
    itClearance?: number | undefined;
    durationItClearance?: Date | undefined;
    homeCountryVisaCancellationStatus?: number | undefined;
    durationHomeCountryVisaCancellationStatus?: Date | undefined;
    exitFormalitiesStatus?: number | undefined;
    educationDocumentProcurementforAttestationId?: number | undefined;
    educationDocumentProcurementforAttestationRequestInitiatedDate?: Date | undefined;
    educationDocumentProcurementforAttestationDocumentscollectedDate?: Date | undefined;
    educationDocumentProcurementforAttestationAssesmentDate?: Date | undefined;
    educationDocumentProcurementforAttestationCompletedDate?: Date | undefined;
    documentProcurementforWorkPermitId?: number | undefined;
    documentProcurementforWorkPermitInitiatedDate?: Date | undefined;
    documentProcurementforWorkPermitCollectedDate?: Date | undefined;
    documentProcurementforWorkPermitAssesmentDate?: Date | undefined;
    documentProcurementforWorkPermitCompletedDate?: Date | undefined;
    educationDocumentAttestationId?: number | undefined;
    educationDocumentAttestationInitiatedDate?: Date | undefined;
    educationDocumentAttestationUnderProcessDate?: Date | undefined;
    educationDocumentAttestationCompletedDate?: Date | undefined;
    exceptionApprovalWorkPermitId?: number | undefined;
    exceptionApprovalWorkPermitInitiatedDate?: Date | undefined;
    exceptionApprovalWorkPermitApprovalReceivedDate?: Date | undefined;
    corporateDocumentId?: number | undefined;
    corporateDocumentInitiatedDate?: Date | undefined;
    corporateDocumentReceivedByVendorDate?: Date | undefined;
    corporateDocumentAssesmentDate?: Date | undefined;
    corporateDocumentCompletedDate?: Date | undefined;
    visaReTaggingId?: number | undefined;
    visaReTaggingNewDegree?: string | undefined;
    visaReTaggingNewDesignation?: string | undefined;
    visaReTaggingNewPortOfExitCountryId?: number | undefined;
    visaReTaggingNewPortOfExitCityId?: number | undefined;
    visaReTaggingInitiatedDate?: Date | undefined;
    visaReTaggingCompletedDate?: Date | undefined;
    revisedCorporateDocumentId?: number | undefined;
    revisedCorporateDocumentInitiatedDate?: Date | undefined;
    revisedCorporateDocumentReceivedByVendorDate?: Date | undefined;
    revisedCorporateDocumentAssesmentDate?: Date | undefined;
    revisedCorporateDocumentCompletedDate?: Date | undefined;
    pjDocumentCollectedStatus?: number | undefined;
    documentExpectedDate?: Date | undefined;
    mosadaqaId?: number | undefined;
    mosadaqaInitiatedDate?: Date | undefined;
    mosadaqaUnderProcessDate?: Date | undefined;
    mosadaqaCompletedDate?: Date | undefined;
    qvpId?: number | undefined;
    qvpInitiatedDate?: Date | undefined;
    qvpUnderProcessDate?: Date | undefined;
    qvpCompletedDate?: Date | undefined;
    professionalMembershipCertificateId?: number | undefined;
    professionalMembershipCertificateInitiatedDate?: Date | undefined;
    professionalMembershipCertificateUnderProcessDate?: Date | undefined;
    professionalMembershipCertificateCompletedDate?: Date | undefined;
    businessVisaCancellationLetterId?: number | undefined;
    businessVisaCancellationLetterInitiatedDate?: Date | undefined;
    businessVisaCancellationLetterCompletedDate?: Date | undefined;
    wpApplicationNJId?: number | undefined;
    wpApplicationNJMedicalAppointmentDate?: Date | undefined;
    wpApplicationNJMedicalProcessCompletedDate?: Date | undefined;
    wpApplicationNJPCCAppointmentDate?: Date | undefined;
    wpApplicationNJPCCProcessCompletedDate?: Date | undefined;
    wpApplicationNJBiometricsAppointmentDate?: Date | undefined;
    wpApplicationNJBiometricsProcessCompletedDate?: Date | undefined;
    wpApplicationNJHomeCountryVisaStampingProcessDate?: Date | undefined;
    wpApplicationNJHomeVisaStampedIssuedDate?: Date | undefined;
    wpApplicationEYId?: number | undefined;
    wpApplicationEYInitiatedDate?: Date | undefined;
    wpApplicationEYQVCAppointmentDate?: Date | undefined;
    wpApplicationEYEmbassyAppointmentDate?: Date | undefined;
    wpApplicationEYWorkPermitIssuedDate?: Date | undefined;
    laborContractId?: number | undefined;
    laborContractReceivedImmigrationDate?: Date | undefined;
    laborContractSharedWithEmployeeDate?: Date | undefined;
    laborContractReceivedFromEmployeeDate?: Date | undefined;
    laborContractSharedWithImmigrationDate?: Date | undefined;
    homeCountryExitFormalityId?: number | undefined;
    homeCountryExitFormalityInitiatedDate?: Date | undefined;
    homeCountryExitFormalityUnderProcessDate?: Date | undefined;
    homeCountryExitFormalityCompletedDate?: Date | undefined;
    travelBookingId?: number | undefined;
    travelBookingInitiatedDate?: Date | undefined;
    travelBookingCompletedDate?: Date | undefined;
    itAsset?: number | undefined;
    assetCourier?: number | undefined;
    accessCard?: number | undefined;

    constructor(data?: IPBProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.candidateProfile = _data["candidateProfile"] ? CandidateProfile.fromJS(_data["candidateProfile"]) : <any>undefined;
            this.pbStatus = _data["pbStatus"] ? LookupField.fromJS(_data["pbStatus"]) : <any>undefined;
            this.currentLocation = _data["currentLocation"];
            this.currentLocationId = _data["currentLocationId"];
            this.currentLocationCountryID = _data["currentLocationCountryID"];
            this.noticePeriod = _data["noticePeriod"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.marriageEffectiveDate = _data["marriageEffectiveDate"] ? new Date(_data["marriageEffectiveDate"].toString()) : <any>undefined;
            this.dependentsId = _data["dependentsId"];
            this.lastWorkingday = _data["lastWorkingday"] ? new Date(_data["lastWorkingday"].toString()) : <any>undefined;
            this.startdate = _data["startdate"] ? new Date(_data["startdate"].toString()) : <any>undefined;
            this.startdateStatusID = _data["startdateStatusID"];
            this.confirmedEnddate = _data["confirmedEnddate"] ? new Date(_data["confirmedEnddate"].toString()) : <any>undefined;
            this.pbInitiationdatebyPTC = _data["pbInitiationdatebyPTC"] ? new Date(_data["pbInitiationdatebyPTC"].toString()) : <any>undefined;
            this.pbStatusID = _data["pbStatusID"];
            this.currentEmploymentStatusID = _data["currentEmploymentStatusID"];
            this.transferTypeID = _data["transferTypeID"];
            this.transferScenarioID = _data["transferScenarioID"];
            this.epRequestedDate = _data["epRequestedDate"] ? new Date(_data["epRequestedDate"].toString()) : <any>undefined;
            this.epCreatedDate = _data["epCreatedDate"] ? new Date(_data["epCreatedDate"].toString()) : <any>undefined;
            this.gpn = _data["gpn"];
            this.immigrationCaseTypeID = _data["immigrationCaseTypeID"];
            this.currentVisaStatusID = _data["currentVisaStatusID"];
            this.flightBookingID = _data["flightBookingID"];
            this.flightBookingstatusIDEmp = _data["flightBookingstatusIDEmp"];
            this.flightBookingstatusIDDep = _data["flightBookingstatusIDDep"];
            this.empDateOfIntiation = _data["empDateOfIntiation"] ? new Date(_data["empDateOfIntiation"].toString()) : <any>undefined;
            this.empDateOfCompletion = _data["empDateOfCompletion"] ? new Date(_data["empDateOfCompletion"].toString()) : <any>undefined;
            this.depDateOfIntiation = _data["depDateOfIntiation"] ? new Date(_data["depDateOfIntiation"].toString()) : <any>undefined;
            this.depDateOfCompletion = _data["depDateOfCompletion"] ? new Date(_data["depDateOfCompletion"].toString()) : <any>undefined;
            this.hotelBookingID = _data["hotelBookingID"];
            this.reallocationBenefitID = _data["reallocationBenefitID"];
            this.chargeCode = _data["chargeCode"];
            this.buddyId = _data["buddyId"];
            this.buddyData = _data["buddyData"] ? AdUser.fromJS(_data["buddyData"]) : <any>undefined;
            this.counselorId = _data["counselorId"];
            this.counselorData = _data["counselorData"] ? AdUser.fromJS(_data["counselorData"]) : <any>undefined;
            this.executiveAssistantId = _data["executiveAssistantId"];
            this.executiveAssistantData = _data["executiveAssistantData"] ? AdUser.fromJS(_data["executiveAssistantData"]) : <any>undefined;
            this.ccgLeadId = _data["ccgLeadId"];
            this.ccgLeadData = _data["ccgLeadData"] ? AdUser.fromJS(_data["ccgLeadData"]) : <any>undefined;
            this.cftLeadId = _data["cftLeadId"];
            this.cftLeadData = _data["cftLeadData"] ? AdUser.fromJS(_data["cftLeadData"]) : <any>undefined;
            this.approvedPreHireExceptions = _data["approvedPreHireExceptions"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.isNPNegotiableId = _data["isNPNegotiableId"];
            this.isActivitiesCompleted = _data["isActivitiesCompleted"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.profileSubmittedDate = _data["profileSubmittedDate"] ? new Date(_data["profileSubmittedDate"].toString()) : <any>undefined;
            this.dualCitizenshipId = _data["dualCitizenshipId"];
            this.eyVisaLCStatusID = _data["eyVisaLCStatusID"];
            this.previousPBStatusID = _data["previousPBStatusID"];
            this.secondNationalityId = _data["secondNationalityId"];
            this.visaAgentName = _data["visaAgentName"];
            this.isMerrSync = _data["isMerrSync"];
            if (Array.isArray(_data["autoEmails"])) {
                this.autoEmails = [] as any;
                for (let item of _data["autoEmails"])
                    this.autoEmails!.push(AutoEmail.fromJS(item));
            }
            this.previousStartdate = _data["previousStartdate"] ? new Date(_data["previousStartdate"].toString()) : <any>undefined;
            this.previousStartdateStatusID = _data["previousStartdateStatusID"];
            this.autoAssignedBuddyId = _data["autoAssignedBuddyId"];
            this.autoAssignedCounselorId = _data["autoAssignedCounselorId"];
            this.arabicJobGroup = _data["arabicJobGroup"];
            this.arabicVisaDesignation = _data["arabicVisaDesignation"];
            this.citizenshipId = _data["citizenshipId"];
            this.eduDocAttestationId = _data["eduDocAttestationId"];
            this.famDocAttestationId = _data["famDocAttestationId"];
            this.vendorDetails = _data["vendorDetails"];
            this.isLowerJobTitle = _data["isLowerJobTitle"];
            this.reasonForLowerJobTitle = _data["reasonForLowerJobTitle"];
            this.reasonForLowerJobTitleComment = _data["reasonForLowerJobTitleComment"];
            this.jobTitleUpdateAfterJoining = _data["jobTitleUpdateAfterJoining"];
            this.isJobTitleUpdated = _data["isJobTitleUpdated"];
            this.eyApprovedVisaDate = _data["eyApprovedVisaDate"] ? new Date(_data["eyApprovedVisaDate"].toString()) : <any>undefined;
            this.entryPermitExpiryDate = _data["entryPermitExpiryDate"] ? new Date(_data["entryPermitExpiryDate"].toString()) : <any>undefined;
            this.joinedDate = _data["joinedDate"] ? new Date(_data["joinedDate"].toString()) : <any>undefined;
            this.withdrawnDate = _data["withdrawnDate"] ? new Date(_data["withdrawnDate"].toString()) : <any>undefined;
            this.declinedDate = _data["declinedDate"] ? new Date(_data["declinedDate"].toString()) : <any>undefined;
            this.inprocessDate = _data["inprocessDate"] ? new Date(_data["inprocessDate"].toString()) : <any>undefined;
            this.hotelBookingStatusID = _data["hotelBookingStatusID"];
            this.bookingInitiationDate = _data["bookingInitiationDate"] ? new Date(_data["bookingInitiationDate"].toString()) : <any>undefined;
            this.bookingCompletionDate = _data["bookingCompletionDate"] ? new Date(_data["bookingCompletionDate"].toString()) : <any>undefined;
            this.hotelBookingExceptions = _data["hotelBookingExceptions"];
            this.exceptionStatusId = _data["exceptionStatusId"];
            this.exceptionValidityDocAttestStatus = _data["exceptionValidityDocAttestStatus"] ? new Date(_data["exceptionValidityDocAttestStatus"].toString()) : <any>undefined;
            this.isJoiningWithoutValidWorkPermit = _data["isJoiningWithoutValidWorkPermit"];
            this.exceptionValidityJoiningWithoutValidWorkPermit = _data["exceptionValidityJoiningWithoutValidWorkPermit"] ? new Date(_data["exceptionValidityJoiningWithoutValidWorkPermit"].toString()) : <any>undefined;
            this.visaJobTitleChangeStatus = _data["visaJobTitleChangeStatus"];
            this.exceptionValidityVisaJobTitleChangeStatus = _data["exceptionValidityVisaJobTitleChangeStatus"] ? new Date(_data["exceptionValidityVisaJobTitleChangeStatus"].toString()) : <any>undefined;
            this.currentLegalEntity = _data["currentLegalEntity"];
            this.newJoinerWorkPermit = _data["newJoinerWorkPermit"];
            this.immigrationCaseTypeCurrentLocation = _data["immigrationCaseTypeCurrentLocation"];
            this.newJoinerCurrentLocationVisa = _data["newJoinerCurrentLocationVisa"];
            this.activeVisa = _data["activeVisa"];
            this.doesNewJoinerSponsorDep = _data["doesNewJoinerSponsorDep"];
            this.depVisaCancellationStatus = _data["depVisaCancellationStatus"];
            this.gdaProcessRequirement = _data["gdaProcessRequirement"];
            this.gdaProcessStatus = _data["gdaProcessStatus"];
            this.itClearance = _data["itClearance"];
            this.durationItClearance = _data["durationItClearance"] ? new Date(_data["durationItClearance"].toString()) : <any>undefined;
            this.homeCountryVisaCancellationStatus = _data["homeCountryVisaCancellationStatus"];
            this.durationHomeCountryVisaCancellationStatus = _data["durationHomeCountryVisaCancellationStatus"] ? new Date(_data["durationHomeCountryVisaCancellationStatus"].toString()) : <any>undefined;
            this.exitFormalitiesStatus = _data["exitFormalitiesStatus"];
            this.educationDocumentProcurementforAttestationId = _data["educationDocumentProcurementforAttestationId"];
            this.educationDocumentProcurementforAttestationRequestInitiatedDate = _data["educationDocumentProcurementforAttestationRequestInitiatedDate"] ? new Date(_data["educationDocumentProcurementforAttestationRequestInitiatedDate"].toString()) : <any>undefined;
            this.educationDocumentProcurementforAttestationDocumentscollectedDate = _data["educationDocumentProcurementforAttestationDocumentscollectedDate"] ? new Date(_data["educationDocumentProcurementforAttestationDocumentscollectedDate"].toString()) : <any>undefined;
            this.educationDocumentProcurementforAttestationAssesmentDate = _data["educationDocumentProcurementforAttestationAssesmentDate"] ? new Date(_data["educationDocumentProcurementforAttestationAssesmentDate"].toString()) : <any>undefined;
            this.educationDocumentProcurementforAttestationCompletedDate = _data["educationDocumentProcurementforAttestationCompletedDate"] ? new Date(_data["educationDocumentProcurementforAttestationCompletedDate"].toString()) : <any>undefined;
            this.documentProcurementforWorkPermitId = _data["documentProcurementforWorkPermitId"];
            this.documentProcurementforWorkPermitInitiatedDate = _data["documentProcurementforWorkPermitInitiatedDate"] ? new Date(_data["documentProcurementforWorkPermitInitiatedDate"].toString()) : <any>undefined;
            this.documentProcurementforWorkPermitCollectedDate = _data["documentProcurementforWorkPermitCollectedDate"] ? new Date(_data["documentProcurementforWorkPermitCollectedDate"].toString()) : <any>undefined;
            this.documentProcurementforWorkPermitAssesmentDate = _data["documentProcurementforWorkPermitAssesmentDate"] ? new Date(_data["documentProcurementforWorkPermitAssesmentDate"].toString()) : <any>undefined;
            this.documentProcurementforWorkPermitCompletedDate = _data["documentProcurementforWorkPermitCompletedDate"] ? new Date(_data["documentProcurementforWorkPermitCompletedDate"].toString()) : <any>undefined;
            this.educationDocumentAttestationId = _data["educationDocumentAttestationId"];
            this.educationDocumentAttestationInitiatedDate = _data["educationDocumentAttestationInitiatedDate"] ? new Date(_data["educationDocumentAttestationInitiatedDate"].toString()) : <any>undefined;
            this.educationDocumentAttestationUnderProcessDate = _data["educationDocumentAttestationUnderProcessDate"] ? new Date(_data["educationDocumentAttestationUnderProcessDate"].toString()) : <any>undefined;
            this.educationDocumentAttestationCompletedDate = _data["educationDocumentAttestationCompletedDate"] ? new Date(_data["educationDocumentAttestationCompletedDate"].toString()) : <any>undefined;
            this.exceptionApprovalWorkPermitId = _data["exceptionApprovalWorkPermitId"];
            this.exceptionApprovalWorkPermitInitiatedDate = _data["exceptionApprovalWorkPermitInitiatedDate"] ? new Date(_data["exceptionApprovalWorkPermitInitiatedDate"].toString()) : <any>undefined;
            this.exceptionApprovalWorkPermitApprovalReceivedDate = _data["exceptionApprovalWorkPermitApprovalReceivedDate"] ? new Date(_data["exceptionApprovalWorkPermitApprovalReceivedDate"].toString()) : <any>undefined;
            this.corporateDocumentId = _data["corporateDocumentId"];
            this.corporateDocumentInitiatedDate = _data["corporateDocumentInitiatedDate"] ? new Date(_data["corporateDocumentInitiatedDate"].toString()) : <any>undefined;
            this.corporateDocumentReceivedByVendorDate = _data["corporateDocumentReceivedByVendorDate"] ? new Date(_data["corporateDocumentReceivedByVendorDate"].toString()) : <any>undefined;
            this.corporateDocumentAssesmentDate = _data["corporateDocumentAssesmentDate"] ? new Date(_data["corporateDocumentAssesmentDate"].toString()) : <any>undefined;
            this.corporateDocumentCompletedDate = _data["corporateDocumentCompletedDate"] ? new Date(_data["corporateDocumentCompletedDate"].toString()) : <any>undefined;
            this.visaReTaggingId = _data["visaReTaggingId"];
            this.visaReTaggingNewDegree = _data["visaReTaggingNewDegree"];
            this.visaReTaggingNewDesignation = _data["visaReTaggingNewDesignation"];
            this.visaReTaggingNewPortOfExitCountryId = _data["visaReTaggingNewPortOfExitCountryId"];
            this.visaReTaggingNewPortOfExitCityId = _data["visaReTaggingNewPortOfExitCityId"];
            this.visaReTaggingInitiatedDate = _data["visaReTaggingInitiatedDate"] ? new Date(_data["visaReTaggingInitiatedDate"].toString()) : <any>undefined;
            this.visaReTaggingCompletedDate = _data["visaReTaggingCompletedDate"] ? new Date(_data["visaReTaggingCompletedDate"].toString()) : <any>undefined;
            this.revisedCorporateDocumentId = _data["revisedCorporateDocumentId"];
            this.revisedCorporateDocumentInitiatedDate = _data["revisedCorporateDocumentInitiatedDate"] ? new Date(_data["revisedCorporateDocumentInitiatedDate"].toString()) : <any>undefined;
            this.revisedCorporateDocumentReceivedByVendorDate = _data["revisedCorporateDocumentReceivedByVendorDate"] ? new Date(_data["revisedCorporateDocumentReceivedByVendorDate"].toString()) : <any>undefined;
            this.revisedCorporateDocumentAssesmentDate = _data["revisedCorporateDocumentAssesmentDate"] ? new Date(_data["revisedCorporateDocumentAssesmentDate"].toString()) : <any>undefined;
            this.revisedCorporateDocumentCompletedDate = _data["revisedCorporateDocumentCompletedDate"] ? new Date(_data["revisedCorporateDocumentCompletedDate"].toString()) : <any>undefined;
            this.pjDocumentCollectedStatus = _data["pjDocumentCollectedStatus"];
            this.documentExpectedDate = _data["documentExpectedDate"] ? new Date(_data["documentExpectedDate"].toString()) : <any>undefined;
            this.mosadaqaId = _data["mosadaqaId"];
            this.mosadaqaInitiatedDate = _data["mosadaqaInitiatedDate"] ? new Date(_data["mosadaqaInitiatedDate"].toString()) : <any>undefined;
            this.mosadaqaUnderProcessDate = _data["mosadaqaUnderProcessDate"] ? new Date(_data["mosadaqaUnderProcessDate"].toString()) : <any>undefined;
            this.mosadaqaCompletedDate = _data["mosadaqaCompletedDate"] ? new Date(_data["mosadaqaCompletedDate"].toString()) : <any>undefined;
            this.qvpId = _data["qvpId"];
            this.qvpInitiatedDate = _data["qvpInitiatedDate"] ? new Date(_data["qvpInitiatedDate"].toString()) : <any>undefined;
            this.qvpUnderProcessDate = _data["qvpUnderProcessDate"] ? new Date(_data["qvpUnderProcessDate"].toString()) : <any>undefined;
            this.qvpCompletedDate = _data["qvpCompletedDate"] ? new Date(_data["qvpCompletedDate"].toString()) : <any>undefined;
            this.professionalMembershipCertificateId = _data["professionalMembershipCertificateId"];
            this.professionalMembershipCertificateInitiatedDate = _data["professionalMembershipCertificateInitiatedDate"] ? new Date(_data["professionalMembershipCertificateInitiatedDate"].toString()) : <any>undefined;
            this.professionalMembershipCertificateUnderProcessDate = _data["professionalMembershipCertificateUnderProcessDate"] ? new Date(_data["professionalMembershipCertificateUnderProcessDate"].toString()) : <any>undefined;
            this.professionalMembershipCertificateCompletedDate = _data["professionalMembershipCertificateCompletedDate"] ? new Date(_data["professionalMembershipCertificateCompletedDate"].toString()) : <any>undefined;
            this.businessVisaCancellationLetterId = _data["businessVisaCancellationLetterId"];
            this.businessVisaCancellationLetterInitiatedDate = _data["businessVisaCancellationLetterInitiatedDate"] ? new Date(_data["businessVisaCancellationLetterInitiatedDate"].toString()) : <any>undefined;
            this.businessVisaCancellationLetterCompletedDate = _data["businessVisaCancellationLetterCompletedDate"] ? new Date(_data["businessVisaCancellationLetterCompletedDate"].toString()) : <any>undefined;
            this.wpApplicationNJId = _data["wpApplicationNJId"];
            this.wpApplicationNJMedicalAppointmentDate = _data["wpApplicationNJMedicalAppointmentDate"] ? new Date(_data["wpApplicationNJMedicalAppointmentDate"].toString()) : <any>undefined;
            this.wpApplicationNJMedicalProcessCompletedDate = _data["wpApplicationNJMedicalProcessCompletedDate"] ? new Date(_data["wpApplicationNJMedicalProcessCompletedDate"].toString()) : <any>undefined;
            this.wpApplicationNJPCCAppointmentDate = _data["wpApplicationNJPCCAppointmentDate"] ? new Date(_data["wpApplicationNJPCCAppointmentDate"].toString()) : <any>undefined;
            this.wpApplicationNJPCCProcessCompletedDate = _data["wpApplicationNJPCCProcessCompletedDate"] ? new Date(_data["wpApplicationNJPCCProcessCompletedDate"].toString()) : <any>undefined;
            this.wpApplicationNJBiometricsAppointmentDate = _data["wpApplicationNJBiometricsAppointmentDate"] ? new Date(_data["wpApplicationNJBiometricsAppointmentDate"].toString()) : <any>undefined;
            this.wpApplicationNJBiometricsProcessCompletedDate = _data["wpApplicationNJBiometricsProcessCompletedDate"] ? new Date(_data["wpApplicationNJBiometricsProcessCompletedDate"].toString()) : <any>undefined;
            this.wpApplicationNJHomeCountryVisaStampingProcessDate = _data["wpApplicationNJHomeCountryVisaStampingProcessDate"] ? new Date(_data["wpApplicationNJHomeCountryVisaStampingProcessDate"].toString()) : <any>undefined;
            this.wpApplicationNJHomeVisaStampedIssuedDate = _data["wpApplicationNJHomeVisaStampedIssuedDate"] ? new Date(_data["wpApplicationNJHomeVisaStampedIssuedDate"].toString()) : <any>undefined;
            this.wpApplicationEYId = _data["wpApplicationEYId"];
            this.wpApplicationEYInitiatedDate = _data["wpApplicationEYInitiatedDate"] ? new Date(_data["wpApplicationEYInitiatedDate"].toString()) : <any>undefined;
            this.wpApplicationEYQVCAppointmentDate = _data["wpApplicationEYQVCAppointmentDate"] ? new Date(_data["wpApplicationEYQVCAppointmentDate"].toString()) : <any>undefined;
            this.wpApplicationEYEmbassyAppointmentDate = _data["wpApplicationEYEmbassyAppointmentDate"] ? new Date(_data["wpApplicationEYEmbassyAppointmentDate"].toString()) : <any>undefined;
            this.wpApplicationEYWorkPermitIssuedDate = _data["wpApplicationEYWorkPermitIssuedDate"] ? new Date(_data["wpApplicationEYWorkPermitIssuedDate"].toString()) : <any>undefined;
            this.laborContractId = _data["laborContractId"];
            this.laborContractReceivedImmigrationDate = _data["laborContractReceivedImmigrationDate"] ? new Date(_data["laborContractReceivedImmigrationDate"].toString()) : <any>undefined;
            this.laborContractSharedWithEmployeeDate = _data["laborContractSharedWithEmployeeDate"] ? new Date(_data["laborContractSharedWithEmployeeDate"].toString()) : <any>undefined;
            this.laborContractReceivedFromEmployeeDate = _data["laborContractReceivedFromEmployeeDate"] ? new Date(_data["laborContractReceivedFromEmployeeDate"].toString()) : <any>undefined;
            this.laborContractSharedWithImmigrationDate = _data["laborContractSharedWithImmigrationDate"] ? new Date(_data["laborContractSharedWithImmigrationDate"].toString()) : <any>undefined;
            this.homeCountryExitFormalityId = _data["homeCountryExitFormalityId"];
            this.homeCountryExitFormalityInitiatedDate = _data["homeCountryExitFormalityInitiatedDate"] ? new Date(_data["homeCountryExitFormalityInitiatedDate"].toString()) : <any>undefined;
            this.homeCountryExitFormalityUnderProcessDate = _data["homeCountryExitFormalityUnderProcessDate"] ? new Date(_data["homeCountryExitFormalityUnderProcessDate"].toString()) : <any>undefined;
            this.homeCountryExitFormalityCompletedDate = _data["homeCountryExitFormalityCompletedDate"] ? new Date(_data["homeCountryExitFormalityCompletedDate"].toString()) : <any>undefined;
            this.travelBookingId = _data["travelBookingId"];
            this.travelBookingInitiatedDate = _data["travelBookingInitiatedDate"] ? new Date(_data["travelBookingInitiatedDate"].toString()) : <any>undefined;
            this.travelBookingCompletedDate = _data["travelBookingCompletedDate"] ? new Date(_data["travelBookingCompletedDate"].toString()) : <any>undefined;
            this.itAsset = _data["itAsset"];
            this.assetCourier = _data["assetCourier"];
            this.accessCard = _data["accessCard"];
        }
    }

    static fromJS(data: any): PBProfile {
        data = typeof data === 'object' ? data : {};
        let result = new PBProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["candidateProfile"] = this.candidateProfile ? this.candidateProfile.toJSON() : <any>undefined;
        data["pbStatus"] = this.pbStatus ? this.pbStatus.toJSON() : <any>undefined;
        data["currentLocation"] = this.currentLocation;
        data["currentLocationId"] = this.currentLocationId;
        data["currentLocationCountryID"] = this.currentLocationCountryID;
        data["noticePeriod"] = this.noticePeriod;
        data["maritalStatusId"] = this.maritalStatusId;
        data["marriageEffectiveDate"] = this.marriageEffectiveDate ? this.marriageEffectiveDate.toISOString() : <any>undefined;
        data["dependentsId"] = this.dependentsId;
        data["lastWorkingday"] = this.lastWorkingday ? this.lastWorkingday.toISOString() : <any>undefined;
        data["startdate"] = this.startdate ? this.startdate.toISOString() : <any>undefined;
        data["startdateStatusID"] = this.startdateStatusID;
        data["confirmedEnddate"] = this.confirmedEnddate ? this.confirmedEnddate.toISOString() : <any>undefined;
        data["pbInitiationdatebyPTC"] = this.pbInitiationdatebyPTC ? this.pbInitiationdatebyPTC.toISOString() : <any>undefined;
        data["pbStatusID"] = this.pbStatusID;
        data["currentEmploymentStatusID"] = this.currentEmploymentStatusID;
        data["transferTypeID"] = this.transferTypeID;
        data["transferScenarioID"] = this.transferScenarioID;
        data["epRequestedDate"] = this.epRequestedDate ? this.epRequestedDate.toISOString() : <any>undefined;
        data["epCreatedDate"] = this.epCreatedDate ? this.epCreatedDate.toISOString() : <any>undefined;
        data["gpn"] = this.gpn;
        data["immigrationCaseTypeID"] = this.immigrationCaseTypeID;
        data["currentVisaStatusID"] = this.currentVisaStatusID;
        data["flightBookingID"] = this.flightBookingID;
        data["flightBookingstatusIDEmp"] = this.flightBookingstatusIDEmp;
        data["flightBookingstatusIDDep"] = this.flightBookingstatusIDDep;
        data["empDateOfIntiation"] = this.empDateOfIntiation ? this.empDateOfIntiation.toISOString() : <any>undefined;
        data["empDateOfCompletion"] = this.empDateOfCompletion ? this.empDateOfCompletion.toISOString() : <any>undefined;
        data["depDateOfIntiation"] = this.depDateOfIntiation ? this.depDateOfIntiation.toISOString() : <any>undefined;
        data["depDateOfCompletion"] = this.depDateOfCompletion ? this.depDateOfCompletion.toISOString() : <any>undefined;
        data["hotelBookingID"] = this.hotelBookingID;
        data["reallocationBenefitID"] = this.reallocationBenefitID;
        data["chargeCode"] = this.chargeCode;
        data["buddyId"] = this.buddyId;
        data["buddyData"] = this.buddyData ? this.buddyData.toJSON() : <any>undefined;
        data["counselorId"] = this.counselorId;
        data["counselorData"] = this.counselorData ? this.counselorData.toJSON() : <any>undefined;
        data["executiveAssistantId"] = this.executiveAssistantId;
        data["executiveAssistantData"] = this.executiveAssistantData ? this.executiveAssistantData.toJSON() : <any>undefined;
        data["ccgLeadId"] = this.ccgLeadId;
        data["ccgLeadData"] = this.ccgLeadData ? this.ccgLeadData.toJSON() : <any>undefined;
        data["cftLeadId"] = this.cftLeadId;
        data["cftLeadData"] = this.cftLeadData ? this.cftLeadData.toJSON() : <any>undefined;
        data["approvedPreHireExceptions"] = this.approvedPreHireExceptions;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["isNPNegotiableId"] = this.isNPNegotiableId;
        data["isActivitiesCompleted"] = this.isActivitiesCompleted;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["profileSubmittedDate"] = this.profileSubmittedDate ? this.profileSubmittedDate.toISOString() : <any>undefined;
        data["dualCitizenshipId"] = this.dualCitizenshipId;
        data["eyVisaLCStatusID"] = this.eyVisaLCStatusID;
        data["previousPBStatusID"] = this.previousPBStatusID;
        data["secondNationalityId"] = this.secondNationalityId;
        data["visaAgentName"] = this.visaAgentName;
        data["isMerrSync"] = this.isMerrSync;
        if (Array.isArray(this.autoEmails)) {
            data["autoEmails"] = [];
            for (let item of this.autoEmails)
                data["autoEmails"].push(item.toJSON());
        }
        data["previousStartdate"] = this.previousStartdate ? this.previousStartdate.toISOString() : <any>undefined;
        data["previousStartdateStatusID"] = this.previousStartdateStatusID;
        data["autoAssignedBuddyId"] = this.autoAssignedBuddyId;
        data["autoAssignedCounselorId"] = this.autoAssignedCounselorId;
        data["arabicJobGroup"] = this.arabicJobGroup;
        data["arabicVisaDesignation"] = this.arabicVisaDesignation;
        data["citizenshipId"] = this.citizenshipId;
        data["eduDocAttestationId"] = this.eduDocAttestationId;
        data["famDocAttestationId"] = this.famDocAttestationId;
        data["vendorDetails"] = this.vendorDetails;
        data["isLowerJobTitle"] = this.isLowerJobTitle;
        data["reasonForLowerJobTitle"] = this.reasonForLowerJobTitle;
        data["reasonForLowerJobTitleComment"] = this.reasonForLowerJobTitleComment;
        data["jobTitleUpdateAfterJoining"] = this.jobTitleUpdateAfterJoining;
        data["isJobTitleUpdated"] = this.isJobTitleUpdated;
        data["eyApprovedVisaDate"] = this.eyApprovedVisaDate ? this.eyApprovedVisaDate.toISOString() : <any>undefined;
        data["entryPermitExpiryDate"] = this.entryPermitExpiryDate ? this.entryPermitExpiryDate.toISOString() : <any>undefined;
        data["joinedDate"] = this.joinedDate ? this.joinedDate.toISOString() : <any>undefined;
        data["withdrawnDate"] = this.withdrawnDate ? this.withdrawnDate.toISOString() : <any>undefined;
        data["declinedDate"] = this.declinedDate ? this.declinedDate.toISOString() : <any>undefined;
        data["inprocessDate"] = this.inprocessDate ? this.inprocessDate.toISOString() : <any>undefined;
        data["hotelBookingStatusID"] = this.hotelBookingStatusID;
        data["bookingInitiationDate"] = this.bookingInitiationDate ? this.bookingInitiationDate.toISOString() : <any>undefined;
        data["bookingCompletionDate"] = this.bookingCompletionDate ? this.bookingCompletionDate.toISOString() : <any>undefined;
        data["hotelBookingExceptions"] = this.hotelBookingExceptions;
        data["exceptionStatusId"] = this.exceptionStatusId;
        data["exceptionValidityDocAttestStatus"] = this.exceptionValidityDocAttestStatus ? this.exceptionValidityDocAttestStatus.toISOString() : <any>undefined;
        data["isJoiningWithoutValidWorkPermit"] = this.isJoiningWithoutValidWorkPermit;
        data["exceptionValidityJoiningWithoutValidWorkPermit"] = this.exceptionValidityJoiningWithoutValidWorkPermit ? this.exceptionValidityJoiningWithoutValidWorkPermit.toISOString() : <any>undefined;
        data["visaJobTitleChangeStatus"] = this.visaJobTitleChangeStatus;
        data["exceptionValidityVisaJobTitleChangeStatus"] = this.exceptionValidityVisaJobTitleChangeStatus ? this.exceptionValidityVisaJobTitleChangeStatus.toISOString() : <any>undefined;
        data["currentLegalEntity"] = this.currentLegalEntity;
        data["newJoinerWorkPermit"] = this.newJoinerWorkPermit;
        data["immigrationCaseTypeCurrentLocation"] = this.immigrationCaseTypeCurrentLocation;
        data["newJoinerCurrentLocationVisa"] = this.newJoinerCurrentLocationVisa;
        data["activeVisa"] = this.activeVisa;
        data["doesNewJoinerSponsorDep"] = this.doesNewJoinerSponsorDep;
        data["depVisaCancellationStatus"] = this.depVisaCancellationStatus;
        data["gdaProcessRequirement"] = this.gdaProcessRequirement;
        data["gdaProcessStatus"] = this.gdaProcessStatus;
        data["itClearance"] = this.itClearance;
        data["durationItClearance"] = this.durationItClearance ? this.durationItClearance.toISOString() : <any>undefined;
        data["homeCountryVisaCancellationStatus"] = this.homeCountryVisaCancellationStatus;
        data["durationHomeCountryVisaCancellationStatus"] = this.durationHomeCountryVisaCancellationStatus ? this.durationHomeCountryVisaCancellationStatus.toISOString() : <any>undefined;
        data["exitFormalitiesStatus"] = this.exitFormalitiesStatus;
        data["educationDocumentProcurementforAttestationId"] = this.educationDocumentProcurementforAttestationId;
        data["educationDocumentProcurementforAttestationRequestInitiatedDate"] = this.educationDocumentProcurementforAttestationRequestInitiatedDate ? this.educationDocumentProcurementforAttestationRequestInitiatedDate.toISOString() : <any>undefined;
        data["educationDocumentProcurementforAttestationDocumentscollectedDate"] = this.educationDocumentProcurementforAttestationDocumentscollectedDate ? this.educationDocumentProcurementforAttestationDocumentscollectedDate.toISOString() : <any>undefined;
        data["educationDocumentProcurementforAttestationAssesmentDate"] = this.educationDocumentProcurementforAttestationAssesmentDate ? this.educationDocumentProcurementforAttestationAssesmentDate.toISOString() : <any>undefined;
        data["educationDocumentProcurementforAttestationCompletedDate"] = this.educationDocumentProcurementforAttestationCompletedDate ? this.educationDocumentProcurementforAttestationCompletedDate.toISOString() : <any>undefined;
        data["documentProcurementforWorkPermitId"] = this.documentProcurementforWorkPermitId;
        data["documentProcurementforWorkPermitInitiatedDate"] = this.documentProcurementforWorkPermitInitiatedDate ? this.documentProcurementforWorkPermitInitiatedDate.toISOString() : <any>undefined;
        data["documentProcurementforWorkPermitCollectedDate"] = this.documentProcurementforWorkPermitCollectedDate ? this.documentProcurementforWorkPermitCollectedDate.toISOString() : <any>undefined;
        data["documentProcurementforWorkPermitAssesmentDate"] = this.documentProcurementforWorkPermitAssesmentDate ? this.documentProcurementforWorkPermitAssesmentDate.toISOString() : <any>undefined;
        data["documentProcurementforWorkPermitCompletedDate"] = this.documentProcurementforWorkPermitCompletedDate ? this.documentProcurementforWorkPermitCompletedDate.toISOString() : <any>undefined;
        data["educationDocumentAttestationId"] = this.educationDocumentAttestationId;
        data["educationDocumentAttestationInitiatedDate"] = this.educationDocumentAttestationInitiatedDate ? this.educationDocumentAttestationInitiatedDate.toISOString() : <any>undefined;
        data["educationDocumentAttestationUnderProcessDate"] = this.educationDocumentAttestationUnderProcessDate ? this.educationDocumentAttestationUnderProcessDate.toISOString() : <any>undefined;
        data["educationDocumentAttestationCompletedDate"] = this.educationDocumentAttestationCompletedDate ? this.educationDocumentAttestationCompletedDate.toISOString() : <any>undefined;
        data["exceptionApprovalWorkPermitId"] = this.exceptionApprovalWorkPermitId;
        data["exceptionApprovalWorkPermitInitiatedDate"] = this.exceptionApprovalWorkPermitInitiatedDate ? this.exceptionApprovalWorkPermitInitiatedDate.toISOString() : <any>undefined;
        data["exceptionApprovalWorkPermitApprovalReceivedDate"] = this.exceptionApprovalWorkPermitApprovalReceivedDate ? this.exceptionApprovalWorkPermitApprovalReceivedDate.toISOString() : <any>undefined;
        data["corporateDocumentId"] = this.corporateDocumentId;
        data["corporateDocumentInitiatedDate"] = this.corporateDocumentInitiatedDate ? this.corporateDocumentInitiatedDate.toISOString() : <any>undefined;
        data["corporateDocumentReceivedByVendorDate"] = this.corporateDocumentReceivedByVendorDate ? this.corporateDocumentReceivedByVendorDate.toISOString() : <any>undefined;
        data["corporateDocumentAssesmentDate"] = this.corporateDocumentAssesmentDate ? this.corporateDocumentAssesmentDate.toISOString() : <any>undefined;
        data["corporateDocumentCompletedDate"] = this.corporateDocumentCompletedDate ? this.corporateDocumentCompletedDate.toISOString() : <any>undefined;
        data["visaReTaggingId"] = this.visaReTaggingId;
        data["visaReTaggingNewDegree"] = this.visaReTaggingNewDegree;
        data["visaReTaggingNewDesignation"] = this.visaReTaggingNewDesignation;
        data["visaReTaggingNewPortOfExitCountryId"] = this.visaReTaggingNewPortOfExitCountryId;
        data["visaReTaggingNewPortOfExitCityId"] = this.visaReTaggingNewPortOfExitCityId;
        data["visaReTaggingInitiatedDate"] = this.visaReTaggingInitiatedDate ? this.visaReTaggingInitiatedDate.toISOString() : <any>undefined;
        data["visaReTaggingCompletedDate"] = this.visaReTaggingCompletedDate ? this.visaReTaggingCompletedDate.toISOString() : <any>undefined;
        data["revisedCorporateDocumentId"] = this.revisedCorporateDocumentId;
        data["revisedCorporateDocumentInitiatedDate"] = this.revisedCorporateDocumentInitiatedDate ? this.revisedCorporateDocumentInitiatedDate.toISOString() : <any>undefined;
        data["revisedCorporateDocumentReceivedByVendorDate"] = this.revisedCorporateDocumentReceivedByVendorDate ? this.revisedCorporateDocumentReceivedByVendorDate.toISOString() : <any>undefined;
        data["revisedCorporateDocumentAssesmentDate"] = this.revisedCorporateDocumentAssesmentDate ? this.revisedCorporateDocumentAssesmentDate.toISOString() : <any>undefined;
        data["revisedCorporateDocumentCompletedDate"] = this.revisedCorporateDocumentCompletedDate ? this.revisedCorporateDocumentCompletedDate.toISOString() : <any>undefined;
        data["pjDocumentCollectedStatus"] = this.pjDocumentCollectedStatus;
        data["documentExpectedDate"] = this.documentExpectedDate ? this.documentExpectedDate.toISOString() : <any>undefined;
        data["mosadaqaId"] = this.mosadaqaId;
        data["mosadaqaInitiatedDate"] = this.mosadaqaInitiatedDate ? this.mosadaqaInitiatedDate.toISOString() : <any>undefined;
        data["mosadaqaUnderProcessDate"] = this.mosadaqaUnderProcessDate ? this.mosadaqaUnderProcessDate.toISOString() : <any>undefined;
        data["mosadaqaCompletedDate"] = this.mosadaqaCompletedDate ? this.mosadaqaCompletedDate.toISOString() : <any>undefined;
        data["qvpId"] = this.qvpId;
        data["qvpInitiatedDate"] = this.qvpInitiatedDate ? this.qvpInitiatedDate.toISOString() : <any>undefined;
        data["qvpUnderProcessDate"] = this.qvpUnderProcessDate ? this.qvpUnderProcessDate.toISOString() : <any>undefined;
        data["qvpCompletedDate"] = this.qvpCompletedDate ? this.qvpCompletedDate.toISOString() : <any>undefined;
        data["professionalMembershipCertificateId"] = this.professionalMembershipCertificateId;
        data["professionalMembershipCertificateInitiatedDate"] = this.professionalMembershipCertificateInitiatedDate ? this.professionalMembershipCertificateInitiatedDate.toISOString() : <any>undefined;
        data["professionalMembershipCertificateUnderProcessDate"] = this.professionalMembershipCertificateUnderProcessDate ? this.professionalMembershipCertificateUnderProcessDate.toISOString() : <any>undefined;
        data["professionalMembershipCertificateCompletedDate"] = this.professionalMembershipCertificateCompletedDate ? this.professionalMembershipCertificateCompletedDate.toISOString() : <any>undefined;
        data["businessVisaCancellationLetterId"] = this.businessVisaCancellationLetterId;
        data["businessVisaCancellationLetterInitiatedDate"] = this.businessVisaCancellationLetterInitiatedDate ? this.businessVisaCancellationLetterInitiatedDate.toISOString() : <any>undefined;
        data["businessVisaCancellationLetterCompletedDate"] = this.businessVisaCancellationLetterCompletedDate ? this.businessVisaCancellationLetterCompletedDate.toISOString() : <any>undefined;
        data["wpApplicationNJId"] = this.wpApplicationNJId;
        data["wpApplicationNJMedicalAppointmentDate"] = this.wpApplicationNJMedicalAppointmentDate ? this.wpApplicationNJMedicalAppointmentDate.toISOString() : <any>undefined;
        data["wpApplicationNJMedicalProcessCompletedDate"] = this.wpApplicationNJMedicalProcessCompletedDate ? this.wpApplicationNJMedicalProcessCompletedDate.toISOString() : <any>undefined;
        data["wpApplicationNJPCCAppointmentDate"] = this.wpApplicationNJPCCAppointmentDate ? this.wpApplicationNJPCCAppointmentDate.toISOString() : <any>undefined;
        data["wpApplicationNJPCCProcessCompletedDate"] = this.wpApplicationNJPCCProcessCompletedDate ? this.wpApplicationNJPCCProcessCompletedDate.toISOString() : <any>undefined;
        data["wpApplicationNJBiometricsAppointmentDate"] = this.wpApplicationNJBiometricsAppointmentDate ? this.wpApplicationNJBiometricsAppointmentDate.toISOString() : <any>undefined;
        data["wpApplicationNJBiometricsProcessCompletedDate"] = this.wpApplicationNJBiometricsProcessCompletedDate ? this.wpApplicationNJBiometricsProcessCompletedDate.toISOString() : <any>undefined;
        data["wpApplicationNJHomeCountryVisaStampingProcessDate"] = this.wpApplicationNJHomeCountryVisaStampingProcessDate ? this.wpApplicationNJHomeCountryVisaStampingProcessDate.toISOString() : <any>undefined;
        data["wpApplicationNJHomeVisaStampedIssuedDate"] = this.wpApplicationNJHomeVisaStampedIssuedDate ? this.wpApplicationNJHomeVisaStampedIssuedDate.toISOString() : <any>undefined;
        data["wpApplicationEYId"] = this.wpApplicationEYId;
        data["wpApplicationEYInitiatedDate"] = this.wpApplicationEYInitiatedDate ? this.wpApplicationEYInitiatedDate.toISOString() : <any>undefined;
        data["wpApplicationEYQVCAppointmentDate"] = this.wpApplicationEYQVCAppointmentDate ? this.wpApplicationEYQVCAppointmentDate.toISOString() : <any>undefined;
        data["wpApplicationEYEmbassyAppointmentDate"] = this.wpApplicationEYEmbassyAppointmentDate ? this.wpApplicationEYEmbassyAppointmentDate.toISOString() : <any>undefined;
        data["wpApplicationEYWorkPermitIssuedDate"] = this.wpApplicationEYWorkPermitIssuedDate ? this.wpApplicationEYWorkPermitIssuedDate.toISOString() : <any>undefined;
        data["laborContractId"] = this.laborContractId;
        data["laborContractReceivedImmigrationDate"] = this.laborContractReceivedImmigrationDate ? this.laborContractReceivedImmigrationDate.toISOString() : <any>undefined;
        data["laborContractSharedWithEmployeeDate"] = this.laborContractSharedWithEmployeeDate ? this.laborContractSharedWithEmployeeDate.toISOString() : <any>undefined;
        data["laborContractReceivedFromEmployeeDate"] = this.laborContractReceivedFromEmployeeDate ? this.laborContractReceivedFromEmployeeDate.toISOString() : <any>undefined;
        data["laborContractSharedWithImmigrationDate"] = this.laborContractSharedWithImmigrationDate ? this.laborContractSharedWithImmigrationDate.toISOString() : <any>undefined;
        data["homeCountryExitFormalityId"] = this.homeCountryExitFormalityId;
        data["homeCountryExitFormalityInitiatedDate"] = this.homeCountryExitFormalityInitiatedDate ? this.homeCountryExitFormalityInitiatedDate.toISOString() : <any>undefined;
        data["homeCountryExitFormalityUnderProcessDate"] = this.homeCountryExitFormalityUnderProcessDate ? this.homeCountryExitFormalityUnderProcessDate.toISOString() : <any>undefined;
        data["homeCountryExitFormalityCompletedDate"] = this.homeCountryExitFormalityCompletedDate ? this.homeCountryExitFormalityCompletedDate.toISOString() : <any>undefined;
        data["travelBookingId"] = this.travelBookingId;
        data["travelBookingInitiatedDate"] = this.travelBookingInitiatedDate ? this.travelBookingInitiatedDate.toISOString() : <any>undefined;
        data["travelBookingCompletedDate"] = this.travelBookingCompletedDate ? this.travelBookingCompletedDate.toISOString() : <any>undefined;
        data["itAsset"] = this.itAsset;
        data["assetCourier"] = this.assetCourier;
        data["accessCard"] = this.accessCard;
        return data;
    }
}

export interface IPBProfile {
    id?: number;
    candidateProfile?: CandidateProfile | undefined;
    pbStatus?: LookupField | undefined;
    currentLocation?: string | undefined;
    currentLocationId?: number | undefined;
    currentLocationCountryID?: number | undefined;
    noticePeriod?: string | undefined;
    maritalStatusId?: number | undefined;
    marriageEffectiveDate?: Date | undefined;
    dependentsId?: number | undefined;
    lastWorkingday?: Date | undefined;
    startdate?: Date | undefined;
    startdateStatusID?: number | undefined;
    confirmedEnddate?: Date | undefined;
    pbInitiationdatebyPTC?: Date | undefined;
    pbStatusID?: number | undefined;
    currentEmploymentStatusID?: number | undefined;
    transferTypeID?: number | undefined;
    transferScenarioID?: number | undefined;
    epRequestedDate?: Date | undefined;
    epCreatedDate?: Date | undefined;
    gpn?: string | undefined;
    immigrationCaseTypeID?: number | undefined;
    currentVisaStatusID?: number | undefined;
    flightBookingID?: number | undefined;
    flightBookingstatusIDEmp?: number | undefined;
    flightBookingstatusIDDep?: number | undefined;
    empDateOfIntiation?: Date | undefined;
    empDateOfCompletion?: Date | undefined;
    depDateOfIntiation?: Date | undefined;
    depDateOfCompletion?: Date | undefined;
    hotelBookingID?: number | undefined;
    reallocationBenefitID?: number | undefined;
    chargeCode?: string | undefined;
    buddyId?: number | undefined;
    buddyData?: AdUser | undefined;
    counselorId?: number | undefined;
    counselorData?: AdUser | undefined;
    executiveAssistantId?: number | undefined;
    executiveAssistantData?: AdUser | undefined;
    ccgLeadId?: number | undefined;
    ccgLeadData?: AdUser | undefined;
    cftLeadId?: number | undefined;
    cftLeadData?: AdUser | undefined;
    approvedPreHireExceptions?: string | undefined;
    createdBy?: number | undefined;
    createdDate?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    isNPNegotiableId?: number | undefined;
    isActivitiesCompleted?: number | undefined;
    completedDate?: Date | undefined;
    profileSubmittedDate?: Date | undefined;
    dualCitizenshipId?: number | undefined;
    eyVisaLCStatusID?: number | undefined;
    previousPBStatusID?: number | undefined;
    secondNationalityId?: number | undefined;
    visaAgentName?: string | undefined;
    isMerrSync?: boolean | undefined;
    autoEmails?: AutoEmail[] | undefined;
    previousStartdate?: Date | undefined;
    previousStartdateStatusID?: number | undefined;
    autoAssignedBuddyId?: number | undefined;
    autoAssignedCounselorId?: number | undefined;
    arabicJobGroup?: string | undefined;
    arabicVisaDesignation?: string | undefined;
    citizenshipId?: number | undefined;
    eduDocAttestationId?: number | undefined;
    famDocAttestationId?: number | undefined;
    vendorDetails?: string | undefined;
    isLowerJobTitle?: number | undefined;
    reasonForLowerJobTitle?: number | undefined;
    reasonForLowerJobTitleComment?: string | undefined;
    jobTitleUpdateAfterJoining?: number | undefined;
    isJobTitleUpdated?: number | undefined;
    eyApprovedVisaDate?: Date | undefined;
    entryPermitExpiryDate?: Date | undefined;
    joinedDate?: Date | undefined;
    withdrawnDate?: Date | undefined;
    declinedDate?: Date | undefined;
    inprocessDate?: Date | undefined;
    hotelBookingStatusID?: number | undefined;
    bookingInitiationDate?: Date | undefined;
    bookingCompletionDate?: Date | undefined;
    hotelBookingExceptions?: string | undefined;
    exceptionStatusId?: number | undefined;
    exceptionValidityDocAttestStatus?: Date | undefined;
    isJoiningWithoutValidWorkPermit?: number | undefined;
    exceptionValidityJoiningWithoutValidWorkPermit?: Date | undefined;
    visaJobTitleChangeStatus?: number | undefined;
    exceptionValidityVisaJobTitleChangeStatus?: Date | undefined;
    currentLegalEntity?: number | undefined;
    newJoinerWorkPermit?: number | undefined;
    immigrationCaseTypeCurrentLocation?: number | undefined;
    newJoinerCurrentLocationVisa?: number | undefined;
    activeVisa?: number | undefined;
    doesNewJoinerSponsorDep?: number | undefined;
    depVisaCancellationStatus?: number | undefined;
    gdaProcessRequirement?: number | undefined;
    gdaProcessStatus?: number | undefined;
    itClearance?: number | undefined;
    durationItClearance?: Date | undefined;
    homeCountryVisaCancellationStatus?: number | undefined;
    durationHomeCountryVisaCancellationStatus?: Date | undefined;
    exitFormalitiesStatus?: number | undefined;
    educationDocumentProcurementforAttestationId?: number | undefined;
    educationDocumentProcurementforAttestationRequestInitiatedDate?: Date | undefined;
    educationDocumentProcurementforAttestationDocumentscollectedDate?: Date | undefined;
    educationDocumentProcurementforAttestationAssesmentDate?: Date | undefined;
    educationDocumentProcurementforAttestationCompletedDate?: Date | undefined;
    documentProcurementforWorkPermitId?: number | undefined;
    documentProcurementforWorkPermitInitiatedDate?: Date | undefined;
    documentProcurementforWorkPermitCollectedDate?: Date | undefined;
    documentProcurementforWorkPermitAssesmentDate?: Date | undefined;
    documentProcurementforWorkPermitCompletedDate?: Date | undefined;
    educationDocumentAttestationId?: number | undefined;
    educationDocumentAttestationInitiatedDate?: Date | undefined;
    educationDocumentAttestationUnderProcessDate?: Date | undefined;
    educationDocumentAttestationCompletedDate?: Date | undefined;
    exceptionApprovalWorkPermitId?: number | undefined;
    exceptionApprovalWorkPermitInitiatedDate?: Date | undefined;
    exceptionApprovalWorkPermitApprovalReceivedDate?: Date | undefined;
    corporateDocumentId?: number | undefined;
    corporateDocumentInitiatedDate?: Date | undefined;
    corporateDocumentReceivedByVendorDate?: Date | undefined;
    corporateDocumentAssesmentDate?: Date | undefined;
    corporateDocumentCompletedDate?: Date | undefined;
    visaReTaggingId?: number | undefined;
    visaReTaggingNewDegree?: string | undefined;
    visaReTaggingNewDesignation?: string | undefined;
    visaReTaggingNewPortOfExitCountryId?: number | undefined;
    visaReTaggingNewPortOfExitCityId?: number | undefined;
    visaReTaggingInitiatedDate?: Date | undefined;
    visaReTaggingCompletedDate?: Date | undefined;
    revisedCorporateDocumentId?: number | undefined;
    revisedCorporateDocumentInitiatedDate?: Date | undefined;
    revisedCorporateDocumentReceivedByVendorDate?: Date | undefined;
    revisedCorporateDocumentAssesmentDate?: Date | undefined;
    revisedCorporateDocumentCompletedDate?: Date | undefined;
    pjDocumentCollectedStatus?: number | undefined;
    documentExpectedDate?: Date | undefined;
    mosadaqaId?: number | undefined;
    mosadaqaInitiatedDate?: Date | undefined;
    mosadaqaUnderProcessDate?: Date | undefined;
    mosadaqaCompletedDate?: Date | undefined;
    qvpId?: number | undefined;
    qvpInitiatedDate?: Date | undefined;
    qvpUnderProcessDate?: Date | undefined;
    qvpCompletedDate?: Date | undefined;
    professionalMembershipCertificateId?: number | undefined;
    professionalMembershipCertificateInitiatedDate?: Date | undefined;
    professionalMembershipCertificateUnderProcessDate?: Date | undefined;
    professionalMembershipCertificateCompletedDate?: Date | undefined;
    businessVisaCancellationLetterId?: number | undefined;
    businessVisaCancellationLetterInitiatedDate?: Date | undefined;
    businessVisaCancellationLetterCompletedDate?: Date | undefined;
    wpApplicationNJId?: number | undefined;
    wpApplicationNJMedicalAppointmentDate?: Date | undefined;
    wpApplicationNJMedicalProcessCompletedDate?: Date | undefined;
    wpApplicationNJPCCAppointmentDate?: Date | undefined;
    wpApplicationNJPCCProcessCompletedDate?: Date | undefined;
    wpApplicationNJBiometricsAppointmentDate?: Date | undefined;
    wpApplicationNJBiometricsProcessCompletedDate?: Date | undefined;
    wpApplicationNJHomeCountryVisaStampingProcessDate?: Date | undefined;
    wpApplicationNJHomeVisaStampedIssuedDate?: Date | undefined;
    wpApplicationEYId?: number | undefined;
    wpApplicationEYInitiatedDate?: Date | undefined;
    wpApplicationEYQVCAppointmentDate?: Date | undefined;
    wpApplicationEYEmbassyAppointmentDate?: Date | undefined;
    wpApplicationEYWorkPermitIssuedDate?: Date | undefined;
    laborContractId?: number | undefined;
    laborContractReceivedImmigrationDate?: Date | undefined;
    laborContractSharedWithEmployeeDate?: Date | undefined;
    laborContractReceivedFromEmployeeDate?: Date | undefined;
    laborContractSharedWithImmigrationDate?: Date | undefined;
    homeCountryExitFormalityId?: number | undefined;
    homeCountryExitFormalityInitiatedDate?: Date | undefined;
    homeCountryExitFormalityUnderProcessDate?: Date | undefined;
    homeCountryExitFormalityCompletedDate?: Date | undefined;
    travelBookingId?: number | undefined;
    travelBookingInitiatedDate?: Date | undefined;
    travelBookingCompletedDate?: Date | undefined;
    itAsset?: number | undefined;
    assetCourier?: number | undefined;
    accessCard?: number | undefined;
}

export class AutoEmail implements IAutoEmail {
    errormsg?: string | undefined;
    templateCode?: string | undefined;
    sendEmail?: boolean | undefined;
    templateIdentitfer?: string | undefined;
    activityStatus?: ActivityStatus | undefined;

    constructor(data?: IAutoEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errormsg = _data["errormsg"];
            this.templateCode = _data["templateCode"];
            this.sendEmail = _data["sendEmail"];
            this.templateIdentitfer = _data["templateIdentitfer"];
            this.activityStatus = _data["activityStatus"];
        }
    }

    static fromJS(data: any): AutoEmail {
        data = typeof data === 'object' ? data : {};
        let result = new AutoEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errormsg"] = this.errormsg;
        data["templateCode"] = this.templateCode;
        data["sendEmail"] = this.sendEmail;
        data["templateIdentitfer"] = this.templateIdentitfer;
        data["activityStatus"] = this.activityStatus;
        return data;
    }
}

export interface IAutoEmail {
    errormsg?: string | undefined;
    templateCode?: string | undefined;
    sendEmail?: boolean | undefined;
    templateIdentitfer?: string | undefined;
    activityStatus?: ActivityStatus | undefined;
}

export class Comments implements IComments {
    id?: number;
    comment?: string | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    candidateProfileId?: number | undefined;
    createdDate?: Date | undefined;
    commentType?: number;
    statusId?: number;
    candidateMailSent?: boolean | undefined;

    constructor(data?: IComments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.candidateProfileId = _data["candidateProfileId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.commentType = _data["commentType"];
            this.statusId = _data["statusId"];
            this.candidateMailSent = _data["candidateMailSent"];
        }
    }

    static fromJS(data: any): Comments {
        data = typeof data === 'object' ? data : {};
        let result = new Comments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["candidateProfileId"] = this.candidateProfileId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["commentType"] = this.commentType;
        data["statusId"] = this.statusId;
        data["candidateMailSent"] = this.candidateMailSent;
        return data;
    }
}

export interface IComments {
    id?: number;
    comment?: string | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    candidateProfileId?: number | undefined;
    createdDate?: Date | undefined;
    commentType?: number;
    statusId?: number;
    candidateMailSent?: boolean | undefined;
}

export class CandidateDocCombined implements ICandidateDocCombined {
    id?: number | undefined;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    documentNameId?: number;
    documentName?: string | undefined;
    candidateProfileId?: number | undefined;
    moduleType?: number;
    description?: string | undefined;
    additionalReqId?: number | undefined;
    instruction?: string | undefined;
    isUploaded?: boolean;
    isEditMode?: boolean;
    createdById?: number;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    isMandatory?: boolean;
    mandatoryType?: number | undefined;
    disabled?: boolean;
    checks?: string | undefined;
    validationResults?: string | undefined;
    tmT_Check_Status?: string | undefined;
    documentChecks?: DocumentConfigLookupMapping[] | undefined;

    constructor(data?: ICandidateDocCombined) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.documentNameId = _data["documentNameId"];
            this.documentName = _data["documentName"];
            this.candidateProfileId = _data["candidateProfileId"];
            this.moduleType = _data["moduleType"];
            this.description = _data["description"];
            this.additionalReqId = _data["additionalReqId"];
            this.instruction = _data["instruction"];
            this.isUploaded = _data["isUploaded"];
            this.isEditMode = _data["isEditMode"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.isMandatory = _data["isMandatory"];
            this.mandatoryType = _data["mandatoryType"];
            this.disabled = _data["disabled"];
            this.checks = _data["checks"];
            this.validationResults = _data["validationResults"];
            this.tmT_Check_Status = _data["tmT_Check_Status"];
            if (Array.isArray(_data["documentChecks"])) {
                this.documentChecks = [] as any;
                for (let item of _data["documentChecks"])
                    this.documentChecks!.push(DocumentConfigLookupMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidateDocCombined {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateDocCombined();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["documentNameId"] = this.documentNameId;
        data["documentName"] = this.documentName;
        data["candidateProfileId"] = this.candidateProfileId;
        data["moduleType"] = this.moduleType;
        data["description"] = this.description;
        data["additionalReqId"] = this.additionalReqId;
        data["instruction"] = this.instruction;
        data["isUploaded"] = this.isUploaded;
        data["isEditMode"] = this.isEditMode;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["isMandatory"] = this.isMandatory;
        data["mandatoryType"] = this.mandatoryType;
        data["disabled"] = this.disabled;
        data["checks"] = this.checks;
        data["validationResults"] = this.validationResults;
        data["tmT_Check_Status"] = this.tmT_Check_Status;
        if (Array.isArray(this.documentChecks)) {
            data["documentChecks"] = [];
            for (let item of this.documentChecks)
                data["documentChecks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICandidateDocCombined {
    id?: number | undefined;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    documentNameId?: number;
    documentName?: string | undefined;
    candidateProfileId?: number | undefined;
    moduleType?: number;
    description?: string | undefined;
    additionalReqId?: number | undefined;
    instruction?: string | undefined;
    isUploaded?: boolean;
    isEditMode?: boolean;
    createdById?: number;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    isMandatory?: boolean;
    mandatoryType?: number | undefined;
    disabled?: boolean;
    checks?: string | undefined;
    validationResults?: string | undefined;
    tmT_Check_Status?: string | undefined;
    documentChecks?: DocumentConfigLookupMapping[] | undefined;
}

export class CandidateAdditionDocumentRequest implements ICandidateAdditionDocumentRequest {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    candidateProfileId?: number;
    requestorEmployeeId?: number;
    createDate?: Date | undefined;
    isUploaded?: boolean | undefined;
    comment?: string | undefined;

    constructor(data?: ICandidateAdditionDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNameId = _data["docNameId"];
            this.docNameDisplayText = _data["docNameDisplayText"];
            this.docTypeId = _data["docTypeId"];
            this.docTypeDisplayText = _data["docTypeDisplayText"];
            this.isMandatory = _data["isMandatory"];
            this.mandatoryType = _data["mandatoryType"];
            this.candidateProfileId = _data["candidateProfileId"];
            this.requestorEmployeeId = _data["requestorEmployeeId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.isUploaded = _data["isUploaded"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CandidateAdditionDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateAdditionDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNameId"] = this.docNameId;
        data["docNameDisplayText"] = this.docNameDisplayText;
        data["docTypeId"] = this.docTypeId;
        data["docTypeDisplayText"] = this.docTypeDisplayText;
        data["isMandatory"] = this.isMandatory;
        data["mandatoryType"] = this.mandatoryType;
        data["candidateProfileId"] = this.candidateProfileId;
        data["requestorEmployeeId"] = this.requestorEmployeeId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["isUploaded"] = this.isUploaded;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICandidateAdditionDocumentRequest {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    candidateProfileId?: number;
    requestorEmployeeId?: number;
    createDate?: Date | undefined;
    isUploaded?: boolean | undefined;
    comment?: string | undefined;
}

export class CandidatePendingDocumentRequest implements ICandidatePendingDocumentRequest {
    id?: number;
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    candidateProfileId?: number;
    requestorEmployeeId?: number;
    createDate?: Date | undefined;
    isActive?: boolean;

    constructor(data?: ICandidatePendingDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.docNameId = _data["docNameId"];
            this.docNameDisplayText = _data["docNameDisplayText"];
            this.docTypeId = _data["docTypeId"];
            this.docTypeDisplayText = _data["docTypeDisplayText"];
            this.candidateProfileId = _data["candidateProfileId"];
            this.requestorEmployeeId = _data["requestorEmployeeId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CandidatePendingDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatePendingDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["docNameId"] = this.docNameId;
        data["docNameDisplayText"] = this.docNameDisplayText;
        data["docTypeId"] = this.docTypeId;
        data["docTypeDisplayText"] = this.docTypeDisplayText;
        data["candidateProfileId"] = this.candidateProfileId;
        data["requestorEmployeeId"] = this.requestorEmployeeId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICandidatePendingDocumentRequest {
    id?: number;
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    candidateProfileId?: number;
    requestorEmployeeId?: number;
    createDate?: Date | undefined;
    isActive?: boolean;
}

export class CandidateInfoMin implements ICandidateInfoMin {
    officeLocationCountryId?: number | undefined;
    id?: number;
    createdVia?: string | undefined;
    pbProfileId?: number | undefined;
    empCategoryId?: number | undefined;
    nationalityId?: number | undefined;
    pbProfile?: PBProfile | undefined;

    constructor(data?: ICandidateInfoMin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.officeLocationCountryId = _data["officeLocationCountryId"];
            this.id = _data["id"];
            this.createdVia = _data["createdVia"];
            this.pbProfileId = _data["pbProfileId"];
            this.empCategoryId = _data["empCategoryId"];
            this.nationalityId = _data["nationalityId"];
            this.pbProfile = _data["pbProfile"] ? PBProfile.fromJS(_data["pbProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CandidateInfoMin {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateInfoMin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeLocationCountryId"] = this.officeLocationCountryId;
        data["id"] = this.id;
        data["createdVia"] = this.createdVia;
        data["pbProfileId"] = this.pbProfileId;
        data["empCategoryId"] = this.empCategoryId;
        data["nationalityId"] = this.nationalityId;
        data["pbProfile"] = this.pbProfile ? this.pbProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICandidateInfoMin {
    officeLocationCountryId?: number | undefined;
    id?: number;
    createdVia?: string | undefined;
    pbProfileId?: number | undefined;
    empCategoryId?: number | undefined;
    nationalityId?: number | undefined;
    pbProfile?: PBProfile | undefined;
}

export class Activity implements IActivity {
    id?: number;
    header?: string | undefined;
    activityType?: ActivityTypes;
    order?: number;
    pbTypeId?: number;
    additionalInfo?: ActivityAdditionalInfo | undefined;
    propertyExtensions?: string | undefined;
    status?: ActivityStatus;
    activityCompletedDate?: Date | undefined;
    isActive?: boolean;
    isRequestActivityInitiated?: boolean;
    candidateActivityId?: number | undefined;
    description?: string | undefined;
    modifiedBy?: number | undefined;
    modifiedByNm?: string | undefined;
    canInitiate?: boolean | undefined;

    constructor(data?: IActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.header = _data["header"];
            this.activityType = _data["activityType"];
            this.order = _data["order"];
            this.pbTypeId = _data["pbTypeId"];
            this.additionalInfo = _data["additionalInfo"] ? ActivityAdditionalInfo.fromJS(_data["additionalInfo"]) : <any>undefined;
            this.propertyExtensions = _data["propertyExtensions"];
            this.status = _data["status"];
            this.activityCompletedDate = _data["activityCompletedDate"] ? new Date(_data["activityCompletedDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isRequestActivityInitiated = _data["isRequestActivityInitiated"];
            this.candidateActivityId = _data["candidateActivityId"];
            this.description = _data["description"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedByNm = _data["modifiedByNm"];
            this.canInitiate = _data["canInitiate"];
        }
    }

    static fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["header"] = this.header;
        data["activityType"] = this.activityType;
        data["order"] = this.order;
        data["pbTypeId"] = this.pbTypeId;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : <any>undefined;
        data["propertyExtensions"] = this.propertyExtensions;
        data["status"] = this.status;
        data["activityCompletedDate"] = this.activityCompletedDate ? this.activityCompletedDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isRequestActivityInitiated"] = this.isRequestActivityInitiated;
        data["candidateActivityId"] = this.candidateActivityId;
        data["description"] = this.description;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedByNm"] = this.modifiedByNm;
        data["canInitiate"] = this.canInitiate;
        return data;
    }
}

export interface IActivity {
    id?: number;
    header?: string | undefined;
    activityType?: ActivityTypes;
    order?: number;
    pbTypeId?: number;
    additionalInfo?: ActivityAdditionalInfo | undefined;
    propertyExtensions?: string | undefined;
    status?: ActivityStatus;
    activityCompletedDate?: Date | undefined;
    isActive?: boolean;
    isRequestActivityInitiated?: boolean;
    candidateActivityId?: number | undefined;
    description?: string | undefined;
    modifiedBy?: number | undefined;
    modifiedByNm?: string | undefined;
    canInitiate?: boolean | undefined;
}

export class ActivityAdditionalInfo implements IActivityAdditionalInfo {
    countries?: number[] | undefined;
    employeeCategories?: number[] | undefined;
    contractTypes?: (number | undefined)[] | undefined;
    hiringTypes?: (number | undefined)[] | undefined;
    nationalities?: (number | undefined)[] | undefined;
    officeLocations?: (number | undefined)[] | undefined;
    immigrationCaseTypes?: (number | undefined)[] | undefined;
    transferTypes?: (number | undefined)[] | undefined;
    transferScenarios?: (number | undefined)[] | undefined;
    preboardingTypeId?: (number | undefined)[] | undefined;

    constructor(data?: IActivityAdditionalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["employeeCategories"])) {
                this.employeeCategories = [] as any;
                for (let item of _data["employeeCategories"])
                    this.employeeCategories!.push(item);
            }
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(item);
            }
            if (Array.isArray(_data["hiringTypes"])) {
                this.hiringTypes = [] as any;
                for (let item of _data["hiringTypes"])
                    this.hiringTypes!.push(item);
            }
            if (Array.isArray(_data["nationalities"])) {
                this.nationalities = [] as any;
                for (let item of _data["nationalities"])
                    this.nationalities!.push(item);
            }
            if (Array.isArray(_data["officeLocations"])) {
                this.officeLocations = [] as any;
                for (let item of _data["officeLocations"])
                    this.officeLocations!.push(item);
            }
            if (Array.isArray(_data["immigrationCaseTypes"])) {
                this.immigrationCaseTypes = [] as any;
                for (let item of _data["immigrationCaseTypes"])
                    this.immigrationCaseTypes!.push(item);
            }
            if (Array.isArray(_data["transferTypes"])) {
                this.transferTypes = [] as any;
                for (let item of _data["transferTypes"])
                    this.transferTypes!.push(item);
            }
            if (Array.isArray(_data["transferScenarios"])) {
                this.transferScenarios = [] as any;
                for (let item of _data["transferScenarios"])
                    this.transferScenarios!.push(item);
            }
            if (Array.isArray(_data["preboardingTypeId"])) {
                this.preboardingTypeId = [] as any;
                for (let item of _data["preboardingTypeId"])
                    this.preboardingTypeId!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityAdditionalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAdditionalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.employeeCategories)) {
            data["employeeCategories"] = [];
            for (let item of this.employeeCategories)
                data["employeeCategories"].push(item);
        }
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item);
        }
        if (Array.isArray(this.hiringTypes)) {
            data["hiringTypes"] = [];
            for (let item of this.hiringTypes)
                data["hiringTypes"].push(item);
        }
        if (Array.isArray(this.nationalities)) {
            data["nationalities"] = [];
            for (let item of this.nationalities)
                data["nationalities"].push(item);
        }
        if (Array.isArray(this.officeLocations)) {
            data["officeLocations"] = [];
            for (let item of this.officeLocations)
                data["officeLocations"].push(item);
        }
        if (Array.isArray(this.immigrationCaseTypes)) {
            data["immigrationCaseTypes"] = [];
            for (let item of this.immigrationCaseTypes)
                data["immigrationCaseTypes"].push(item);
        }
        if (Array.isArray(this.transferTypes)) {
            data["transferTypes"] = [];
            for (let item of this.transferTypes)
                data["transferTypes"].push(item);
        }
        if (Array.isArray(this.transferScenarios)) {
            data["transferScenarios"] = [];
            for (let item of this.transferScenarios)
                data["transferScenarios"].push(item);
        }
        if (Array.isArray(this.preboardingTypeId)) {
            data["preboardingTypeId"] = [];
            for (let item of this.preboardingTypeId)
                data["preboardingTypeId"].push(item);
        }
        return data;
    }
}

export interface IActivityAdditionalInfo {
    countries?: number[] | undefined;
    employeeCategories?: number[] | undefined;
    contractTypes?: (number | undefined)[] | undefined;
    hiringTypes?: (number | undefined)[] | undefined;
    nationalities?: (number | undefined)[] | undefined;
    officeLocations?: (number | undefined)[] | undefined;
    immigrationCaseTypes?: (number | undefined)[] | undefined;
    transferTypes?: (number | undefined)[] | undefined;
    transferScenarios?: (number | undefined)[] | undefined;
    preboardingTypeId?: (number | undefined)[] | undefined;
}

export class AmmendActivityFilter implements IAmmendActivityFilter {
    isCandidate?: boolean;
    isWSO?: boolean;
    pbType?: LookupField | undefined;
    country?: LookupField | undefined;
    employeeCategory?: LookupField | undefined;

    constructor(data?: IAmmendActivityFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCandidate = _data["isCandidate"];
            this.isWSO = _data["isWSO"];
            this.pbType = _data["pbType"] ? LookupField.fromJS(_data["pbType"]) : <any>undefined;
            this.country = _data["country"] ? LookupField.fromJS(_data["country"]) : <any>undefined;
            this.employeeCategory = _data["employeeCategory"] ? LookupField.fromJS(_data["employeeCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AmmendActivityFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AmmendActivityFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCandidate"] = this.isCandidate;
        data["isWSO"] = this.isWSO;
        data["pbType"] = this.pbType ? this.pbType.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["employeeCategory"] = this.employeeCategory ? this.employeeCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAmmendActivityFilter {
    isCandidate?: boolean;
    isWSO?: boolean;
    pbType?: LookupField | undefined;
    country?: LookupField | undefined;
    employeeCategory?: LookupField | undefined;
}

export class Activity2 implements IActivity2 {
    id?: number;
    activityType?: ActivityTypes;
    order?: number;
    header?: string | undefined;
    description?: string | undefined;
    pbType?: LookupField2 | undefined;
    pbTypeId?: number;
    additionalInfo?: ActivityAdditionalInfo | undefined;
    propertyExtensions?: string | undefined;
    isActive?: boolean;

    constructor(data?: IActivity2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityType = _data["activityType"];
            this.order = _data["order"];
            this.header = _data["header"];
            this.description = _data["description"];
            this.pbType = _data["pbType"] ? LookupField2.fromJS(_data["pbType"]) : <any>undefined;
            this.pbTypeId = _data["pbTypeId"];
            this.additionalInfo = _data["additionalInfo"] ? ActivityAdditionalInfo.fromJS(_data["additionalInfo"]) : <any>undefined;
            this.propertyExtensions = _data["propertyExtensions"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): Activity2 {
        data = typeof data === 'object' ? data : {};
        let result = new Activity2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityType"] = this.activityType;
        data["order"] = this.order;
        data["header"] = this.header;
        data["description"] = this.description;
        data["pbType"] = this.pbType ? this.pbType.toJSON() : <any>undefined;
        data["pbTypeId"] = this.pbTypeId;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : <any>undefined;
        data["propertyExtensions"] = this.propertyExtensions;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IActivity2 {
    id?: number;
    activityType?: ActivityTypes;
    order?: number;
    header?: string | undefined;
    description?: string | undefined;
    pbType?: LookupField2 | undefined;
    pbTypeId?: number;
    additionalInfo?: ActivityAdditionalInfo | undefined;
    propertyExtensions?: string | undefined;
    isActive?: boolean;
}

export class LookupField2 implements ILookupField2 {
    id?: number;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    lookupTypeId?: number;
    lookupType?: LookupType | undefined;
    parentFieldId?: number | undefined;
    parentField?: LookupField2 | undefined;
    parentCode?: string | undefined;
    childFields?: LookupField2[] | undefined;
    filterKey?: LookupField2 | undefined;
    filterKeyId?: number | undefined;

    constructor(data?: ILookupField2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.lookupTypeId = _data["lookupTypeId"];
            this.lookupType = _data["lookupType"] ? LookupType.fromJS(_data["lookupType"]) : <any>undefined;
            this.parentFieldId = _data["parentFieldId"];
            this.parentField = _data["parentField"] ? LookupField2.fromJS(_data["parentField"]) : <any>undefined;
            this.parentCode = _data["parentCode"];
            if (Array.isArray(_data["childFields"])) {
                this.childFields = [] as any;
                for (let item of _data["childFields"])
                    this.childFields!.push(LookupField2.fromJS(item));
            }
            this.filterKey = _data["filterKey"] ? LookupField2.fromJS(_data["filterKey"]) : <any>undefined;
            this.filterKeyId = _data["filterKeyId"];
        }
    }

    static fromJS(data: any): LookupField2 {
        data = typeof data === 'object' ? data : {};
        let result = new LookupField2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["lookupTypeId"] = this.lookupTypeId;
        data["lookupType"] = this.lookupType ? this.lookupType.toJSON() : <any>undefined;
        data["parentFieldId"] = this.parentFieldId;
        data["parentField"] = this.parentField ? this.parentField.toJSON() : <any>undefined;
        data["parentCode"] = this.parentCode;
        if (Array.isArray(this.childFields)) {
            data["childFields"] = [];
            for (let item of this.childFields)
                data["childFields"].push(item.toJSON());
        }
        data["filterKey"] = this.filterKey ? this.filterKey.toJSON() : <any>undefined;
        data["filterKeyId"] = this.filterKeyId;
        return data;
    }
}

export interface ILookupField2 {
    id?: number;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    lookupTypeId?: number;
    lookupType?: LookupType | undefined;
    parentFieldId?: number | undefined;
    parentField?: LookupField2 | undefined;
    parentCode?: string | undefined;
    childFields?: LookupField2[] | undefined;
    filterKey?: LookupField2 | undefined;
    filterKeyId?: number | undefined;
}

export class LookupType implements ILookupType {
    id?: number;
    value?: string | undefined;
    displayText?: string | undefined;
    isActive?: boolean;
    isEditable?: boolean;
    lookupFields?: LookupField2[] | undefined;
    module?: string | undefined;

    constructor(data?: ILookupType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isActive = _data["isActive"];
            this.isEditable = _data["isEditable"];
            if (Array.isArray(_data["lookupFields"])) {
                this.lookupFields = [] as any;
                for (let item of _data["lookupFields"])
                    this.lookupFields!.push(LookupField2.fromJS(item));
            }
            this.module = _data["module"];
        }
    }

    static fromJS(data: any): LookupType {
        data = typeof data === 'object' ? data : {};
        let result = new LookupType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isActive"] = this.isActive;
        data["isEditable"] = this.isEditable;
        if (Array.isArray(this.lookupFields)) {
            data["lookupFields"] = [];
            for (let item of this.lookupFields)
                data["lookupFields"].push(item.toJSON());
        }
        data["module"] = this.module;
        return data;
    }
}

export interface ILookupType {
    id?: number;
    value?: string | undefined;
    displayText?: string | undefined;
    isActive?: boolean;
    isEditable?: boolean;
    lookupFields?: LookupField2[] | undefined;
    module?: string | undefined;
}

export class ConfigureImmActivities implements IConfigureImmActivities {
    immigrationActivities?: ImmigrationActivity[] | undefined;
    filter?: FilterParams | undefined;

    constructor(data?: IConfigureImmActivities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["immigrationActivities"])) {
                this.immigrationActivities = [] as any;
                for (let item of _data["immigrationActivities"])
                    this.immigrationActivities!.push(ImmigrationActivity.fromJS(item));
            }
            this.filter = _data["filter"] ? FilterParams.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfigureImmActivities {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigureImmActivities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.immigrationActivities)) {
            data["immigrationActivities"] = [];
            for (let item of this.immigrationActivities)
                data["immigrationActivities"].push(item.toJSON());
        }
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfigureImmActivities {
    immigrationActivities?: ImmigrationActivity[] | undefined;
    filter?: FilterParams | undefined;
}

export class AmmendImmActivityFilter implements IAmmendImmActivityFilter {
    visaType?: LookupField | undefined;
    country?: LookupField | undefined;
    officeLE?: number | undefined;
    officeToBeVisited?: number | undefined;

    constructor(data?: IAmmendImmActivityFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visaType = _data["visaType"] ? LookupField.fromJS(_data["visaType"]) : <any>undefined;
            this.country = _data["country"] ? LookupField.fromJS(_data["country"]) : <any>undefined;
            this.officeLE = _data["officeLE"];
            this.officeToBeVisited = _data["officeToBeVisited"];
        }
    }

    static fromJS(data: any): AmmendImmActivityFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AmmendImmActivityFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visaType"] = this.visaType ? this.visaType.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["officeLE"] = this.officeLE;
        data["officeToBeVisited"] = this.officeToBeVisited;
        return data;
    }
}

export interface IAmmendImmActivityFilter {
    visaType?: LookupField | undefined;
    country?: LookupField | undefined;
    officeLE?: number | undefined;
    officeToBeVisited?: number | undefined;
}

export class OperationResultOfListOfImmigrationActivities implements IOperationResultOfListOfImmigrationActivities {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationActivities[] | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfListOfImmigrationActivities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImmigrationActivities.fromJS(item));
            }
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfListOfImmigrationActivities {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfListOfImmigrationActivities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfListOfImmigrationActivities {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: ImmigrationActivities[] | undefined;
    errorCode?: number;
}

export class ImmigrationActivities implements IImmigrationActivities {
    id?: number;
    activityType?: ActivityTypes;
    header?: string | undefined;
    description?: string | undefined;
    visaType?: LookupField2 | undefined;
    order?: number;
    filterKeyId?: number | undefined;
    additionalInfo?: string | undefined;
    visaTypeId?: number;
    propertyExtensions?: string | undefined;
    isActive?: boolean;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    isKPI?: boolean | undefined;
    kpiTimeline?: number | undefined;
    isMilestone?: boolean | undefined;
    milestoneTimeline?: number | undefined;
    milestoneName?: string | undefined;
    timelineInfo?: string | undefined;

    constructor(data?: IImmigrationActivities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityType = _data["activityType"];
            this.header = _data["header"];
            this.description = _data["description"];
            this.visaType = _data["visaType"] ? LookupField2.fromJS(_data["visaType"]) : <any>undefined;
            this.order = _data["order"];
            this.filterKeyId = _data["filterKeyId"];
            this.additionalInfo = _data["additionalInfo"];
            this.visaTypeId = _data["visaTypeId"];
            this.propertyExtensions = _data["propertyExtensions"];
            this.isActive = _data["isActive"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.isKPI = _data["isKPI"];
            this.kpiTimeline = _data["kpiTimeline"];
            this.isMilestone = _data["isMilestone"];
            this.milestoneTimeline = _data["milestoneTimeline"];
            this.milestoneName = _data["milestoneName"];
            this.timelineInfo = _data["timelineInfo"];
        }
    }

    static fromJS(data: any): ImmigrationActivities {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationActivities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityType"] = this.activityType;
        data["header"] = this.header;
        data["description"] = this.description;
        data["visaType"] = this.visaType ? this.visaType.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["filterKeyId"] = this.filterKeyId;
        data["additionalInfo"] = this.additionalInfo;
        data["visaTypeId"] = this.visaTypeId;
        data["propertyExtensions"] = this.propertyExtensions;
        data["isActive"] = this.isActive;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["isKPI"] = this.isKPI;
        data["kpiTimeline"] = this.kpiTimeline;
        data["isMilestone"] = this.isMilestone;
        data["milestoneTimeline"] = this.milestoneTimeline;
        data["milestoneName"] = this.milestoneName;
        data["timelineInfo"] = this.timelineInfo;
        return data;
    }
}

export interface IImmigrationActivities {
    id?: number;
    activityType?: ActivityTypes;
    header?: string | undefined;
    description?: string | undefined;
    visaType?: LookupField2 | undefined;
    order?: number;
    filterKeyId?: number | undefined;
    additionalInfo?: string | undefined;
    visaTypeId?: number;
    propertyExtensions?: string | undefined;
    isActive?: boolean;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    isKPI?: boolean | undefined;
    kpiTimeline?: number | undefined;
    isMilestone?: boolean | undefined;
    milestoneTimeline?: number | undefined;
    milestoneName?: string | undefined;
    timelineInfo?: string | undefined;
}

export class AmmendExitActivityFilter implements IAmmendExitActivityFilter {
    exitType?: LookupField | undefined;
    exitSubType?: number | undefined;
    officeLocation?: number | undefined;
    nationalityType?: number | undefined;
    isPartner?: boolean | undefined;

    constructor(data?: IAmmendExitActivityFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exitType = _data["exitType"] ? LookupField.fromJS(_data["exitType"]) : <any>undefined;
            this.exitSubType = _data["exitSubType"];
            this.officeLocation = _data["officeLocation"];
            this.nationalityType = _data["nationalityType"];
            this.isPartner = _data["isPartner"];
        }
    }

    static fromJS(data: any): AmmendExitActivityFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AmmendExitActivityFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exitType"] = this.exitType ? this.exitType.toJSON() : <any>undefined;
        data["exitSubType"] = this.exitSubType;
        data["officeLocation"] = this.officeLocation;
        data["nationalityType"] = this.nationalityType;
        data["isPartner"] = this.isPartner;
        return data;
    }
}

export interface IAmmendExitActivityFilter {
    exitType?: LookupField | undefined;
    exitSubType?: number | undefined;
    officeLocation?: number | undefined;
    nationalityType?: number | undefined;
    isPartner?: boolean | undefined;
}

export class ImmigrationDocumentVisaMappingDTO implements IImmigrationDocumentVisaMappingDTO {
    id?: number;
    visaTypeValue?: string | undefined;
    documentType?: string | undefined;
    documentValue?: string | undefined;
    documentName?: string | undefined;
    isApprover?: boolean;
    isRequestor?: boolean;
    additionalInfo?: ImmAdditionalInfo | undefined;
    documentNameId?: number;
    instruction?: string | undefined;

    constructor(data?: IImmigrationDocumentVisaMappingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.visaTypeValue = _data["visaTypeValue"];
            this.documentType = _data["documentType"];
            this.documentValue = _data["documentValue"];
            this.documentName = _data["documentName"];
            this.isApprover = _data["isApprover"];
            this.isRequestor = _data["isRequestor"];
            this.additionalInfo = _data["additionalInfo"] ? ImmAdditionalInfo.fromJS(_data["additionalInfo"]) : <any>undefined;
            this.documentNameId = _data["documentNameId"];
            this.instruction = _data["instruction"];
        }
    }

    static fromJS(data: any): ImmigrationDocumentVisaMappingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationDocumentVisaMappingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["visaTypeValue"] = this.visaTypeValue;
        data["documentType"] = this.documentType;
        data["documentValue"] = this.documentValue;
        data["documentName"] = this.documentName;
        data["isApprover"] = this.isApprover;
        data["isRequestor"] = this.isRequestor;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : <any>undefined;
        data["documentNameId"] = this.documentNameId;
        data["instruction"] = this.instruction;
        return data;
    }
}

export interface IImmigrationDocumentVisaMappingDTO {
    id?: number;
    visaTypeValue?: string | undefined;
    documentType?: string | undefined;
    documentValue?: string | undefined;
    documentName?: string | undefined;
    isApprover?: boolean;
    isRequestor?: boolean;
    additionalInfo?: ImmAdditionalInfo | undefined;
    documentNameId?: number;
    instruction?: string | undefined;
}

export class ImmAdditionalInfo implements IImmAdditionalInfo {
    mandatory?: boolean;
    cm9Filing?: boolean;
    officeLocation?: (number | undefined)[] | undefined;
    nationalityType?: (number | undefined)[] | undefined;
    rank?: string[] | undefined;
    nationality?: (number | undefined)[] | undefined;
    excludedNationality?: (number | undefined)[] | undefined;
    currentVisaStatusId?: (number | undefined)[] | undefined;
    officeLE?: (number | undefined)[] | undefined;
    gender?: (number | undefined)[] | undefined;
    shortTermVisa?: (number | undefined)[] | undefined;
    typeOfSupport?: (number | undefined)[] | undefined;
    empCurrentLocation?: (number | undefined)[] | undefined;
    immigrationCaseTypeId?: (number | undefined)[] | undefined;

    constructor(data?: IImmAdditionalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mandatory = _data["mandatory"];
            this.cm9Filing = _data["cm9Filing"];
            if (Array.isArray(_data["officeLocation"])) {
                this.officeLocation = [] as any;
                for (let item of _data["officeLocation"])
                    this.officeLocation!.push(item);
            }
            if (Array.isArray(_data["nationalityType"])) {
                this.nationalityType = [] as any;
                for (let item of _data["nationalityType"])
                    this.nationalityType!.push(item);
            }
            if (Array.isArray(_data["rank"])) {
                this.rank = [] as any;
                for (let item of _data["rank"])
                    this.rank!.push(item);
            }
            if (Array.isArray(_data["nationality"])) {
                this.nationality = [] as any;
                for (let item of _data["nationality"])
                    this.nationality!.push(item);
            }
            if (Array.isArray(_data["excludedNationality"])) {
                this.excludedNationality = [] as any;
                for (let item of _data["excludedNationality"])
                    this.excludedNationality!.push(item);
            }
            if (Array.isArray(_data["currentVisaStatusId"])) {
                this.currentVisaStatusId = [] as any;
                for (let item of _data["currentVisaStatusId"])
                    this.currentVisaStatusId!.push(item);
            }
            if (Array.isArray(_data["officeLE"])) {
                this.officeLE = [] as any;
                for (let item of _data["officeLE"])
                    this.officeLE!.push(item);
            }
            if (Array.isArray(_data["gender"])) {
                this.gender = [] as any;
                for (let item of _data["gender"])
                    this.gender!.push(item);
            }
            if (Array.isArray(_data["shortTermVisa"])) {
                this.shortTermVisa = [] as any;
                for (let item of _data["shortTermVisa"])
                    this.shortTermVisa!.push(item);
            }
            if (Array.isArray(_data["typeOfSupport"])) {
                this.typeOfSupport = [] as any;
                for (let item of _data["typeOfSupport"])
                    this.typeOfSupport!.push(item);
            }
            if (Array.isArray(_data["empCurrentLocation"])) {
                this.empCurrentLocation = [] as any;
                for (let item of _data["empCurrentLocation"])
                    this.empCurrentLocation!.push(item);
            }
            if (Array.isArray(_data["immigrationCaseTypeId"])) {
                this.immigrationCaseTypeId = [] as any;
                for (let item of _data["immigrationCaseTypeId"])
                    this.immigrationCaseTypeId!.push(item);
            }
        }
    }

    static fromJS(data: any): ImmAdditionalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ImmAdditionalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandatory"] = this.mandatory;
        data["cm9Filing"] = this.cm9Filing;
        if (Array.isArray(this.officeLocation)) {
            data["officeLocation"] = [];
            for (let item of this.officeLocation)
                data["officeLocation"].push(item);
        }
        if (Array.isArray(this.nationalityType)) {
            data["nationalityType"] = [];
            for (let item of this.nationalityType)
                data["nationalityType"].push(item);
        }
        if (Array.isArray(this.rank)) {
            data["rank"] = [];
            for (let item of this.rank)
                data["rank"].push(item);
        }
        if (Array.isArray(this.nationality)) {
            data["nationality"] = [];
            for (let item of this.nationality)
                data["nationality"].push(item);
        }
        if (Array.isArray(this.excludedNationality)) {
            data["excludedNationality"] = [];
            for (let item of this.excludedNationality)
                data["excludedNationality"].push(item);
        }
        if (Array.isArray(this.currentVisaStatusId)) {
            data["currentVisaStatusId"] = [];
            for (let item of this.currentVisaStatusId)
                data["currentVisaStatusId"].push(item);
        }
        if (Array.isArray(this.officeLE)) {
            data["officeLE"] = [];
            for (let item of this.officeLE)
                data["officeLE"].push(item);
        }
        if (Array.isArray(this.gender)) {
            data["gender"] = [];
            for (let item of this.gender)
                data["gender"].push(item);
        }
        if (Array.isArray(this.shortTermVisa)) {
            data["shortTermVisa"] = [];
            for (let item of this.shortTermVisa)
                data["shortTermVisa"].push(item);
        }
        if (Array.isArray(this.typeOfSupport)) {
            data["typeOfSupport"] = [];
            for (let item of this.typeOfSupport)
                data["typeOfSupport"].push(item);
        }
        if (Array.isArray(this.empCurrentLocation)) {
            data["empCurrentLocation"] = [];
            for (let item of this.empCurrentLocation)
                data["empCurrentLocation"].push(item);
        }
        if (Array.isArray(this.immigrationCaseTypeId)) {
            data["immigrationCaseTypeId"] = [];
            for (let item of this.immigrationCaseTypeId)
                data["immigrationCaseTypeId"].push(item);
        }
        return data;
    }
}

export interface IImmAdditionalInfo {
    mandatory?: boolean;
    cm9Filing?: boolean;
    officeLocation?: (number | undefined)[] | undefined;
    nationalityType?: (number | undefined)[] | undefined;
    rank?: string[] | undefined;
    nationality?: (number | undefined)[] | undefined;
    excludedNationality?: (number | undefined)[] | undefined;
    currentVisaStatusId?: (number | undefined)[] | undefined;
    officeLE?: (number | undefined)[] | undefined;
    gender?: (number | undefined)[] | undefined;
    shortTermVisa?: (number | undefined)[] | undefined;
    typeOfSupport?: (number | undefined)[] | undefined;
    empCurrentLocation?: (number | undefined)[] | undefined;
    immigrationCaseTypeId?: (number | undefined)[] | undefined;
}

export class ImmDocumentVisaMappingFilter implements IImmDocumentVisaMappingFilter {
    officeLocation?: number | undefined;
    visaType?: number | undefined;
    isRequestor?: boolean | undefined;
    isApprover?: boolean | undefined;

    constructor(data?: IImmDocumentVisaMappingFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.officeLocation = _data["officeLocation"];
            this.visaType = _data["visaType"];
            this.isRequestor = _data["isRequestor"];
            this.isApprover = _data["isApprover"];
        }
    }

    static fromJS(data: any): ImmDocumentVisaMappingFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ImmDocumentVisaMappingFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeLocation"] = this.officeLocation;
        data["visaType"] = this.visaType;
        data["isRequestor"] = this.isRequestor;
        data["isApprover"] = this.isApprover;
        return data;
    }
}

export interface IImmDocumentVisaMappingFilter {
    officeLocation?: number | undefined;
    visaType?: number | undefined;
    isRequestor?: boolean | undefined;
    isApprover?: boolean | undefined;
}

export class AppConfig implements IAppConfig {
    id?: number;
    configKey?: string | undefined;
    configValue?: string | undefined;

    constructor(data?: IAppConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.configKey = _data["configKey"];
            this.configValue = _data["configValue"];
        }
    }

    static fromJS(data: any): AppConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AppConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configKey"] = this.configKey;
        data["configValue"] = this.configValue;
        return data;
    }
}

export interface IAppConfig {
    id?: number;
    configKey?: string | undefined;
    configValue?: string | undefined;
}

export class AppConfiguration implements IAppConfiguration {
    configKey?: string | undefined;
    configValue?: string | undefined;
    id?: number;

    constructor(data?: IAppConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configKey = _data["configKey"];
            this.configValue = _data["configValue"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new AppConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configKey"] = this.configKey;
        data["configValue"] = this.configValue;
        data["id"] = this.id;
        return data;
    }
}

export interface IAppConfiguration {
    configKey?: string | undefined;
    configValue?: string | undefined;
    id?: number;
}

export class FieldToolTips implements IFieldToolTips {
    id?: number;
    module?: string | undefined;
    fieldName?: string | undefined;
    parentId?: number;
    toolTipText?: string | undefined;

    constructor(data?: IFieldToolTips) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.module = _data["module"];
            this.fieldName = _data["fieldName"];
            this.parentId = _data["parentId"];
            this.toolTipText = _data["toolTipText"];
        }
    }

    static fromJS(data: any): FieldToolTips {
        data = typeof data === 'object' ? data : {};
        let result = new FieldToolTips();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["module"] = this.module;
        data["fieldName"] = this.fieldName;
        data["parentId"] = this.parentId;
        data["toolTipText"] = this.toolTipText;
        return data;
    }
}

export interface IFieldToolTips {
    id?: number;
    module?: string | undefined;
    fieldName?: string | undefined;
    parentId?: number;
    toolTipText?: string | undefined;
}

export class OperationResultOfCWProfile implements IOperationResultOfCWProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CWProfile | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfCWProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? CWProfile.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfCWProfile {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfCWProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfCWProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CWProfile | undefined;
    errorCode?: number;
}

export class CWDocCombined implements ICWDocCombined {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    cwProfileId?: number;
    createdById?: number;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;
    instruction?: string | undefined;
    isUploaded?: boolean;
    isEditMode?: boolean;
    isMandatory?: boolean;
    mandatoryType?: number | undefined;

    constructor(data?: ICWDocCombined) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.cwProfileId = _data["cwProfileId"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.documentName = _data["documentName"];
            this.description = _data["description"];
            this.documentNameId = _data["documentNameId"];
            this.instruction = _data["instruction"];
            this.isUploaded = _data["isUploaded"];
            this.isEditMode = _data["isEditMode"];
            this.isMandatory = _data["isMandatory"];
            this.mandatoryType = _data["mandatoryType"];
        }
    }

    static fromJS(data: any): CWDocCombined {
        data = typeof data === 'object' ? data : {};
        let result = new CWDocCombined();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["cwProfileId"] = this.cwProfileId;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["documentName"] = this.documentName;
        data["description"] = this.description;
        data["documentNameId"] = this.documentNameId;
        data["instruction"] = this.instruction;
        data["isUploaded"] = this.isUploaded;
        data["isEditMode"] = this.isEditMode;
        data["isMandatory"] = this.isMandatory;
        data["mandatoryType"] = this.mandatoryType;
        return data;
    }
}

export interface ICWDocCombined {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    cwProfileId?: number;
    createdById?: number;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;
    instruction?: string | undefined;
    isUploaded?: boolean;
    isEditMode?: boolean;
    isMandatory?: boolean;
    mandatoryType?: number | undefined;
}

export class OperationResultOfCWDocument implements IOperationResultOfCWDocument {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CWDocument | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfCWDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? CWDocument.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfCWDocument {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfCWDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfCWDocument {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: CWDocument | undefined;
    errorCode?: number;
}

export class CWDocument implements ICWDocument {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    cwProfileId?: number;
    createdById?: number;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;

    constructor(data?: ICWDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? LookupField.fromJS(_data["documentType"]) : <any>undefined;
            this.cwProfileId = _data["cwProfileId"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.documentName = _data["documentName"];
            this.description = _data["description"];
            this.documentNameId = _data["documentNameId"];
        }
    }

    static fromJS(data: any): CWDocument {
        data = typeof data === 'object' ? data : {};
        let result = new CWDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["cwProfileId"] = this.cwProfileId;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["documentName"] = this.documentName;
        data["description"] = this.description;
        data["documentNameId"] = this.documentNameId;
        return data;
    }
}

export interface ICWDocument {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    cwProfileId?: number;
    createdById?: number;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    description?: string | undefined;
    documentNameId?: number;
}

export class EmailMessage implements IEmailMessage {
    missingPlaceholders?: string[] | undefined;
    emailHistoryId?: number;
    activityId?: number;
    candidateId?: number;
    templateCode?: string | undefined;
    fromAddresses?: string | undefined;
    toAddresses?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    attachments?: string[] | undefined;
    customAttachments?: EmailAttachments[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    isMissingValues?: boolean;
    candidateDocuments?: CandidateDocCombined[] | undefined;
    activityTemplates?: EmailTemplate[] | undefined;
    activityTemplate?: string | undefined;
    activityTemplateId?: number;
    candidateActivityId?: number | undefined;
    rawAttatchmentString?: string | undefined;
    allActivityTemplateId?: number[] | undefined;

    constructor(data?: IEmailMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missingPlaceholders"])) {
                this.missingPlaceholders = [] as any;
                for (let item of _data["missingPlaceholders"])
                    this.missingPlaceholders!.push(item);
            }
            this.emailHistoryId = _data["emailHistoryId"];
            this.activityId = _data["activityId"];
            this.candidateId = _data["candidateId"];
            this.templateCode = _data["templateCode"];
            this.fromAddresses = _data["fromAddresses"];
            this.toAddresses = _data["toAddresses"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            if (Array.isArray(_data["customAttachments"])) {
                this.customAttachments = [] as any;
                for (let item of _data["customAttachments"])
                    this.customAttachments!.push(EmailAttachments.fromJS(item));
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.isMissingValues = _data["isMissingValues"];
            if (Array.isArray(_data["candidateDocuments"])) {
                this.candidateDocuments = [] as any;
                for (let item of _data["candidateDocuments"])
                    this.candidateDocuments!.push(CandidateDocCombined.fromJS(item));
            }
            if (Array.isArray(_data["activityTemplates"])) {
                this.activityTemplates = [] as any;
                for (let item of _data["activityTemplates"])
                    this.activityTemplates!.push(EmailTemplate.fromJS(item));
            }
            this.activityTemplate = _data["activityTemplate"];
            this.activityTemplateId = _data["activityTemplateId"];
            this.candidateActivityId = _data["candidateActivityId"];
            this.rawAttatchmentString = _data["rawAttatchmentString"];
            if (Array.isArray(_data["allActivityTemplateId"])) {
                this.allActivityTemplateId = [] as any;
                for (let item of _data["allActivityTemplateId"])
                    this.allActivityTemplateId!.push(item);
            }
        }
    }

    static fromJS(data: any): EmailMessage {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missingPlaceholders)) {
            data["missingPlaceholders"] = [];
            for (let item of this.missingPlaceholders)
                data["missingPlaceholders"].push(item);
        }
        data["emailHistoryId"] = this.emailHistoryId;
        data["activityId"] = this.activityId;
        data["candidateId"] = this.candidateId;
        data["templateCode"] = this.templateCode;
        data["fromAddresses"] = this.fromAddresses;
        data["toAddresses"] = this.toAddresses;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        if (Array.isArray(this.customAttachments)) {
            data["customAttachments"] = [];
            for (let item of this.customAttachments)
                data["customAttachments"].push(item.toJSON());
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["isMissingValues"] = this.isMissingValues;
        if (Array.isArray(this.candidateDocuments)) {
            data["candidateDocuments"] = [];
            for (let item of this.candidateDocuments)
                data["candidateDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.activityTemplates)) {
            data["activityTemplates"] = [];
            for (let item of this.activityTemplates)
                data["activityTemplates"].push(item.toJSON());
        }
        data["activityTemplate"] = this.activityTemplate;
        data["activityTemplateId"] = this.activityTemplateId;
        data["candidateActivityId"] = this.candidateActivityId;
        data["rawAttatchmentString"] = this.rawAttatchmentString;
        if (Array.isArray(this.allActivityTemplateId)) {
            data["allActivityTemplateId"] = [];
            for (let item of this.allActivityTemplateId)
                data["allActivityTemplateId"].push(item);
        }
        return data;
    }
}

export interface IEmailMessage {
    missingPlaceholders?: string[] | undefined;
    emailHistoryId?: number;
    activityId?: number;
    candidateId?: number;
    templateCode?: string | undefined;
    fromAddresses?: string | undefined;
    toAddresses?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    attachments?: string[] | undefined;
    customAttachments?: EmailAttachments[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    isMissingValues?: boolean;
    candidateDocuments?: CandidateDocCombined[] | undefined;
    activityTemplates?: EmailTemplate[] | undefined;
    activityTemplate?: string | undefined;
    activityTemplateId?: number;
    candidateActivityId?: number | undefined;
    rawAttatchmentString?: string | undefined;
    allActivityTemplateId?: number[] | undefined;
}

export class EmailTemplate implements IEmailTemplate {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    fromAddress?: string | undefined;
    toAddress?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    additionalInfo?: string | undefined;

    constructor(data?: IEmailTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.fromAddress = _data["fromAddress"];
            this.toAddress = _data["toAddress"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): EmailTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["fromAddress"] = this.fromAddress;
        data["toAddress"] = this.toAddress;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        data["additionalInfo"] = this.additionalInfo;
        return data;
    }
}

export interface IEmailTemplate {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    fromAddress?: string | undefined;
    toAddress?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    additionalInfo?: string | undefined;
}

export class ImmigrationEmailMessage implements IImmigrationEmailMessage {
    missingPlaceholders?: string[] | undefined;
    emailHistoryId?: number;
    activityId?: number;
    immigrationProfileId?: number;
    templateCode?: string | undefined;
    fromAddresses?: string | undefined;
    toAddresses?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    attachments?: string[] | undefined;
    customAttachments?: ImmigrationEmailAttachments[] | undefined;
    candidateDocuments?: ImmigrationDocument[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    isMissingValues?: boolean;
    activityTemplates?: EmailTemplate[] | undefined;
    activityTemplate?: string | undefined;
    activityTemplateId?: number;
    immigrationProfileActivityId?: number | undefined;
    rawAttatchmentString?: string | undefined;

    constructor(data?: IImmigrationEmailMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missingPlaceholders"])) {
                this.missingPlaceholders = [] as any;
                for (let item of _data["missingPlaceholders"])
                    this.missingPlaceholders!.push(item);
            }
            this.emailHistoryId = _data["emailHistoryId"];
            this.activityId = _data["activityId"];
            this.immigrationProfileId = _data["immigrationProfileId"];
            this.templateCode = _data["templateCode"];
            this.fromAddresses = _data["fromAddresses"];
            this.toAddresses = _data["toAddresses"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            if (Array.isArray(_data["customAttachments"])) {
                this.customAttachments = [] as any;
                for (let item of _data["customAttachments"])
                    this.customAttachments!.push(ImmigrationEmailAttachments.fromJS(item));
            }
            if (Array.isArray(_data["candidateDocuments"])) {
                this.candidateDocuments = [] as any;
                for (let item of _data["candidateDocuments"])
                    this.candidateDocuments!.push(ImmigrationDocument.fromJS(item));
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.isMissingValues = _data["isMissingValues"];
            if (Array.isArray(_data["activityTemplates"])) {
                this.activityTemplates = [] as any;
                for (let item of _data["activityTemplates"])
                    this.activityTemplates!.push(EmailTemplate.fromJS(item));
            }
            this.activityTemplate = _data["activityTemplate"];
            this.activityTemplateId = _data["activityTemplateId"];
            this.immigrationProfileActivityId = _data["immigrationProfileActivityId"];
            this.rawAttatchmentString = _data["rawAttatchmentString"];
        }
    }

    static fromJS(data: any): ImmigrationEmailMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationEmailMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missingPlaceholders)) {
            data["missingPlaceholders"] = [];
            for (let item of this.missingPlaceholders)
                data["missingPlaceholders"].push(item);
        }
        data["emailHistoryId"] = this.emailHistoryId;
        data["activityId"] = this.activityId;
        data["immigrationProfileId"] = this.immigrationProfileId;
        data["templateCode"] = this.templateCode;
        data["fromAddresses"] = this.fromAddresses;
        data["toAddresses"] = this.toAddresses;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        if (Array.isArray(this.customAttachments)) {
            data["customAttachments"] = [];
            for (let item of this.customAttachments)
                data["customAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.candidateDocuments)) {
            data["candidateDocuments"] = [];
            for (let item of this.candidateDocuments)
                data["candidateDocuments"].push(item.toJSON());
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["isMissingValues"] = this.isMissingValues;
        if (Array.isArray(this.activityTemplates)) {
            data["activityTemplates"] = [];
            for (let item of this.activityTemplates)
                data["activityTemplates"].push(item.toJSON());
        }
        data["activityTemplate"] = this.activityTemplate;
        data["activityTemplateId"] = this.activityTemplateId;
        data["immigrationProfileActivityId"] = this.immigrationProfileActivityId;
        data["rawAttatchmentString"] = this.rawAttatchmentString;
        return data;
    }
}

export interface IImmigrationEmailMessage {
    missingPlaceholders?: string[] | undefined;
    emailHistoryId?: number;
    activityId?: number;
    immigrationProfileId?: number;
    templateCode?: string | undefined;
    fromAddresses?: string | undefined;
    toAddresses?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    attachments?: string[] | undefined;
    customAttachments?: ImmigrationEmailAttachments[] | undefined;
    candidateDocuments?: ImmigrationDocument[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    isMissingValues?: boolean;
    activityTemplates?: EmailTemplate[] | undefined;
    activityTemplate?: string | undefined;
    activityTemplateId?: number;
    immigrationProfileActivityId?: number | undefined;
    rawAttatchmentString?: string | undefined;
}

export class EmployeeProfileEmailMessage implements IEmployeeProfileEmailMessage {
    emailHistoryId?: number;
    masterProfileId?: number;
    employeeId?: number;
    templateCode?: string | undefined;
    fromAddresses?: string | undefined;
    toAddresses?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    attachments?: string[] | undefined;
    customAttachments?: ImmigrationEmailAttachments[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    isMissingValues?: boolean;
    missingPlaceholders?: string[] | undefined;
    activityTemplates?: EmailTemplate[] | undefined;
    activityTemplate?: string | undefined;
    activityTemplateId?: number;
    rawAttatchmentString?: string | undefined;

    constructor(data?: IEmployeeProfileEmailMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailHistoryId = _data["emailHistoryId"];
            this.masterProfileId = _data["masterProfileId"];
            this.employeeId = _data["employeeId"];
            this.templateCode = _data["templateCode"];
            this.fromAddresses = _data["fromAddresses"];
            this.toAddresses = _data["toAddresses"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            if (Array.isArray(_data["customAttachments"])) {
                this.customAttachments = [] as any;
                for (let item of _data["customAttachments"])
                    this.customAttachments!.push(ImmigrationEmailAttachments.fromJS(item));
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.isMissingValues = _data["isMissingValues"];
            if (Array.isArray(_data["missingPlaceholders"])) {
                this.missingPlaceholders = [] as any;
                for (let item of _data["missingPlaceholders"])
                    this.missingPlaceholders!.push(item);
            }
            if (Array.isArray(_data["activityTemplates"])) {
                this.activityTemplates = [] as any;
                for (let item of _data["activityTemplates"])
                    this.activityTemplates!.push(EmailTemplate.fromJS(item));
            }
            this.activityTemplate = _data["activityTemplate"];
            this.activityTemplateId = _data["activityTemplateId"];
            this.rawAttatchmentString = _data["rawAttatchmentString"];
        }
    }

    static fromJS(data: any): EmployeeProfileEmailMessage {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeProfileEmailMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailHistoryId"] = this.emailHistoryId;
        data["masterProfileId"] = this.masterProfileId;
        data["employeeId"] = this.employeeId;
        data["templateCode"] = this.templateCode;
        data["fromAddresses"] = this.fromAddresses;
        data["toAddresses"] = this.toAddresses;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        if (Array.isArray(this.customAttachments)) {
            data["customAttachments"] = [];
            for (let item of this.customAttachments)
                data["customAttachments"].push(item.toJSON());
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["isMissingValues"] = this.isMissingValues;
        if (Array.isArray(this.missingPlaceholders)) {
            data["missingPlaceholders"] = [];
            for (let item of this.missingPlaceholders)
                data["missingPlaceholders"].push(item);
        }
        if (Array.isArray(this.activityTemplates)) {
            data["activityTemplates"] = [];
            for (let item of this.activityTemplates)
                data["activityTemplates"].push(item.toJSON());
        }
        data["activityTemplate"] = this.activityTemplate;
        data["activityTemplateId"] = this.activityTemplateId;
        data["rawAttatchmentString"] = this.rawAttatchmentString;
        return data;
    }
}

export interface IEmployeeProfileEmailMessage {
    emailHistoryId?: number;
    masterProfileId?: number;
    employeeId?: number;
    templateCode?: string | undefined;
    fromAddresses?: string | undefined;
    toAddresses?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    attachments?: string[] | undefined;
    customAttachments?: ImmigrationEmailAttachments[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    isMissingValues?: boolean;
    missingPlaceholders?: string[] | undefined;
    activityTemplates?: EmailTemplate[] | undefined;
    activityTemplate?: string | undefined;
    activityTemplateId?: number;
    rawAttatchmentString?: string | undefined;
}

export class EmailTemplateEditorInfo implements IEmailTemplateEditorInfo {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    subject?: string | undefined;
    activityHeader?: string | undefined;
    pbType?: string | undefined;
    order?: number;
    officeLocation?: string | undefined;
    employeeCategory?: string | undefined;
    activityId?: number;
    exitType?: string | undefined;

    constructor(data?: IEmailTemplateEditorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.subject = _data["subject"];
            this.activityHeader = _data["activityHeader"];
            this.pbType = _data["pbType"];
            this.order = _data["order"];
            this.officeLocation = _data["officeLocation"];
            this.employeeCategory = _data["employeeCategory"];
            this.activityId = _data["activityId"];
            this.exitType = _data["exitType"];
        }
    }

    static fromJS(data: any): EmailTemplateEditorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateEditorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["subject"] = this.subject;
        data["activityHeader"] = this.activityHeader;
        data["pbType"] = this.pbType;
        data["order"] = this.order;
        data["officeLocation"] = this.officeLocation;
        data["employeeCategory"] = this.employeeCategory;
        data["activityId"] = this.activityId;
        data["exitType"] = this.exitType;
        return data;
    }
}

export interface IEmailTemplateEditorInfo {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    subject?: string | undefined;
    activityHeader?: string | undefined;
    pbType?: string | undefined;
    order?: number;
    officeLocation?: string | undefined;
    employeeCategory?: string | undefined;
    activityId?: number;
    exitType?: string | undefined;
}

export class ImmigrationMailTemplateInfo implements IImmigrationMailTemplateInfo {
    id?: number;
    activityHeader?: string | undefined;
    immigrationAdditionalInfo?: string | undefined;

    constructor(data?: IImmigrationMailTemplateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityHeader = _data["activityHeader"];
            this.immigrationAdditionalInfo = _data["immigrationAdditionalInfo"];
        }
    }

    static fromJS(data: any): ImmigrationMailTemplateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ImmigrationMailTemplateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityHeader"] = this.activityHeader;
        data["immigrationAdditionalInfo"] = this.immigrationAdditionalInfo;
        return data;
    }
}

export interface IImmigrationMailTemplateInfo {
    id?: number;
    activityHeader?: string | undefined;
    immigrationAdditionalInfo?: string | undefined;
}

export class OperationResultOfTemplateAttachments implements IOperationResultOfTemplateAttachments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: TemplateAttachments | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfTemplateAttachments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? TemplateAttachments.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfTemplateAttachments {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfTemplateAttachments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfTemplateAttachments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: TemplateAttachments | undefined;
    errorCode?: number;
}

export class TemplateAttachments implements ITemplateAttachments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    emailTemplateId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;

    constructor(data?: ITemplateAttachments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? Employee.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TemplateAttachments {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAttachments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["emailTemplateId"] = this.emailTemplateId;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITemplateAttachments {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    emailTemplateId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;
}

export class PagedResultOfEmailTemplateEditorInfo implements IPagedResultOfEmailTemplateEditorInfo {
    page?: number;
    itemsPerPage?: number;
    sortBy?: string | undefined;
    reverse?: boolean;
    totalRecords?: number;
    results?: EmailTemplateEditorInfo[] | undefined;

    constructor(data?: IPagedResultOfEmailTemplateEditorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.itemsPerPage = _data["itemsPerPage"];
            this.sortBy = _data["sortBy"];
            this.reverse = _data["reverse"];
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(EmailTemplateEditorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfEmailTemplateEditorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfEmailTemplateEditorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["itemsPerPage"] = this.itemsPerPage;
        data["sortBy"] = this.sortBy;
        data["reverse"] = this.reverse;
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfEmailTemplateEditorInfo {
    page?: number;
    itemsPerPage?: number;
    sortBy?: string | undefined;
    reverse?: boolean;
    totalRecords?: number;
    results?: EmailTemplateEditorInfo[] | undefined;
}

export class ExitEmailMessage implements IExitEmailMessage {
    missingPlaceholders?: string[] | undefined;
    emailHistoryId?: number;
    activityId?: number;
    exitRequestId?: number;
    templateCode?: string | undefined;
    fromAddresses?: string | undefined;
    toAddresses?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    attachments?: string[] | undefined;
    customAttachments?: ExitEmailAttachments[] | undefined;
    candidateDocuments?: ExitDocument[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    isMissingValues?: boolean;
    activityTemplates?: EmailTemplate[] | undefined;
    activityTemplate?: string | undefined;
    activityTemplateId?: number;
    exitRequestActivityId?: number | undefined;
    rawAttatchmentString?: string | undefined;

    constructor(data?: IExitEmailMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missingPlaceholders"])) {
                this.missingPlaceholders = [] as any;
                for (let item of _data["missingPlaceholders"])
                    this.missingPlaceholders!.push(item);
            }
            this.emailHistoryId = _data["emailHistoryId"];
            this.activityId = _data["activityId"];
            this.exitRequestId = _data["exitRequestId"];
            this.templateCode = _data["templateCode"];
            this.fromAddresses = _data["fromAddresses"];
            this.toAddresses = _data["toAddresses"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            if (Array.isArray(_data["customAttachments"])) {
                this.customAttachments = [] as any;
                for (let item of _data["customAttachments"])
                    this.customAttachments!.push(ExitEmailAttachments.fromJS(item));
            }
            if (Array.isArray(_data["candidateDocuments"])) {
                this.candidateDocuments = [] as any;
                for (let item of _data["candidateDocuments"])
                    this.candidateDocuments!.push(ExitDocument.fromJS(item));
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.isMissingValues = _data["isMissingValues"];
            if (Array.isArray(_data["activityTemplates"])) {
                this.activityTemplates = [] as any;
                for (let item of _data["activityTemplates"])
                    this.activityTemplates!.push(EmailTemplate.fromJS(item));
            }
            this.activityTemplate = _data["activityTemplate"];
            this.activityTemplateId = _data["activityTemplateId"];
            this.exitRequestActivityId = _data["exitRequestActivityId"];
            this.rawAttatchmentString = _data["rawAttatchmentString"];
        }
    }

    static fromJS(data: any): ExitEmailMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ExitEmailMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missingPlaceholders)) {
            data["missingPlaceholders"] = [];
            for (let item of this.missingPlaceholders)
                data["missingPlaceholders"].push(item);
        }
        data["emailHistoryId"] = this.emailHistoryId;
        data["activityId"] = this.activityId;
        data["exitRequestId"] = this.exitRequestId;
        data["templateCode"] = this.templateCode;
        data["fromAddresses"] = this.fromAddresses;
        data["toAddresses"] = this.toAddresses;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        if (Array.isArray(this.customAttachments)) {
            data["customAttachments"] = [];
            for (let item of this.customAttachments)
                data["customAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.candidateDocuments)) {
            data["candidateDocuments"] = [];
            for (let item of this.candidateDocuments)
                data["candidateDocuments"].push(item.toJSON());
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["isMissingValues"] = this.isMissingValues;
        if (Array.isArray(this.activityTemplates)) {
            data["activityTemplates"] = [];
            for (let item of this.activityTemplates)
                data["activityTemplates"].push(item.toJSON());
        }
        data["activityTemplate"] = this.activityTemplate;
        data["activityTemplateId"] = this.activityTemplateId;
        data["exitRequestActivityId"] = this.exitRequestActivityId;
        data["rawAttatchmentString"] = this.rawAttatchmentString;
        return data;
    }
}

export interface IExitEmailMessage {
    missingPlaceholders?: string[] | undefined;
    emailHistoryId?: number;
    activityId?: number;
    exitRequestId?: number;
    templateCode?: string | undefined;
    fromAddresses?: string | undefined;
    toAddresses?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    attachments?: string[] | undefined;
    customAttachments?: ExitEmailAttachments[] | undefined;
    candidateDocuments?: ExitDocument[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    isMissingValues?: boolean;
    activityTemplates?: EmailTemplate[] | undefined;
    activityTemplate?: string | undefined;
    activityTemplateId?: number;
    exitRequestActivityId?: number | undefined;
    rawAttatchmentString?: string | undefined;
}

export class ExitMailTemplateInfo implements IExitMailTemplateInfo {
    id?: number;
    activityHeader?: string | undefined;
    emailTempName?: string | undefined;
    code?: string | undefined;

    constructor(data?: IExitMailTemplateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityHeader = _data["activityHeader"];
            this.emailTempName = _data["emailTempName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ExitMailTemplateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExitMailTemplateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityHeader"] = this.activityHeader;
        data["emailTempName"] = this.emailTempName;
        data["code"] = this.code;
        return data;
    }
}

export interface IExitMailTemplateInfo {
    id?: number;
    activityHeader?: string | undefined;
    emailTempName?: string | undefined;
    code?: string | undefined;
}

export class MilestoneDetail implements IMilestoneDetail {
    id?: number;
    displayText?: string | undefined;
    activityHeader?: string | undefined;
    activityId?: number;
    status?: ActivityStatus;
    completedDate?: Date | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;

    constructor(data?: IMilestoneDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayText = _data["displayText"];
            this.activityHeader = _data["activityHeader"];
            this.activityId = _data["activityId"];
            this.status = _data["status"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): MilestoneDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MilestoneDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayText"] = this.displayText;
        data["activityHeader"] = this.activityHeader;
        data["activityId"] = this.activityId;
        data["status"] = this.status;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IMilestoneDetail {
    id?: number;
    displayText?: string | undefined;
    activityHeader?: string | undefined;
    activityId?: number;
    status?: ActivityStatus;
    completedDate?: Date | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
}

export class AppUser implements IAppUser {
    userId?: number;
    userName?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    employeeId?: number;
    employeeProfileId?: number | undefined;
    employeeName?: string | undefined;
    userClaims?: UserClaims[] | undefined;
    roles?: string[] | undefined;
    features?: string[] | undefined;
    modules?: string[] | undefined;
    accessToken?: string | undefined;
    delegateId?: number | undefined;
    delegateUser?: DelegateUser | undefined;
    emailSignature?: string | undefined;
    activeRole?: string | undefined;
    roleIds?: number[] | undefined;
    userOfficeLocation?: number[] | undefined;
    userOfficeLocationCountries?: number[] | undefined;
    userOfficeLegalEntities?: number[] | undefined;
    activeRoleId?: number;
    isActive?: boolean;
    additionalInfo?: AppUserAdditionalInfo | undefined;

    constructor(data?: IAppUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.employeeId = _data["employeeId"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.employeeName = _data["employeeName"];
            if (Array.isArray(_data["userClaims"])) {
                this.userClaims = [] as any;
                for (let item of _data["userClaims"])
                    this.userClaims!.push(UserClaims.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(item);
            }
            this.accessToken = _data["accessToken"];
            this.delegateId = _data["delegateId"];
            this.delegateUser = _data["delegateUser"] ? DelegateUser.fromJS(_data["delegateUser"]) : <any>undefined;
            this.emailSignature = _data["emailSignature"];
            this.activeRole = _data["activeRole"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["userOfficeLocation"])) {
                this.userOfficeLocation = [] as any;
                for (let item of _data["userOfficeLocation"])
                    this.userOfficeLocation!.push(item);
            }
            if (Array.isArray(_data["userOfficeLocationCountries"])) {
                this.userOfficeLocationCountries = [] as any;
                for (let item of _data["userOfficeLocationCountries"])
                    this.userOfficeLocationCountries!.push(item);
            }
            if (Array.isArray(_data["userOfficeLegalEntities"])) {
                this.userOfficeLegalEntities = [] as any;
                for (let item of _data["userOfficeLegalEntities"])
                    this.userOfficeLegalEntities!.push(item);
            }
            this.activeRoleId = _data["activeRoleId"];
            this.isActive = _data["isActive"];
            this.additionalInfo = _data["additionalInfo"] ? AppUserAdditionalInfo.fromJS(_data["additionalInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppUser {
        data = typeof data === 'object' ? data : {};
        let result = new AppUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["employeeId"] = this.employeeId;
        data["employeeProfileId"] = this.employeeProfileId;
        data["employeeName"] = this.employeeName;
        if (Array.isArray(this.userClaims)) {
            data["userClaims"] = [];
            for (let item of this.userClaims)
                data["userClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item);
        }
        data["accessToken"] = this.accessToken;
        data["delegateId"] = this.delegateId;
        data["delegateUser"] = this.delegateUser ? this.delegateUser.toJSON() : <any>undefined;
        data["emailSignature"] = this.emailSignature;
        data["activeRole"] = this.activeRole;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.userOfficeLocation)) {
            data["userOfficeLocation"] = [];
            for (let item of this.userOfficeLocation)
                data["userOfficeLocation"].push(item);
        }
        if (Array.isArray(this.userOfficeLocationCountries)) {
            data["userOfficeLocationCountries"] = [];
            for (let item of this.userOfficeLocationCountries)
                data["userOfficeLocationCountries"].push(item);
        }
        if (Array.isArray(this.userOfficeLegalEntities)) {
            data["userOfficeLegalEntities"] = [];
            for (let item of this.userOfficeLegalEntities)
                data["userOfficeLegalEntities"].push(item);
        }
        data["activeRoleId"] = this.activeRoleId;
        data["isActive"] = this.isActive;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppUser {
    userId?: number;
    userName?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    employeeId?: number;
    employeeProfileId?: number | undefined;
    employeeName?: string | undefined;
    userClaims?: UserClaims[] | undefined;
    roles?: string[] | undefined;
    features?: string[] | undefined;
    modules?: string[] | undefined;
    accessToken?: string | undefined;
    delegateId?: number | undefined;
    delegateUser?: DelegateUser | undefined;
    emailSignature?: string | undefined;
    activeRole?: string | undefined;
    roleIds?: number[] | undefined;
    userOfficeLocation?: number[] | undefined;
    userOfficeLocationCountries?: number[] | undefined;
    userOfficeLegalEntities?: number[] | undefined;
    activeRoleId?: number;
    isActive?: boolean;
    additionalInfo?: AppUserAdditionalInfo | undefined;
}

export class UserClaims implements IUserClaims {
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: IUserClaims) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UserClaims {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaims();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IUserClaims {
    type?: string | undefined;
    value?: string | undefined;
}

export class DelegateUser implements IDelegateUser {
    delegateId?: number | undefined;
    delegateName?: string | undefined;

    constructor(data?: IDelegateUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegateId = _data["delegateId"];
            this.delegateName = _data["delegateName"];
        }
    }

    static fromJS(data: any): DelegateUser {
        data = typeof data === 'object' ? data : {};
        let result = new DelegateUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegateId"] = this.delegateId;
        data["delegateName"] = this.delegateName;
        return data;
    }
}

export interface IDelegateUser {
    delegateId?: number | undefined;
    delegateName?: string | undefined;
}

export class AppUserAdditionalInfo implements IAppUserAdditionalInfo {
    policyVersion?: number;
    immPolicyAccepted?: boolean;

    constructor(data?: IAppUserAdditionalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyVersion = _data["policyVersion"];
            this.immPolicyAccepted = _data["immPolicyAccepted"];
        }
    }

    static fromJS(data: any): AppUserAdditionalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserAdditionalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyVersion"] = this.policyVersion;
        data["immPolicyAccepted"] = this.immPolicyAccepted;
        return data;
    }
}

export interface IAppUserAdditionalInfo {
    policyVersion?: number;
    immPolicyAccepted?: boolean;
}

export class OperationResultOfAppUser implements IOperationResultOfAppUser {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: AppUser | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfAppUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? AppUser.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfAppUser {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfAppUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfAppUser {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: AppUser | undefined;
    errorCode?: number;
}

export class OperationResultOfComments implements IOperationResultOfComments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: Comments | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfComments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? Comments.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfComments {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfComments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfComments {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: Comments | undefined;
    errorCode?: number;
}

export class OperationResultOfEmployeeProfile implements IOperationResultOfEmployeeProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: EmployeeProfile | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfEmployeeProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? EmployeeProfile.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfEmployeeProfile {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfEmployeeProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfEmployeeProfile {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: EmployeeProfile | undefined;
    errorCode?: number;
}

export class EmployeeProfileCandidate implements IEmployeeProfileCandidate {
    profile?: EmployeeProfile | undefined;
    countryCode?: string | undefined;
    legalEntityId?: string | undefined;
    profileEditComment?: EmployeeProfileEditComment | undefined;

    constructor(data?: IEmployeeProfileCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"] ? EmployeeProfile.fromJS(_data["profile"]) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.legalEntityId = _data["legalEntityId"];
            this.profileEditComment = _data["profileEditComment"] ? EmployeeProfileEditComment.fromJS(_data["profileEditComment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeProfileCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeProfileCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["legalEntityId"] = this.legalEntityId;
        data["profileEditComment"] = this.profileEditComment ? this.profileEditComment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeProfileCandidate {
    profile?: EmployeeProfile | undefined;
    countryCode?: string | undefined;
    legalEntityId?: string | undefined;
    profileEditComment?: EmployeeProfileEditComment | undefined;
}

export class EmployeeProfileEditComment implements IEmployeeProfileEditComment {
    id?: number;
    comment?: string | undefined;
    profileId?: number | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    commentType?: ImmigrationCommentTypes;
    statusId?: number | undefined;
    createdDate?: Date;
    modifiedDate?: Date | undefined;

    constructor(data?: IEmployeeProfileEditComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.profileId = _data["profileId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.commentType = _data["commentType"];
            this.statusId = _data["statusId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeProfileEditComment {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeProfileEditComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["profileId"] = this.profileId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["commentType"] = this.commentType;
        data["statusId"] = this.statusId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployeeProfileEditComment {
    id?: number;
    comment?: string | undefined;
    profileId?: number | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    commentType?: ImmigrationCommentTypes;
    statusId?: number | undefined;
    createdDate?: Date;
    modifiedDate?: Date | undefined;
}

export class OperationResultOfEmployeeDoc implements IOperationResultOfEmployeeDoc {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: EmployeeDoc | undefined;
    errorCode?: number;

    constructor(data?: IOperationResultOfEmployeeDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? EmployeeDoc.fromJS(_data["data"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): OperationResultOfEmployeeDoc {
        data = typeof data === 'object' ? data : {};
        let result = new OperationResultOfEmployeeDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOperationResultOfEmployeeDoc {
    statusCode?: HttpStatusCode;
    message?: string | undefined;
    data?: EmployeeDoc | undefined;
    errorCode?: number;
}

export class EmployeeDoc implements IEmployeeDoc {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    employeeProfileEditRequestId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedBy?: Employee | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    employeeProfileId?: number;
    employeeId?: number;
    description?: string | undefined;
    documentNameId?: number;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;

    constructor(data?: IEmployeeDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? LookupField.fromJS(_data["documentType"]) : <any>undefined;
            this.employeeProfileEditRequestId = _data["employeeProfileEditRequestId"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? Employee.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"] ? Employee.fromJS(_data["modifiedBy"]) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.documentName = _data["documentName"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.employeeId = _data["employeeId"];
            this.description = _data["description"];
            this.documentNameId = _data["documentNameId"];
            this.additionalReqId = _data["additionalReqId"];
            this.dependentId = _data["dependentId"];
        }
    }

    static fromJS(data: any): EmployeeDoc {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["employeeProfileEditRequestId"] = this.employeeProfileEditRequestId;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["documentName"] = this.documentName;
        data["employeeProfileId"] = this.employeeProfileId;
        data["employeeId"] = this.employeeId;
        data["description"] = this.description;
        data["documentNameId"] = this.documentNameId;
        data["additionalReqId"] = this.additionalReqId;
        data["dependentId"] = this.dependentId;
        return data;
    }
}

export interface IEmployeeDoc {
    id?: number;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentType?: LookupField | undefined;
    employeeProfileEditRequestId?: number;
    createdById?: number;
    createdBy?: Employee | undefined;
    createdDate?: Date;
    modifiedById?: number | undefined;
    modifiedBy?: Employee | undefined;
    modifiedDate?: Date | undefined;
    documentName?: string | undefined;
    employeeProfileId?: number;
    employeeId?: number;
    description?: string | undefined;
    documentNameId?: number;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;
}

export class EmployeeDocCombined implements IEmployeeDocCombined {
    id?: number | undefined;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    documentNameId?: number;
    documentName?: string | undefined;
    employeeProfileEditRequestId?: number | undefined;
    employeeProfileId?: number | undefined;
    employeeId?: number;
    description?: string | undefined;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;
    dependentName?: string | undefined;
    instruction?: string | undefined;
    isUploaded?: boolean;
    createdById?: number;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    mandatoryType?: number | undefined;
    isEditMode?: boolean | undefined;

    constructor(data?: IEmployeeDocCombined) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileGuiId = _data["fileGuiId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.documentNameId = _data["documentNameId"];
            this.documentName = _data["documentName"];
            this.employeeProfileEditRequestId = _data["employeeProfileEditRequestId"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.employeeId = _data["employeeId"];
            this.description = _data["description"];
            this.additionalReqId = _data["additionalReqId"];
            this.dependentId = _data["dependentId"];
            this.dependentName = _data["dependentName"];
            this.instruction = _data["instruction"];
            this.isUploaded = _data["isUploaded"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedById = _data["modifiedById"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.mandatoryType = _data["mandatoryType"];
            this.isEditMode = _data["isEditMode"];
        }
    }

    static fromJS(data: any): EmployeeDocCombined {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDocCombined();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileGuiId"] = this.fileGuiId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["documentNameId"] = this.documentNameId;
        data["documentName"] = this.documentName;
        data["employeeProfileEditRequestId"] = this.employeeProfileEditRequestId;
        data["employeeProfileId"] = this.employeeProfileId;
        data["employeeId"] = this.employeeId;
        data["description"] = this.description;
        data["additionalReqId"] = this.additionalReqId;
        data["dependentId"] = this.dependentId;
        data["dependentName"] = this.dependentName;
        data["instruction"] = this.instruction;
        data["isUploaded"] = this.isUploaded;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedById"] = this.modifiedById;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["mandatoryType"] = this.mandatoryType;
        data["isEditMode"] = this.isEditMode;
        return data;
    }
}

export interface IEmployeeDocCombined {
    id?: number | undefined;
    fileName?: string | undefined;
    fileGuiId?: string | undefined;
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    documentNameId?: number;
    documentName?: string | undefined;
    employeeProfileEditRequestId?: number | undefined;
    employeeProfileId?: number | undefined;
    employeeId?: number;
    description?: string | undefined;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;
    dependentName?: string | undefined;
    instruction?: string | undefined;
    isUploaded?: boolean;
    createdById?: number;
    createdDate?: Date | undefined;
    modifiedById?: number | undefined;
    modifiedDate?: Date | undefined;
    mandatoryType?: number | undefined;
    isEditMode?: boolean | undefined;
}

export class EmployeeDocDelete implements IEmployeeDocDelete {
    isEdit?: boolean;
    isSearch?: boolean;
    employeeDocCombined?: EmployeeDocCombined | undefined;
    profileId?: number;
    employeeProfile?: EmployeeProfile | undefined;

    constructor(data?: IEmployeeDocDelete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEdit = _data["isEdit"];
            this.isSearch = _data["isSearch"];
            this.employeeDocCombined = _data["employeeDocCombined"] ? EmployeeDocCombined.fromJS(_data["employeeDocCombined"]) : <any>undefined;
            this.profileId = _data["profileId"];
            this.employeeProfile = _data["employeeProfile"] ? EmployeeProfile.fromJS(_data["employeeProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeDocDelete {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDocDelete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEdit"] = this.isEdit;
        data["isSearch"] = this.isSearch;
        data["employeeDocCombined"] = this.employeeDocCombined ? this.employeeDocCombined.toJSON() : <any>undefined;
        data["profileId"] = this.profileId;
        data["employeeProfile"] = this.employeeProfile ? this.employeeProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeDocDelete {
    isEdit?: boolean;
    isSearch?: boolean;
    employeeDocCombined?: EmployeeDocCombined | undefined;
    profileId?: number;
    employeeProfile?: EmployeeProfile | undefined;
}

export class EmployeeDocumentType implements IEmployeeDocumentType {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    value?: string | undefined;
    checks?: string | undefined;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;

    constructor(data?: IEmployeeDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNameId = _data["docNameId"];
            this.docNameDisplayText = _data["docNameDisplayText"];
            this.docTypeId = _data["docTypeId"];
            this.docTypeDisplayText = _data["docTypeDisplayText"];
            this.isMandatory = _data["isMandatory"];
            this.mandatoryType = _data["mandatoryType"];
            this.value = _data["value"];
            this.checks = _data["checks"];
            this.additionalReqId = _data["additionalReqId"];
            this.dependentId = _data["dependentId"];
        }
    }

    static fromJS(data: any): EmployeeDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNameId"] = this.docNameId;
        data["docNameDisplayText"] = this.docNameDisplayText;
        data["docTypeId"] = this.docTypeId;
        data["docTypeDisplayText"] = this.docTypeDisplayText;
        data["isMandatory"] = this.isMandatory;
        data["mandatoryType"] = this.mandatoryType;
        data["value"] = this.value;
        data["checks"] = this.checks;
        data["additionalReqId"] = this.additionalReqId;
        data["dependentId"] = this.dependentId;
        return data;
    }
}

export interface IEmployeeDocumentType {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    value?: string | undefined;
    checks?: string | undefined;
    additionalReqId?: number | undefined;
    dependentId?: number | undefined;
}

export class EmpAdditionalDocRequests implements IEmpAdditionalDocRequests {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    employeeProfileId?: number;
    requestorEmployeeId?: number;
    createDate?: Date | undefined;
    isUploaded?: boolean | undefined;
    comment?: string | undefined;

    constructor(data?: IEmpAdditionalDocRequests) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNameId = _data["docNameId"];
            this.docNameDisplayText = _data["docNameDisplayText"];
            this.docTypeId = _data["docTypeId"];
            this.docTypeDisplayText = _data["docTypeDisplayText"];
            this.isMandatory = _data["isMandatory"];
            this.mandatoryType = _data["mandatoryType"];
            this.employeeProfileId = _data["employeeProfileId"];
            this.requestorEmployeeId = _data["requestorEmployeeId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.isUploaded = _data["isUploaded"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): EmpAdditionalDocRequests {
        data = typeof data === 'object' ? data : {};
        let result = new EmpAdditionalDocRequests();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNameId"] = this.docNameId;
        data["docNameDisplayText"] = this.docNameDisplayText;
        data["docTypeId"] = this.docTypeId;
        data["docTypeDisplayText"] = this.docTypeDisplayText;
        data["isMandatory"] = this.isMandatory;
        data["mandatoryType"] = this.mandatoryType;
        data["employeeProfileId"] = this.employeeProfileId;
        data["requestorEmployeeId"] = this.requestorEmployeeId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["isUploaded"] = this.isUploaded;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IEmpAdditionalDocRequests {
    docNameId?: number;
    docNameDisplayText?: string | undefined;
    docTypeId?: number;
    docTypeDisplayText?: string | undefined;
    isMandatory?: boolean;
    mandatoryType?: number;
    employeeProfileId?: number;
    requestorEmployeeId?: number;
    createDate?: Date | undefined;
    isUploaded?: boolean | undefined;
    comment?: string | undefined;
}

export class Log implements ILog {
    id?: number;
    message?: string | undefined;
    timeStamp?: Date;
    exception?: string | undefined;
    level?: string | undefined;

    constructor(data?: ILog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.exception = _data["exception"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): Log {
        data = typeof data === 'object' ? data : {};
        let result = new Log();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["exception"] = this.exception;
        data["level"] = this.level;
        return data;
    }
}

export interface ILog {
    id?: number;
    message?: string | undefined;
    timeStamp?: Date;
    exception?: string | undefined;
    level?: string | undefined;
}

export class LogGridInfo implements ILogGridInfo {
    logList?: Log[] | undefined;
    sortParameters?: SortParameters | undefined;

    constructor(data?: ILogGridInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["logList"])) {
                this.logList = [] as any;
                for (let item of _data["logList"])
                    this.logList!.push(Log.fromJS(item));
            }
            this.sortParameters = _data["sortParameters"] ? SortParameters.fromJS(_data["sortParameters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LogGridInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LogGridInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logList)) {
            data["logList"] = [];
            for (let item of this.logList)
                data["logList"].push(item.toJSON());
        }
        data["sortParameters"] = this.sortParameters ? this.sortParameters.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILogGridInfo {
    logList?: Log[] | undefined;
    sortParameters?: SortParameters | undefined;
}

export class LookupType2 implements ILookupType2 {
    id?: number;
    displayText?: string | undefined;
    isActive?: boolean;
    isEditable?: boolean;
    module?: string | undefined;
    lookupFields?: LookupField[] | undefined;

    constructor(data?: ILookupType2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayText = _data["displayText"];
            this.isActive = _data["isActive"];
            this.isEditable = _data["isEditable"];
            this.module = _data["module"];
            if (Array.isArray(_data["lookupFields"])) {
                this.lookupFields = [] as any;
                for (let item of _data["lookupFields"])
                    this.lookupFields!.push(LookupField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LookupType2 {
        data = typeof data === 'object' ? data : {};
        let result = new LookupType2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayText"] = this.displayText;
        data["isActive"] = this.isActive;
        data["isEditable"] = this.isEditable;
        data["module"] = this.module;
        if (Array.isArray(this.lookupFields)) {
            data["lookupFields"] = [];
            for (let item of this.lookupFields)
                data["lookupFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILookupType2 {
    id?: number;
    displayText?: string | undefined;
    isActive?: boolean;
    isEditable?: boolean;
    module?: string | undefined;
    lookupFields?: LookupField[] | undefined;
}

export class DeptCodeblock implements IDeptCodeblock {
    deptCode?: string | undefined;
    smuCode?: string | undefined;
    buCode?: string | undefined;
    ouCode?: string | undefined;
    muCode?: string | undefined;
    displayText?: string | undefined;
    isActive?: boolean;
    disabled?: boolean;
    speciality?: string | undefined;
    costCentre?: string | undefined;
    id?: number;

    constructor(data?: IDeptCodeblock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deptCode = _data["deptCode"];
            this.smuCode = _data["smuCode"];
            this.buCode = _data["buCode"];
            this.ouCode = _data["ouCode"];
            this.muCode = _data["muCode"];
            this.displayText = _data["displayText"];
            this.isActive = _data["isActive"];
            this.disabled = _data["disabled"];
            this.speciality = _data["speciality"];
            this.costCentre = _data["costCentre"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeptCodeblock {
        data = typeof data === 'object' ? data : {};
        let result = new DeptCodeblock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deptCode"] = this.deptCode;
        data["smuCode"] = this.smuCode;
        data["buCode"] = this.buCode;
        data["ouCode"] = this.ouCode;
        data["muCode"] = this.muCode;
        data["displayText"] = this.displayText;
        data["isActive"] = this.isActive;
        data["disabled"] = this.disabled;
        data["speciality"] = this.speciality;
        data["costCentre"] = this.costCentre;
        data["id"] = this.id;
        return data;
    }
}

export interface IDeptCodeblock {
    deptCode?: string | undefined;
    smuCode?: string | undefined;
    buCode?: string | undefined;
    ouCode?: string | undefined;
    muCode?: string | undefined;
    displayText?: string | undefined;
    isActive?: boolean;
    disabled?: boolean;
    speciality?: string | undefined;
    costCentre?: string | undefined;
    id?: number;
}

export class OfficeLocation implements IOfficeLocation {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;

    constructor(data?: IOfficeLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
            this.parentFieldId = _data["parentFieldId"];
        }
    }

    static fromJS(data: any): OfficeLocation {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        data["parentFieldId"] = this.parentFieldId;
        return data;
    }
}

export interface IOfficeLocation {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
}

export class WorkPermitJobTitle implements IWorkPermitJobTitle {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    jobCode?: string | undefined;
    skillCategory?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;

    constructor(data?: IWorkPermitJobTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.jobCode = _data["jobCode"];
            this.skillCategory = _data["skillCategory"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
            this.parentFieldId = _data["parentFieldId"];
        }
    }

    static fromJS(data: any): WorkPermitJobTitle {
        data = typeof data === 'object' ? data : {};
        let result = new WorkPermitJobTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["jobCode"] = this.jobCode;
        data["skillCategory"] = this.skillCategory;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        data["parentFieldId"] = this.parentFieldId;
        return data;
    }
}

export interface IWorkPermitJobTitle {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    jobCode?: string | undefined;
    skillCategory?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
}

export class LookupFieldGridInfo implements ILookupFieldGridInfo {
    lookupFields?: LookupField[] | undefined;
    sortParameters?: SortParameters | undefined;

    constructor(data?: ILookupFieldGridInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lookupFields"])) {
                this.lookupFields = [] as any;
                for (let item of _data["lookupFields"])
                    this.lookupFields!.push(LookupField.fromJS(item));
            }
            this.sortParameters = _data["sortParameters"] ? SortParameters.fromJS(_data["sortParameters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LookupFieldGridInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LookupFieldGridInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lookupFields)) {
            data["lookupFields"] = [];
            for (let item of this.lookupFields)
                data["lookupFields"].push(item.toJSON());
        }
        data["sortParameters"] = this.sortParameters ? this.sortParameters.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILookupFieldGridInfo {
    lookupFields?: LookupField[] | undefined;
    sortParameters?: SortParameters | undefined;
}

export class Cities implements ICities {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;

    constructor(data?: ICities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.parentCode = _data["parentCode"];
            this.filterKeyId = _data["filterKeyId"];
            this.parentFieldId = _data["parentFieldId"];
        }
    }

    static fromJS(data: any): Cities {
        data = typeof data === 'object' ? data : {};
        let result = new Cities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["filterKeyId"] = this.filterKeyId;
        data["parentFieldId"] = this.parentFieldId;
        return data;
    }
}

export interface ICities {
    id?: number | undefined;
    value?: string | undefined;
    displayText?: string | undefined;
    order?: number;
    isActive?: boolean;
    parentCode?: string | undefined;
    filterKeyId?: number | undefined;
    parentFieldId?: number | undefined;
}

export class ValueTupleOfIntegerAndInteger implements IValueTupleOfIntegerAndInteger {
    item1?: number;
    item2?: number;

    constructor(data?: IValueTupleOfIntegerAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfIntegerAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfIntegerAndInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    }
}

export interface IValueTupleOfIntegerAndInteger {
    item1?: number;
    item2?: number;
}

export class CountryVisaOptionDto implements ICountryVisaOptionDto {
    visaId?: number;
    visaName?: string | undefined;
    entryTypeId?: number;
    entryTypeName?: string | undefined;
    visaDurationId?: number;
    visaDurationName?: string | undefined;
    isBillableWorkId?: number;
    isBillableWorkName?: string | undefined;

    constructor(data?: ICountryVisaOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visaId = _data["visaId"];
            this.visaName = _data["visaName"];
            this.entryTypeId = _data["entryTypeId"];
            this.entryTypeName = _data["entryTypeName"];
            this.visaDurationId = _data["visaDurationId"];
            this.visaDurationName = _data["visaDurationName"];
            this.isBillableWorkId = _data["isBillableWorkId"];
            this.isBillableWorkName = _data["isBillableWorkName"];
        }
    }

    static fromJS(data: any): CountryVisaOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryVisaOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visaId"] = this.visaId;
        data["visaName"] = this.visaName;
        data["entryTypeId"] = this.entryTypeId;
        data["entryTypeName"] = this.entryTypeName;
        data["visaDurationId"] = this.visaDurationId;
        data["visaDurationName"] = this.visaDurationName;
        data["isBillableWorkId"] = this.isBillableWorkId;
        data["isBillableWorkName"] = this.isBillableWorkName;
        return data;
    }
}

export interface ICountryVisaOptionDto {
    visaId?: number;
    visaName?: string | undefined;
    entryTypeId?: number;
    entryTypeName?: string | undefined;
    visaDurationId?: number;
    visaDurationName?: string | undefined;
    isBillableWorkId?: number;
    isBillableWorkName?: string | undefined;
}

export class CandidateActivities implements ICandidateActivities {
    candidateProfileId?: number;
    pbProfileId?: number;
    pbStatusID?: number;
    candidateProfile?: CandidateProfile | undefined;
    isActivitiesCompeted?: number | undefined;
    activities?: Activity[] | undefined;
    chargeCode?: string | undefined;
    immigrationCaseTypeId?: number | undefined;

    constructor(data?: ICandidateActivities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateProfileId = _data["candidateProfileId"];
            this.pbProfileId = _data["pbProfileId"];
            this.pbStatusID = _data["pbStatusID"];
            this.candidateProfile = _data["candidateProfile"] ? CandidateProfile.fromJS(_data["candidateProfile"]) : <any>undefined;
            this.isActivitiesCompeted = _data["isActivitiesCompeted"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(Activity.fromJS(item));
            }
            this.chargeCode = _data["chargeCode"];
            this.immigrationCaseTypeId = _data["immigrationCaseTypeId"];
        }
    }

    static fromJS(data: any): CandidateActivities {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateActivities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateProfileId"] = this.candidateProfileId;
        data["pbProfileId"] = this.pbProfileId;
        data["pbStatusID"] = this.pbStatusID;
        data["candidateProfile"] = this.candidateProfile ? this.candidateProfile.toJSON() : <any>undefined;
        data["isActivitiesCompeted"] = this.isActivitiesCompeted;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["chargeCode"] = this.chargeCode;
        data["immigrationCaseTypeId"] = this.immigrationCaseTypeId;
        return data;
    }
}

export interface ICandidateActivities {
    candidateProfileId?: number;
    pbProfileId?: number;
    pbStatusID?: number;
    candidateProfile?: CandidateProfile | undefined;
    isActivitiesCompeted?: number | undefined;
    activities?: Activity[] | undefined;
    chargeCode?: string | undefined;
    immigrationCaseTypeId?: number | undefined;
}

export class KeyValuePairOfStringAndDateTime implements IKeyValuePairOfStringAndDateTime {
    key?: string;
    value?: Date;

    constructor(data?: IKeyValuePairOfStringAndDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        return data;
    }
}

export interface IKeyValuePairOfStringAndDateTime {
    key?: string;
    value?: Date;
}

export enum DateFields {
    StartDate = 0,
    ProfileSubmittedDate = 1,
}

export class DateRange implements IDateRange {
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateRange {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export enum RoleType {
    Admin = 0,
    Recruiter = 1,
    PTC = 2,
    Immigration = 3,
    TSS = 4,
    Employee = 5,
    LocalHRE = 6,
    PlaceholderForNewRole = 7,
    ExitTeam = 8,
    VisaApprover = 9,
    TSS_Recruiter = 10,
    HRCC = 11,
    Core_HR = 12,
    CBTS = 13,
    MobilityTeam = 14,
    ITTeam = 15,
    Expense = 16,
    LMS = 17,
    AMEX = 18,
    ARCAndCanvas = 19,
    LEADSTeam = 20,
    FinanceTeam = 21,
    GuidanceMail = 22,
    STC = 23,
    GigNow = 24,
    IBM_Team = 25,
    AdminEditProfile = 33,
}

export class PagedResultOfUserInfo implements IPagedResultOfUserInfo {
    page?: number;
    itemsPerPage?: number;
    sortBy?: string | undefined;
    reverse?: boolean;
    totalRecords?: number;
    results?: UserInfo[] | undefined;

    constructor(data?: IPagedResultOfUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.itemsPerPage = _data["itemsPerPage"];
            this.sortBy = _data["sortBy"];
            this.reverse = _data["reverse"];
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["itemsPerPage"] = this.itemsPerPage;
        data["sortBy"] = this.sortBy;
        data["reverse"] = this.reverse;
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfUserInfo {
    page?: number;
    itemsPerPage?: number;
    sortBy?: string | undefined;
    reverse?: boolean;
    totalRecords?: number;
    results?: UserInfo[] | undefined;
}

export class UserInfo implements IUserInfo {
    userId?: number;
    userName?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    employeeId?: number;
    userClaims?: UserClaims[] | undefined;
    roles?: string[] | undefined;
    officeEntities?: number[] | undefined;
    officeLocations?: number[] | undefined;
    firstName?: string | undefined;
    activeRole?: string | undefined;
    delegateEmpId?: number;
    isActive?: boolean;
    exitLocations?: number[] | undefined;
    exitServiceLines?: number[] | undefined;
    employeeCategories?: number[] | undefined;
    contractTypes?: number[] | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.employeeId = _data["employeeId"];
            if (Array.isArray(_data["userClaims"])) {
                this.userClaims = [] as any;
                for (let item of _data["userClaims"])
                    this.userClaims!.push(UserClaims.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["officeEntities"])) {
                this.officeEntities = [] as any;
                for (let item of _data["officeEntities"])
                    this.officeEntities!.push(item);
            }
            if (Array.isArray(_data["officeLocations"])) {
                this.officeLocations = [] as any;
                for (let item of _data["officeLocations"])
                    this.officeLocations!.push(item);
            }
            this.firstName = _data["firstName"];
            this.activeRole = _data["activeRole"];
            this.delegateEmpId = _data["delegateEmpId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["exitLocations"])) {
                this.exitLocations = [] as any;
                for (let item of _data["exitLocations"])
                    this.exitLocations!.push(item);
            }
            if (Array.isArray(_data["exitServiceLines"])) {
                this.exitServiceLines = [] as any;
                for (let item of _data["exitServiceLines"])
                    this.exitServiceLines!.push(item);
            }
            if (Array.isArray(_data["employeeCategories"])) {
                this.employeeCategories = [] as any;
                for (let item of _data["employeeCategories"])
                    this.employeeCategories!.push(item);
            }
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["employeeId"] = this.employeeId;
        if (Array.isArray(this.userClaims)) {
            data["userClaims"] = [];
            for (let item of this.userClaims)
                data["userClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.officeEntities)) {
            data["officeEntities"] = [];
            for (let item of this.officeEntities)
                data["officeEntities"].push(item);
        }
        if (Array.isArray(this.officeLocations)) {
            data["officeLocations"] = [];
            for (let item of this.officeLocations)
                data["officeLocations"].push(item);
        }
        data["firstName"] = this.firstName;
        data["activeRole"] = this.activeRole;
        data["delegateEmpId"] = this.delegateEmpId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.exitLocations)) {
            data["exitLocations"] = [];
            for (let item of this.exitLocations)
                data["exitLocations"].push(item);
        }
        if (Array.isArray(this.exitServiceLines)) {
            data["exitServiceLines"] = [];
            for (let item of this.exitServiceLines)
                data["exitServiceLines"].push(item);
        }
        if (Array.isArray(this.employeeCategories)) {
            data["employeeCategories"] = [];
            for (let item of this.employeeCategories)
                data["employeeCategories"].push(item);
        }
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item);
        }
        return data;
    }
}

export interface IUserInfo {
    userId?: number;
    userName?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    employeeId?: number;
    userClaims?: UserClaims[] | undefined;
    roles?: string[] | undefined;
    officeEntities?: number[] | undefined;
    officeLocations?: number[] | undefined;
    firstName?: string | undefined;
    activeRole?: string | undefined;
    delegateEmpId?: number;
    isActive?: boolean;
    exitLocations?: number[] | undefined;
    exitServiceLines?: number[] | undefined;
    employeeCategories?: number[] | undefined;
    contractTypes?: number[] | undefined;
}

export class QueryParametersOfUserListFilter implements IQueryParametersOfUserListFilter {
    page?: number;
    itemsPerPage?: number;
    sortBy?: string | undefined;
    reverse?: boolean;
    filterParams?: UserListFilter | undefined;

    constructor(data?: IQueryParametersOfUserListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.itemsPerPage = _data["itemsPerPage"];
            this.sortBy = _data["sortBy"];
            this.reverse = _data["reverse"];
            this.filterParams = _data["filterParams"] ? UserListFilter.fromJS(_data["filterParams"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QueryParametersOfUserListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new QueryParametersOfUserListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["itemsPerPage"] = this.itemsPerPage;
        data["sortBy"] = this.sortBy;
        data["reverse"] = this.reverse;
        data["filterParams"] = this.filterParams ? this.filterParams.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQueryParametersOfUserListFilter {
    page?: number;
    itemsPerPage?: number;
    sortBy?: string | undefined;
    reverse?: boolean;
    filterParams?: UserListFilter | undefined;
}

export class UserListFilter implements IUserListFilter {
    name?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;

    constructor(data?: IUserListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UserListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UserListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["role"] = this.role;
        return data;
    }
}

export interface IUserListFilter {
    name?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
}

export class UserRole implements IUserRole {
    roleType?: RoleType;
    role?: string | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleType = _data["roleType"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleType"] = this.roleType;
        data["role"] = this.role;
        return data;
    }
}

export interface IUserRole {
    roleType?: RoleType;
    role?: string | undefined;
}

export class EmployeeAdditionalInfo implements IEmployeeAdditionalInfo {
    id?: number;
    employeeId?: number;
    exitOfficeLocations?: (number | undefined)[] | undefined;
    exitServiceLines?: (number | undefined)[] | undefined;
    employeeCategories?: (number | undefined)[] | undefined;
    contractTypes?: (number | undefined)[] | undefined;

    constructor(data?: IEmployeeAdditionalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            if (Array.isArray(_data["exitOfficeLocations"])) {
                this.exitOfficeLocations = [] as any;
                for (let item of _data["exitOfficeLocations"])
                    this.exitOfficeLocations!.push(item);
            }
            if (Array.isArray(_data["exitServiceLines"])) {
                this.exitServiceLines = [] as any;
                for (let item of _data["exitServiceLines"])
                    this.exitServiceLines!.push(item);
            }
            if (Array.isArray(_data["employeeCategories"])) {
                this.employeeCategories = [] as any;
                for (let item of _data["employeeCategories"])
                    this.employeeCategories!.push(item);
            }
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeAdditionalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAdditionalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        if (Array.isArray(this.exitOfficeLocations)) {
            data["exitOfficeLocations"] = [];
            for (let item of this.exitOfficeLocations)
                data["exitOfficeLocations"].push(item);
        }
        if (Array.isArray(this.exitServiceLines)) {
            data["exitServiceLines"] = [];
            for (let item of this.exitServiceLines)
                data["exitServiceLines"].push(item);
        }
        if (Array.isArray(this.employeeCategories)) {
            data["employeeCategories"] = [];
            for (let item of this.employeeCategories)
                data["employeeCategories"].push(item);
        }
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item);
        }
        return data;
    }
}

export interface IEmployeeAdditionalInfo {
    id?: number;
    employeeId?: number;
    exitOfficeLocations?: (number | undefined)[] | undefined;
    exitServiceLines?: (number | undefined)[] | undefined;
    employeeCategories?: (number | undefined)[] | undefined;
    contractTypes?: (number | undefined)[] | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
